export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: number; output: number; }
  CmDate: { input: Date; output: Date; }
  CmDateTimeOffset: { input: any; output: any; }
  DateTime: { input: Date; output: Date; }
  DateTimeOffset: { input: Date; output: Date; }
  Decimal: { input: number; output: number; }
  Long: { input: number; output: number; }
  Milliseconds: { input: number; output: number; }
  Seconds: { input: number; output: number; }
  Short: { input: number; output: number; }
}

export enum AaHistType {
  /** EditAccount */
  EditAccount = 'EditAccount',
  /** EditApiAccountClientRole */
  EditApiAccountClientRole = 'EditApiAccountClientRole',
  /** Login */
  Login = 'Login',
  /** Logout */
  Logout = 'Logout',
  /** PermissionChange */
  PermissionChange = 'PermissionChange',
  /** WebToolActivity */
  WebToolActivity = 'WebToolActivity'
}

export interface AccredibleCandidateBadgeResponseGqlType {
  /** The date the badge is considered active. */
  activeDate?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the candidate. */
  candidateName: Scalars['String']['output'];
  /** The email used for this particular badge's issuance. Can be different for each badge. */
  email: Scalars['String']['output'];
  /** The date the badge is considered expired. */
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  /** Accredible's group id. */
  groupId: Scalars['Int']['output'];
  /** Accredible's group name. */
  groupName: Scalars['String']['output'];
  /** Accredible's badge id. */
  id: Scalars['String']['output'];
}

export interface AccredibleGroupCatalogResponseGqlType {
  /** The CertMetrics catalog id. See the Type to determine which type of CM catalog it belongs to. */
  catalogId?: Maybe<Scalars['Int']['output']>;
  /** An Id assigned by Accredible */
  groupId?: Maybe<Scalars['String']['output']>;
  /** The group name from Accredible. */
  groupName?: Maybe<Scalars['String']['output']>;
  /** The CertMetrics catalog name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The type of catalog. Ex. Ccat, Excat, or Crcat. */
  type?: Maybe<CateidType>;
}

/** Represents the active audit certs and their related audit info. */
export interface ActiveAuditCerts {
  /** List of active cert infos. */
  activeCertInfos?: Maybe<Array<Maybe<CertDetail>>>;
  /** List of audit certification requirement infos. */
  creqAuditInfos?: Maybe<Array<Maybe<CreqAuditItemDetail>>>;
}

/** Adds a client setting to the client_setting table. */
export interface AddClientSettingRequest {
  /** The use of this field is determined by the setting; it may or may not be used at all. */
  csetDatetime?: InputMaybe<Scalars['CmDate']['input']>;
  /** The use of this field is determined by the setting; it may or may not be used at all. */
  csetInt?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the setting being controlled/defined. Names should be in PascalCase. */
  csetName: Scalars['String']['input'];
  /** The use of this field is determined by the setting; it may or may not be used at all. This is used as COALESCE(nvarchar, varchar). */
  csetNvarchar?: InputMaybe<Scalars['String']['input']>;
  /** The use of this field is determined by the setting; it may or may not be used at all. This is used as COALESCE(nvarchar, varchar). */
  csetVarchar?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Shows additional details about an exam record.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: ExamMSFTExamDetails
 *
 */
export interface AdditionalExamDetails {
  /** The ID of the exam that this detail record belongs to. */
  examId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  maxRawScore?: Maybe<Scalars['Int']['output']>;
  notViewedItemCount?: Maybe<Scalars['Int']['output']>;
  /** The number of breaks taken by the candidate during the exam. */
  numberOfBreaks?: Maybe<Scalars['Int']['output']>;
  /** The total &quot;Open Book&quot; pages viewed by the candidate during the exam. */
  obTotalPages?: Maybe<Scalars['Int']['output']>;
  /** The total time spent by the candidate using the &quot;Open Book&quot; feature during the exam. */
  obTotalTime?: Maybe<Scalars['Int']['output']>;
  /** The Rasch score estimate for this exam. */
  raschEstimate?: Maybe<Scalars['Decimal']['output']>;
  rawCutScore?: Maybe<Scalars['Int']['output']>;
  /** The total break time in seconds taken by the candidate during the exam. */
  totalBreakTimeSeconds?: Maybe<Scalars['Int']['output']>;
}

/** Address information for a testing site */
export interface Address {
  /** The lines of the address */
  addressLine?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The state or administrative district */
  adminDistrict?: Maybe<Scalars['String']['output']>;
  /** The country */
  country?: Maybe<Scalars['String']['output']>;
  /** The complete formatted address */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** The city or locality */
  locality?: Maybe<Scalars['String']['output']>;
  /** The postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
}

export enum AffType {
  /** Customer */
  Customer = 'Customer',
  /** Employee */
  Employee = 'Employee',
  /** Government */
  Government = 'Government',
  /** Other */
  Other = 'Other',
  /** Partner */
  Partner = 'Partner',
  /** SelfEmployed */
  SelfEmployed = 'SelfEmployed',
  /** Student */
  Student = 'Student'
}

/**
 * Defines the entities that the candidate can select as their relation to the client. The client maintains the list of options and the candidate is required to select from the list of available options.
 * 
 * 
 *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
 *
 */
export interface AffiliationCatalog {
  /** When this field is not null, this indicates that the candidate must enter an Affiliate Id. If the value is an empty string, any entry is acceptable. If not, the value is a regular expression indicating the approved format of the Affiliate Id. */
  affiliateIdFormat?: Maybe<Scalars['String']['output']>;
  /** When true, indicates that this affiliation is no longer active. Candidates cannot select this affiliation, and if the candidate currently has this affiliation selected, they will be required to change to an active affiliation option. */
  disabled: Scalars['Boolean']['output'];
  /** When this field is not null, it indicates that the candidate must enter a valid email address. If value is an empty string, any valid email address is acceptable. If the value is not an empty string, it will be a pipe-delimited list of strings that the email address will end with (e.g., gmail.com|yahoo.com). This is a whitelist of ends with options. If the string begins with '!' the list is a blacklist. Works in combination with EmailRequired value. */
  emailFormat?: Maybe<Scalars['String']['output']>;
  /** Indicates if email is required or optional. A null value indicates that an email is not allowed to be provide. False indicates that an email can be entered, but is optional. If entered value must follow the rules in EmailFormat. True indicates that email is required and must follow the rules in EmailFormat. */
  emailRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A unique identifier for the affiliated entity within CertMetrics. This identifier can either be provided by the client or auto-generated by CertMetrics.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  externalId?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  id: Scalars['Int']['output'];
  /**
   * The name of the affiliated entity as it is known by the client.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  name: Scalars['String']['output'];
  /** When this field is not null, this indicates that this is an 'Other' affiliation, meaning that the candidate was unable to locate a standard selection, and is required to enter the name of their affiliated organization by hand. If this value is empty, that indicates that the candidate can enter any value without restrictions. If this value is not empty, this is a regular expression that dictates what values can be accepted. */
  otherFormat?: Maybe<Scalars['String']['output']>;
  /**
   * An optional way to group affiliations different than WebGroup that is for reporting purposes. Hasn't been implemented yet.
   * 
   * 
   *  - Internal accounts only
   *
   */
  reportGroup?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AffType>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  updated: Scalars['CmDateTimeOffset']['output'];
  /**
   * Indicates a grouping of affiliation types that are used in CertMetrics as the first step in a two-part selection for the candidate's affiliation. This is typically 'Partner', 'Customer', or similar.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  webGroup?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface ApiAccount {
  admin: Scalars['Boolean']['output'];
  anyCandidate: Scalars['Boolean']['output'];
  anyEndpoint: Scalars['Boolean']['output'];
  bypassAccessCode: Scalars['Boolean']['output'];
  canSsoCandidate: Scalars['Boolean']['output'];
  canSsoWebUser: Scalars['Boolean']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  idAuthorityDataProvider?: Maybe<DataProvider>;
  importDataProvider?: Maybe<DataProvider>;
  internal: Scalars['Boolean']['output'];
  loginId?: Maybe<Scalars['String']['output']>;
  loginPassword?: Maybe<Scalars['String']['output']>;
  loginToken: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  whitelist?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface ApiAccountDetails {
  apiAccount?: Maybe<ApiAccount>;
  historyList?: Maybe<Array<Maybe<ApiAccountHistory>>>;
  id: Scalars['Int']['output'];
  permissionList?: Maybe<Array<Maybe<Permission>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface ApiAccountDetailsPermissionListArgs {
  request?: InputMaybe<ApiAccountPermissionListRequest>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface ApiAccountHistory {
  /** Indicates the user this pertains to. */
  apiAccountId: Scalars['Int']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  /** This indicates the user responsible. */
  creator?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** The message that was logged */
  message?: Maybe<Scalars['String']['output']>;
  /** The type of the history entry. */
  type: AaHistType;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface ApiAccountIdRequest {
  /** The CertMetrics ApiAccount Id. When this is set, all other fields are ignored. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The unique login id for the ApiAccount account. This is used to find a ApiAccount when ApiAccount Id is not supplied. */
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface ApiAccountPermissionListRequest {
  includeAvailable?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface Appointment {
  /** This will be a list of the accommodation codes that have been approved for the candidate for this registration */
  accommodationList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The date and time of the appointment */
  appointmentDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** The authorization ID for this registration, if provided. Not all exams require authorizations to test */
  authorizationId?: Maybe<Scalars['String']['output']>;
  /** An optional field to show more information about the change such as Scheduled, Rescheduled, etc. */
  changeReason?: Maybe<Scalars['String']['output']>;
  /** The timestamp indicating the effective datetime of the change */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** List of external exam IDs associated with this appointment */
  examExternalIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique registration number at the delivery provider for this registration */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Indicates the current status of the appointment. Only the following options are supported: Aborted (Indicates the candidate ended the exam without completing it), NoShow (Indicates the candidate did not appear for the appointment), Canceled (Indicates the candidate canceled the appointment), Corrupted (Indicates that an unexpected error occurred during delivery and the exam is not a valid result), ApptOK (Indicates the appointment is valid) */
  status: ExevtType;
  /** Indicates the test center the candidate tested in, if applicable */
  testCenterId?: Maybe<Scalars['String']['output']>;
}

export interface AppointmentRequest {
  /** This will be a list of the accommodation codes that have been approved for the candidate for this registration */
  accommodationList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The date and time of the appointment */
  appointmentDateTime: Scalars['DateTime']['input'];
  /** The authorization ID for this registration, if provided. Not all exams require authorizations to test */
  authorizationId?: InputMaybe<Scalars['String']['input']>;
  /** Shared unique ID between systems */
  candidateId: CandidateIdRequest;
  /** An optional field to show more information about the change such as Scheduled, Rescheduled, etc. */
  changeReason?: InputMaybe<Scalars['String']['input']>;
  /** The timestamp indicating the effective datetime of the change */
  effectiveDate: Scalars['CmDateTimeOffset']['input'];
  /** List of external exam IDs associated with this appointment */
  examExternalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The unique registration number at the delivery provider for this registration */
  registrationNumber: Scalars['String']['input'];
  /** Indicates the current status of the appointment. Only the following options are supported: Aborted (Indicates the candidate ended the exam without completing it), NoShow (Indicates the candidate did not appear for the appointment), Canceled (Indicates the candidate canceled the appointment), Corrupted (Indicates that an unexpected error occurred during delivery and the exam is not a valid result), ApptOK (Indicates the appointment is valid) */
  status: ExevtType;
  /** Indicates the test center the candidate tested in, if applicable */
  testCenterId?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Represents an audit assignment linking an audit to a web user.
 * 
 * 
 *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
 * 
 *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
 *
 */
export interface AssignCreqAuditRequest {
  /** The creq audit ID. */
  craId: Scalars['Int']['input'];
  /** The web user ID to assign to the creq audit. */
  wuserId?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * Request parameters for assigning audits to web users.
 * 
 * 
 *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
 * 
 *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
 *
 */
export interface AssignCreqAuditRequestList {
  /** A list requests to assign creq audits to web users. Multiple audit-web user pairs may be requested, but only one web user may be assigned to a given audit. */
  audits: Array<AssignCreqAuditRequest>;
}

/** A summary of completed audit counts by year. */
export interface AuditHistorySummary {
  /** A mapping of years to their completed audit counts. */
  completedCountsByYear?: Maybe<Array<Maybe<AuditHistoryYearCountPair>>>;
}

/** A year and associated completed audit count for the audit history summary. */
export interface AuditHistoryYearCountPair {
  /** The completed audit count for a given year. */
  count: Scalars['Int']['output'];
  /** The year in which the completed count applies. */
  year: Scalars['Int']['output'];
}

export enum AuditItemStatus {
  /** Invalid */
  Invalid = 'Invalid',
  /** Pending */
  Pending = 'Pending',
  /** Valid */
  Valid = 'Valid'
}

/** Request parameters for retrieving audit messages for a specific audit. */
export interface AuditMessagesRequest {
  /** The audit ID for which to retrieve messages. */
  craId: Scalars['Int']['input'];
}

/**
 * Represents a candidate that is available for audit review.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface AuditUser {
  /** The web user id. */
  id: Scalars['Int']['output'];
  /** The web user's internal status. */
  internal: Scalars['Boolean']['output'];
  /** The web user's name. */
  name: Scalars['String']['output'];
}

export enum AuthPackageStateEnum {
  /** An appointment is scheduled in the future */
  AppointmentScheduled = 'AppointmentScheduled',
  /** Expiration date is in the past */
  Expired = 'Expired',
  /** Send Ok Date is null */
  Ineligible = 'Ineligible',
  /** No Authorizations found for the candidate */
  NoAuths = 'NoAuths',
  /** Active Date is in the past and expiration date is in the future, usable by the candidate */
  Open = 'Open',
  /** Send Ok Date is in the past, but at least one individual auth Send Ok Date is in the future */
  OpenCannotSendYet = 'OpenCannotSendYet',
  /** Send Ok Date is in the past, and the canddiate has a valid, future, appointment scheduled */
  OpenWithAppointment = 'OpenWithAppointment',
  /** The eligibility has been revoked */
  Revoked = 'Revoked',
  /** The eligibility cannot be sent to the data provider */
  Unsendable = 'Unsendable',
  /** The eligibility has been determined to be old and not usable */
  Unusable = 'Unusable',
  /** Send Ok Date is in the future */
  Upcoming = 'Upcoming',
  /** A completed or aborted exam is tied to an associated authorization */
  Used = 'Used'
}

export interface AutomationScriptsSecurityGqlType {
  unparsedConfig?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: AWSCustomReports
 *
 */
export interface AwsTools {
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: AWSCustomReportsVerifyVoucherCode
   * 
   *  - Requires All Permissions: VerifyVoucherCodes.Modify, VerifyVoucherCodes.View
   *
   */
  verifyVoucherCodes?: Maybe<Array<Maybe<VerifyVoucherCode>>>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: AWSCustomReports
 *
 */
export interface AwsToolsVerifyVoucherCodesArgs {
  request?: InputMaybe<VerifyVoucherCodeRequest>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: ShareCertMetricsBadging
 * 
 *  - Requires All Permissions: Candidate.CertMetricsBadging.View
 * 
 *  - Must have candidate access
 *
 */
export interface Badge {
  activeDate: Scalars['CmDate']['output'];
  catalog: BadgeCatalog;
  criteriaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publicApiUrl?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** Possible values are: c, e or r and refer to certs, exams and cert requirements respectively. */
  type: BadgeType;
  uid?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: ShareCertMetricsBadging
 *
 */
export interface BadgeCatalog {
  certCatalog?: Maybe<CertCatalog>;
  certRequirementCatalog?: Maybe<CertRequirementCatalog>;
  criteriaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  examCatalog?: Maybe<ExamCatalog>;
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUploadUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  issuerUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Possible values are: c, e or r and refer to certs, exams and cert requirements respectively. */
  type: BadgeType;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: ShareCertMetricsBadging
 * 
 *  - Requires All Permissions: Candidate.CertMetricsBadging.View
 * 
 *  - Must have candidate access
 *
 */
export interface BadgeDetail {
  activeDate: Scalars['CmDate']['output'];
  /** A count of the number of times the assertion endpoint has been called. */
  assertionCount?: Maybe<Scalars['Int']['output']>;
  catalog: BadgeCatalog;
  criteriaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publicApiUrl?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** Possible values are: c, e or r and refer to certs, exams and cert requirements respectively. */
  type: BadgeType;
  uid?: Maybe<Scalars['String']['output']>;
}

/** Possible values are: c, e or r and refer to certs, exams and cert requirements respectively. */
export enum BadgeType {
  /** Cert */
  C = 'c',
  /** Exam */
  E = 'e',
  /** CertRequirement */
  R = 'r'
}

/**
 * Returns a list of candidates who were banned.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Permissions: BannedCandidateList.View
 * 
 *  - Must have candidate access
 *
 */
export interface BannedCandidatesReport {
  bannedUntil: Scalars['CmDate']['output'];
  candidate?: Maybe<Candidate>;
  cmcId: Scalars['Int']['output'];
}

export interface BatchListRequest {
  activeOnly: Scalars['Boolean']['input'];
}

export enum BcatGrantType {
  /** Manual */
  Manual = 'Manual',
  /** OncePerCcat */
  OncePerCcat = 'OncePerCcat',
  /** OncePerCcatAchievedLogic */
  OncePerCcatAchievedLogic = 'OncePerCcatAchievedLogic',
  /** OncePerCcatAchievement */
  OncePerCcatAchievement = 'OncePerCcatAchievement',
  /** OncePerCcatList */
  OncePerCcatList = 'OncePerCcatList'
}

export enum BcatType {
  /** Download */
  Download = 'Download',
  /** Lineup */
  Lineup = 'Lineup',
  /** StampedPDF */
  StampedPdf = 'StampedPDF',
  /** TokenGlobal */
  TokenGlobal = 'TokenGlobal',
  /** TokenUnique */
  TokenUnique = 'TokenUnique',
  /** Url */
  Url = 'Url'
}

export interface Benefit {
  benefitCatalogDetail?: Maybe<BenefitCatalogDetail>;
  catalogId: Scalars['Int']['output'];
  certCatalogId: Scalars['Int']['output'];
  claimDate?: Maybe<Scalars['CmDate']['output']>;
  claimed: Scalars['Boolean']['output'];
  cmcId: Scalars['Int']['output'];
  created: Scalars['CmDate']['output'];
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  id: Scalars['Int']['output'];
  status?: Maybe<BenefitStatus>;
  token?: Maybe<Scalars['String']['output']>;
  uniqueTokenInvalid?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface BenefitCatalog {
  /** Indicates the number of months the exam will be active/available. */
  activePeriod: Scalars['Short']['output'];
  benefitGroup?: Maybe<BenefitGroup>;
  certCatalogAssociationList?: Maybe<Array<Maybe<BenefitCcatAssoc>>>;
  /** Indicates the last date that a candidate is able to claim a granted benefit. */
  claimEndDate?: Maybe<Scalars['CmDate']['output']>;
  /** This value is used to override the default sorting, which is alphabetical. BenefitCatalog will sort by items with a DisplayOrder value, in that order, then alphabetically. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** This is a calculated field based off the latest of all associated ccat end dates. */
  endDate?: Maybe<Scalars['CmDate']['output']>;
  /** A non-unique token to be used with all benefits granted of this type. */
  globalToken?: Maybe<Scalars['String']['output']>;
  /** Defines how a benefit can be granted to a candidate. */
  grantType: BcatGrantType;
  id: Scalars['Int']['output'];
  /** The unique name of the benefit. */
  name: Scalars['String']['output'];
  /** The abbreviated name of the benefit. */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** When true, indicates that the benefit should be visible, even if there is no underlying cert. */
  pinned?: Maybe<Scalars['Boolean']['output']>;
  /** This is a calculated field based off the earliest of all associated ccat start dates. */
  startDate?: Maybe<Scalars['CmDate']['output']>;
  /** Defines the type of benefit. */
  type: BcatType;
  /** A url to be used to redirect candidates to if necessary by a benefit. */
  url?: Maybe<Scalars['String']['output']>;
  /** Indicates the last date candidates can view the benefit. */
  viewEndDate?: Maybe<Scalars['CmDate']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface BenefitCatalogDetail {
  /** Indicates the number of months the exam will be active/available. */
  activePeriod: Scalars['Short']['output'];
  /** A list of voucher counts by batch ID for a benefit catalog. */
  batchCounts?: Maybe<VoucherCountByBatch>;
  /** A list of batch IDs for a benefit catalog. Defaults to active only if nothing is specified. */
  batchList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  benefitGroup?: Maybe<BenefitGroup>;
  certCatalogAssociationList?: Maybe<Array<Maybe<BenefitCcatAssoc>>>;
  /** Indicates the last date that a candidate is able to claim a granted benefit. */
  claimEndDate?: Maybe<Scalars['CmDate']['output']>;
  dataProvider?: Maybe<DataProvider>;
  /** A set of objects that, if provided, allows localizing the description per culture per benefit. */
  description?: Maybe<Array<Maybe<DescriptionGqlType>>>;
  /** This value is used to override the default sorting, which is alphabetical. BenefitCatalog will sort by items with a DisplayOrder value, in that order, then alphabetically. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** This is a calculated field based off the latest of all associated ccat end dates. */
  endDate?: Maybe<Scalars['CmDate']['output']>;
  /** Count of expired vouchers available for a benefit catalog. */
  expiredVoucherCount?: Maybe<Scalars['Int']['output']>;
  /** A non-unique token to be used with all benefits granted of this type. */
  globalToken?: Maybe<Scalars['String']['output']>;
  /** Defines how a benefit can be granted to a candidate. */
  grantType: BcatGrantType;
  id: Scalars['Int']['output'];
  /** A set of objects that, if provided, allows localizing instructions per culture per benefit. */
  instructions?: Maybe<Array<Maybe<InstructionGqlType>>>;
  /** Count of invalidated vouchers available for a benefit catalog. */
  invalidatedVoucherCount?: Maybe<Scalars['Int']['output']>;
  /** The unique name of the benefit. */
  name: Scalars['String']['output'];
  /** The abbreviated name of the benefit. */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** When true, indicates that the benefit should be visible, even if there is no underlying cert. */
  pinned?: Maybe<Scalars['Boolean']['output']>;
  /** Count of remainng vouchers available for a benefit catalog. */
  remainingVoucherCount?: Maybe<Scalars['Int']['output']>;
  /** This is a calculated field based off the earliest of all associated ccat start dates. */
  startDate?: Maybe<Scalars['CmDate']['output']>;
  /** Count of total vouchers available for a benefit catalog. */
  totalVoucherCount?: Maybe<Scalars['Int']['output']>;
  /** Defines the type of benefit. */
  type: BcatType;
  /** A url to be used to redirect candidates to if necessary by a benefit. */
  url?: Maybe<Scalars['String']['output']>;
  /** Count of used vouchers available for a benefit catalog. */
  usedVoucherCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates the last date candidates can view the benefit. */
  viewEndDate?: Maybe<Scalars['CmDate']['output']>;
  /** A list of vouchers for a benefit catalog. */
  voucherList?: Maybe<Array<Maybe<Voucher>>>;
}


/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface BenefitCatalogDetailBatchCountsArgs {
  request: VoucherCountByBatchRequest;
}


/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface BenefitCatalogDetailBatchListArgs {
  request?: InputMaybe<BatchListRequest>;
}


/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface BenefitCatalogDetailVoucherListArgs {
  requestConfig?: InputMaybe<RequestConfig>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface BenefitCcatAssoc {
  bcaBcatId: Scalars['Int']['output'];
  bcaCcatId: Scalars['Int']['output'];
  certCatalog?: Maybe<CertCatalog>;
  /** The last day that this benefit catalog/cert catalog combination can be granted to a candidate. */
  grantEndDate?: Maybe<Scalars['CmDate']['output']>;
  /** The first day that this benefit catalog/cert catalog combination can be granted to a candidate. */
  grantStartDate?: Maybe<Scalars['CmDate']['output']>;
  id: Scalars['Int']['output'];
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface BenefitGroup {
  /** This value is used to override the default sorting, which is alphabetical. BenefitGroup will sort by items with a DisplayOrder value, in that order, then alphabetically. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  id: Scalars['Int']['output'];
  /** The name of the benefit. */
  name: Scalars['String']['output'];
}

export enum BenefitStatus {
  /** Active */
  Active = 'Active',
  /** Expired */
  Expired = 'Expired',
  /** Used */
  Used = 'Used'
}

/** Creates an exam appointment for the user */
export interface BookingRequest {
  /** Candidate id */
  cmcId: Scalars['Int']['input'];
  /** Unique exam code */
  examCode: Scalars['String']['input'];
  /** Appointment/slot hold id */
  holdId: Scalars['String']['input'];
}

export interface BulkCandidateMerge {
  results: Array<CandidateMergeResponse>;
}

export interface BulkCandidateMergeRequest {
  requests: Array<CandidateMergeRequest>;
}

export interface BulkCorruptExamRequest {
  corruptExamRequests: Array<InputMaybe<CorruptExamRequest>>;
}

export interface BulkCorruptExamResponse {
  exam?: Maybe<Exam>;
  examRegistrationNumber?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
}

export interface BulkCreateAffiliationRequest {
  /** Accepts an array of affiliation requests to create. Any errors will result in the whole request being rejected. */
  affiliationList?: InputMaybe<Array<InputMaybe<CreateAffiliationRequest>>>;
}

export interface BulkCreateCertCatalogMetadataRequest {
  /** The list of cert catalog metadata to create. */
  items: Array<CreateCertCatalogMetadataRequest>;
}

export interface BulkCreateCertLogicItemMetadataRequest {
  /** The list of cert logic item metadata to create. */
  items: Array<CreateCertLogicItemMetadataRequest>;
}

export interface BulkCreateCertRequirementCatalogMetadataRequest {
  /** The list of cert requirement catalog metadata to create. */
  items: Array<CreateCertRequirementCatalogMetadataRequest>;
}

export interface BulkCreateExamAuthorizationRequest {
  /** A list of exam authorizations to upsert. */
  createExamAuthorizationRequests: Array<InputMaybe<CreateExamAuthorizationRequest>>;
}

export interface BulkCreateExamCatalogMetadataRequest {
  /** The list of exam catalog metadata to create. */
  items: Array<CreateExamCatalogMetadataRequest>;
}

export interface BulkCreateExamItemCatalogRequest {
  excatId: Scalars['Int']['input'];
  itemList?: InputMaybe<Array<InputMaybe<CreateExamItemCatalogRequest>>>;
}

export interface BulkCreateExamSectionCatalogRequest {
  excatId: Scalars['Int']['input'];
  itemList?: InputMaybe<Array<InputMaybe<CreateExamSectionCatalogRequest>>>;
}

export interface BulkCreateMetadataAttributeRequest {
  /** The list of metadata attributes to create. */
  items: Array<CreateMetadataAttributeRequest>;
}

export interface BulkCreateMetadataItemRequest {
  /** The list of metadata items to create. */
  items: Array<CreateMetadataItemRequest>;
}

export interface BulkDeleteCertCatalogMetadataRequest {
  /** The list of cert catalog metadata IDs to delete. */
  ids: Array<Scalars['Int']['input']>;
}

export interface BulkDeleteCertLogicItemMetadataRequest {
  /** The list of cert logic item metadata IDs to delete. */
  ids: Array<Scalars['Int']['input']>;
}

export interface BulkDeleteCertRequirementCatalogMetadataRequest {
  /** The list of cert requirement catalog metadata IDs to delete. */
  ids: Array<Scalars['Int']['input']>;
}

export interface BulkDeleteExamCatalogMetadataRequest {
  /** The list of exam catalog metadata IDs to delete. */
  ids: Array<Scalars['Int']['input']>;
}

export interface BulkDeleteExamItemCatalogRequest {
  itemIdList: Array<InputMaybe<Scalars['Int']['input']>>;
}

export interface BulkDeleteExamSectionCatalogRequest {
  itemIdList: Array<InputMaybe<Scalars['Int']['input']>>;
}

export interface BulkDeleteMetadataAttributeRequest {
  /** The list of metadata attribute IDs to delete. */
  ids: Array<Scalars['Int']['input']>;
}

export interface BulkDeleteMetadataItemRequest {
  /** The list of metadata item IDs to delete. */
  ids: Array<Scalars['Int']['input']>;
}

export interface BulkExamValidation {
  dataProviderExternalId: Scalars['String']['output'];
  examRegistrationNumber: Scalars['String']['output'];
  examState: ExamState;
  note: Scalars['String']['output'];
  notifyCandidate?: Maybe<Scalars['Boolean']['output']>;
  updateStatus: ExamValidationUpdateStatus;
}

export interface BulkExamValidationRequest {
  examValidationList: Array<InputMaybe<ExamValidationRequest>>;
}

export interface BulkUpdateAffiliationRequest {
  /** Accepts an array of affiliation requests to update or create. Any errors will result in the whole request being rejected. */
  affiliationList?: InputMaybe<Array<InputMaybe<UpdateAffiliationRequest>>>;
}

export interface BulkUpdateCandidateAuxiliaryRequest {
  /** Accepts an array of candidate auxiliary update requests. */
  candidateUpdates?: InputMaybe<Array<InputMaybe<UpdateCandidateAuxiliaryRequest>>>;
}

export interface BulkUpdateCertCatalogMetadataRequest {
  /** The list of cert catalog metadata to update. */
  items: Array<UpdateCertCatalogMetadataRequest>;
}

export interface BulkUpdateCertLogicItemMetadataRequest {
  /** The list of cert logic item metadata to update. */
  items: Array<UpdateCertLogicItemMetadataRequest>;
}

export interface BulkUpdateCertRequirementCatalogMetadataRequest {
  /** The list of cert requirement catalog metadata to update. */
  items: Array<UpdateCertRequirementCatalogMetadataRequest>;
}

export interface BulkUpdateExamCatalogMetadataRequest {
  /** The list of exam catalog metadata to update. */
  items: Array<UpdateExamCatalogMetadataRequest>;
}

export interface BulkUpdateExamItemCatalogRequest {
  itemList?: InputMaybe<Array<InputMaybe<UpdateExamItemCatalogRequest>>>;
}

export interface BulkUpdateExamSectionCatalogRequest {
  itemList?: InputMaybe<Array<InputMaybe<UpdateExamSectionCatalogRequest>>>;
}

export interface BulkUpdateMetadataAttributeRequest {
  /** The list of metadata attributes to update. */
  items: Array<UpdateMetadataAttributeRequest>;
}

export interface BulkUpdateMetadataItemRequest {
  /** The list of metadata items to update. */
  items: Array<UpdateMetadataItemRequest>;
}

export enum BulkUploadCommunityIdUpdateStatus {
  /** CommunityIdAlreadyExists */
  CommunityIdAlreadyExists = 'CommunityIdAlreadyExists',
  /** DuplicateCommunityId */
  DuplicateCommunityId = 'DuplicateCommunityId',
  /** IdAddedSuccessfully */
  IdAddedSuccessfully = 'IdAddedSuccessfully',
  /** SnowIdNotFound */
  SnowIdNotFound = 'SnowIdNotFound'
}

export interface BulkUploadExamRequest {
  examRequests: Array<InputMaybe<UploadExamRequest>>;
}

/** Request parameters for bulk uploading fulfillment vouchers */
export interface BulkUploadFulfillmentVoucherRequest {
  /** Optional batch identifier to group the vouchers together */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** Optional expiration date for the vouchers. If not provided, vouchers will never expire */
  expireDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** The ID of the fulfillment catalog to associate the vouchers with */
  fcatId?: InputMaybe<Scalars['Int']['input']>;
  /** List of voucher codes to be uploaded */
  voucherIds: Array<InputMaybe<Scalars['String']['input']>>;
}

export interface BulkUpsertAffiliationRequest {
  /** Accepts an array of affiliation requests to create or update. Any errors will result in the whole request being rejected. */
  affiliationList?: InputMaybe<Array<InputMaybe<UpsertAffiliationRequest>>>;
}

export interface BulkUpsertExamItemCatalogRequest {
  excatId: Scalars['Int']['input'];
  itemList?: InputMaybe<Array<InputMaybe<UpsertExamItemCatalogRequest>>>;
}

export interface BulkUpsertExamSectionCatalogRequest {
  excatId: Scalars['Int']['input'];
  itemList?: InputMaybe<Array<InputMaybe<UpsertExamSectionCatalogRequest>>>;
}

export interface BulkVoucherInvalidateRequest {
  batchId: Scalars['String']['input'];
  bcatId: Scalars['Int']['input'];
  reassign?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface BulkVoucherUpload {
  batchId?: Maybe<Scalars['String']['output']>;
  bcatId: Scalars['Int']['output'];
  inactiveDate?: Maybe<Scalars['CmDate']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
}

export interface BulkVoucherUploadRequest {
  batchId: Scalars['String']['input'];
  bcatId: Scalars['Int']['input'];
  voucherList: Array<InputMaybe<VoucherUploadRequest>>;
}

export enum CeVoucherBatchDetailsStatus {
  /** Expired */
  Expired = 'Expired',
  /** Redeemed */
  Redeemed = 'Redeemed',
  /** Revoked */
  Revoked = 'Revoked',
  /** Valid */
  Valid = 'Valid'
}

/**
 * The current data for a candidate account.
 * 
 * 
 *  - Requires All Features: CandidateProfile
 * 
 *  - Must have candidate access
 *
 */
export interface Candidate {
  /**
   * True when the address is considered bad for some reason. Either core data is missing or some entity/process has flagged the data as bad.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1Bad: Scalars['Boolean']['output'];
  /**
   * When true, the address is for a business. Otherwise, the address is residential.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1Business: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1City?: Maybe<Scalars['String']['output']>;
  /**
   * A 3-char ISO-3166-1 code.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1CountryCode?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1FaxNumber?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1Line1?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1Line2?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1Line3?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1PhoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1PostalCode?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1State?: Maybe<Scalars['String']['output']>;
  /**
   * True when the address is considered bad for some reason. Either core data is missing or some entity/process has flagged the data as bad.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2Bad: Scalars['Boolean']['output'];
  /**
   * When true, the address is for a business. Otherwise, the address is residential.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2Business: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2City?: Maybe<Scalars['String']['output']>;
  /**
   * A 3-char ISO-3166-1 code.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2CountryCode?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2FaxNumber?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2Line1?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2Line2?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2Line3?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2PhoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2PostalCode?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.View
   *
   */
  addr2State?: Maybe<Scalars['String']['output']>;
  /** Shows information about the candidate and the entity they affiliate with as defined by the client Affiliation list. */
  affiliation?: Maybe<CandidateAffiliation>;
  /** The attributes for the candidate. These are free-form text entry (name/value pair) items. */
  attributes?: Maybe<Array<Maybe<CandidateAttribute>>>;
  /** The un-versioned portion of the core candidate data. */
  auxiliaryData?: Maybe<CandidateAuxiliary>;
  /** The CertMetrics Candidate Id. It is usually better to use an external Id (use the Identification field) since those do not incur merge-related complications. */
  cmcId: Scalars['Int']['output'];
  /**
   * The name of the company with which the candidate indicates they are affiliated with or work for. This is not used when the Affiliation feature is on.
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  companyName?: Maybe<Scalars['String']['output']>;
  /**
   * The date of birth of the candidate.
   * 
   * 
   *  - Requires All Features: CandidateProfileDateOfBirth
   * 
   *  - Requires All Permissions: Candidate.DateOfBirth.View
   *
   */
  dateOfBirth?: Maybe<Scalars['CmDate']['output']>;
  /**
   * Lists the external Id data for the account. The default is to return only the preferred Id on the default data provider for the account used to access this field. If Show client primary id feature is On then return only the preferred Id on the primary data provider for the account used to access this field.
   * 
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryInformation.View, ViewCandidateExternalIds.View
   *
   */
  displayId?: Maybe<CandidateExternalId>;
  /**
   * When this revision became effective.
   * 
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  effective: Scalars['CmDateTimeOffset']['output'];
  /**
   * The email address of the candidate.
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * Does this candidate have a password?
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   */
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Lists the external Id data for the account. The default is to return only the preferred Id on the default data provider for the account used to access this field.
   * 
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryInformation.View, ViewCandidateExternalIds.View
   *
   */
  identificationList?: Maybe<Array<Maybe<CandidateExternalId>>>;
  /**
   * Info about the import data provider; NULL means this revision was not from an import process.
   * 
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  importDataProvider?: Maybe<DataProvider>;
  /**
   * The Id of the data provider where this revision came from; NULL means it was not from an import process.
   * 
   *  - Disallowed Account Types: Candidate
   * 
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  importDpId?: Maybe<Scalars['Int']['output']>;
  /**
   * The file this revision was imported from; NULL means it was not from an import process.
   * 
   *  - Disallowed Account Types: Candidate
   * 
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  importSource?: Maybe<Scalars['String']['output']>;
  /**
   * True when the address is considered bad for some reason. Either core data is missing or some entity/process has flagged the data as bad.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.View
   *
   */
  locAddr1Bad: Scalars['Boolean']['output'];
  /**
   * The localized version of the corresponding Addr1 data. Used only for printed fulfillment.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.View
   *
   */
  locAddr1City?: Maybe<Scalars['String']['output']>;
  /**
   * The localized version of the corresponding Addr1 data. Used only for printed fulfillment.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.View
   *
   */
  locAddr1Line1?: Maybe<Scalars['String']['output']>;
  /**
   * The localized version of the corresponding Addr1 data. Used only for printed fulfillment.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.View
   *
   */
  locAddr1Line2?: Maybe<Scalars['String']['output']>;
  /**
   * The localized version of the corresponding Addr1 data. Used only for printed fulfillment.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.View
   *
   */
  locAddr1Line3?: Maybe<Scalars['String']['output']>;
  /**
   * The localized version of the corresponding Addr1 data. Used only for printed fulfillment.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.View
   *
   */
  locAddr1PostalCode?: Maybe<Scalars['String']['output']>;
  /**
   * The localized version of the corresponding Addr1 data. Used only for printed fulfillment.
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.View
   *
   */
  locAddr1State?: Maybe<Scalars['String']['output']>;
  /**
   * The localized version of the CompanyName data. Used only for printed fulfillment.
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedInformation.View
   *
   */
  locCompanyName?: Maybe<Scalars['String']['output']>;
  /**
   * The localized version of the NameFirst data. Used for printed fulfillment and other non-authoritative locations, depending on client need.
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedInformation.View
   *
   */
  locNameFirst?: Maybe<Scalars['String']['output']>;
  /**
   * The localized version of the NameLast data. Used for printed fulfillment and other non-authoritative locations, depending on client need.
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedInformation.View
   *
   */
  locNameLast?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  nameFirst: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  nameInvalid: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  nameLast: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationPreferredName
   * 
   *  - Requires All Permissions: CandidateProfile.PreferredName.View
   *
   */
  preferredNameFirst?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationPreferredName
   * 
   *  - Requires All Permissions: CandidateProfile.PreferredName.View
   *
   */
  preferredNameLast?: Maybe<Scalars['String']['output']>;
  /** The internal row Id of the dmgr revision. */
  rowId: Scalars['Int']['output'];
  /**
   * The date this revision was created/updated in the system; this is often different than EffectiveStarts, especially when the data came from an external source.
   * 
   *  - Disallowed Account Types: Candidate
   * 
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  updated: Scalars['CmDateTimeOffset']['output'];
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   * 
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  updator?: Maybe<Scalars['String']['output']>;
}


/**
 * The current data for a candidate account.
 * 
 * 
 *  - Requires All Features: CandidateProfile
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateDisplayIdArgs {
  request?: InputMaybe<CandidateExternalIdListRequestVmGqlType>;
}


/**
 * The current data for a candidate account.
 * 
 * 
 *  - Requires All Features: CandidateProfile
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateIdentificationListArgs {
  request?: InputMaybe<CandidateExternalIdListRequestVmGqlType>;
}

/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccount {
  /**
   * A list of Candidate badges from Accredible.
   * 
   * 
   *  - Requires All Features: ShareAccredibleBadging
   * 
   *  - Requires All Permissions: AccredibleBadging.Catalog.View
   *
   */
  accredibleCandidateBadgeList?: Maybe<Array<Maybe<AccredibleCandidateBadgeResponseGqlType>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliationRequired
   * 
   *  - Requires All Permissions: Candidate.Affiliation.View
   *
   */
  affiliationUpdateRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The attributes for the account. These are free-form text entry (name/value pair) items.
   * @deprecated This field has been deprecated. Use the Attributes field on the Candidate type instead.
   */
  attributes?: Maybe<Array<Maybe<CandidateAttribute>>>;
  /**
   * The un-versioned portion of the core candidate data.
   * @deprecated Moved to candidate so this data is accessible in search results
   */
  auxiliaryData?: Maybe<CandidateAuxiliary>;
  /** Gives details for a specific badge. ExternalId  maps to the open badge standard of UID. */
  badgeDetail?: Maybe<BadgeDetail>;
  /** Gives a list of this users badges */
  badgeList?: Maybe<Array<Maybe<Badge>>>;
  /**
   * Information about a single Benefit record on a Candidate account.
   * 
   * 
   *  - Requires All Features: Benefit
   *
   */
  benefitDetail?: Maybe<Benefit>;
  /**
   * Benefit List
   * 
   * 
   *  - Requires All Features: Benefit
   *
   */
  benefitList?: Maybe<Array<Maybe<Benefit>>>;
  /** Whether a candidate can freely update their date of birth. */
  canUpdateDob?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a candidate can freely update their own name. */
  canUpdateName?: Maybe<Scalars['Boolean']['output']>;
  /** This is the main Candidate object that contains profile and account setting information. */
  candidate?: Maybe<Candidate>;
  /**
   * A flag for determining if the candidate's email needs confirming.
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationRequireEmailConfirmation
   *
   */
  candidateEmailConfirmationRequired: Scalars['Boolean']['output'];
  /**
   * A flag for determining if the candidate's name needs verifying.
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationRequireNameVerification
   *
   */
  candidateNameVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** All previous and current versions of this candidate. */
  candidateVersionList?: Maybe<Array<Maybe<Candidate>>>;
  /**
   * Indicates if this candidate has signed the latest agreement.
   * 
   * 
   *  - Requires All Features: CredentialAgreementAtLogin
   * 
   *  - Requires All Permissions: Candidate.CredentialAgreements.View
   *
   */
  certAgreementRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates the status of the candidate's current agreement.
   * 
   * 
   *  - Requires All Features: CredentialAgreement
   *
   */
  certAgreementStatus?: Maybe<CertAgreementStatus>;
  /** Detailed information about a single Cert record on a Candidate account. */
  certDetail?: Maybe<CertDetail>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  certHistoryList?: Maybe<Array<Maybe<CertHistory>>>;
  /** The list of certifications on the candidate account. This can include started, active, suspended, and expired certifications. */
  certList?: Maybe<Array<Maybe<Cert>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.CredentialDetails.View
   *
   */
  certProcessRequestList?: Maybe<Array<Maybe<CertProcessRequest>>>;
  /** Returns one specific 'other requirement' on the candidate account. Other requirements are defined as requirements that can be used toward certification but are not exams or certifications. Other requirements include fees, agreements, training, etc. */
  certRequirementDetail?: Maybe<CertRequirementDetail>;
  /** Returns the list of 'other requirements' on the candidate account. Other requirements are defined as requirements that can be used toward certification but are not exams or certifications. Other requirements include fees, agreements, training, etc. */
  certRequirementList?: Maybe<Array<Maybe<CertRequirement>>>;
  cmcId: Scalars['Int']['output'];
  /**
   * Returns the list of exams that have been used toward recertification with exam points, or are currently counting toward current recertification progress. Specifically excludes exams that were only used for initial certification.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducationCEProgress
   * 
   *  - Requires All Permissions: Candidate.Exams.View
   *
   */
  continuingEducationExamList?: Maybe<Array<Maybe<Exam>>>;
  /**
   * The list of credly badges on the candidate account.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Permissions: Credly.Admin.View
   *
   */
  credlyBadgeList?: Maybe<Array<Maybe<CredlyBadge>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileDateOfBirth
   * 
   *  - Requires All Permissions: Candidate.DateOfBirth.View
   *
   */
  dateOfBirthInvalid: Scalars['Boolean']['output'];
  dpExternalId?: Maybe<Scalars['String']['output']>;
  /**
   * The list of electronic transactions made by the candidate.
   * 
   * 
   *  - Requires All Features: Ecommerce, EcommerceShowTransactionHistory
   * 
   *  - Requires All Permissions: Ecommerce.Transactions.View
   *
   */
  eTransactionList?: Maybe<Array<Maybe<ETransaction>>>;
  /** A list of the exam catalog entries a candidate can schedule for. */
  eligibleExamList?: Maybe<Array<Maybe<EligibleExam>>>;
  /**
   * Shows detailed information on a specific email request.
   * 
   * 
   *  - Requires All Permissions: Candidate.EmailHistory.View
   *
   */
  emailRequestDetail?: Maybe<EmailRequestDetail>;
  /**
   * Shows a list of email requests associated with this candidate account.
   * 
   * 
   *  - Requires All Permissions: Candidate.EmailHistory.View
   *
   */
  emailRequestList?: Maybe<Array<Maybe<EmailRequest>>>;
  /**
   * Returns the list of exam accomm packs on the candidate account.
   * 
   * 
   *  - Requires All Features: ExamAccommodations
   * 
   *  - Requires All Permissions: Exam.Accommodations.View
   *
   */
  examAccommPackDetail?: Maybe<ExamAccommPackDetail>;
  /**
   * Returns the list of exam accomm packs on the candidate account.
   * 
   * 
   *  - Requires All Features: ExamAccommodations
   * 
   *  - Requires All Permissions: Exam.Accommodations.View
   *
   */
  examAccommPackList?: Maybe<Array<Maybe<ExamAccommPack>>>;
  /**
   * A list of the exam authorization packs (eligibilities) for a candidate.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamAuthorization
   * 
   *  - Requires All Permissions: Exam.Authorizations.View
   *
   */
  examAuthorizationPackList?: Maybe<Array<Maybe<ExamAuthorizationPack>>>;
  /** Detailed information about a single Exam record on a Candidate account. */
  examDetail?: Maybe<ExamDetail>;
  /** Shows a list of exam events associated with this candidate account. */
  examEventList?: Maybe<Array<Maybe<ExamEvent>>>;
  /** Returns the list of exam images. */
  examImageList?: Maybe<Array<Maybe<ExamImage>>>;
  /**
   * Returns the list of exams on the candidate account. Exams may be active, expired, invalidated, hidden, under review, etc.
   * 
   * 
   *  - Requires All Permissions: Candidate.Exams.View
   *
   */
  examList?: Maybe<Array<Maybe<Exam>>>;
  /**
   * Returns the list of exam violations on the candidate account.
   * 
   * 
   *  - Requires All Permissions: Candidate.Exams.View
   *
   */
  examViolationList?: Maybe<Array<Maybe<ExamViolation>>>;
  /** A list of the exam vouchers for this candidate. */
  examVoucherList?: Maybe<Array<Maybe<ExamVoucher>>>;
  externalId?: Maybe<Scalars['String']['output']>;
  /**
   * A list of exam catalogs that an authorization can be manually granted for.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamAuthorization
   * 
   *  - Requires All Permissions: Exam.Authorizations.View
   *
   */
  grantableExamAuthorizationPackList?: Maybe<Array<Maybe<ExamCatalog>>>;
  /**
   * Shows detailed information on a specific candidate history entry.
   * 
   *  - Disallowed Account Types: Candidate
   */
  historyDetail?: Maybe<CandidateHistoryDetail>;
  /**
   * Shows a list of this candidates history entries.
   * 
   *  - Disallowed Account Types: Candidate
   */
  historyList?: Maybe<Array<Maybe<CandidateHistory>>>;
  /** The last date this candidate certified or extended a cert */
  lastCertification?: Maybe<Scalars['CmDate']['output']>;
  /**
   * Indicates if this candidate has signed the latest agreement within the required number of days.
   * 
   * 
   *  - Requires All Features: CredentialLogoDownloadAgreement
   *
   */
  logoAgreementRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Shows a list of this candidates merge history entries.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.MergeHistory.View
   *
   */
  mergeHistoryList?: Maybe<Array<Maybe<CandidateMerge>>>;
  /**
   * 
   * 
   * 
   *  - Requires Any Features: CandidateProfileAddressesPrimaryRequireMinimum, CandidateAccessIntegrationEgressPearsonVue
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  minimumPrimaryAddressInformationRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires Any Features: CandidateProfilePrimaryInformationRequireMinimum, CandidateAccessIntegrationEgressPearsonVue
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  minimumPrimaryProfileInformationRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  nameUpdateRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A list of OtherAchievements for this candidate.
   * 
   * 
   *  - Requires All Features: CandidateAccessLoginEMCOtherAchievements
   * 
   *  - Requires All Permissions: Candidate.OtherAchievement.View
   *
   */
  otherAchievementList?: Maybe<Array<Maybe<CandidateOtherAchievementResponse>>>;
  /**
   * Paddle subscription data for the candidate.
   * 
   * 
   *  - Requires All Features: CandidateAccessIntegrationEgressTestrun
   *
   */
  paddleData?: Maybe<PaddleData>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialFulfillment
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.View
   *
   */
  pendingFulfillmentDmgr?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialFulfillment
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.View
   *
   */
  pendingFulfillmentRequeue?: Maybe<Scalars['Boolean']['output']>;
  /** Shows detailed information on a specific fulfillment. */
  physicalFulfillmentDetail?: Maybe<PhysicalFulfillmentDetail>;
  /** Shows a list of this candidates physical fulfillments. */
  physicalFulfillmentList?: Maybe<Array<Maybe<PhysicalFulfillment>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  primaryInformationUpdateRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A list of the transaction catalogs for this candidate.
   * 
   * 
   *  - Requires All Features: Ecommerce
   * 
   *  - Requires All Permissions: Ecommerce.Catalog.View
   *
   */
  purchaseableETransactionCatalogList?: Maybe<Array<Maybe<EtransactionItemCatalog>>>;
  /**
   * The list of certifications on the candidate account that expired within the last 90 days and are eligible for extension.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation, CredentialComptiaSelfExtend
   *
   */
  recentlyExpiredCECertList?: Maybe<Array<Maybe<Cert>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileCustomDataAttributes
   * 
   *  - Requires All Permissions: Candidate.SponsorSettings.Attributes.View
   *
   */
  requiredAttributesMissing?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileCustomDataSettings
   * 
   *  - Requires All Permissions: Candidate.SponsorSettings.Settings.View
   *
   */
  requiredSettingsMissing?: Maybe<Scalars['Boolean']['output']>;
  /** The selected custom settings (AKA candidate list associations) for the account. */
  settings?: Maybe<Array<Maybe<CandidateSettingAssoc>>>;
  /** Shows detailed information on a specific candidate transcript. */
  transcriptDetail?: Maybe<CandidateTranscriptDetail>;
  /** Shows a list of this candidates transcripts. */
  transcriptList?: Maybe<Array<Maybe<CandidateTranscript>>>;
  /**
   * Shows a list of this candidates history entries. Optionally syncs Zendesk ticket history on request.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CandidateProfileZendeskHistory
   *
   */
  zendeskEnabledHistoryList?: Maybe<Array<Maybe<CandidateHistory>>>;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountBadgeDetailArgs {
  request: RequestByExternalId;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountBenefitDetailArgs {
  request: RequestById;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountCertDetailArgs {
  request: RequestById;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountCertHistoryListArgs {
  request: CandidateCertHistoryListRequest;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountCertListArgs {
  request?: InputMaybe<CertListRequest>;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountCertRequirementDetailArgs {
  request: RequestByIdOrExternalId;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountCertRequirementListArgs {
  request?: InputMaybe<CertRequirementListRequest>;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountEligibleExamListArgs {
  request?: InputMaybe<RequestConfig>;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountEmailRequestDetailArgs {
  request: RequestById;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountExamAccommPackDetailArgs {
  request: RequestById;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountExamDetailArgs {
  request: RequestById;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountExamListArgs {
  request?: InputMaybe<ExamListRequest>;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountHistoryDetailArgs {
  request: RequestById;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountPhysicalFulfillmentDetailArgs {
  request: RequestByIdOrExternalId;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountPurchaseableETransactionCatalogListArgs {
  request?: InputMaybe<RequestConfig>;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountTranscriptDetailArgs {
  request: RequestByIdOrExternalId;
}


/**
 * 
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAccountZendeskEnabledHistoryListArgs {
  request: ZendeskEnabledHistoryListRequest;
}

/**
 * When the Candidate Affiliation feature is enabled, shows more information about the entity the candidate is affiliated with.
 * 
 * 
 *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
 * 
 *  - Requires All Permissions: Candidate.Affiliation.View
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAffiliation {
  /** A unique identifier for the candidate at the affiliated entity. */
  affiliateId?: Maybe<Scalars['String']['output']>;
  /** Provides more information about the Affiliation definition. */
  affiliationCatalog?: Maybe<AffiliationCatalog>;
  /** The email address the candidate uses as part of the affiliated entity. */
  email?: Maybe<Scalars['String']['output']>;
  /** Primary key for the Affiliation that the candidated has selected that they are affiliated with. */
  id?: Maybe<Scalars['Int']['output']>;
  /** This value can only be set if the OtherFormat of the Affiliation indicates that the candidate needs to enter a free-form Affiliation name, as the entity they are affiliated with is not found. */
  otherAffiliationName?: Maybe<Scalars['String']['output']>;
}

/**
 * This is a client-defined name/value pair value stored on a candidate account.
 * 
 * 
 *  - Requires All Features: CandidateProfileCustomDataAttributes
 * 
 *  - Requires All Permissions: Candidate.SponsorSettings.Attributes.View
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAttribute {
  /** The catalog/definition of the item when one has been defined. */
  attributeCatalog?: Maybe<CandidateAttributeCatalog>;
  cmcId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** The name/key as defined by the client. */
  name: Scalars['String']['output'];
  updated: Scalars['CmDateTimeOffset']['output'];
  /** The arbitrary value to store. */
  value?: Maybe<Scalars['String']['output']>;
}

/**
 * This stores an arbitrary, candidate-specific collection of name-value pairs. The names are unique per-candidate.
 * 
 * 
 *  - Requires All Features: CandidateProfileCustomDataAttributes
 *
 */
export interface CandidateAttributeCatalog {
  /** True if the candidate can edit their data for this attribute */
  candidateEdit?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True if the candidate can see their data for this attribute.
   * 
   *  - Disallowed Account Types: Candidate
   */
  candidateView?: Maybe<Scalars['Boolean']['output']>;
  /** For descriptive text to say what the attribute is for (and what rules should be followed when entering information for it). Null for no description. */
  description?: Maybe<Scalars['String']['output']>;
  /** A regular expression describing the format values must be in when editing */
  format?: Maybe<Scalars['String']['output']>;
  /** Determines if the stored value is interpreted/used as either a datetime or just a date */
  formatDateTime?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** What is displayed on the web for the attribute; null means use the name. */
  label?: Maybe<Scalars['String']['output']>;
  /** Matches the CandidateAttribute Name */
  name: Scalars['String']['output'];
  /** True if this attribute is required when creating or updating candidate attributes */
  required: Scalars['Boolean']['output'];
  /**
   * True if a user with edit-permissions can edit data for this attribute on candidates.
   * 
   *  - Disallowed Account Types: Candidate
   */
  userEdit?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True if a user with view-permissions can see data for this attribute on candidates. 
   * 
   *  - Disallowed Account Types: Candidate
   */
  userView?: Maybe<Scalars['Boolean']['output']>;
}

/**
 * This is used to indicate how to search for a candidate account by attribute data. All fields must be specifed. Only exact matches are returned.
 * 
 * 
 *  - Requires All Features: CandidateProfileCustomDataAttributes
 * 
 *  - Requires All Permissions: Candidate.Search, Candidate.SponsorSettings.Attributes.View
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAttributeSearchRequest {
  /** The name of the candidate attribute. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The value of the candidate attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

/** Represents the audit history for a specific candidate. */
export interface CandidateAuditHistory {
  /** List of audit items associated with the audit */
  auditItems?: Maybe<Array<Maybe<CreqAuditItem>>>;
  /** The candidate ID being audited. */
  cmcId: Scalars['Int']['output'];
  /** The date when the audit was completed. */
  completed?: Maybe<Scalars['DateTime']['output']>;
  /** The due date for the audit. */
  due?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the audit record. */
  id: Scalars['Int']['output'];
  /** Indicates if the audit is currently on hold. */
  onHold: Scalars['Boolean']['output'];
  /** The date when the audit was started. */
  started?: Maybe<Scalars['DateTime']['output']>;
  /** The audit status. */
  status: CandidateAuditHistoryStatus;
  /**
   * The web user assigned to this audit.
   * 
   *  - Disallowed Account Types: Candidate
   */
  user?: Maybe<WebUser>;
}

/** Request parameters for retrieving audit history for a specific candidate. */
export interface CandidateAuditHistoryRequest {
  /** The candidate ID for which to retrieve audit history. */
  cmcId?: InputMaybe<Scalars['Int']['input']>;
}

export enum CandidateAuditHistoryStatus {
  /** Closed */
  Closed = 'Closed',
  /** InQueue */
  InQueue = 'InQueue',
  /** New */
  New = 'New',
  /** OnHold */
  OnHold = 'OnHold',
  /** PastDue */
  PastDue = 'PastDue'
}

/**
 * The part of the Candidate entity/profile that is not versioned. Contains settings and other static options used on the Candidate account.
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateAuxiliary {
  /**
   * Before this date, the candidate is banned from accessing the system.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.BannedStatus.View
   *
   */
  bannedUntil?: Maybe<Scalars['CmDate']['output']>;
  /**
   * When true, the badges are enabled to be verified for the Candidate in the Open Badging feature. This should not be true unless the OpenBadgeIdentity property is set.
   * 
   * 
   *  - Requires All Features: ShareCertMetricsBadging
   * 
   *  - Requires All Permissions: Candidate.CertMetricsBadging.View
   *
   */
  certMetricsBadgingEnabled: Scalars['Boolean']['output'];
  /**
   * This is the unique recipient identity value (email) used when a Candidate is asserting badges in the Open Badge feature.
   * 
   * 
   *  - Requires All Features: ShareCertMetricsBadging
   * 
   *  - Requires All Permissions: Candidate.CertMetricsBadging.View
   *
   */
  certMetricsBadgingIdentity?: Maybe<Scalars['String']['output']>;
  cmcId?: Maybe<Scalars['Int']['output']>;
  /** The candidate creation date */
  created?: Maybe<Scalars['DateTimeOffset']['output']>;
  /**
   * When this value is true, the Candidate profile is not allowed to be updated by the import process.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.ImportSettings.View
   *
   */
  dmgrProtected: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.EmailPreferences.View
   *
   */
  emailLanguage: Scalars['String']['output'];
  /**
   * When this value is true, the import process will not update the email field on the Candidate profile.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.ImportSettings.View
   *
   */
  emailProtected: Scalars['Boolean']['output'];
  /**
   * This is a hint that can be used in the forgot-password feature. If this is set, the ForgotPwdPhrase will also be set. These two values will be different if set.
   * 
   * 
   *  - Requires All Features: CandidateAccessLogin
   * 
   *  - Requires All Permissions: Candidate.SecuritySettings.View
   *
   * @deprecated Password hint and phrase are no longer permitted as password reset methods.
   */
  forgotPwdHint?: Maybe<Scalars['String']['output']>;
  /**
   * This is a phrase that can be used in the forgot-password feature. If this is set, the ForgotPwdHint will also be set. These two values will be different if set.
   * 
   * 
   *  - Requires All Features: CandidateAccessLogin
   * 
   *  - Requires All Permissions: Candidate.SecuritySettings.View
   *
   * @deprecated Password hint and phrase are no longer permitted as password reset methods.
   */
  forgotPwdPhrase?: Maybe<Scalars['String']['output']>;
  /**
   * True when the candidate is presently banned.
   * 
   * 
   *  - Requires All Permissions: Candidate.BannedStatus.View
   *
   */
  isBanned?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the candidate is presently on the watch list.
   * 
   * 
   *  - Requires All Permissions: Candidate.WatchStatus.View
   *
   */
  isWatched?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When this value is true, the import process will not update the English name fields on the Candidate profile.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.ImportSettings.View
   *
   */
  nameProtected: Scalars['Boolean']['output'];
  /**
   * When this is true, the system will only send emails for emcats where the trigger is the Candidate themselves, where the emcat is required to use the system.
   * 
   * 
   *  - Requires All Features: CandidatePreferencesDisableEmails
   * 
   *  - Requires All Permissions: Candidate.EmailPreferences.Toggle.View
   *
   */
  restrictEmcats?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, badges are not processed or sent to external systems. This does not affect the Open Badging feature that is hosted by CertMetrics.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires Any Features: ShareCredlyBadging, ShareAccredibleBadging
   * 
   *  - Requires Any Permissions: Candidate.CredlyBadgingSettings.View, AccredibleBadging.CandidateSettings.View
   *
   */
  restrictExternalBadging: Scalars['Boolean']['output'];
  /**
   * When true, the candidate is only able to test at a test center.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamTestCenterRestriction
   * 
   *  - Requires All Permissions: Candidate.RestrictTestingStatus.View, Candidate.RestrictTestingStatus.Modify
   *
   */
  restrictTesting: Scalars['Boolean']['output'];
  /**
   * This field is used in the merge process. When true, this indicates that the Candidate has been determined to be a unique Candidate and should not be merged into another Candidate Account.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: MergeCandidates
   * 
   *  - Requires All Permissions: Candidate.MergeSettings.View
   *
   */
  unique: Scalars['Boolean']['output'];
  updated: Scalars['CmDateTimeOffset']['output'];
  updator?: Maybe<Scalars['String']['output']>;
  /**
   * Before this date, the candidate is on a watch list and their data may be treated differently in the system.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.WatchStatus.View
   *
   */
  watchUntil?: Maybe<Scalars['CmDate']['output']>;
}

export interface CandidateCertHistoryListRequest {
  manualGrantsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * This is used to indicate how to search for a candidate account by demographics data. At least one field must be specified, and all specified fields must match for an account to match the search.
 * 
 * 
 *  - Requires All Permissions: Candidate.Search
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateDemographicsSearchRequest {
  /**
   * Specify this to search by the city value on the candidate's primary address.
   * 
   * 
   *  - Requires Any Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1City?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify this to search by the ISO country code value on the candidate's primary address.
   * 
   * 
   *  - Requires Any Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1CountryCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify this to search by the state/province value on the candidate's primary address.
   * 
   * 
   *  - Requires Any Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryAddress.View
   *
   */
  addr1State?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify this to search by the candidate's first name.
   * 
   * 
   *  - Requires Any Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  nameFirst?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify this to search by the candidate's last name.
   * 
   * 
   *  - Requires Any Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  nameLast?: InputMaybe<Scalars['String']['input']>;
}

/** Contains the ExternalId, that externally identifies a candidate account, plus other metadata. */
export interface CandidateExternalId {
  created: Scalars['CmDateTimeOffset']['output'];
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  /** The unique Id (PK) of the data provider that 'owns' this external Id. This is considered the domain/context/scope within which the Id is unique. */
  dpId: Scalars['Int']['output'];
  /** This value uniquely identifies the candidate within the domain/context/scope of the indicated data provider. */
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Multiple different Ids may exist for a single candidate within the context of any given data provider, but only 1 will be marked as preferred. This is mostly so that a UI/export can have an easy way to pick which Id to render when multiple exist. */
  isPreferred: Scalars['Boolean']['output'];
}

export interface CandidateExternalIdListRequestVmGqlType {
  /** Specify true to receive Ids for any data provider. With false (the default), you only receive Ids for your account's default data provider. */
  allDps?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specify true to receive all Ids, not just the preferred one. With false (the default), you only recieve the preferred Id for each data provider included. */
  allIdsForEachDp?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CandidateGdprRequest {
  cmcId?: InputMaybe<Scalars['Int']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * The history for a candidate account.
 * 
 * 
 *  - Requires All Permissions: Candidate.History.View
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateHistory {
  cmcId: Scalars['Int']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  creator?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['Int']['output']>;
  type: ChistType;
}

/**
 * The history for a candidate account.
 * 
 * 
 *  - Requires All Permissions: Candidate.History.View
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateHistoryDetail {
  certRequirement?: Maybe<CertRequirement>;
  cmcId: Scalars['Int']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  creator?: Maybe<Scalars['String']['output']>;
  electronicFulfillment?: Maybe<ElectronicFulfillment>;
  exam?: Maybe<Exam>;
  id: Scalars['Int']['output'];
  identification?: Maybe<CandidateExternalId>;
  message?: Maybe<Scalars['String']['output']>;
  physicalFulfillment?: Maybe<PhysicalFulfillment>;
  targetId?: Maybe<Scalars['Int']['output']>;
  type: ChistType;
}

export interface CandidateIdRequest {
  /** The CertMetrics Candidate Id. When this is set, all other fields are ignored. */
  cmcId?: InputMaybe<Scalars['Int']['input']>;
  /** This is used to indicate what DataProvider (e.g. the provider representing the CertMetrics Client Candidate Id or a testing vendor) to search for the specified ExternalId. If this is not set, the default DataProvider for your account is used (most commonly the one that is for the CertMetrics Client Candidate Id, which is usually the login Id. */
  dpExternalId?: InputMaybe<Scalars['String']['input']>;
  /** A unique Id that indirectly identifies a candidate account. E.g. the Id the candidate uses to login or the candidate's Id at a testing vendor. */
  externalId?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: MergeCandidates
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateMerge {
  approver?: Maybe<Scalars['String']['output']>;
  created: Scalars['CmDateTimeOffset']['output'];
  dataProvider?: Maybe<DataProvider>;
  id: Scalars['Int']['output'];
  /** This is snapshotted data, so resolved fields may not function as expected. */
  loserCandidate?: Maybe<Candidate>;
  loserCmcId?: Maybe<Scalars['Int']['output']>;
  loserIdentificationList?: Maybe<Array<Maybe<CandidateExternalId>>>;
  message?: Maybe<Scalars['String']['output']>;
  requestState: MergeRequestState;
  requestor?: Maybe<Scalars['String']['output']>;
  state: MergeState;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  winnerCandidate?: Maybe<Candidate>;
  winnerCmcId?: Maybe<Scalars['Int']['output']>;
  winnerIdentificationList?: Maybe<Array<Maybe<CandidateExternalId>>>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: MergeCandidates
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateMergeDetail {
  approver?: Maybe<Scalars['String']['output']>;
  created: Scalars['CmDateTimeOffset']['output'];
  dataProvider?: Maybe<DataProvider>;
  id: Scalars['Int']['output'];
  /** This is snapshotted data, so resolved fields may not function as expected. */
  loserAuxiliaryData?: Maybe<CandidateAuxiliary>;
  /** This is snapshotted data, so resolved fields may not function as expected. */
  loserCandidate?: Maybe<Candidate>;
  loserCertRequirementList?: Maybe<Array<Maybe<CertRequirement>>>;
  loserCmcId?: Maybe<Scalars['Int']['output']>;
  loserExamList?: Maybe<Array<Maybe<Exam>>>;
  loserIdentificationList?: Maybe<Array<Maybe<CandidateExternalId>>>;
  loserOverrides?: Maybe<Array<Maybe<CreateCandidateMergeLoserOverride>>>;
  message?: Maybe<Scalars['String']['output']>;
  requestState: MergeRequestState;
  requestor?: Maybe<Scalars['String']['output']>;
  state: MergeState;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  winnerAuxiliaryData?: Maybe<CandidateAuxiliary>;
  winnerCandidate?: Maybe<Candidate>;
  winnerCertRequirementList?: Maybe<Array<Maybe<CertRequirement>>>;
  winnerCmcId?: Maybe<Scalars['Int']['output']>;
  winnerExamList?: Maybe<Array<Maybe<Exam>>>;
  winnerIdentificationList?: Maybe<Array<Maybe<CandidateExternalId>>>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: MergeCandidatesCandidateSelfMerge, MergeCandidates
 * 
 *  - Requires All Permissions: MergeList.View
 *
 */
export interface CandidateMergeListRequest {
  /** If true, only returns merge requests that were initiated by a candidate. */
  candidateRequestedOnly: Scalars['Boolean']['input'];
}

export interface CandidateMergeRequest {
  loserCandidateId: Scalars['String']['input'];
  winnerCandidateId: Scalars['String']['input'];
}

export interface CandidateMergeResponse {
  loserCandidateId?: Maybe<Scalars['String']['output']>;
  messages: Array<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  winnerCandidateId?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CandidateAccessLoginEMCOtherAchievements
 *
 */
export interface CandidateOtherAchievement {
  activeDate: Scalars['DateTime']['output'];
  catalogId?: Maybe<Scalars['Int']['output']>;
  cmcId?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  funded?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  verification?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CandidateAccessLoginEMCOtherAchievements
 *
 */
export interface CandidateOtherAchievementResponse {
  activeDate: Scalars['DateTime']['output'];
  catalog?: Maybe<OtherAchievementCatalog>;
  cmcId?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  funded?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  otherAchievementId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<CandidateOtherAchievementState>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  verification?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
}

export enum CandidateOtherAchievementState {
  /** Active */
  Active = 'Active',
  /** Deleted */
  Deleted = 'Deleted',
  /** Expired */
  Expired = 'Expired'
}

/**
 * This is used to indicate how to search for a candidate account. Exactly one type of search must be specified per request.
 * 
 * 
 *  - Requires Any Features: CandidateProfile
 * 
 *  - Requires All Permissions: Candidate.Search
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateSearchRequest {
  /**
   * Specify this to search by the affiliation Id value (AKA: Employee Id.
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
   * 
   *  - Requires All Permissions: Candidate.Affiliation.View
   *
   */
  affiliationId?: InputMaybe<Scalars['String']['input']>;
  /** Specify this to search by a candidate attribute. */
  attribute?: InputMaybe<CandidateAttributeSearchRequest>;
  /** Specify this to search by a combination of candidate demographics data. */
  demographics?: InputMaybe<CandidateDemographicsSearchRequest>;
  /**
   * Specify this to search by email address or affiliation email address (if the feature is on).
   * 
   * 
   *  - Requires Any Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryInformation.View, Candidate.Affiliation.View
   *
   */
  emailAddr?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify this to search by an Exam Authorization Id (i.e. exam eligibilities).
   * 
   * 
   *  - Requires All Features: ExamAuthorization
   * 
   *  - Requires Any Permissions: Candidate.Exams.View
   *
   */
  examAuthorizationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify this to search by the Registration Id of an exam result.
   * 
   * 
   *  - Requires All Features: Exam
   * 
   *  - Requires Any Permissions: Candidate.Exams.View
   *
   */
  examRegistrationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify this to search by External Id (AKA: a Login Id).
   * 
   * 
   *  - Requires Any Permissions: CandidateProfile.PrimaryInformation.View
   *
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
}

export interface CandidateSecurityConfigurationGqlType {
  unparsedConfig?: Maybe<Scalars['String']['output']>;
}

/**
 * The association between a candidate account and a custom multiple-choice, single/multiple response option (AKA candidate list associations); this indicates the account has selected this item/option.
 * 
 * 
 *  - Requires All Features: CandidateProfileCustomDataSettings
 * 
 *  - Requires All Permissions: Candidate.SponsorSettings.Settings.View
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateSettingAssoc {
  cmcId: Scalars['Int']['output'];
  /** The date the selection was made and became effective.  */
  created: Scalars['CmDateTimeOffset']['output'];
  /**
   * Who made the change.
   * 
   *  - Disallowed Account Types: Candidate
   */
  creator?: Maybe<Scalars['String']['output']>;
  /** The item the candidate selected. */
  settingItem?: Maybe<SettingItem>;
  /** The item that the candidate selected (is assoicated with) */
  settingItemId: Scalars['Int']['output'];
}

/**
 * The candidate setting filter for users.
 * 
 * 
 *  - Requires All Features: CandidateProfileCustomDataSettings
 * 
 *  - Admin accounts only
 *
 */
export interface CandidateSettingFilter {
  /** The date the filter was created. */
  created: Scalars['DateTime']['output'];
  /** The id of the filter. */
  id: Scalars['Int']['output'];
  /** The name of the filter. */
  name: Scalars['String']['output'];
  /** All candidate settings associated with the filter. */
  settings?: Maybe<Array<Maybe<SettingItem>>>;
}

/**
 * Shows high-level information about the transcript.
 * 
 * 
 *  - Requires All Features: ShareTranscript
 * 
 *  - Requires All Permissions: Candidate.Transcripts.View
 * 
 *  - Must have candidate access
 *
 */
export interface CandidateTranscript {
  addrDisplay: CtranAddrDisplay;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowCredentials
   *
   */
  certDateOk: Scalars['Boolean']['output'];
  cmcId: Scalars['Int']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowOtherRequirements
   *
   */
  creqDateOk: Scalars['Boolean']['output'];
  disabled: Scalars['Boolean']['output'];
  displayMode: CtranDisplayMode;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationPreferredName
   *
   */
  displayPreferredName: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowExams
   *
   */
  examDateOk: Scalars['Boolean']['output'];
  expireDate: Scalars['CmDate']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageOk: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowCredentials
   *
   */
  includeAllCerts: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowOtherRequirements
   *
   */
  includeAllCreqs: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowExams
   *
   */
  includeAllExams: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowAchievements
   *
   */
  includeAllStandings: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lastView?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowAchievements
   *
   */
  standingsDateOk: Scalars['Boolean']['output'];
  views: Scalars['Int']['output'];
}

/**
 * Shows low-level and related information about the transcript.
 * 
 *  - Disallowed Account Types: ApiAccount, WebUser
 */
export interface CandidateTranscriptDetail {
  addrDisplay: CtranAddrDisplay;
  /**
   * Certification catalog ids excluded from the transcript
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowCredentials
   *
   */
  certCatalogInclusions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowCredentials
   *
   */
  certDateOk: Scalars['Boolean']['output'];
  /**
   * Certification requirement catalog ids excluded from the transcript
   * 
   * 
   *  - Requires Any Features: ShareTranscriptAllowAchievements, ShareTranscriptAllowOtherRequirements
   *
   */
  certRequirementInclusions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  cmcId: Scalars['Int']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowOtherRequirements
   *
   */
  creqDateOk: Scalars['Boolean']['output'];
  disabled: Scalars['Boolean']['output'];
  displayMode: CtranDisplayMode;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationPreferredName
   *
   */
  displayPreferredName: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowExams
   *
   */
  examDateOk: Scalars['Boolean']['output'];
  /**
   * Exam ids included in the transcript
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowExams
   *
   */
  examInclusions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  expireDate: Scalars['CmDate']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageOk: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowCredentials
   *
   */
  includeAllCerts: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowOtherRequirements
   *
   */
  includeAllCreqs: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowExams
   *
   */
  includeAllExams: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowAchievements
   *
   */
  includeAllStandings: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lastView?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareTranscriptAllowAchievements
   *
   */
  standingsDateOk: Scalars['Boolean']['output'];
  views: Scalars['Int']['output'];
}

export interface CandidateUnmergeRequest {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
}

/** Returns binary Data of various attachments to catalog items (Cert Logos, Badge Images, etc.) */
export interface CatalogAttachment {
  /** The language for the data for the file, default is english */
  ciName?: Maybe<Scalars['String']['output']>;
  /** A flag indicating if this attachment is disabled. */
  disabledFlag: Scalars['Boolean']['output'];
  /** The id of the record */
  id: Scalars['Int']['output'];
  /** The ID of the target of the item's data you are looking */
  targetId: Scalars['Int']['output'];
  /** The type of the Attachment */
  type?: Maybe<CatchType>;
  /** The url to access the file */
  url?: Maybe<Scalars['String']['output']>;
}

export interface CatalogExternalId {
  /** When the record became active, null means forever. */
  activeDate?: Maybe<Scalars['DateTime']['output']>;
  /** Which data provider the external id is used for/with. */
  dataProvider?: Maybe<DataProvider>;
  /** True when the record is considered deleted. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** When the record will become flagged as deleted. */
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  /** How the external system refers to the catalog item. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Determines which catalog the external id is related to. */
  type?: Maybe<CateidType>;
}

export enum CatchType {
  /** CcatLogo */
  CcatLogo = 'CcatLogo',
  /** CcatOpenBadge */
  CcatOpenBadge = 'CcatOpenBadge',
  /** CrcatOpenBadge */
  CrcatOpenBadge = 'CrcatOpenBadge',
  /** ExcatOpenBadge */
  ExcatOpenBadge = 'ExcatOpenBadge',
  /** ExcatScoreReportFail */
  ExcatScoreReportFail = 'ExcatScoreReportFail',
  /** ExcatScoreReportPass */
  ExcatScoreReportPass = 'ExcatScoreReportPass',
  /** FcatTemplate */
  FcatTemplate = 'FcatTemplate',
  /** Invalid */
  Invalid = 'Invalid',
  /** StandingLogoFile */
  StandingLogoFile = 'StandingLogoFile',
  /** StandingTemplate */
  StandingTemplate = 'StandingTemplate'
}

export enum CateidType {
  /** Ccat */
  Ccat = 'Ccat',
  /** Crcat */
  Crcat = 'Crcat',
  /** Excat */
  Excat = 'Excat',
  /** ExcatDataProvider */
  ExcatDataProvider = 'ExcatDataProvider'
}

export enum CcatExtensionType {
  /** ExtendByUsedItems */
  ExtendByUsedItems = 'ExtendByUsedItems',
  /** ExtendFromInactiveDate */
  ExtendFromInactiveDate = 'ExtendFromInactiveDate',
  /** ExtendToLogicVersionDate */
  ExtendToLogicVersionDate = 'ExtendToLogicVersionDate',
  /** IncludeSuspendedTime */
  IncludeSuspendedTime = 'IncludeSuspendedTime',
  /** Normal */
  Normal = 'Normal'
}

export enum CcatPathType {
  /** OneShot */
  OneShot = 'OneShot',
  /** OneShotExtendable */
  OneShotExtendable = 'OneShotExtendable',
  /** Repeatable */
  Repeatable = 'Repeatable'
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.Credentials.View
 * 
 *  - Must have candidate access
 *
 */
export interface Cert {
  /** The date the Cert became Active. */
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  catalogId: Scalars['Int']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialProgramNumber
   *
   */
  catalogProgramNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialProgramNumber
   *
   */
  catalogProgramNumberLabel?: Maybe<Scalars['String']['output']>;
  certCatalog?: Maybe<CertCatalog>;
  cmcId: Scalars['Int']['output'];
  /** The list of certification intent details on the candidate account. These are fetched by type (CEActivity or CertFee) and include intent level data that describe the candidate's current CE cycle. */
  continuingEducationIntent?: Maybe<Array<Maybe<ContinuingEducationIntent>>>;
  /**
   * The continuing education progress for the current logic track at a single priority. Used for progress on logic tracks with only one logic priority defined.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   * 
   *  - Requires All Permissions: Candidate.Requirements.ContinuingEducation.View
   *
   */
  continuingEducationProgress?: Maybe<Array<Maybe<ContinuingEducationProgress>>>;
  /**
   * The continuing education progress list for the current logic track. Members are unique by cert logic priority within a given track.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   * 
   *  - Requires All Permissions: Candidate.Requirements.ContinuingEducation.View
   *
   */
  continuingEducationProgressList?: Maybe<Array<Maybe<ContinuingEducationProgressList>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialElectronicCertificate
   *
   */
  eCertUrl?: Maybe<Scalars['String']['output']>;
  /** The date after which the Cert will become Expired if there is a Suspend period. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  id: Scalars['Int']['output'];
  /** The date after which the Cert will become Suspended or Expired, depending on if the Cert track has a Suspend period. */
  inactiveDate?: Maybe<Scalars['CmDate']['output']>;
  /** The last date the InactiveDate moved forward, indicating a recertification or extension. */
  latestExtendDate?: Maybe<Scalars['CmDate']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: SnowflakeDisplayBadgeId
   *
   */
  snowflakeBadgeId?: Maybe<Scalars['String']['output']>;
  /** Indicates for a Cert in Started status, the date of the first requirement that was achieved that applies to this Cert track. */
  startedDate?: Maybe<Scalars['CmDate']['output']>;
  /** The current status of the Cert including emeritus logic. */
  status: CertStatus;
}


/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.Credentials.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertContinuingEducationIntentArgs {
  request?: InputMaybe<ContinuingEducationIntentRequest>;
}


/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.Credentials.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertContinuingEducationProgressArgs {
  request?: InputMaybe<ContinuingEducationProgressRequest>;
}

export enum CertAgreementStatus {
  /** InactiveAgreementAvailable */
  InactiveAgreementAvailable = 'InactiveAgreementAvailable',
  /** NoActiveAgreementAvailable */
  NoActiveAgreementAvailable = 'NoActiveAgreementAvailable',
  /** Signed */
  Signed = 'Signed',
  /** Unsigned */
  Unsigned = 'Unsigned'
}

export interface CertBatch {
  candidateName?: Maybe<Scalars['String']['output']>;
  certActiveDate?: Maybe<Scalars['CmDate']['output']>;
  certId?: Maybe<Scalars['Int']['output']>;
  cmcId?: Maybe<Scalars['Int']['output']>;
}

export interface CertBatchRequest {
  jurisdictionId: Scalars['Int']['input'];
  /** If true, will return previously batched certs. If false, will return certs that can be batched. Null is treated as false. */
  rebatch?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 *
 */
export interface CertCatalog {
  /** The date on which the Cert track went active, and, if applicable, when the logic engine started processing against this track. */
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareCertMetricsBadging
   *
   */
  badgeCatalog?: Maybe<BadgeCatalog>;
  /** The Certification Group */
  certGroup?: Maybe<CertGroup>;
  /**
   * When true, Candidates with Active Certs can download a PDF Certificate.
   * 
   * 
   *  - Requires All Features: CredentialElectronicCertificate
   *
   */
  certificateEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** An optional brief description of the Cert track. */
  description?: Maybe<Scalars['String']['output']>;
  /** This value is used to override the default sorting, which is alphabetical. CertCatalog will sort by items with a DisplayOrder value, in that order, then alphabetically. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** When true, indicates that the Cert track is hidden from the Candidate. This typically indicates that there is logic processing required that does not indicate Cert achievement by the Candidate. */
  eligibility?: Maybe<Scalars['Boolean']['output']>;
  /** This will indicate the number of months prior to the candidate's certification active date that exams can be considered for achievement. Zero will indicate that no exams passed prior to the certification active date will be considered. */
  examActiveAge?: Maybe<Scalars['Int']['output']>;
  /** I.e., the retire date of the Cert track. After this date, no new Certs will be granted and Certs can no longer be extended on this track. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  /**
   * A unique identifier that can be used externally to CertMetrics to indicate a Cert track.
   * 
   *  - Disallowed Account Types: Candidate
   */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the CertGroup definition. */
  groupId?: Maybe<Scalars['Int']['output']>;
  /**
   * True when this catalog has any recertification logic that includes CE items.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  hasCEInRecertLogic: Scalars['Boolean']['output'];
  /**
   * True when this catalog has any recertification logic.
   * 
   * 
   *  - Requires All Features: CredentialRecertLogic
   *
   */
  hasRecertLogic: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  /**
   * A link to download the logo file(s) for this particular cert
   * 
   * 
   *  - Requires All Features: CredentialLogoDownload
   *
   */
  logoDownloadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * When true, there is a logo attachment available to download for Candidates who hold an Active Cert in this Cert track.
   * 
   * 
   *  - Requires All Features: CredentialLogoDownload
   *
   */
  logoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A link to upload the logo file(s) for this particular cert
   * 
   * 
   *  - Requires All Features: CredentialLogoDownload
   *
   */
  logoUploadUrl?: Maybe<Scalars['String']['output']>;
  /** Custom metadata attributes for this certification catalog entry. */
  metadata?: Maybe<Array<Maybe<CertCatalogMetadata>>>;
  /** The name of the Cert track */
  name: Scalars['String']['output'];
  /** The shortened name of the Cert track */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** This will indicate the number of months prior to the candidate's certification active date that certification requirements can be considered for achievement. Zero will indicate that no certification requirements earned prior to the certification active date will be considered. */
  reqActiveAge?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the Cert track is still Active, in a Sunset state, Retired, or Future. */
  status?: Maybe<CertCatalogStatus>;
  /**
   * When true, indicates that the Cert track cannot be shared on Transcripts.
   * 
   * 
   *  - Requires All Features: ShareTranscript
   *
   */
  transcriptProhibited?: Maybe<Scalars['Boolean']['output']>;
  /** An optional public url to show more information about the Cert track. */
  url?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 * 
 * 
 *  - Requires All Permissions: Credential.Catalog.View
 *
 */
export interface CertCatalogDetail {
  /** The date on which the Cert track went active, and, if applicable, when the logic engine started processing against this track. */
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  /** When true, indicates that if the Cert track is included in the logic of another Cert track, the Candidate's ActiveDate value of this Cert will not impact the ActiveDate of the other Cert. */
  activeDateCalcExcluded: Scalars['Boolean']['output'];
  /** Indicates the number of months that a granted Cert should be active. This also indicates, for Cert tracks with normal extension rules how long a Candidate is extended for when recertifying. Zero indicates that the Cert never expires. */
  activePeriod: Scalars['Short']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareCertMetricsBadging
   *
   */
  badgeCatalog?: Maybe<BadgeCatalog>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Benefit
   * 
   *  - Requires All Permissions: Benefit.Catalog.View
   *
   */
  benefitCatalogList?: Maybe<Array<Maybe<BenefitCatalog>>>;
  /** Any catalog external ids associated with the cert. */
  catalogExternalIdList?: Maybe<Array<Maybe<CatalogExternalId>>>;
  /**
   * Only applies to Cert tracks with Continuing Education. Indicates the number of months by which to divide the overall CE fee for renewal.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  ceFeePeriod?: Maybe<Scalars['Short']['output']>;
  /** The Certification Group */
  certGroup?: Maybe<CertGroup>;
  /**
   * When true, Candidates with Active Certs can download a PDF Certificate.
   * 
   * 
   *  - Requires All Features: CredentialElectronicCertificate
   *
   */
  certificateEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The url to make a PUT request to, in order to upload an ecert template. If this is null then you need to enable ecert uploading
   * 
   *  - Disallowed Account Types: Candidate
   */
  certificateTemplateUploadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * A link for the cert template url, null if no file exists
   * 
   *  - Disallowed Account Types: Candidate
   */
  certificateTemplateUrl?: Maybe<Scalars['String']['output']>;
  /** An optional brief description of the Cert track. */
  description?: Maybe<Scalars['String']['output']>;
  /** This value is used to override the default sorting, which is alphabetical. CertCatalog will sort by items with a DisplayOrder value, in that order, then alphabetically. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** When true, indicates that the Cert track is hidden from the Candidate. This typically indicates that there is logic processing required that does not indicate Cert achievement by the Candidate. */
  eligibility?: Maybe<Scalars['Boolean']['output']>;
  /** This will indicate the number of months prior to the candidate's certification active date that exams can be considered for achievement. Zero will indicate that no exams passed prior to the certification active date will be considered. */
  examActiveAge?: Maybe<Scalars['Int']['output']>;
  /** I.e., the retire date of the Cert track. After this date, no new Certs will be granted and Certs can no longer be extended on this track. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  /** Indicates the method to use to calculate the new ExpireDate on the Cert when a Candidate recertifies. Availalble options are Normal, Include Suspended Time, and Extend From Inactive Date. */
  extensionType: CcatExtensionType;
  /**
   * A unique identifier that can be used externally to CertMetrics to indicate a Cert track.
   * 
   *  - Disallowed Account Types: Candidate
   */
  externalId?: Maybe<Scalars['String']['output']>;
  /** When true, the first time the Candidate earns this Cert track, they are assigned the next number in the number sequence for this track. */
  generateCertNumber: Scalars['Boolean']['output'];
  greaterLinkedExtensionList?: Maybe<Array<Maybe<CertLinkedExtensionResponse>>>;
  /** Unique identifier for the CertGroup definition. */
  groupId?: Maybe<Scalars['Int']['output']>;
  /**
   * True when this catalog has any recertification logic that includes CE items.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  hasCEInRecertLogic: Scalars['Boolean']['output'];
  /**
   * True when this catalog has any recertification logic.
   * 
   * 
   *  - Requires All Features: CredentialRecertLogic
   *
   */
  hasRecertLogic: Scalars['Boolean']['output'];
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  historyList?: Maybe<Array<Maybe<SystemHistory>>>;
  id?: Maybe<Scalars['Int']['output']>;
  lesserLinkedExtensionList?: Maybe<Array<Maybe<CertLinkedExtensionResponse>>>;
  /** The list of cert logic entries (initial and recert) for this catalog. */
  logicList?: Maybe<Array<Maybe<CertLogic>>>;
  /**
   * A link to download the logo file(s) for this particular cert
   * 
   * 
   *  - Requires All Features: CredentialLogoDownload
   *
   */
  logoDownloadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * When true, there is a logo attachment available to download for Candidates who hold an Active Cert in this Cert track.
   * 
   * 
   *  - Requires All Features: CredentialLogoDownload
   *
   */
  logoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A link to upload the logo file(s) for this particular cert
   * 
   * 
   *  - Requires All Features: CredentialLogoDownload
   *
   */
  logoUploadUrl?: Maybe<Scalars['String']['output']>;
  /** Custom metadata attributes for this certification catalog entry. */
  metadata?: Maybe<Array<Maybe<CertCatalogMetadata>>>;
  /** The name of the Cert track */
  name: Scalars['String']['output'];
  /** The shortened name of the Cert track */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** Indicates whether or not the Cert track can be earned multiple times. Available options are Repeatable, One Shot, and One Shot Extendable. */
  pathType: CcatPathType;
  /**
   * Shows the list of electronic and physical fulfillment that can be granted when this Cert track is achieved.
   * 
   * 
   *  - Requires All Features: CredentialFulfillment
   * 
   *  - Requires All Permissions: CredentialFulfillment.Catalog.View
   *
   */
  physicalFulfillmentCatalogList?: Maybe<Array<Maybe<PhysicalFulfillmentCatalog>>>;
  /** Returns the list of Cert tracks that use this Cert track in logic processing. */
  relatedCertCatalogList?: Maybe<Array<Maybe<CertCatalog>>>;
  /** This will indicate the number of months prior to the candidate's certification active date that certification requirements can be considered for achievement. Zero will indicate that no certification requirements earned prior to the certification active date will be considered. */
  reqActiveAge?: Maybe<Scalars['Int']['output']>;
  /** When set, this indicates the number of months prior to the Cert track ActiveDate that requirements will be counted toward certification status. Null means there are no restrictions. Zero means that all requirements must be completed on or after the Cert track Active Date. */
  requirementCutoff?: Maybe<Scalars['Byte']['output']>;
  /** The maximum age, in months, that requirements are allowed to be counted toward achievement. If the item is too old, it is not counted toward certification. */
  requirementMaxAge?: Maybe<Scalars['Byte']['output']>;
  /** Indicates if the Cert track is still Active, in a Sunset state, Retired, or Future. */
  status?: Maybe<CertCatalogStatus>;
  /** On or after this date, Certs can only be extended. No new Certs will be granted. */
  sunsetDate?: Maybe<Scalars['CmDate']['output']>;
  /** Indicates the number of months after a granted Cert goes inactive that the track should be considered suspended. Zero indicates that there is no suspend period. */
  suspendPeriod: Scalars['Short']['output'];
  /** When true, indicates that Certs in Suspended status are still valid toward achieving this Cert track. */
  suspendedCertsAreValid?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, indicates that the Cert track cannot be shared on Transcripts.
   * 
   * 
   *  - Requires All Features: ShareTranscript
   *
   */
  transcriptProhibited?: Maybe<Scalars['Boolean']['output']>;
  /** An optional public url to show more information about the Cert track. */
  url?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 *
 */
export interface CertCatalogListRequest {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  logicType?: InputMaybe<CertLogicType>;
}

/** Custom metadata attribute for a certification catalog entry. */
export interface CertCatalogMetadata {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['output'];
  /** Foreign key to the cert catalog record this metadata belongs to. */
  certCatalogId: Scalars['Int']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** The value of the attribute. */
  value?: Maybe<Scalars['String']['output']>;
}

export enum CertCatalogStatus {
  /** Active */
  Active = 'Active',
  /** Future */
  Future = 'Future',
  /** Retired */
  Retired = 'Retired',
  /** Sunset */
  Sunset = 'Sunset'
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertCurrentProgressResponse {
  itemTree?: Maybe<CertLogicItemResponse>;
  logic?: Maybe<CertLogic>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.Credentials.View
 * 
 *  - Must have candidate access
 * 
 * 
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 *
 */
export interface CertDetail {
  /** The date the Cert became Active. */
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ExamComptiaAnsiCriteria
   *
   */
  ansiCriteria?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  catalogId: Scalars['Int']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialProgramNumber
   *
   */
  catalogProgramNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialProgramNumber
   *
   */
  catalogProgramNumberLabel?: Maybe<Scalars['String']['output']>;
  certCatalog?: Maybe<CertCatalog>;
  certHistoryDetail?: Maybe<CertHistoryDetail>;
  certHistoryList?: Maybe<Array<Maybe<CertHistory>>>;
  cmcId: Scalars['Int']['output'];
  /** The list of certification intent details on the candidate account. These are fetched by type (CEActivity or CertFee) and include intent level data that describe the candidate's current CE cycle. */
  continuingEducationIntent?: Maybe<Array<Maybe<ContinuingEducationIntent>>>;
  /**
   * The continuing education progress for the current logic track at a single priority. Used for progress on logic tracks with only one logic priority defined.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   * 
   *  - Requires All Permissions: Candidate.Requirements.ContinuingEducation.View
   *
   */
  continuingEducationProgress?: Maybe<Array<Maybe<ContinuingEducationProgress>>>;
  /**
   * The continuing education progress list for the current logic track. Members are unique by cert logic priority within a given track.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   * 
   *  - Requires All Permissions: Candidate.Requirements.ContinuingEducation.View
   *
   */
  continuingEducationProgressList?: Maybe<Array<Maybe<ContinuingEducationProgressList>>>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  created: Scalars['CmDateTimeOffset']['output'];
  /** The highest priority current progress tree for a cert. */
  currentProgress?: Maybe<CertCurrentProgressResponse>;
  /** A list of all current progress trees (by priority) for a cert. */
  currentProgressList?: Maybe<Array<Maybe<CertCurrentProgressResponse>>>;
  /**
   * When true, indicates that the Cert record is stale and has been deleted due to Candidate certification status reprocessing. This is not a current record.
   * 
   * 
   *  - Internal accounts only
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialElectronicCertificate
   *
   */
  eCertUrl?: Maybe<Scalars['String']['output']>;
  /** The date after which the Cert will become Expired if there is a Suspend period. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  /** When set, indicates that the first item used toward achievement was an Exam. This specifies the Exam.Id for that item. */
  firstExamId?: Maybe<Scalars['Int']['output']>;
  /** When set, indicates that the first item used toward achievement was a Requirement. This specifies the Requirement.Id for that item. */
  firstRequirementId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** The date after which the Cert will become Suspended or Expired, depending on if the Cert track has a Suspend period. */
  inactiveDate?: Maybe<Scalars['CmDate']['output']>;
  /** The last date the InactiveDate moved forward, indicating a recertification or extension. */
  latestExtendDate?: Maybe<Scalars['CmDate']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: SnowflakeDisplayBadgeId
   *
   */
  snowflakeBadgeId?: Maybe<Scalars['String']['output']>;
  /** Indicates for a Cert in Started status, the date of the first requirement that was achieved that applies to this Cert track. */
  startedDate?: Maybe<Scalars['CmDate']['output']>;
  /** The current status of the Cert including emeritus logic. */
  status: CertStatus;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialVerification
   *
   */
  verificationId?: Maybe<Scalars['String']['output']>;
}


/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.Credentials.View
 * 
 *  - Must have candidate access
 * 
 * 
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 *
 */
export interface CertDetailCertHistoryDetailArgs {
  request: RequestById;
}


/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.Credentials.View
 * 
 *  - Must have candidate access
 * 
 * 
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 *
 */
export interface CertDetailContinuingEducationIntentArgs {
  request?: InputMaybe<ContinuingEducationIntentRequest>;
}


/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.Credentials.View
 * 
 *  - Must have candidate access
 * 
 * 
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 *
 */
export interface CertDetailContinuingEducationProgressArgs {
  request?: InputMaybe<ContinuingEducationProgressRequest>;
}

/**
 * This is for the grouping of certification tracks (CertCatalog). Groups are able to be further/alternately grouped into classifications.
 * 
 * 
 *  - Requires All Features: Credential
 *
 */
export interface CertGroup {
  /** An optional classification/family/type of the group; if any groups have this set (non-null), then all groups should have one set. The distinct list of all values in the table define the set of classifications used. */
  classification?: Maybe<Scalars['String']['output']>;
  /** The color to be used in the cert group card in hex (#000000) format. */
  color?: Maybe<Scalars['String']['output']>;
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** If true, when a candidate initially certifies in a ccat within the group (first time ever), they are assigned the next number in the cert-group's candidate certification number sequence. */
  generateCertNumber: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Group display name. */
  name: Scalars['String']['output'];
  /** Optional grouping used instead of defaults built into the catalog. If using, must be on all groups. */
  program?: Maybe<Scalars['String']['output']>;
  /** Order of the program groups, if programs is used this must be set for all or alphabetical will be used. */
  programDisplayOrder?: Maybe<Scalars['Short']['output']>;
  /** The color to be used in the cert group text in hex (#000000) format. */
  textColor?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertHistory {
  activeDate: Scalars['CmDate']['output'];
  cert?: Maybe<Cert>;
  created: Scalars['CmDateTimeOffset']['output'];
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  id: Scalars['Int']['output'];
  inactiveDate?: Maybe<Scalars['CmDate']['output']>;
  logic?: Maybe<CertLogic>;
  type: ChType;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertHistoryDetail {
  activeDate: Scalars['CmDate']['output'];
  cert?: Maybe<Cert>;
  created: Scalars['CmDateTimeOffset']['output'];
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  id: Scalars['Int']['output'];
  inactiveDate?: Maybe<Scalars['CmDate']['output']>;
  linkedCert?: Maybe<Cert>;
  logic?: Maybe<CertLogic>;
  logicVersion?: Maybe<CertLogicVersion>;
  type: ChType;
  usedItemList?: Maybe<Array<Maybe<CertUsedItem>>>;
}

export interface CertImportListVmGqlType {
  /** Items to import; each item is required. */
  requestList: Array<InputMaybe<CertImportVmGqlType>>;
}

/** Response for certificate import, including aggregate counts and per-row status. */
export interface CertImportResponseVmGqlType {
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedRecords: Scalars['Int']['output'];
  importStatus?: Maybe<Scalars['String']['output']>;
  importedRecords: Scalars['Int']['output'];
  statusList?: Maybe<Array<Maybe<CertImportVmOutputGqlType>>>;
  totalRecords: Scalars['Int']['output'];
}

export interface CertImportVmGqlType {
  /** Activation date (date-only). */
  activeDate: Scalars['CmDate']['input'];
  /** Candidate external identifier. */
  candidateExternalId: Scalars['ID']['input'];
  /** Certification external identifier. */
  certificationExternalId: Scalars['ID']['input'];
  /** Country name or ISO code as supported. */
  country: Scalars['String']['input'];
  /** Candidate email address. */
  emailAddress: Scalars['String']['input'];
  /** Email domain portion (e.g., example.com). */
  emailDomain: Scalars['String']['input'];
  /** Candidate first name. */
  firstName: Scalars['String']['input'];
  /** Candidate last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Partner company name. */
  partnerCompany: Scalars['String']['input'];
}

export interface CertImportVmOutputGqlType {
  activeDate: Scalars['CmDate']['output'];
  candidateExternalId: Scalars['String']['output'];
  certificationExternalId: Scalars['String']['output'];
  country: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  partnerCompany: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 *
 */
export interface CertLinkedExtensionResponse {
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  greaterCcat?: Maybe<CertCatalog>;
  id: Scalars['Int']['output'];
  jules: Scalars['Boolean']['output'];
  lesserCcat?: Maybe<CertCatalog>;
  scarble: Scalars['Boolean']['output'];
}

export interface CertListRequest {
  /** Determines whether to include eligibility certs in the request. */
  includeEligibilityCerts: Scalars['Boolean']['input'];
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires Any Permissions: Candidate.CredentialDetails.View, Credential.Catalog.View
 *
 */
export interface CertLogic {
  displayStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  type: ClType;
  versionList?: Maybe<Array<Maybe<CertLogicVersion>>>;
}

/** Custom metadata attribute for a cert logic item entry. */
export interface CertLogicItemMetadata {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['output'];
  /** Foreign key to the cert logic item record this metadata belongs to. */
  certLogicItemId: Scalars['Int']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** The value of the attribute. */
  value?: Maybe<Scalars['String']['output']>;
}

export interface CertLogicItemRequest {
  ccatId?: InputMaybe<Scalars['Int']['input']>;
  children?: InputMaybe<Array<InputMaybe<CertLogicItemRequest>>>;
  clvId?: InputMaybe<Scalars['Int']['input']>;
  crcatId?: InputMaybe<Scalars['Int']['input']>;
  egId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['CmDate']['input']>;
  excatId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxPoints?: InputMaybe<Scalars['Short']['input']>;
  numRequired?: InputMaybe<Scalars['Int']['input']>;
  parentCliId?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Short']['input']>;
  startDate?: InputMaybe<Scalars['CmDate']['input']>;
  type?: InputMaybe<CliType>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires Any Permissions: Candidate.CredentialDetails.View, Credential.Catalog.View
 *
 */
export interface CertLogicItemResponse {
  certCatalog?: Maybe<CertCatalog>;
  certRequirementCatalog?: Maybe<CertRequirementCatalog>;
  children?: Maybe<Array<Maybe<CertLogicItemResponse>>>;
  earnedPoints?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  egId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['CmDate']['output']>;
  examCatalog?: Maybe<ExamCatalog>;
  examGroup?: Maybe<ExamGroup>;
  externalId?: Maybe<Scalars['String']['output']>;
  folderType?: Maybe<CliType>;
  id: Scalars['Int']['output'];
  isComplete: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  maxPoints?: Maybe<Scalars['Int']['output']>;
  /** Custom metadata attributes for this cert logic item entry. */
  metadata?: Maybe<Array<Maybe<CertLogicItemMetadata>>>;
  numChildren: Scalars['Int']['output'];
  numComplete: Scalars['Int']['output'];
  /** 0 means all are required. */
  numRequired?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['Int']['output'];
  pointsPerItem?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['CmDate']['output']>;
  type: CertLogicItemType;
  usedItemList?: Maybe<Array<Maybe<CertUsedItem>>>;
}

export enum CertLogicItemType {
  /** Ccat */
  Ccat = 'Ccat',
  /** Crcat */
  Crcat = 'Crcat',
  /** Excat */
  Excat = 'Excat',
  /** Folder */
  Folder = 'Folder'
}

export enum CertLogicType {
  /** Initial */
  Initial = 'Initial',
  /** Miscellaneous */
  Miscellaneous = 'Miscellaneous',
  /** Recertification */
  Recertification = 'Recertification'
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires Any Permissions: Candidate.CredentialDetails.View, Credential.Catalog.View
 *
 */
export interface CertLogicVersion {
  approved: Scalars['Boolean']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  endDate?: Maybe<Scalars['CmDate']['output']>;
  id: Scalars['Int']['output'];
  itemTree?: Maybe<CertLogicItemResponse>;
  priorityExpansion?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['CmDate']['output']>;
}

export interface CertLogicVersionRequest {
  clId: Scalars['Int']['input'];
  itemTree: CertLogicItemRequest;
  priorityExpansion?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['CmDate']['input'];
}

export interface CertMetricsMutation {
  /**
   * Adds a client setting to the database
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ClientSettingsModify
   * 
   *  - Requires All Permissions: ClientSettings.Modify, ClientSettings.View
   *
   */
  addClientSetting?: Maybe<ClientSetting>;
  /**
   * Assigns audits to select web users. Multiple audit-web user pairs may be requested, but only one web user may be assigned to a given audit.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
   *
   */
  assignCreqAudits?: Maybe<Array<Maybe<CreqAudit>>>;
  /**
   * Bulk corrupts exams.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools
   *
   */
  bulkCorruptExam?: Maybe<Array<Maybe<BulkCorruptExamResponse>>>;
  /**
   * Can be used to create multiple affiliation entries at one time.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
   * 
   *  - Requires All Permissions: Affiliation.Catalog.Modify
   *
   */
  bulkCreateAffiliationList?: Maybe<Array<Maybe<AffiliationCatalog>>>;
  /**
   * Creates new cert catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkCreateCertCatalogMetadata?: Maybe<Array<Maybe<CertCatalogMetadata>>>;
  /**
   * Creates new cert logic item metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkCreateCertLogicItemMetadata?: Maybe<Array<Maybe<CertLogicItemMetadata>>>;
  /**
   * Creates new cert requirement catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkCreateCertRequirementCatalogMetadata?: Maybe<Array<Maybe<CertRequirementCatalogMetadata>>>;
  /**
   * Bulk create exam authorizations.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools
   * 
   *  - Requires Any Permissions: Exam.Authorizations.Modify, Exam.Authorizations.View
   *
   */
  bulkCreateExamAuthorization: Array<Maybe<UpsertExamAuthorizationResponse>>;
  /**
   * Creates new exam catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkCreateExamCatalogMetadata?: Maybe<Array<Maybe<ExamCatalogMetadata>>>;
  /**
   * Can be used to create multiple exam item catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Items.Modify
   *
   */
  bulkCreateExamItemCatalog?: Maybe<Array<Maybe<ExamItemCatalog>>>;
  /**
   * Can be used to create multiple exam section catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Sections.Modify
   *
   */
  bulkCreateExamSectionCatalog?: Maybe<Array<Maybe<ExamSectionCatalog>>>;
  /**
   * Creates new metadata attributes for metadata items.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkCreateMetadataAttributes?: Maybe<Array<Maybe<MetadataAttribute>>>;
  /**
   * Creates new metadata items.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkCreateMetadataItems?: Maybe<Array<Maybe<MetadataItem>>>;
  /**
   * Deletes existing cert catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkDeleteCertCatalogMetadata?: Maybe<Array<Maybe<CertCatalogMetadata>>>;
  /**
   * Deletes existing cert logic item metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkDeleteCertLogicItemMetadata?: Maybe<Array<Maybe<CertLogicItemMetadata>>>;
  /**
   * Deletes existing cert requirement catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkDeleteCertRequirementCatalogMetadata?: Maybe<Array<Maybe<CertRequirementCatalogMetadata>>>;
  /**
   * Deletes existing exam catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkDeleteExamCatalogMetadata?: Maybe<Array<Maybe<ExamCatalogMetadata>>>;
  /**
   * Can be used to delete multiple exam item catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Items.Modify
   *
   */
  bulkDeleteExamItemCatalog?: Maybe<Array<Maybe<ExamItemCatalog>>>;
  /**
   * Can be used to delete multiple exam section catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Sections.Modify
   *
   */
  bulkDeleteExamSectionCatalog?: Maybe<Array<Maybe<ExamSectionCatalog>>>;
  /**
   * Deletes existing metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkDeleteMetadataAttributes?: Maybe<Array<Maybe<MetadataAttribute>>>;
  /**
   * Deletes existing metadata items and all their associated attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkDeleteMetadataItems?: Maybe<Array<Maybe<MetadataItem>>>;
  /**
   * Bulk validate exams.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, Exam
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.Modify
   *
   */
  bulkExamValidation?: Maybe<Array<Maybe<BulkExamValidation>>>;
  /**
   * Can be used to update multiple affiliation entries at one time.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
   * 
   *  - Requires All Permissions: Affiliation.Catalog.Modify
   *
   */
  bulkUpdateAffiliationList?: Maybe<Array<Maybe<AffiliationCatalog>>>;
  /**
   * Bulk updates candidate auxiliary data.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools
   * 
   *  - Requires All Permissions: Candidate.BannedStatus.View, Candidate.BannedStatus.Modify, Candidate.WatchStatus.View, Candidate.WatchStatus.Modify
   * 
   *  - Must have candidate access
   *
   */
  bulkUpdateCandidateAuxiliary?: Maybe<Array<Maybe<UpdateCandidateAuxiliaryResponse>>>;
  /**
   * Updates existing cert catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkUpdateCertCatalogMetadata?: Maybe<Array<Maybe<CertCatalogMetadata>>>;
  /**
   * Updates existing cert logic item metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkUpdateCertLogicItemMetadata?: Maybe<Array<Maybe<CertLogicItemMetadata>>>;
  /**
   * Updates existing cert requirement catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkUpdateCertRequirementCatalogMetadata?: Maybe<Array<Maybe<CertRequirementCatalogMetadata>>>;
  /**
   * Updates existing exam catalog metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkUpdateExamCatalogMetadata?: Maybe<Array<Maybe<ExamCatalogMetadata>>>;
  /**
   * Can be used to update multiple exam item catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Items.Modify
   *
   */
  bulkUpdateExamItemCatalog?: Maybe<Array<Maybe<ExamItemCatalog>>>;
  /**
   * Can be used to update multiple exam section catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Sections.Modify
   *
   */
  bulkUpdateExamSectionCatalog?: Maybe<Array<Maybe<ExamSectionCatalog>>>;
  /**
   * Updates existing metadata attributes.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkUpdateMetadataAttributes?: Maybe<Array<Maybe<MetadataAttribute>>>;
  /**
   * Updates existing metadata items.
   * 
   *  - Disallowed Account Types: Candidate
   */
  bulkUpdateMetadataItems?: Maybe<Array<Maybe<MetadataItem>>>;
  /**
   * Bulk uploads exams.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: UploadExamsTool
   *
   */
  bulkUploadExam: Array<Maybe<UploadExamResponse>>;
  /**
   * Can be used to create and update multiple affiliation entries at one time.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
   * 
   *  - Requires All Permissions: Affiliation.Catalog.Modify
   *
   */
  bulkUpsertAffiliationList?: Maybe<Array<Maybe<AffiliationCatalog>>>;
  /**
   * Can be used to insert and update multiple exam item catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Items.Modify
   *
   */
  bulkUpsertExamItemCatalog?: Maybe<Array<Maybe<ExamItemCatalog>>>;
  /**
   * Can be used to update and insert multiple exam section catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Sections.Modify
   *
   */
  bulkUpsertExamSectionCatalog?: Maybe<Array<Maybe<ExamSectionCatalog>>>;
  /**
   * Bulk invalidates vouchers.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Benefit.Catalog.Modify
   *
   */
  bulkVoucherInvalidate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Bulk imports vouchers.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Benefit.Catalog.Modify
   *
   */
  bulkVoucherUpload?: Maybe<Array<Maybe<BulkVoucherUpload>>>;
  /** Completes the candidate self-registration process */
  candidateSelfRegistration?: Maybe<SelfRegisteredCandidateAccount>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CandidateDataBulkImport
   * 
   *  - Requires All Permissions: CandidateData.BulkImport.Manage
   * 
   *  - Must have candidate access
   *
   */
  certImport?: Maybe<CertImportResponseVmGqlType>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: Benefit
   * 
   *  - Must have candidate access
   *
   */
  claimBenefit?: Maybe<Benefit>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: ExamAuthorization
   * 
   *  - Requires All Permissions: Exam.Authorizations.Modify
   * 
   *  - Must have candidate access
   *
   */
  claimExamAuthorizationPack?: Maybe<ExamAuthorizationPack>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: MergeCandidatesCandidateSelfMerge
   *
   */
  completeCandidateSelfMerge?: Maybe<CandidateMerge>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: ComptiaCustomDashboardReports
   *
   */
  comptiaReportsMutations?: Maybe<ComptiaReportsMutations>;
  /**
   * Corrupts an exam. This is a destructive operation and is not recoverable. The system will act as though the exam never existed.
   * 
   * 
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.Modify
   *
   */
  corruptExam?: Maybe<ExamDetail>;
  /**
   * Requests creation of a new api account.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  createApiAccount?: Maybe<ApiAccount>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
   *
   */
  createAuditMessage?: Maybe<CreqAuditMessage>;
  /**
   * Can be used to create a new benefit-cert catalog association entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Benefit
   * 
   *  - Requires All Permissions: Benefit.Catalog.Modify
   *
   */
  createBenefitCcatAssoc?: Maybe<BenefitCcatAssoc>;
  /**
   * Creates a booking for exam
   * 
   * 
   *  - Requires All Features: ExamExamSchedulingInternal
   *
   */
  createBooking?: Maybe<PrometricBookingResponse>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: MergeCandidatesBulkMergeTool
   * 
   *  - Requires All Permissions: Candidate.Merge.Create, Candidate.MergeDetails.Modify
   * 
   *  - Must have candidate access
   *
   */
  createBulkCandidateMerge?: Maybe<BulkCandidateMerge>;
  /**
   * Creates a candidate.
   * 
   * 
   *  - Requires All Features: CandidateProfile
   * 
   *  - Requires All Permissions: CandidateProfile.Create
   *
   */
  createCandidate?: Maybe<CandidateAccount>;
  /**
   * Creates a candidate id.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CandidateProfileManageCandidateId
   * 
   *  - Requires All Permissions: CandidateProfile.ManageCandidateId.Modify
   *
   */
  createCandidateId?: Maybe<CandidateAccount>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: MergeCandidates
   * 
   *  - Requires All Permissions: Candidate.Merge.Create
   * 
   *  - Must have candidate access
   *
   */
  createCandidateMerge?: Maybe<CandidateMerge>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: Credential, CredentialComptiaSelfExtend
   * 
   *  - Requires All Permissions: Candidate.CredentialDetails.Modify
   * 
   *  - Must have candidate access
   *
   */
  createCandidateSelfExtensionRequest?: Maybe<SelfExtensionCertProcessRequest>;
  /**
   * Can be used to create a candidate setting filter.
   * 
   * 
   *  - Requires All Features: CandidateProfileCustomDataSettings
   * 
   *  - Admin accounts only
   *
   */
  createCandidateSettingFilter?: Maybe<CandidateSettingFilter>;
  /**
   * Creates a new candidate transcript.
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: ShareTranscript
   *
   */
  createCandidateTranscript?: Maybe<CandidateTranscriptDetail>;
  /**
   * Can be used to create a cert catalog entry.
   * 
   * 
   *  - Requires All Features: Credential
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  createCertCatalog?: Maybe<CertCatalogDetail>;
  /**
   * Creates a cert group.
   * 
   * 
   *  - Internal accounts only
   *
   */
  createCertGroup?: Maybe<CertGroup>;
  /**
   * Creates a new cert logic version.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  createCertLogicVersion?: Maybe<CertLogicVersion>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Credential
   * 
   *  - Requires All Permissions: Candidate.CredentialDetails.Modify
   * 
   *  - Must have candidate access
   *
   */
  createCertProcessRequest?: Maybe<CertProcessRequest>;
  /**
   * Creates a new cert requirement.
   * 
   * 
   *  - Requires All Features: OtherRequirementUpload
   * 
   *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
   * 
   *  - Requires Any Permissions: Candidate.Requirements.Miscellaneous.Modify, Candidate.CredentialAgreements.Modify, Candidate.Requirements.ExternalCert.Modify, Candidate.Requirements.ContinuingEducation.Modify, Candidate.Requirements.ProgramFee.Modify, Candidate.Requirements.Enrollment.Modify, Candidate.Requirements.Training.Modify, Candidate.Requirements.Lab.Modify, Candidate.Requirements.ExternalExam.Modify, Candidate.Requirements.Participation.Modify, Candidate.Requirements.AdditionalAgreement.Modify
   * 
   *  - Must have candidate access
   *
   */
  createCertRequirement?: Maybe<CertRequirement>;
  /**
   * Can be used to create a cert requirement catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: OtherRequirement
   * 
   *  - Requires Any Permissions: Requirements.Miscellaneous.Catalog.Modify, CredentialAgreements.Catalog.Modify, Requirements.ExternalCert.Catalog.Modify, Requirements.ContinuingEducation.Catalog.Modify, Requirements.ProgramFee.Catalog.Modify, Requirements.Enrollment.Catalog.Modify, Requirements.Training.Catalog.Modify, Requirements.Lab.Catalog.Modify, Requirements.ExternalExam.Catalog.Modify, Requirements.Participation.Catalog.Modify, CredentialAchievements.Catalog.Modify, Requirements.AdditionalAgreement.Catalog.Modify
   * 
   *  - Internal accounts only
   *
   */
  createCertRequirementCatalog?: Maybe<CertRequirementCatalogDetail>;
  /**
   * Creates a cert requirement group.
   * 
   * 
   *  - Internal accounts only
   *
   */
  createCertRequirementGroup?: Maybe<CertificationRequirementGroup>;
  /**
   * Creates cert requirements with vouchers.
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: CredentialContinuingEducationCredentialContinuingEducationVouchers
   *
   */
  createCertRequirementWithVouchers?: Maybe<Array<Maybe<CertRequirement>>>;
  /**
   * Makes a client feature available
   * 
   * 
   *  - Internal accounts only
   *
   */
  createClientFeature?: Maybe<Feature>;
  /**
   * Can be used to create localizations.
   * 
   * 
   *  - Must have localization enabled
   *
   */
  createClientLocalizationList?: Maybe<Array<Maybe<ClientLocalization>>>;
  /**
   * Can be used to create a crcat override catalog.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: OtherRequirementAdvancedSelection
   * 
   *  - Requires All Permissions: OtherRequirements.AdvancedSelection.Modify, OtherRequirements.AdvancedSelection.View
   *
   */
  createCrcatOverrideCatalog?: Maybe<CertRequirementCatalogOverrideCatalog>;
  /**
   * Can be used to create a crcat override group.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: OtherRequirementAdvancedSelection
   * 
   *  - Requires All Permissions: OtherRequirements.AdvancedSelection.Modify, OtherRequirements.AdvancedSelection.View
   *
   */
  createCrcatOverrideGroup?: Maybe<CertRequirementCatalogOverrideGroup>;
  /**
   * Can be used to create an email catalog entry with a context based on the current base context.
   * 
   * 
   *  - Internal accounts only
   *
   */
  createEmailCatalogWithContext?: Maybe<EmailCatalogDetail>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: Ecommerce
   * 
   *  - Requires All Permissions: Ecommerce.Transactions.Modify
   * 
   *  - Must have candidate access
   *
   */
  createEtransaction?: Maybe<ETransaction>;
  /**
   * Creates an exam.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.Modify
   * 
   *  - Must have candidate access
   *
   */
  createExam?: Maybe<ExamDetail>;
  /**
   * Creates an exam accomm pack and associated exam accomms.
   * 
   * 
   *  - Requires All Features: ExamAccommodations
   * 
   *  - Requires All Permissions: Exam.Accommodations.Modify
   * 
   *  - Must have candidate access
   *
   */
  createExamAccommPack?: Maybe<ExamAccommPack>;
  /**
   * Can be used to create an exam catalog entry.
   * 
   * 
   *  - Requires All Features: Exam
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  createExamCatalog?: Maybe<ExamCatalogDetail>;
  /**
   * Creates an exam group.
   * 
   * 
   *  - Internal accounts only
   *
   */
  createExamGroup?: Maybe<ExamGroup>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Candidate.ExamViolations.Modify
   * 
   *  - Must have candidate access
   *
   */
  createExamViolation?: Maybe<ExamViolation>;
  /**
   * Creates a filter.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires Any Features: CandidateSegmentation, Announcements
   * 
   *  - Requires Any Permissions: Announcements.Catalog.Modify, Candidate.Segmentation.Modify
   *
   */
  createFilter?: Maybe<Filter>;
  /**
   * Can be used to create a geography.
   * 
   * 
   *  - Admin accounts only
   *
   */
  createGeography?: Maybe<ClientGeography>;
  /**
   * Can be used to create hub localizations.
   * 
   * 
   *  - Must have localization enabled
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  createHubLocalizationList?: Maybe<Array<Maybe<HubLocalization>>>;
  /**
   * Creates a hold reservation for an in person exam
   * 
   * 
   *  - Requires All Features: ExamExamSchedulingInternal
   *
   */
  createInPersonExamHold?: Maybe<Array<Maybe<PrometricHoldResponse>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: BenefitLineup
   * 
   *  - Requires All Permissions: Benefit.Catalog.View, Candidate.Benefit.View
   *
   */
  createLineupAccount?: Maybe<CandidateExternalId>;
  /**
   * Creates a linked extension.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  createLinkedExtension?: Maybe<CertLinkedExtensionResponse>;
  /**
   * Can be used to create localizations.
   * 
   * 
   *  - Must have localization enabled
   *
   * @deprecated A new mutation of CreateClientLocalizationList has been created using ClientLocalizationVm.
   */
  createLocalizationList?: Maybe<Array<Maybe<LocalizationResponse>>>;
  /**
   * Creates a news article.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Announcements
   * 
   *  - Requires All Permissions: Announcements.Catalog.Modify
   *
   */
  createNewsArticle?: Maybe<NewsArticleDetail>;
  /**
   * Creates a hold reservation for an online exam
   * 
   * 
   *  - Requires All Features: ExamExamSchedulingInternal
   *
   */
  createOnlineExamHold?: Maybe<Array<Maybe<ProctorHoldResponse>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: CandidateAccessLoginEMCOtherAchievements
   *
   */
  createOtherAchievement?: Maybe<CandidateOtherAchievement>;
  /**
   * Can be used to create an OtherAchievement record.
   * 
   * 
   *  - Requires All Features: CandidateAccessLoginEMCOtherAchievements
   * 
   *  - Requires All Permissions: OtherAchievement.Catalog.Modify
   *
   */
  createOtherAchievementCatalog?: Maybe<OtherAchievementCatalog>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: CredentialFulfillment
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.Modify
   * 
   *  - Must have candidate access
   *
   */
  createPhysicalFulfillment?: Maybe<PhysicalFulfillmentDetail>;
  /**
   * Can be used to create a role.
   * 
   * 
   *  - Admin accounts only
   *
   */
  createRole?: Maybe<ClientRole>;
  /**
   * Creates a new cert requirement using custom end point for Seertech.
   * 
   * 
   *  - Requires All Features: OtherRequirementOtherRequirementSeertechCustomApiImportSnowflake
   * 
   *  - Requires All Permissions: OtherRequirements.SeertechCustomApiImport.Modify
   * 
   *  - Must have candidate access
   *
   */
  createSeertechCertRequirement?: Maybe<CertRequirement>;
  /**
   * Creates a tag domain.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: Tagging
   * 
   *  - Requires All Permissions: Tagging.Catalog.Modify
   *
   */
  createTagDomain?: Maybe<TagDomainDetail>;
  /**
   * Send a test email to the web users email address.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Permissions: Email.Catalog.Modify
   *
   */
  createTestEmail?: Maybe<EmailRequestDetail>;
  /**
   * Requests creation of a new web user.
   * 
   * 
   *  - Admin accounts only
   *
   */
  createWebUser?: Maybe<WebUser>;
  /**
   * Deletes a candidate id.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires Any Permissions: Credly.Admin.Modify, CandidateProfile.ManageCandidateId.Modify
   *
   */
  deleteCandidateId?: Maybe<CandidateAccount>;
  /**
   * Can be used to remove a candidate setting filter.
   * 
   * 
   *  - Requires All Features: CandidateProfileCustomDataSettings
   * 
   *  - Admin accounts only
   *
   */
  deleteCandidateSettingFilter?: Maybe<CandidateSettingFilter>;
  /**
   * Deletes an eligible cert requirement.
   * 
   * 
   *  - Requires All Features: OtherRequirementUploadCandidateAccessDeleteItems
   * 
   *  - Requires Any Permissions: Candidate.Requirements.Miscellaneous.Modify, Candidate.CredentialAgreements.Modify, Candidate.Requirements.ExternalCert.Modify, Candidate.Requirements.ContinuingEducation.Modify, Candidate.Requirements.ProgramFee.Modify, Candidate.Requirements.Enrollment.Modify, Candidate.Requirements.Training.Modify, Candidate.Requirements.Lab.Modify, Candidate.Requirements.ExternalExam.Modify, Candidate.Requirements.Participation.Modify, Candidate.Requirements.AdditionalAgreement.Modify
   * 
   *  - Must have candidate access
   *
   */
  deleteCertRequirement?: Maybe<CertRequirement>;
  /**
   * Makes a client feature unavailable
   * 
   * 
   *  - Internal accounts only
   *
   */
  deleteClientFeature?: Maybe<Feature>;
  /**
   * Can be used to delete localizations.
   * 
   * 
   *  - Must have localization enabled
   *
   */
  deleteClientLocalizationList?: Maybe<Array<Maybe<ClientLocalization>>>;
  /**
   * Deletes a client setting to the database
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ClientSettingsModify
   * 
   *  - Requires All Permissions: ClientSettings.Modify, ClientSettings.View
   *
   */
  deleteClientSetting?: Maybe<ClientSetting>;
  /**
   * Deletes a filter.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires Any Features: CandidateSegmentation, Announcements
   * 
   *  - Requires Any Permissions: Announcements.Catalog.Modify, Candidate.Segmentation.Modify
   *
   */
  deleteFilter?: Maybe<Filter>;
  /**
   * Can be used to remove a geography.
   * 
   * 
   *  - Admin accounts only
   *
   */
  deleteGeography?: Maybe<ClientGeography>;
  /**
   * Deletes a linked extension and performs rebuilds.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  deleteLinkedExtension?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Can be used to delete localizations.
   * 
   * 
   *  - Must have localization enabled
   *
   * @deprecated A new mutation of DeleteClientLocalizationList has been created using ClientLocalizationVm.
   */
  deleteLocalizationList?: Maybe<Array<Maybe<LocalizationResponse>>>;
  /**
   * Deletes a news article.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Announcements
   * 
   *  - Requires All Permissions: Announcements.Catalog.Modify
   *
   */
  deleteNewsArticle?: Maybe<NewsArticleDetail>;
  /**
   * Can be used to delete a role.
   * 
   * 
   *  - Admin accounts only
   *
   */
  deleteRole?: Maybe<ClientRole>;
  /** Initiates a candidate self-registration for an existing web user. */
  employeeSelfRegisterCandidateRequest?: Maybe<SelfRegistrationResponse>;
  /**
   * Deletes all personal candidate data for the Gdpr Candidate.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  gdprCandidate?: Maybe<CandidateAccount>;
  /** Requests a short-lived token that can only access the specified url. */
  generateShortLivedToken?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the latest differences report, or the number of candidates left to process if not yet complete
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  getDifferences?: Maybe<DifferencesReport>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamAuthorization
   * 
   *  - Requires All Permissions: Exam.Authorizations.Modify
   * 
   *  - Must have candidate access
   *
   */
  grantExamAuthorizationPack?: Maybe<ExamAuthorizationPack>;
  /**
   * Imports an exam.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.Modify
   * 
   *  - Must have candidate access
   *
   */
  importExam?: Maybe<ExamDetail>;
  /**
   * Inserts a candidate history entry.
   * 
   * 
   *  - Requires All Permissions: Candidate.History.Modify
   * 
   *  - Must have candidate access
   *
   */
  insertCandidateHistory?: Maybe<CandidateHistory>;
  /**
   * Inserts a web user history entry.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   */
  insertWebUserHistory?: Maybe<WebUserHistory>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: ExamNCARBCertBatching
   *
   */
  ncarbToolsMutations?: Maybe<NcarbToolsMutations>;
  /**
   * Bulk corrupts exams.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools
   *
   */
  queueBulkCorruptExam?: Maybe<Scalars['String']['output']>;
  /**
   * Bulk validate exams.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, Exam
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.Modify
   *
   */
  queueBulkExamValidation?: Maybe<Scalars['String']['output']>;
  /**
   * Queues a bulk candidate auxiliary data update job.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools
   * 
   *  - Requires All Permissions: Candidate.BannedStatus.View, Candidate.BannedStatus.Modify, Candidate.WatchStatus.View, Candidate.WatchStatus.Modify
   * 
   *  - Must have candidate access
   *
   */
  queueBulkUpdateCandidateAuxiliary?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.ReassignData
   * 
   *  - Must have candidate access
   *
   */
  reassignCandidateData?: Maybe<Array<Maybe<CandidateAccount>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Benefit
   * 
   *  - Requires All Permissions: Candidate.Benefit.Modify
   * 
   *  - Must have candidate access
   *
   */
  reassignClaimedBenefit?: Maybe<Voucher>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: CredentialFulfillmentFulfillmentVouchers
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.Modify
   * 
   *  - Must have candidate access
   *
   */
  redeemFulfillmentVoucher?: Maybe<PhysicalFulfillment>;
  /**
   * Refreshes this candidate's Zendesk ticket activity in their history logs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CandidateProfileZendeskHistory
   *
   */
  refreshZendeskHistory?: Maybe<Array<Maybe<CandidateHistory>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfile
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.Modify
   * 
   *  - Must have candidate access
   *
   */
  releaseFulfillments?: Maybe<Array<Maybe<PhysicalFulfillment>>>;
  /**
   * Removes all traces of a list of audits from the system. The operation is logged in candidate history.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
   *
   */
  removeCreqAudits: RemoveCreqAuditResponse;
  /**
   * Requeues an email request that was previously sent on a candidate account.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Permissions: Candidate.EmailHistory.Modify
   *
   */
  requeueEmailRequest?: Maybe<EmailRequest>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamAuthorization
   * 
   *  - Requires All Permissions: Exam.Authorizations.Modify
   * 
   *  - Must have candidate access
   *
   */
  revokeExamAuthorizationPack?: Maybe<ExamAuthorizationPack>;
  /** Initiates a candidate self-registration. */
  selfRegisterCandidateRequest?: Maybe<SelfRegistrationResponse>;
  /**
   * Send a test email to beta user.
   * 
   * 
   *  - Requires All Permissions: Email.Catalog.Modify
   *
   */
  sendTestEmail: Scalars['Boolean']['output'];
  /**
   * Sends a transcript email using the WebTranscript email template. Logs email attempts and outcomes.
   * 
   * 
   *  - Requires All Features: ShareTranscriptSendEmails
   *
   */
  sendTranscriptEmail?: Maybe<EmailRequest>;
  /**
   * Signs the latest agreement.
   * 
   * 
   *  - Requires All Features: CredentialAgreement
   * 
   *  - Requires All Permissions: Candidate.CredentialAgreements.Modify
   * 
   *  - Must have candidate access
   *
   */
  signLatestAgreement?: Maybe<CandidateAccount>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: ToolsSnowflakeTools
   *
   */
  snowflakeToolsMutations?: Maybe<SnowflakeToolsMutations>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: MergeCandidatesCandidateSelfMerge
   *
   */
  startCandidateSelfMerge?: Maybe<CandidateMerge>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: MergeCandidates
   * 
   *  - Requires All Permissions: Candidate.MergeDetails.Modify
   *
   */
  unmergeCandidate?: Maybe<CandidateMerge>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamAuthorization
   * 
   *  - Requires All Permissions: Exam.Authorizations.Modify
   * 
   *  - Must have candidate access
   *
   */
  unrevokeExamAuthorizationPack?: Maybe<ExamAuthorizationPack>;
  /**
   * Requests changes to the indicated api account.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  updateApiAccount?: Maybe<ApiAccount>;
  /**
   * Requests changes to the indicated ApiAccount's roles.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  updateApiAccountRoles?: Maybe<ApiAccountDetails>;
  /**
   * Allows user to modify an exam appointment.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamAppointmentsExamAppointmentsStandardAppointments
   * 
   *  - Requires All Permissions: Exam.Appointments.Modify, Candidate.History.Modify
   *
   */
  updateAppointment?: Maybe<Array<Maybe<ExamEvent>>>;
  /**
   * Updates an exam group.
   * 
   * 
   *  - Requires Any Features: ShareCertMetricsBadging
   * 
   *  - Requires All Permissions: CertMetrics.Badging.Catalog.Modify
   *
   */
  updateBadgeCatalog?: Maybe<BadgeCatalog>;
  /**
   * Can be used to modify a benefit catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Benefit
   * 
   *  - Requires All Permissions: Benefit.Catalog.Modify
   *
   */
  updateBenefitCatalog?: Maybe<BenefitCatalog>;
  /**
   * Can be used to modify a benefit catalog instruction entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Benefit
   * 
   *  - Requires All Permissions: Benefit.Catalog.Modify
   *
   */
  updateBenefitCatalogLocalizedFields?: Maybe<BenefitCatalogDetail>;
  /**
   * Can be used to update the grant end date of a benefit-cert catalog association.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Benefit
   * 
   *  - Requires All Permissions: Benefit.Catalog.Modify
   * 
   *  - Internal accounts only
   *
   */
  updateBenefitCcatAssoc?: Maybe<BenefitCcatAssoc>;
  /**
   * Updates a benefit group.
   * 
   * 
   *  - Internal accounts only
   *
   */
  updateBenefitGroup?: Maybe<BenefitGroup>;
  /**
   * Requests changes to the indicated candidate's demographics.
   * 
   * 
   *  - Requires All Features: CandidateProfile
   * 
   *  - Must have candidate access
   *
   */
  updateCandidate?: Maybe<CandidateAccount>;
  /**
   * Requests changes to the indicated candidate's attributes.
   * 
   * 
   *  - Requires All Features: CandidateProfileCustomDataAttributes
   * 
   *  - Requires All Permissions: Candidate.SponsorSettings.Attributes.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateCandidateAttributeList?: Maybe<CandidateAccount>;
  /**
   * Updates auxiliary data for the candidate.
   * 
   * 
   *  - Must have candidate access
   *
   */
  updateCandidateAuxiliary?: Maybe<CandidateAuxiliary>;
  /**
   * Updates a candidate external id preferred status.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires Any Permissions: CandidateProfile.ManageCandidateId.Modify, ViewCandidateExternalIds.Modify
   *
   */
  updateCandidateId?: Maybe<CandidateAccount>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: MergeCandidates
   * 
   *  - Requires All Permissions: Candidate.MergeDetails.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateCandidateMerge?: Maybe<CandidateMerge>;
  /**
   * Requests a change to the candidate's password.
   * 
   * 
   *  - Requires All Features: CandidateAccessLoginChangePassword
   * 
   *  - Requires All Permissions: Candidate.SecuritySettings.Password.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateCandidatePassword?: Maybe<CandidateAccount>;
  /**
   * Can be used to update a candidate setting filter.
   * 
   * 
   *  - Requires All Features: CandidateProfileCustomDataSettings
   * 
   *  - Admin accounts only
   *
   */
  updateCandidateSettingFilter?: Maybe<CandidateSettingFilter>;
  /**
   * Requests changes to the indicated candidate's settings.
   * 
   * 
   *  - Requires All Features: CandidateProfileCustomDataSettings
   * 
   *  - Requires All Permissions: Candidate.SponsorSettings.Settings.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateCandidateSettingList?: Maybe<CandidateAccount>;
  /**
   * Updates a candidate transcript.
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: ShareTranscript
   *
   */
  updateCandidateTranscript?: Maybe<CandidateTranscriptDetail>;
  /**
   * Updates a candidates transcript inclusions.
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: ShareTranscriptAllowCredentials
   *
   */
  updateCandidateTranscriptCertCatalogInclusions?: Maybe<CandidateTranscriptDetail>;
  /**
   * Updates a candidates transcript inclusions.
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires Any Features: ShareTranscriptAllowOtherRequirements, ShareTranscriptAllowAchievements
   *
   */
  updateCandidateTranscriptCertRequirementInclusions?: Maybe<CandidateTranscriptDetail>;
  /**
   * Updates a candidates transcript inclusions.
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: ShareTranscriptAllowExams
   *
   */
  updateCandidateTranscriptExamInclusions?: Maybe<CandidateTranscriptDetail>;
  /**
   * Can be used to toggle the disabled flag on a catalog attachment.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: CredentialAchievements.Catalog.Modify
   *
   */
  updateCatalogAttachment?: Maybe<CatalogAttachment>;
  /**
   * Can be used to modify a cert catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Credential
   * 
   *  - Requires All Permissions: Credential.Catalog.Modify
   *
   */
  updateCertCatalog?: Maybe<CertCatalogDetail>;
  /**
   * Updates a cert group.
   * 
   * 
   *  - Internal accounts only
   *
   */
  updateCertGroup?: Maybe<CertGroup>;
  /**
   * Updates the Cert Logic Version approved flag.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Credential
   * 
   *  - Requires All Permissions: Credential.Catalog.Modify
   *
   */
  updateCertLogicVersion?: Maybe<CertLogicVersion>;
  /**
   * Updates a cert requirement.
   * 
   * 
   *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
   * 
   *  - Requires Any Permissions: Candidate.Requirements.Miscellaneous.Modify, Candidate.CredentialAgreements.Modify, Candidate.Requirements.ExternalCert.Modify, Candidate.Requirements.ContinuingEducation.Modify, Candidate.Requirements.ProgramFee.Modify, Candidate.Requirements.Enrollment.Modify, Candidate.Requirements.Training.Modify, Candidate.Requirements.Lab.Modify, Candidate.Requirements.ExternalExam.Modify, Candidate.Requirements.Participation.Modify, Candidate.Requirements.AdditionalAgreement.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateCertRequirement?: Maybe<CertRequirement>;
  /**
   * Can be used to modify an cert requirement catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: OtherRequirement
   * 
   *  - Requires Any Permissions: Requirements.Miscellaneous.Catalog.Modify, CredentialAgreements.Catalog.Modify, Requirements.ExternalCert.Catalog.Modify, Requirements.ContinuingEducation.Catalog.Modify, Requirements.ProgramFee.Catalog.Modify, Requirements.Enrollment.Catalog.Modify, Requirements.Training.Catalog.Modify, Requirements.Lab.Catalog.Modify, Requirements.ExternalExam.Catalog.Modify, Requirements.Participation.Catalog.Modify, CredentialAchievements.Catalog.Modify, Requirements.AdditionalAgreement.Catalog.Modify
   *
   */
  updateCertRequirementCatalog?: Maybe<CertRequirementCatalogDetail>;
  /**
   * Updates a cert requirement group.
   * 
   * 
   *  - Internal accounts only
   *
   */
  updateCertRequirementGroup?: Maybe<CertificationRequirementGroup>;
  /**
   * Allows enabling and disabling of available client features
   * 
   * 
   *  - Admin accounts only
   *
   */
  updateClientFeature?: Maybe<Feature>;
  /**
   * Can be used to update localizations.
   * 
   * 
   *  - Must have localization enabled
   *
   */
  updateClientLocalizationList?: Maybe<Array<Maybe<ClientLocalization>>>;
  /**
   * Updates the specified client setting in the database.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ClientSettingsModify
   * 
   *  - Requires All Permissions: ClientSettings.Modify, ClientSettings.View
   *
   */
  updateClientSetting?: Maybe<ClientSetting>;
  /**
   * Can be used to create a crcat override catalog.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: OtherRequirementAdvancedSelection
   * 
   *  - Requires All Permissions: OtherRequirements.AdvancedSelection.Modify, OtherRequirements.AdvancedSelection.View
   *
   */
  updateCrcatOverrideCatalog?: Maybe<CertRequirementCatalogOverrideCatalog>;
  /**
   * Used to update the expire date of a credly badge template.
   * 
   * 
   *  - Requires All Features: ShareCredlyBadging
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  updateCredlyTemplateExpireDate?: Maybe<CatalogExternalId>;
  /**
   * Updates selected fields on an audit.
   * 
   * 
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
   *
   */
  updateCreqAudit: CreqAudit;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
   *
   */
  updateCreqAuditItem?: Maybe<CreqAuditItem>;
  /**
   * Can be used to modify the shared values on an email catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Email.Catalog.Modify
   *
   */
  updateEmailCatalog?: Maybe<EmailCatalogDetail>;
  /**
   * Can be used to modify or add a localization to an email catalog.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Email.Catalog.Modify
   *
   */
  updateEmailLocalization?: Maybe<EmailCatalogDetail>;
  /**
   * Updates an exam. You can either update state or other values, not both.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateExam?: Maybe<ExamDetail>;
  /**
   * Updates an exam accomm.
   * 
   * 
   *  - Requires All Features: ExamAccommodations
   * 
   *  - Requires All Permissions: Exam.Accommodations.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateExamAccomm?: Maybe<ExamAccomm>;
  /**
   * Updates an exam accomm pack.
   * 
   * 
   *  - Requires All Features: ExamAccommodations
   * 
   *  - Requires All Permissions: Exam.Accommodations.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateExamAccommPack?: Maybe<ExamAccommPack>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamAuthorization
   * 
   *  - Requires All Permissions: Exam.Authorizations.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateExamAuthorizationPack?: Maybe<ExamAuthorizationPack>;
  /**
   * Can be used to modify an exam catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Exam
   * 
   *  - Requires All Permissions: Exam.Catalog.Modify
   *
   */
  updateExamCatalog?: Maybe<ExamCatalogDetail>;
  /**
   * Updates an exam group.
   * 
   * 
   *  - Internal accounts only
   *
   */
  updateExamGroup?: Maybe<ExamGroup>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Exam.CertMetricsVouchers.Modify
   * 
   *  - Must have candidate access
   *
   */
  updateExamVoucher?: Maybe<ExamVoucher>;
  /**
   * Updates a filter.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires Any Features: CandidateSegmentation, Announcements
   * 
   *  - Requires Any Permissions: Announcements.Catalog.Modify, Candidate.Segmentation.Modify
   *
   */
  updateFilter?: Maybe<Filter>;
  /**
   * Can be used to update the name and abbreviation of a fulfillment catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialFulfillment
   * 
   *  - Requires All Permissions: Credential.Catalog.Modify
   * 
   *  - Internal accounts only
   *
   */
  updateFulfillmentCatalog?: Maybe<PhysicalFulfillmentCatalog>;
  /**
   * Can be used to update a geography.
   * 
   * 
   *  - Admin accounts only
   *
   */
  updateGeography?: Maybe<ClientGeography>;
  /**
   * Can be used to update hub localizations.
   * 
   * 
   *  - Must have localization enabled
   *
   */
  updateHubLocalization?: Maybe<HubLocalization>;
  /**
   * Can be used to update localizations.
   * 
   * 
   *  - Must have localization enabled
   *
   * @deprecated A new mutation of UpdateClientLocalizationList has been created using ClientLocalizationVm.
   */
  updateLocalizationList?: Maybe<Array<Maybe<LocalizationResponse>>>;
  /**
   * Requests a complete change to the indicated navigation tree.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Admin accounts only
   *
   */
  updateNavigation?: Maybe<Array<Maybe<Navigation>>>;
  /**
   * Updates a news article.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: Announcements
   * 
   *  - Requires All Permissions: Announcements.Catalog.Modify
   *
   */
  updateNewsArticle?: Maybe<NewsArticleDetail>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: CandidateAccessLoginEMCOtherAchievements
   *
   */
  updateOtherAchievement?: Maybe<CandidateOtherAchievement>;
  /**
   * Can be used to update an OtherAchievement record.
   * 
   * 
   *  - Requires All Features: CandidateAccessLoginEMCOtherAchievements
   * 
   *  - Requires All Permissions: OtherAchievement.Catalog.Modify
   *
   */
  updateOtherAchievementCatalog?: Maybe<OtherAchievementCatalog>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialFulfillment
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.Modify
   * 
   *  - Must have candidate access
   *
   */
  updatePhysicalFulfillment?: Maybe<PhysicalFulfillmentDetail>;
  /**
   * Can be used to update a role.
   * 
   * 
   *  - Admin accounts only
   *
   */
  updateRole?: Maybe<ClientRole>;
  /**
   * Updates a candidate staging entry.
   * 
   * 
   *  - Admin accounts only
   *
   */
  updateStagingCandidate?: Maybe<StagingCandidate>;
  /**
   * Updates a cert requirement staging entry.
   * 
   * 
   *  - Admin accounts only
   *
   */
  updateStagingCertRequirement?: Maybe<StagingCertRequirement>;
  /**
   * Updates a exam staging entry.
   * 
   * 
   *  - Admin accounts only
   *
   */
  updateStagingExam?: Maybe<StagingExam>;
  /**
   * Update tag domain and its associated tag items.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: Tagging
   * 
   *  - Requires All Permissions: Tagging.Catalog.Modify
   *
   */
  updateTagDomain?: Maybe<TagDomainDetail>;
  /**
   * Requests changes to the indicated web user.
   * 
   *  - Disallowed Account Types: Candidate
   */
  updateWebUser?: Maybe<WebUser>;
  /**
   * Requests changes to the indicated WebUser's candidate setting filters.
   * 
   * 
   *  - Requires All Features: CandidateProfileCustomDataSettings
   * 
   *  - Admin accounts only
   *
   */
  updateWebUserCandidateSettingFilters?: Maybe<WebUserAccount>;
  /**
   * Requests changes to the indicated WebUser's geographies.
   * 
   * 
   *  - Admin accounts only
   *
   */
  updateWebUserGeographies?: Maybe<WebUserAccount>;
  /**
   * Requests changes to the indicated WebUser's roles.
   * 
   * 
   *  - Admin accounts only
   *
   */
  updateWebUserRoles?: Maybe<WebUserAccount>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: MergeCandidatesCandidateSelfMerge
   *
   */
  verifyCandidateSelfMerge?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: Ecommerce
   * 
   *  - Requires All Permissions: Ecommerce.Transactions.Modify
   * 
   *  - Must have candidate access
   *
   */
  voidEtransaction?: Maybe<ETransaction>;
}


export interface CertMetricsMutationAddClientSettingArgs {
  request: AddClientSettingRequest;
}


export interface CertMetricsMutationAssignCreqAuditsArgs {
  request?: InputMaybe<AssignCreqAuditRequestList>;
}


export interface CertMetricsMutationBulkCorruptExamArgs {
  request: BulkCorruptExamRequest;
}


export interface CertMetricsMutationBulkCreateAffiliationListArgs {
  request: BulkCreateAffiliationRequest;
}


export interface CertMetricsMutationBulkCreateCertCatalogMetadataArgs {
  request: BulkCreateCertCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkCreateCertLogicItemMetadataArgs {
  request: BulkCreateCertLogicItemMetadataRequest;
}


export interface CertMetricsMutationBulkCreateCertRequirementCatalogMetadataArgs {
  request: BulkCreateCertRequirementCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkCreateExamAuthorizationArgs {
  request: BulkCreateExamAuthorizationRequest;
}


export interface CertMetricsMutationBulkCreateExamCatalogMetadataArgs {
  request: BulkCreateExamCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkCreateExamItemCatalogArgs {
  request: BulkCreateExamItemCatalogRequest;
}


export interface CertMetricsMutationBulkCreateExamSectionCatalogArgs {
  request: BulkCreateExamSectionCatalogRequest;
}


export interface CertMetricsMutationBulkCreateMetadataAttributesArgs {
  request: BulkCreateMetadataAttributeRequest;
}


export interface CertMetricsMutationBulkCreateMetadataItemsArgs {
  request: BulkCreateMetadataItemRequest;
}


export interface CertMetricsMutationBulkDeleteCertCatalogMetadataArgs {
  request: BulkDeleteCertCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkDeleteCertLogicItemMetadataArgs {
  request: BulkDeleteCertLogicItemMetadataRequest;
}


export interface CertMetricsMutationBulkDeleteCertRequirementCatalogMetadataArgs {
  request: BulkDeleteCertRequirementCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkDeleteExamCatalogMetadataArgs {
  request: BulkDeleteExamCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkDeleteExamItemCatalogArgs {
  request: BulkDeleteExamItemCatalogRequest;
}


export interface CertMetricsMutationBulkDeleteExamSectionCatalogArgs {
  request: BulkDeleteExamSectionCatalogRequest;
}


export interface CertMetricsMutationBulkDeleteMetadataAttributesArgs {
  request: BulkDeleteMetadataAttributeRequest;
}


export interface CertMetricsMutationBulkDeleteMetadataItemsArgs {
  request: BulkDeleteMetadataItemRequest;
}


export interface CertMetricsMutationBulkExamValidationArgs {
  request: BulkExamValidationRequest;
}


export interface CertMetricsMutationBulkUpdateAffiliationListArgs {
  request: BulkUpdateAffiliationRequest;
}


export interface CertMetricsMutationBulkUpdateCandidateAuxiliaryArgs {
  request: BulkUpdateCandidateAuxiliaryRequest;
}


export interface CertMetricsMutationBulkUpdateCertCatalogMetadataArgs {
  request: BulkUpdateCertCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkUpdateCertLogicItemMetadataArgs {
  request: BulkUpdateCertLogicItemMetadataRequest;
}


export interface CertMetricsMutationBulkUpdateCertRequirementCatalogMetadataArgs {
  request: BulkUpdateCertRequirementCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkUpdateExamCatalogMetadataArgs {
  request: BulkUpdateExamCatalogMetadataRequest;
}


export interface CertMetricsMutationBulkUpdateExamItemCatalogArgs {
  request: BulkUpdateExamItemCatalogRequest;
}


export interface CertMetricsMutationBulkUpdateExamSectionCatalogArgs {
  request: BulkUpdateExamSectionCatalogRequest;
}


export interface CertMetricsMutationBulkUpdateMetadataAttributesArgs {
  request: BulkUpdateMetadataAttributeRequest;
}


export interface CertMetricsMutationBulkUpdateMetadataItemsArgs {
  request: BulkUpdateMetadataItemRequest;
}


export interface CertMetricsMutationBulkUploadExamArgs {
  request: BulkUploadExamRequest;
}


export interface CertMetricsMutationBulkUpsertAffiliationListArgs {
  request: BulkUpsertAffiliationRequest;
}


export interface CertMetricsMutationBulkUpsertExamItemCatalogArgs {
  request: BulkUpsertExamItemCatalogRequest;
}


export interface CertMetricsMutationBulkUpsertExamSectionCatalogArgs {
  request: BulkUpsertExamSectionCatalogRequest;
}


export interface CertMetricsMutationBulkVoucherInvalidateArgs {
  request: BulkVoucherInvalidateRequest;
}


export interface CertMetricsMutationBulkVoucherUploadArgs {
  request: BulkVoucherUploadRequest;
}


export interface CertMetricsMutationCandidateSelfRegistrationArgs {
  request: SelfRegistration;
}


export interface CertMetricsMutationCertImportArgs {
  request: CertImportListVmGqlType;
}


export interface CertMetricsMutationClaimBenefitArgs {
  request: ClaimBenefitRequest;
}


export interface CertMetricsMutationClaimExamAuthorizationPackArgs {
  request: ClaimExamAuthorizationPackRequest;
}


export interface CertMetricsMutationCompleteCandidateSelfMergeArgs {
  request: CompleteCandidateSelfMergeRequest;
}


export interface CertMetricsMutationCorruptExamArgs {
  request: CorruptExamRequest;
}


export interface CertMetricsMutationCreateApiAccountArgs {
  request: CreateApiAccountRequest;
}


export interface CertMetricsMutationCreateAuditMessageArgs {
  request?: InputMaybe<CreateCreqAuditMessageRequest>;
}


export interface CertMetricsMutationCreateBenefitCcatAssocArgs {
  request: CreateBenefitCcatAssocRequest;
}


export interface CertMetricsMutationCreateBookingArgs {
  request: BookingRequest;
}


export interface CertMetricsMutationCreateBulkCandidateMergeArgs {
  request: BulkCandidateMergeRequest;
}


export interface CertMetricsMutationCreateCandidateArgs {
  request: CreateCandidateRequest;
}


export interface CertMetricsMutationCreateCandidateIdArgs {
  request: CreateCandidateExternalIdRequest;
}


export interface CertMetricsMutationCreateCandidateMergeArgs {
  request: CreateCandidateMergeRequest;
}


export interface CertMetricsMutationCreateCandidateSelfExtensionRequestArgs {
  request: CreateCandidateSelfExtensionRequest;
}


export interface CertMetricsMutationCreateCandidateSettingFilterArgs {
  request: CreateCandidateSettingFilterRequest;
}


export interface CertMetricsMutationCreateCandidateTranscriptArgs {
  request: CreateCandidateTranscriptRequest;
}


export interface CertMetricsMutationCreateCertCatalogArgs {
  request: CreateCertCatalogRequest;
}


export interface CertMetricsMutationCreateCertGroupArgs {
  request: CreateCertGroupRequest;
}


export interface CertMetricsMutationCreateCertLogicVersionArgs {
  request: CertLogicVersionRequest;
}


export interface CertMetricsMutationCreateCertProcessRequestArgs {
  request: CreateCprRequest;
}


export interface CertMetricsMutationCreateCertRequirementArgs {
  request: CreateCertRequirementRequest;
}


export interface CertMetricsMutationCreateCertRequirementCatalogArgs {
  request: CreateCertRequirementCatalogRequest;
}


export interface CertMetricsMutationCreateCertRequirementGroupArgs {
  request: CreateCertRequirementGroupRequest;
}


export interface CertMetricsMutationCreateCertRequirementWithVouchersArgs {
  request: CreateCertReqWithVoucher;
}


export interface CertMetricsMutationCreateClientFeatureArgs {
  request: CreateClientFeatureRequest;
}


export interface CertMetricsMutationCreateClientLocalizationListArgs {
  request: CreateLocalizationListRequest;
}


export interface CertMetricsMutationCreateCrcatOverrideCatalogArgs {
  request: CreateCrcatOverrideCatalogRequest;
}


export interface CertMetricsMutationCreateCrcatOverrideGroupArgs {
  request: CreateCrcatOverrideGroupRequest;
}


export interface CertMetricsMutationCreateEmailCatalogWithContextArgs {
  request: CreateEmailCatalogWithContextRequest;
}


export interface CertMetricsMutationCreateEtransactionArgs {
  request: CreateEtransactionRequest;
}


export interface CertMetricsMutationCreateExamArgs {
  request: CreateExamRequest;
}


export interface CertMetricsMutationCreateExamAccommPackArgs {
  request: CreateExamAccommPackRequest;
}


export interface CertMetricsMutationCreateExamCatalogArgs {
  request: CreateExamCatalogRequest;
}


export interface CertMetricsMutationCreateExamGroupArgs {
  request: CreateExamGroupRequest;
}


export interface CertMetricsMutationCreateExamViolationArgs {
  request: CreateExamViolationRequest;
}


export interface CertMetricsMutationCreateFilterArgs {
  request: CreateFilterRequest;
}


export interface CertMetricsMutationCreateGeographyArgs {
  request: CreateGeographyRequest;
}


export interface CertMetricsMutationCreateHubLocalizationListArgs {
  request: CreateHubLocalizationListRequest;
}


export interface CertMetricsMutationCreateInPersonExamHoldArgs {
  request: CreateInPersonExamHoldRequest;
}


export interface CertMetricsMutationCreateLineupAccountArgs {
  request: CandidateIdRequest;
}


export interface CertMetricsMutationCreateLinkedExtensionArgs {
  request: CreateLinkedExtensionRequest;
}


export interface CertMetricsMutationCreateLocalizationListArgs {
  request: CreateLocalizationListRequest;
}


export interface CertMetricsMutationCreateNewsArticleArgs {
  request: CreateNewsArticleRequest;
}


export interface CertMetricsMutationCreateOnlineExamHoldArgs {
  request: CreateOnlineExamHoldRequest;
}


export interface CertMetricsMutationCreateOtherAchievementArgs {
  request: CreateOtherAchievementRequest;
}


export interface CertMetricsMutationCreateOtherAchievementCatalogArgs {
  request: CreateOtherAchievementCatalogRequest;
}


export interface CertMetricsMutationCreatePhysicalFulfillmentArgs {
  request: CreatePhysicalFulfillmentRequest;
}


export interface CertMetricsMutationCreateRoleArgs {
  request: CreateRoleRequest;
}


export interface CertMetricsMutationCreateSeertechCertRequirementArgs {
  request: CreateSeertechCertRequirementRequest;
}


export interface CertMetricsMutationCreateTagDomainArgs {
  request: CreateTagDomainRequest;
}


export interface CertMetricsMutationCreateTestEmailArgs {
  request: CreateTestEmailRequest;
}


export interface CertMetricsMutationCreateWebUserArgs {
  request: CreateWebUserRequest;
}


export interface CertMetricsMutationDeleteCandidateIdArgs {
  request: DeleteCandidateExternalIdRequest;
}


export interface CertMetricsMutationDeleteCandidateSettingFilterArgs {
  request: DeleteCandidateSettingFilterRequest;
}


export interface CertMetricsMutationDeleteCertRequirementArgs {
  request: DeleteCertRequirementRequest;
}


export interface CertMetricsMutationDeleteClientFeatureArgs {
  request: DeleteClientFeatureRequest;
}


export interface CertMetricsMutationDeleteClientLocalizationListArgs {
  request: DeleteLocalizationListRequest;
}


export interface CertMetricsMutationDeleteClientSettingArgs {
  request: DeleteClientSettingRequest;
}


export interface CertMetricsMutationDeleteFilterArgs {
  request: RequestById;
}


export interface CertMetricsMutationDeleteGeographyArgs {
  request: DeleteGeographyRequest;
}


export interface CertMetricsMutationDeleteLinkedExtensionArgs {
  request: DeleteLinkedExtensionRequest;
}


export interface CertMetricsMutationDeleteLocalizationListArgs {
  request: DeleteLocalizationListRequest;
}


export interface CertMetricsMutationDeleteNewsArticleArgs {
  request: RequestById;
}


export interface CertMetricsMutationDeleteRoleArgs {
  request: DeleteRoleRequest;
}


export interface CertMetricsMutationEmployeeSelfRegisterCandidateRequestArgs {
  request: EmployeeSelfRegistrationRequest;
}


export interface CertMetricsMutationGdprCandidateArgs {
  request: CandidateGdprRequest;
}


export interface CertMetricsMutationGenerateShortLivedTokenArgs {
  request: GenerateShortLivedTokenRequest;
}


export interface CertMetricsMutationGrantExamAuthorizationPackArgs {
  request: GrantExamAuthorizationPackRequest;
}


export interface CertMetricsMutationImportExamArgs {
  request: ImportExamRequest;
}


export interface CertMetricsMutationInsertCandidateHistoryArgs {
  request: InsertCandidateHistory;
}


export interface CertMetricsMutationInsertWebUserHistoryArgs {
  request: InsertWebUserHistory;
}


export interface CertMetricsMutationQueueBulkCorruptExamArgs {
  request: BulkCorruptExamRequest;
}


export interface CertMetricsMutationQueueBulkExamValidationArgs {
  request: BulkExamValidationRequest;
}


export interface CertMetricsMutationQueueBulkUpdateCandidateAuxiliaryArgs {
  request: BulkUpdateCandidateAuxiliaryRequest;
}


export interface CertMetricsMutationReassignCandidateDataArgs {
  request: ReassignCandidateDataRequest;
}


export interface CertMetricsMutationReassignClaimedBenefitArgs {
  request: ReassignClaimedBenefitRequest;
}


export interface CertMetricsMutationRedeemFulfillmentVoucherArgs {
  request: RedeemFulfillmentVoucherRequest;
}


export interface CertMetricsMutationRefreshZendeskHistoryArgs {
  request: RefreshZendeskHistoryRequest;
}


export interface CertMetricsMutationReleaseFulfillmentsArgs {
  request: ReleaseFulfillmentRequest;
}


export interface CertMetricsMutationRemoveCreqAuditsArgs {
  request?: InputMaybe<RemoveCreqAuditRequestList>;
}


export interface CertMetricsMutationRequeueEmailRequestArgs {
  request: RequestById;
}


export interface CertMetricsMutationRevokeExamAuthorizationPackArgs {
  request: RevokeExamAuthorizationPackRequest;
}


export interface CertMetricsMutationSelfRegisterCandidateRequestArgs {
  request: SelfRegistrationRequest;
}


export interface CertMetricsMutationSendTestEmailArgs {
  request: SendTestEmail;
}


export interface CertMetricsMutationSendTranscriptEmailArgs {
  request: SendTranscriptEmailRequest;
}


export interface CertMetricsMutationSignLatestAgreementArgs {
  request: SignLatestAgreementRequest;
}


export interface CertMetricsMutationStartCandidateSelfMergeArgs {
  request: StartCandidateSelfMergeRequest;
}


export interface CertMetricsMutationUnmergeCandidateArgs {
  request: CandidateUnmergeRequest;
}


export interface CertMetricsMutationUnrevokeExamAuthorizationPackArgs {
  request: UnrevokeExamAuthorizationPackRequest;
}


export interface CertMetricsMutationUpdateApiAccountArgs {
  request: UpdateApiAccountRequest;
}


export interface CertMetricsMutationUpdateApiAccountRolesArgs {
  request: UpdateApiAccountRoles;
}


export interface CertMetricsMutationUpdateAppointmentArgs {
  request: AppointmentRequest;
}


export interface CertMetricsMutationUpdateBadgeCatalogArgs {
  request: UpdateBadgeCatalogRequest;
}


export interface CertMetricsMutationUpdateBenefitCatalogArgs {
  request: UpdateBenefitCatalogRequest;
}


export interface CertMetricsMutationUpdateBenefitCatalogLocalizedFieldsArgs {
  request: UpdateBenefitCatalogLocaliedFieldsRequest;
}


export interface CertMetricsMutationUpdateBenefitCcatAssocArgs {
  request: UpdateBenefitCcatAssocRequest;
}


export interface CertMetricsMutationUpdateBenefitGroupArgs {
  request: UpdateBenefitGroupRequest;
}


export interface CertMetricsMutationUpdateCandidateArgs {
  request: UpdateCandidateRequest;
}


export interface CertMetricsMutationUpdateCandidateAttributeListArgs {
  request: UpdateCandidateAttributeListRequest;
}


export interface CertMetricsMutationUpdateCandidateAuxiliaryArgs {
  request: UpdateCandidateAuxiliaryRequest;
}


export interface CertMetricsMutationUpdateCandidateIdArgs {
  request: UpdateCandidateExternalIdRequest;
}


export interface CertMetricsMutationUpdateCandidateMergeArgs {
  request: UpdateCandidateMergeRequest;
}


export interface CertMetricsMutationUpdateCandidatePasswordArgs {
  request: UpdateCandidatePasswordRequest;
}


export interface CertMetricsMutationUpdateCandidateSettingFilterArgs {
  request: UpdateCandidateSettingFilterRequest;
}


export interface CertMetricsMutationUpdateCandidateSettingListArgs {
  request: UpdateCandidateSettingListRequest;
}


export interface CertMetricsMutationUpdateCandidateTranscriptArgs {
  request: UpdateCandidateTranscriptRequest;
}


export interface CertMetricsMutationUpdateCandidateTranscriptCertCatalogInclusionsArgs {
  request: UpdateCandidateTranscriptInclusionsRequest;
}


export interface CertMetricsMutationUpdateCandidateTranscriptCertRequirementInclusionsArgs {
  request: UpdateCandidateTranscriptInclusionsRequest;
}


export interface CertMetricsMutationUpdateCandidateTranscriptExamInclusionsArgs {
  request: UpdateCandidateTranscriptInclusionsRequest;
}


export interface CertMetricsMutationUpdateCatalogAttachmentArgs {
  request: UpdateCatalogAttachmentRequest;
}


export interface CertMetricsMutationUpdateCertCatalogArgs {
  request: UpdateCertCatalogRequest;
}


export interface CertMetricsMutationUpdateCertGroupArgs {
  request: UpdateCertGroupRequest;
}


export interface CertMetricsMutationUpdateCertLogicVersionArgs {
  request: UpdateCertLogicVersionRequest;
}


export interface CertMetricsMutationUpdateCertRequirementArgs {
  request: UpdateCertRequirementRequest;
}


export interface CertMetricsMutationUpdateCertRequirementCatalogArgs {
  request: UpdateCertRequirementCatalogRequest;
}


export interface CertMetricsMutationUpdateCertRequirementGroupArgs {
  request: UpdateCertRequirementGroupRequest;
}


export interface CertMetricsMutationUpdateClientFeatureArgs {
  request: UpdateClientFeatureRequest;
}


export interface CertMetricsMutationUpdateClientLocalizationListArgs {
  request: UpdateLocalizationListRequest;
}


export interface CertMetricsMutationUpdateClientSettingArgs {
  request: UpdateClientSettingRequest;
}


export interface CertMetricsMutationUpdateCrcatOverrideCatalogArgs {
  request: UpdateCrcatOverrideCatalogRequest;
}


export interface CertMetricsMutationUpdateCredlyTemplateExpireDateArgs {
  request: UpdateCredlyTemplateExpireDateRequest;
}


export interface CertMetricsMutationUpdateCreqAuditArgs {
  request?: InputMaybe<UpdateCreqAuditRequest>;
}


export interface CertMetricsMutationUpdateCreqAuditItemArgs {
  request?: InputMaybe<UpdateCreqAuditItemRequest>;
}


export interface CertMetricsMutationUpdateEmailCatalogArgs {
  request: UpdateEmailCatalogRequest;
}


export interface CertMetricsMutationUpdateEmailLocalizationArgs {
  request: UpdateEmailLocalizationRequest;
}


export interface CertMetricsMutationUpdateExamArgs {
  request: UpdateExamRequest;
}


export interface CertMetricsMutationUpdateExamAccommArgs {
  request: UpdateExamAccommRequest;
}


export interface CertMetricsMutationUpdateExamAccommPackArgs {
  request: UpdateExamAccommPackRequest;
}


export interface CertMetricsMutationUpdateExamAuthorizationPackArgs {
  request: UpdateExamAuthorizationPackRequest;
}


export interface CertMetricsMutationUpdateExamCatalogArgs {
  request: UpdateExamCatalogRequest;
}


export interface CertMetricsMutationUpdateExamGroupArgs {
  request: UpdateExamGroupRequest;
}


export interface CertMetricsMutationUpdateExamVoucherArgs {
  request: UpdateExamVoucherRequest;
}


export interface CertMetricsMutationUpdateFilterArgs {
  request: UpdateFilterRequest;
}


export interface CertMetricsMutationUpdateFulfillmentCatalogArgs {
  request: UpdateFulfillmentCatalogRequest;
}


export interface CertMetricsMutationUpdateGeographyArgs {
  request: UpdateGeographyRequest;
}


export interface CertMetricsMutationUpdateHubLocalizationArgs {
  request: UpdateHubLocalizationRequest;
}


export interface CertMetricsMutationUpdateLocalizationListArgs {
  request: UpdateLocalizationListRequest;
}


export interface CertMetricsMutationUpdateNavigationArgs {
  request: UpdateNavigationRequest;
}


export interface CertMetricsMutationUpdateNewsArticleArgs {
  request: UpdateNewsArticleRequest;
}


export interface CertMetricsMutationUpdateOtherAchievementArgs {
  request: UpdateOtherAchievementRequest;
}


export interface CertMetricsMutationUpdateOtherAchievementCatalogArgs {
  request: UpdateOtherAchievementCatalogRequest;
}


export interface CertMetricsMutationUpdatePhysicalFulfillmentArgs {
  request: UpdatePhysicalFulfillmentRequest;
}


export interface CertMetricsMutationUpdateRoleArgs {
  request: UpdateRoleRequest;
}


export interface CertMetricsMutationUpdateStagingCandidateArgs {
  request: UpdateStagingCandidateRequest;
}


export interface CertMetricsMutationUpdateStagingCertRequirementArgs {
  request: UpdateStagingCertRequirementRequest;
}


export interface CertMetricsMutationUpdateStagingExamArgs {
  request: UpdateStagingExamRequest;
}


export interface CertMetricsMutationUpdateTagDomainArgs {
  request: UpdateTagDomainRequest;
}


export interface CertMetricsMutationUpdateWebUserArgs {
  request: UpdateWebUserRequest;
}


export interface CertMetricsMutationUpdateWebUserCandidateSettingFiltersArgs {
  request: UpdateWebUserCandidateSettingFilters;
}


export interface CertMetricsMutationUpdateWebUserGeographiesArgs {
  request: UpdateWebUserGeographies;
}


export interface CertMetricsMutationUpdateWebUserRolesArgs {
  request: UpdateWebUserRoles;
}


export interface CertMetricsMutationVerifyCandidateSelfMergeArgs {
  request: VerifyCandidateSelfMergeRequest;
}


export interface CertMetricsMutationVoidEtransactionArgs {
  request: VoidEtransactionRequest;
}

export interface CertMetricsQuery {
  /**
   * A list of all Accredible catalogs.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: ShareAccredibleBadging
   * 
   *  - Requires All Permissions: AccredibleBadging.Catalog.View
   *
   */
  accredibleCatalogList?: Maybe<Array<Maybe<AccredibleGroupCatalogResponseGqlType>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  activeAuditInfo?: Maybe<ActiveAuditCerts>;
  /**
   * A single affiliation entry.
   * 
   * 
   *  - Requires All Permissions: Affiliation.Catalog.View
   *
   */
  affiliation?: Maybe<AffiliationCatalog>;
  /**
   * A list of all affiliation entries available.
   * 
   * 
   *  - Requires All Permissions: Affiliation.Catalog.View
   *
   */
  affiliationList?: Maybe<Array<Maybe<AffiliationCatalog>>>;
  /**
   * A list of all distinct affiliation web groups.
   * 
   * 
   *  - Requires All Permissions: Affiliation.Catalog.View
   *
   */
  affiliationWebGroupList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  apiAccount?: Maybe<ApiAccountDetails>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  apiAccountList?: Maybe<Array<Maybe<ApiAccount>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: ExamAppointmentsExamAppointmentsStandardAppointments
   * 
   *  - Requires All Permissions: Exam.Appointments.View, Exam.Scheduling.View, Candidate.History.View, Candidate.ExamEvents.View, ViewCandidateExternalIds.View, Exam.Catalog.View
   *
   */
  appointments?: Maybe<Array<Maybe<Appointment>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Permissions: SponsorAttribute.Catalog.View
   *
   */
  attributeCatalogList?: Maybe<Array<Maybe<CandidateAttributeCatalog>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  auditCandidateStats?: Maybe<CreqAuditCandidateStats>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  auditCandidatesCount?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  auditCandidatesList?: Maybe<Array<Maybe<CreqAuditCandidate>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  auditHistorySummary?: Maybe<AuditHistorySummary>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  auditItemDetail?: Maybe<CreqAuditItemDetail>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  auditMessages?: Maybe<Array<Maybe<CreqAuditMessage>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  auditUserList?: Maybe<Array<Maybe<AuditUser>>>;
  /**
   * A list of all badge catalogs.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: CertMetricsBadging.Catalog.View
   *
   */
  badgeCatalogList?: Maybe<Array<Maybe<BadgeCatalog>>>;
  /**
   * A specific benefit catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   */
  benefitCatalogDetail?: Maybe<BenefitCatalogDetail>;
  /**
   * A list of all benefit catalog entries available.
   * 
   *  - Disallowed Account Types: Candidate
   */
  benefitCatalogList?: Maybe<Array<Maybe<BenefitCatalog>>>;
  /**
   * The full list of available benefit groups.
   * 
   *  - Disallowed Account Types: Candidate
   */
  benefitGroupList?: Maybe<Array<Maybe<BenefitGroup>>>;
  /**
   * 
   * 
   *
   */
  candidateAccount?: Maybe<CandidateAccount>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
   * 
   *  - Requires All Permissions: Candidate.AuditHistory.View
   *
   */
  candidateAuditHistory?: Maybe<Array<Maybe<CandidateAuditHistory>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.MergeDetails.View
   *
   */
  candidateMergeDetail?: Maybe<CandidateMergeDetail>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Permissions: MergeList.View
   *
   */
  candidateMergeList?: Maybe<Array<Maybe<CandidateMerge>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  candidateSearch?: Maybe<Array<Maybe<Candidate>>>;
  /**
   * Gets one specific candidate setting filter.
   * 
   * 
   *  - Admin accounts only
   *
   */
  candidateSettingFilter?: Maybe<CandidateSettingFilter>;
  /**
   * List all available candidate setting filters.
   * 
   * 
   *  - Admin accounts only
   *
   */
  candidateSettingFilters?: Maybe<Array<Maybe<CandidateSettingFilter>>>;
  /** A single Cert Catalog entry. */
  certCatalogDetail?: Maybe<CertCatalogDetail>;
  /**
   * A list of all Cert Catalog entries available.
   * 
   * 
   *  - Requires All Permissions: Credential.Catalog.View
   *
   */
  certCatalogList?: Maybe<Array<Maybe<CertCatalog>>>;
  /**
   * The full list of available Cert Groups.
   * 
   *  - Disallowed Account Types: Candidate
   */
  certGroupList?: Maybe<Array<Maybe<CertGroup>>>;
  /**
   * Detailed information about a single certification requirement catalog entry.
   * 
   * 
   *  - Requires Any Permissions: Requirements.Miscellaneous.Catalog.View, CredentialAgreements.Catalog.View, Requirements.ExternalCert.Catalog.View, Requirements.ContinuingEducation.Catalog.View, Requirements.ProgramFee.Catalog.View, Requirements.Enrollment.Catalog.View, Requirements.Training.Catalog.View, Requirements.Lab.Catalog.View, Requirements.ExternalExam.Catalog.View, Requirements.Participation.Catalog.View, CredentialAchievements.Catalog.View, Requirements.AdditionalAgreement.Catalog.View
   *
   */
  certRequirementCatalogDetail?: Maybe<CertRequirementCatalogDetail>;
  /**
   * A list of 'other' certification requirement catalog entries available.
   * 
   * 
   *  - Requires Any Permissions: Requirements.Miscellaneous.Catalog.View, CredentialAgreements.Catalog.View, Requirements.ExternalCert.Catalog.View, Requirements.ContinuingEducation.Catalog.View, Requirements.ProgramFee.Catalog.View, Requirements.Enrollment.Catalog.View, Requirements.Training.Catalog.View, Requirements.Lab.Catalog.View, Requirements.ExternalExam.Catalog.View, Requirements.Participation.Catalog.View, CredentialAchievements.Catalog.View, Requirements.AdditionalAgreement.Catalog.View
   *
   */
  certRequirementCatalogList?: Maybe<Array<Maybe<CertRequirementCatalog>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  certRequirementGroupList?: Maybe<Array<Maybe<CertificationRequirementGroup>>>;
  /**
   * 
   * 
   *
   */
  client?: Maybe<Client>;
  /** Returns client localization info filtered by feature. */
  clientLocalizationList?: Maybe<Array<Maybe<ClientLocalization>>>;
  clientSponsor?: Maybe<ClientSponsor>;
  countries?: Maybe<Array<Maybe<IsoCountry>>>;
  /**
   * A list of all credly badge templates.
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Features: ShareCredlyBadging
   * 
   *  - Requires All Permissions: Credly.Catalog.View
   *
   */
  credlyBadgeCatalogList?: Maybe<Array<Maybe<CredlyBadgeCatalog>>>;
  /** The list of allowed cultures. */
  cultures?: Maybe<Array<Maybe<Culture>>>;
  /** The list of data providers that exams can be imported for. */
  dataProviderList?: Maybe<Array<Maybe<DataProvider>>>;
  /** Returns client localization info as a json object filtered by feature. */
  defaultClientLocalizationList?: Maybe<Array<Maybe<DefaultClientLocalizationResponse>>>;
  /**
   * Gets all differences reports
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  differencesList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Permissions: Ecommerce.Catalog.View
   *
   */
  eTransactionItemCatalogList?: Maybe<Array<Maybe<EtransactionItemCatalog>>>;
  /** The list of data providers where sponsors may create or delete external ids via the ui. */
  editableCandidateDataProviderList?: Maybe<Array<Maybe<DataProvider>>>;
  /**
   * A single physical Fulfillment Catalog entry.
   * 
   * 
   *  - Requires All Permissions: CredentialFulfillment.Catalog.View
   *
   */
  electronicFulfillmentCatalogDetail?: Maybe<ElectronicFulfillmentCatalogDetail>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Permissions: CredentialFulfillment.Catalog.View
   *
   */
  electronicFulfillmentCatalogList?: Maybe<Array<Maybe<PhysicalFulfillmentCatalog>>>;
  /** The distinct list of cultures in which a specific email catalog has been localized/customized. The list contains IETF BCP 47 language tags. */
  emailCatalogCultures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * A single Email Catalog entry.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Email.Catalog.View
   *
   */
  emailCatalogDetail?: Maybe<EmailCatalogDetail>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Email.Catalog.View
   *
   */
  emailCatalogList?: Maybe<Array<Maybe<EmailCatalog>>>;
  /**
   * A list of the EmcatContexts available for a each EmcatType.
   * 
   * 
   *  - Internal accounts only
   *
   */
  emailContextList?: Maybe<Array<Maybe<EmailContextListResponse>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  emailContextOptionList?: Maybe<Array<Maybe<EmailContextOptionResponse>>>;
  /** The distinct list of cultures in which candidate emails have been localized/customized. The list contains IETF BCP 47 language tags. */
  emailCultures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * A list of all exam accommodation entries available.
   * 
   * 
   *  - Requires All Features: ExamAccommodations
   * 
   *  - Requires All Permissions: Exam.Accommodations.View
   *
   */
  examAccommodationCatalogList?: Maybe<Array<Maybe<ExamAccommCatalog>>>;
  /**
   * A list of all exam accommodation pack entries available.
   * 
   * 
   *  - Requires All Features: ExamAccommodations
   * 
   *  - Requires All Permissions: Exam.Accommodations.View
   *
   */
  examAccommodationPackCatalogList?: Maybe<Array<Maybe<ExamAccommPackCatalog>>>;
  /**
   * A single Exam Catalog entry.
   * 
   * 
   *  - Requires All Permissions: Exam.Catalog.View
   *
   */
  examCatalogDetail?: Maybe<ExamCatalogDetail>;
  /**
   * A list of all Exam Catalog entries available.
   * 
   * 
   *  - Requires Any Permissions: Ncarb.ScoreReports.BatchedDownloads.View, Exam.Catalog.View
   *
   */
  examCatalogList?: Maybe<Array<Maybe<ExamCatalog>>>;
  /**
   * The full list of available Exam Groups.
   * 
   *  - Disallowed Account Types: Candidate
   */
  examGroupList?: Maybe<Array<Maybe<ExamGroup>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires Any Features: CandidateSegmentation, Announcements
   * 
   *  - Requires Any Permissions: Announcements.Catalog.View, Candidate.Segmentation.View
   *
   */
  filterList?: Maybe<Array<Maybe<Filter>>>;
  /**
   * Find list of available locations
   * 
   * 
   *  - Requires All Features: ExamExamSchedulingInternal
   *
   */
  findInPersonLocations?: Maybe<SiteAvailabilityResponse>;
  /**
   * Find list of appointments for online exams
   * 
   * 
   *  - Requires All Features: ExamExamSchedulingInternal
   *
   */
  findOnlineExams?: Maybe<PrometricSlotSuggestionResponse>;
  /**
   * Find list of appointments for online exams
   * 
   * 
   *  - Requires All Features: ExamExamSchedulingInternal
   *
   */
  findSiteSlotsAvailability?: Maybe<SiteSlotsAvailabilityResponse>;
  /**
   * Lists all geographies setup by the client.
   * 
   * 
   *  - Admin accounts only
   *
   */
  geographies?: Maybe<Array<Maybe<ClientGeography>>>;
  /**
   * Gets one specific geography and it's related countries.
   * 
   * 
   *  - Admin accounts only
   *
   */
  geography?: Maybe<ClientGeography>;
  /**
   * Gets the latest differences report, or the number of candidates left to process if not yet complete
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  getLatestDifferences?: Maybe<DifferencesReport>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  hubFeature?: Maybe<HubFeature>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  hubPermission?: Maybe<HubPermission>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  linkedExtensionList?: Maybe<Array<Maybe<CertLinkedExtensionResponse>>>;
  /** A list of all metadata item entries. */
  metadataItemList?: Maybe<Array<Maybe<MetadataItem>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount
   */
  navigation?: Maybe<Array<Maybe<Navigation>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Permissions: Announcements.Catalog.View
   *
   */
  newsArticleDetail?: Maybe<NewsArticleDetail>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Permissions: Announcements.Catalog.View
   *
   */
  newsArticleList?: Maybe<Array<Maybe<NewsArticle>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: CandidateAccessLoginEMCOtherAchievements
   * 
   *  - Requires All Permissions: CredentialAchievements.Catalog.View
   *
   */
  otherAchievementCatalogList?: Maybe<Array<Maybe<OtherAchievementCatalog>>>;
  /**
   * Lists all permissions available.
   * 
   * 
   *  - Admin accounts only
   *
   */
  permissions?: Maybe<Array<Maybe<Permission>>>;
  /**
   * A single physical Fulfillment Catalog entry.
   * 
   * 
   *  - Requires All Permissions: CredentialFulfillment.Catalog.View
   *
   */
  physicalFulfillmentCatalogDetail?: Maybe<PhysicalFulfillmentCatalogDetail>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Permissions: CredentialFulfillment.Catalog.View
   *
   */
  physicalFulfillmentCatalogList?: Maybe<Array<Maybe<PhysicalFulfillmentCatalog>>>;
  /** Returns all candidate's e-certs for download. */
  publicEcert?: Maybe<Array<Maybe<PublicEcertDownload>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  queuedJobs?: Maybe<QueuedJobs>;
  /**
   * The quick list of candidates.
   * 
   * 
   *  - Admin accounts only
   *
   */
  quickList?: Maybe<Array<Maybe<Candidate>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Admin accounts only
   *
   */
  role?: Maybe<ClientRole>;
  /**
   * Lists all available roles.
   * 
   * 
   *  - Admin accounts only
   *
   */
  roles?: Maybe<Array<Maybe<ClientRole>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires Any Permissions: SponsorSetting.Catalog.View
   *
   */
  settingCatalogList?: Maybe<Array<Maybe<SettingCatalog>>>;
  /**
   * 
   * 
   *
   */
  ssoEgress?: Maybe<SsoEgress>;
  /**
   * A single Tag Domain entry.
   * 
   * 
   *  - Requires All Features: Tagging
   * 
   *  - Requires All Permissions: Tagging.Catalog.View
   *
   */
  tagDomainDetail?: Maybe<TagDomainDetail>;
  /**
   * A list of all tag domains.
   * 
   * 
   *  - Requires All Features: Tagging
   * 
   *  - Requires All Permissions: Tagging.Catalog.View
   *
   */
  tagDomainList?: Maybe<Array<Maybe<TagDomain>>>;
  /**
   * 
   * 
   *
   */
  tools?: Maybe<Tools>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Admin accounts only
   *
   */
  users?: Maybe<Array<Maybe<WebUser>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  webUserAccount?: Maybe<WebUserAccount>;
}


export interface CertMetricsQueryActiveAuditInfoArgs {
  request?: InputMaybe<CreqAuditItemRequest>;
}


export interface CertMetricsQueryAffiliationArgs {
  request: RequestByIdOrExternalId;
}


export interface CertMetricsQueryAffiliationListArgs {
  requestConfig?: InputMaybe<RequestConfig>;
}


export interface CertMetricsQueryApiAccountArgs {
  request?: InputMaybe<ApiAccountIdRequest>;
}


export interface CertMetricsQueryAppointmentsArgs {
  request?: InputMaybe<CandidateIdRequest>;
}


export interface CertMetricsQueryAuditCandidatesListArgs {
  request?: InputMaybe<CreqAuditCandidateRequest>;
}


export interface CertMetricsQueryAuditItemDetailArgs {
  request?: InputMaybe<RequestById>;
}


export interface CertMetricsQueryAuditMessagesArgs {
  request?: InputMaybe<AuditMessagesRequest>;
}


export interface CertMetricsQueryBenefitCatalogDetailArgs {
  request: RequestById;
}


export interface CertMetricsQueryCandidateAccountArgs {
  request?: InputMaybe<CandidateIdRequest>;
}


export interface CertMetricsQueryCandidateAuditHistoryArgs {
  request?: InputMaybe<CandidateAuditHistoryRequest>;
}


export interface CertMetricsQueryCandidateMergeDetailArgs {
  request: RequestById;
}


export interface CertMetricsQueryCandidateMergeListArgs {
  request?: InputMaybe<CandidateMergeListRequest>;
}


export interface CertMetricsQueryCandidateSearchArgs {
  request?: InputMaybe<CandidateSearchRequest>;
}


export interface CertMetricsQueryCandidateSettingFilterArgs {
  request: RequestByIdOrExternalId;
}


export interface CertMetricsQueryCertCatalogDetailArgs {
  request: RequestByIdOrExternalId;
}


export interface CertMetricsQueryCertCatalogListArgs {
  request?: InputMaybe<CertCatalogListRequest>;
}


export interface CertMetricsQueryCertRequirementCatalogDetailArgs {
  request: RequestByIdOrExternalId;
}


export interface CertMetricsQueryCertRequirementCatalogListArgs {
  request?: InputMaybe<CertRequirementCatalogListRequest>;
}


export interface CertMetricsQueryClientLocalizationListArgs {
  request: ClientLocalizationRequest;
}


export interface CertMetricsQueryCulturesArgs {
  request?: InputMaybe<CulturesRequest>;
}


export interface CertMetricsQueryDefaultClientLocalizationListArgs {
  request: DefaultClientLocalizationRequest;
}


export interface CertMetricsQueryElectronicFulfillmentCatalogDetailArgs {
  request: RequestById;
}


export interface CertMetricsQueryEmailCatalogCulturesArgs {
  request: EmcatType;
}


export interface CertMetricsQueryEmailCatalogDetailArgs {
  request: RequestById;
}


export interface CertMetricsQueryEmailContextOptionListArgs {
  request: EmcatContextOptionListRequest;
}


export interface CertMetricsQueryExamCatalogDetailArgs {
  request: RequestByIdOrExternalId;
}


export interface CertMetricsQueryFindInPersonLocationsArgs {
  request?: InputMaybe<InPersonAvailableLocationsRequest>;
}


export interface CertMetricsQueryFindOnlineExamsArgs {
  request?: InputMaybe<OnlineAvailableExamTimesRequest>;
}


export interface CertMetricsQueryFindSiteSlotsAvailabilityArgs {
  request?: InputMaybe<SiteAvailableSlotsRequest>;
}


export interface CertMetricsQueryGeographyArgs {
  request: RequestByIdOrExternalId;
}


export interface CertMetricsQueryMetadataItemListArgs {
  request?: InputMaybe<MetadataItemListRequest>;
}


export interface CertMetricsQueryNavigationArgs {
  request?: InputMaybe<NavigationListRequestVm>;
}


export interface CertMetricsQueryNewsArticleDetailArgs {
  request?: InputMaybe<RequestById>;
}


export interface CertMetricsQueryPhysicalFulfillmentCatalogDetailArgs {
  request: RequestById;
}


export interface CertMetricsQueryPublicEcertArgs {
  request: PublicEcertRequest;
}


export interface CertMetricsQueryRoleArgs {
  request: RequestByIdOrExternalId;
}


export interface CertMetricsQueryTagDomainDetailArgs {
  request: RequestById;
}


export interface CertMetricsQueryWebUserAccountArgs {
  request?: InputMaybe<WebUserIdRequest>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertProcessRequest {
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  attempts?: Maybe<Scalars['Byte']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  ccatId?: Maybe<Scalars['Int']['output']>;
  cmcId?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['CmDate']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  elapsed?: Maybe<Scalars['Milliseconds']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  handler?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Byte']['output']>;
  requested?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  state?: Maybe<CprState>;
  type?: Maybe<CprType>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
 * 
 *  - Requires Any Permissions: Candidate.Requirements.Miscellaneous.View, Candidate.CredentialAgreements.View, Candidate.Requirements.ExternalCert.View, Candidate.Requirements.ContinuingEducation.View, Candidate.Requirements.ProgramFee.View, Candidate.Requirements.Enrollment.View, Candidate.Requirements.Training.View, Candidate.Requirements.Lab.View, Candidate.Requirements.ExternalExam.View, Candidate.Requirements.Participation.View, Candidate.CredentialAchievements.View, Candidate.Requirements.AdditionalAgreement.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertRequirement {
  activeDate: Scalars['CmDate']['output'];
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  catalogId: Scalars['Int']['output'];
  certRequirementCatalog?: Maybe<CertRequirementCatalog>;
  cmcId: Scalars['Int']['output'];
  creqCrvId?: Maybe<Scalars['Int']['output']>;
  creqVoucher?: Maybe<CreqVoucher>;
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  docChangeable?: Maybe<Scalars['Boolean']['output']>;
  docLanguage?: Maybe<Scalars['String']['output']>;
  docNotes?: Maybe<Scalars['String']['output']>;
  docUploadUrl?: Maybe<Scalars['String']['output']>;
  docUrl?: Maybe<Scalars['String']['output']>;
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  importSource?: Maybe<Scalars['String']['output']>;
  invalid: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementShowOverrideName
   *
   */
  override?: Maybe<CertRequirementCatalogOverrideCatalog>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Short']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  /** Indicates what part of the review process the requirement is in. None indicates that no review is needed. */
  reviewState: CreqReviewState;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialAchievementsCertificate
   *
   */
  standingECertUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CreqStatus>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
 *
 */
export interface CertRequirementCatalog {
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareCertMetricsBadging
   *
   */
  badgeCatalog?: Maybe<BadgeCatalog>;
  canCurrentAccountCreate: Scalars['Boolean']['output'];
  candidateCreateEnabled: Scalars['Boolean']['output'];
  /** The catalog attachment associated with this cert requirement catalog. */
  catalogAttachment?: Maybe<Array<Maybe<CatalogAttachment>>>;
  certRequirementGroup?: Maybe<CertificationRequirementGroup>;
  /** Indicates how certification requirements are created for this catalog */
  createType: CrcatCreateType;
  /**
   * Are certification transcripts enabled?
   * 
   * 
   *  - Requires All Features: ShareTranscript
   *
   */
  ctranEnabled: Scalars['Boolean']['output'];
  /** A description of this requirement catalog */
  description?: Maybe<Scalars['String']['output']>;
  /** The order this requirement should display in the ui */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** When the requirement ends */
  endDate?: Maybe<Scalars['CmDate']['output']>;
  /** The external identifier for the requirement catalog */
  externalId?: Maybe<Scalars['String']['output']>;
  /**
   * The factor for converting between what a person is expected to enter and the actual point-value that should be used for creq-points.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  factor?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Indicates text to use for the label that goes with the input where the value of the creq being created is entered.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  factorUnits?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  /**
   * A link to download the logo file(s) for this particular crcat
   * 
   * 
   *  - Requires All Features: CredentialAchievementsLogoDownload
   *
   */
  logoDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** A flag indicating if the standing logo is enabled. */
  logoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A link to upload the logo file(s) for this particular cert
   * 
   * 
   *  - Requires All Features: CredentialAchievementsLogoDownload
   *
   */
  logoUploadUrl?: Maybe<Scalars['String']['output']>;
  /** Custom metadata attributes for this certification requirement catalog entry. */
  metadata?: Maybe<Array<Maybe<CertRequirementCatalogMetadata>>>;
  name: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Short']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  pointsMax?: Maybe<Scalars['Short']['output']>;
  /** Determines if the UI requires creq-provider to be set when creating/editing a creq. */
  providerRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementSchedulingUrl
   *
   */
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates if this requirement can only be used one time
   * 
   *  - Disallowed Account Types: Candidate
   */
  singleUse: Scalars['Boolean']['output'];
  /** A flag indicating if the catalog attachment catch is disabled. */
  standingECertEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** When the requirement begins */
  startDate?: Maybe<Scalars['CmDate']['output']>;
  /** Indicates the types of requirement possible */
  type: CrcatType;
  /**
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementInformationUrl
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /** How long this requirement is valid for in months */
  validPeriod: Scalars['Short']['output'];
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
 *
 */
export interface CertRequirementCatalogDetail {
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareCertMetricsBadging
   *
   */
  badgeCatalog?: Maybe<BadgeCatalog>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  cadcExclude: Scalars['Boolean']['output'];
  canCurrentAccountCreate: Scalars['Boolean']['output'];
  candidateCreateEnabled: Scalars['Boolean']['output'];
  /** The catalog attachment associated with this cert requirement catalog. */
  catalogAttachment?: Maybe<Array<Maybe<CatalogAttachment>>>;
  /** Any catalog external ids associated with the requirement. */
  catalogExternalIdList?: Maybe<Array<Maybe<CatalogExternalId>>>;
  certRequirementGroup?: Maybe<CertificationRequirementGroup>;
  createAge?: Maybe<Scalars['Byte']['output']>;
  /** Indicates how certification requirements are created for this catalog */
  createType: CrcatCreateType;
  /** When this catalog was created */
  created: Scalars['CmDateTimeOffset']['output'];
  /**
   * Are certification transcripts enabled?
   * 
   * 
   *  - Requires All Features: ShareTranscript
   *
   */
  ctranEnabled: Scalars['Boolean']['output'];
  /** A description of this requirement catalog */
  description?: Maybe<Scalars['String']['output']>;
  /** The order this requirement should display in the ui */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  docRequired?: Maybe<Scalars['Boolean']['output']>;
  /** When the requirement ends */
  endDate?: Maybe<Scalars['CmDate']['output']>;
  /** The external identifier for the requirement catalog */
  externalId?: Maybe<Scalars['String']['output']>;
  /**
   * The factor for converting between what a person is expected to enter and the actual point-value that should be used for creq-points.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  factor?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Indicates text to use for the label that goes with the input where the value of the creq being created is entered.
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  factorUnits?: Maybe<Scalars['String']['output']>;
  /** The id of the associated requirement group */
  groupId: Scalars['Int']['output'];
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  historyList?: Maybe<Array<Maybe<SystemHistory>>>;
  id: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  /**
   * A link to download the logo file(s) for this particular crcat
   * 
   * 
   *  - Requires All Features: CredentialAchievementsLogoDownload
   *
   */
  logoDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** A flag indicating if the standing logo is enabled. */
  logoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A link to upload the logo file(s) for this particular cert
   * 
   * 
   *  - Requires All Features: CredentialAchievementsLogoDownload
   *
   */
  logoUploadUrl?: Maybe<Scalars['String']['output']>;
  /** Custom metadata attributes for this certification requirement catalog entry. */
  metadata?: Maybe<Array<Maybe<CertRequirementCatalogMetadata>>>;
  name: Scalars['String']['output'];
  /**
   * A specific cert requirement override groups associated with the requirement.
   * 
   * 
   *  - Requires All Features: OtherRequirementAdvancedSelection
   *
   */
  overrideGroupDetail?: Maybe<CertRequirementCatalogOverrideGroupDetail>;
  /**
   * Any cert requirement override groups associated with the requirement.
   * 
   * 
   *  - Requires All Features: OtherRequirementAdvancedSelection
   *
   */
  overrideGroupList?: Maybe<Array<Maybe<CertRequirementCatalogOverrideGroup>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Short']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  pointsMax?: Maybe<Scalars['Short']['output']>;
  /** Determines if the UI requires creq-provider to be set when creating/editing a creq. */
  providerRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the list of Cert tracks that use this Cert track in logic processing. */
  relatedCertCatalogList?: Maybe<Array<Maybe<CertCatalog>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementSchedulingUrl
   *
   */
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates if this requirement can only be used one time
   * 
   *  - Disallowed Account Types: Candidate
   */
  singleUse: Scalars['Boolean']['output'];
  /** A flag indicating if the catalog attachment catch is disabled. */
  standingECertEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The url to make a PUT request to, in order to upload a standing ecert template.
   * 
   *  - Disallowed Account Types: Candidate
   */
  standingECertTemplateUploadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * A link for the creq standing ecert template url, null if no file exists
   * 
   *  - Disallowed Account Types: Candidate
   */
  standingECertTemplateUrl?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialAchievements
   *
   */
  standingRule?: Maybe<StandingRule>;
  /** When the requirement begins */
  startDate?: Maybe<Scalars['CmDate']['output']>;
  /** Indicates the types of requirement possible */
  type: CrcatType;
  /**
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementInformationUrl
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /** How long this requirement is valid for in months */
  validPeriod: Scalars['Short']['output'];
}


/**
 * 
 * 
 * 
 *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
 *
 */
export interface CertRequirementCatalogDetailOverrideGroupDetailArgs {
  request?: InputMaybe<RequestById>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: OtherRequirement
 *
 */
export interface CertRequirementCatalogListRequest {
  creatable?: InputMaybe<Scalars['Boolean']['input']>;
  logicCcatId?: InputMaybe<Scalars['Int']['input']>;
  logicType?: InputMaybe<CertLogicType>;
  type?: InputMaybe<CrcatType>;
}

/** Custom metadata attribute for a certification requirement catalog entry. */
export interface CertRequirementCatalogMetadata {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['output'];
  /** Foreign key to the cert requirement catalog record this metadata belongs to. */
  certRequirementCatalogId: Scalars['Int']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** The value of the attribute. */
  value?: Maybe<Scalars['String']['output']>;
}

/**
 * This is for the certification requirement override catalogs (cocats).
 * 
 * 
 *  - Requires All Features: OtherRequirementAdvancedSelection
 *
 */
export interface CertRequirementCatalogOverrideCatalog {
  createAge?: Maybe<Scalars['Byte']['output']>;
  /** Creation date. */
  created: Scalars['CmDateTimeOffset']['output'];
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** Creation date. */
  endDate?: Maybe<Scalars['CmDate']['output']>;
  factor?: Maybe<Scalars['Decimal']['output']>;
  /** Unique identifier for this certification requirement override catalog */
  id: Scalars['Int']['output'];
  maxPoints?: Maybe<Scalars['Short']['output']>;
  /** Catalog display name. */
  name: Scalars['String']['output'];
  points?: Maybe<Scalars['Short']['output']>;
  /** Last updated date. */
  startDate?: Maybe<Scalars['CmDate']['output']>;
  /** Last updated date. */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  validPeriod?: Maybe<Scalars['Short']['output']>;
}

/**
 * This is for the grouping of certification requirement overrides (cogs).
 * 
 * 
 *  - Requires All Features: OtherRequirementAdvancedSelection
 *
 */
export interface CertRequirementCatalogOverrideGroup {
  /** Creation date. */
  created: Scalars['CmDateTimeOffset']['output'];
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** Unique identifier for this certification requirement override group */
  id: Scalars['Int']['output'];
  /** Group display name. */
  name: Scalars['String']['output'];
  /** Last updated date. */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * This is for the grouping of certification requirement overrides (cogs).
 * 
 * 
 *  - Requires All Features: OtherRequirementAdvancedSelection
 * 
 * 
 * 
 *  - Requires All Features: OtherRequirementAdvancedSelection
 *
 */
export interface CertRequirementCatalogOverrideGroupDetail {
  /** The cert requirement override catalogs */
  catalogList?: Maybe<Array<Maybe<CertRequirementCatalogOverrideCatalog>>>;
  /** Creation date. */
  created: Scalars['CmDateTimeOffset']['output'];
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** Unique identifier for this certification requirement override group */
  id: Scalars['Int']['output'];
  /** Group display name. */
  name: Scalars['String']['output'];
  /** Last updated date. */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
 * 
 *  - Requires Any Permissions: Candidate.Requirements.Miscellaneous.View, Candidate.CredentialAgreements.View, Candidate.Requirements.ExternalCert.View, Candidate.Requirements.ContinuingEducation.View, Candidate.Requirements.ProgramFee.View, Candidate.Requirements.Enrollment.View, Candidate.Requirements.Training.View, Candidate.Requirements.Lab.View, Candidate.Requirements.ExternalExam.View, Candidate.Requirements.Participation.View, Candidate.CredentialAchievements.View, Candidate.Requirements.AdditionalAgreement.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertRequirementDetail {
  activeDate: Scalars['CmDate']['output'];
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  candidateCanUpdate?: Maybe<Scalars['Boolean']['output']>;
  candidateCreated: Scalars['Boolean']['output'];
  catalogId: Scalars['Int']['output'];
  certRequirementCatalog?: Maybe<CertRequirementCatalog>;
  certRequirementCatalogDetail?: Maybe<CertRequirementCatalogDetail>;
  cmcId: Scalars['Int']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  creqCrvId?: Maybe<Scalars['Int']['output']>;
  creqVoucher?: Maybe<CreqVoucher>;
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  /** The unique Id (PK) of the data provider that delivered the Exam. This is considered the domain/context/scope within which the Exam.RegistrationNumber is unique. */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  docChangeable?: Maybe<Scalars['Boolean']['output']>;
  docLanguage?: Maybe<Scalars['String']['output']>;
  docNotes?: Maybe<Scalars['String']['output']>;
  docUploadUrl?: Maybe<Scalars['String']['output']>;
  docUrl?: Maybe<Scalars['String']['output']>;
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  importSource?: Maybe<Scalars['String']['output']>;
  invalid: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementShowOverrideName
   *
   */
  override?: Maybe<CertRequirementCatalogOverrideCatalog>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Short']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  /** Indicates what part of the review process the requirement is in. None indicates that no review is needed. */
  reviewState: CreqReviewState;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialAchievementsCertificate
   *
   */
  standingECertUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CreqStatus>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
 *
 */
export interface CertRequirementListRequest {
  types?: InputMaybe<Array<InputMaybe<CrcatType>>>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: OtherRequirementUploadCandidateAccess
 * 
 *  - Requires All Permissions: OtherRequirements.ReviewList.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertRequirementUnderReviewResponse {
  candidate?: Maybe<Candidate>;
  catalog?: Maybe<CertRequirementCatalog>;
  cmcId: Scalars['Int']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  id: Scalars['Int']['output'];
  updated: Scalars['CmDateTimeOffset']['output'];
}

export enum CertStatus {
  /** Active */
  Active = 'Active',
  /** Deleted */
  Deleted = 'Deleted',
  /** Emeritus */
  Emeritus = 'Emeritus',
  /** Expired */
  Expired = 'Expired',
  /** LifetimeEmeritus */
  LifetimeEmeritus = 'LifetimeEmeritus',
  /** Started */
  Started = 'Started',
  /** Suspended */
  Suspended = 'Suspended'
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface CertUsedItem {
  cert?: Maybe<Cert>;
  certRequirement?: Maybe<CertRequirement>;
  created: Scalars['CmDateTimeOffset']['output'];
  exam?: Maybe<Exam>;
  id?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
}

/**
 * This is for the grouping of certification requirements (crcats). Groups are able to be further/alternately grouped into programs.
 * 
 * 
 *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
 *
 */
export interface CertificationRequirementGroup {
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** Unique identifier for this certification requirement group */
  id: Scalars['Int']['output'];
  /** Group display name. */
  name: Scalars['String']['output'];
  /** Optional Grouping used instead of defaults built into the catalog. If using, must be on all groups. */
  program?: Maybe<Scalars['String']['output']>;
}

/** Contains a variety of helper links for Certiverse candidate egress sso. */
export interface CertiverseSsoEgress {
  dashboard?: Maybe<Scalars['String']['output']>;
  store?: Maybe<Scalars['String']['output']>;
}

export enum CfcRule {
  /** CcatAchieved */
  CcatAchieved = 'CcatAchieved',
  /** CcatActive */
  CcatActive = 'CcatActive',
  /** CcatExpired */
  CcatExpired = 'CcatExpired',
  /** CcatInactive */
  CcatInactive = 'CcatInactive',
  /** CcatSuspended */
  CcatSuspended = 'CcatSuspended',
  /** ClaListItems */
  ClaListItems = 'ClaListItems',
  /** CrcatAchieved */
  CrcatAchieved = 'CrcatAchieved',
  /** CrcatActive */
  CrcatActive = 'CrcatActive',
  /** CrcatInactive */
  CrcatInactive = 'CrcatInactive',
  /** ExcatFailed */
  ExcatFailed = 'ExcatFailed',
  /** ExcatPassed */
  ExcatPassed = 'ExcatPassed',
  /** ExcatTaken */
  ExcatTaken = 'ExcatTaken',
  /** IcCodeAddr1 */
  IcCodeAddr1 = 'IcCodeAddr1',
  /** StandingAchieved */
  StandingAchieved = 'StandingAchieved',
  /** StandingActive */
  StandingActive = 'StandingActive',
  /** StandingInactive */
  StandingInactive = 'StandingInactive'
}

export enum ChType {
  /** InitialCert */
  InitialCert = 'InitialCert',
  /** LinkedExtension */
  LinkedExtension = 'LinkedExtension',
  /** LinkedSuspendedExtension */
  LinkedSuspendedExtension = 'LinkedSuspendedExtension',
  /** ManualCertAdjust */
  ManualCertAdjust = 'ManualCertAdjust',
  /** ManualCertAdjustNLE */
  ManualCertAdjustNle = 'ManualCertAdjustNLE',
  /** ManualCertCreate */
  ManualCertCreate = 'ManualCertCreate',
  /** ManualCertCreateNLE */
  ManualCertCreateNle = 'ManualCertCreateNLE',
  /** ManualCertExtend */
  ManualCertExtend = 'ManualCertExtend',
  /** ManualCertExtendNLE */
  ManualCertExtendNle = 'ManualCertExtendNLE',
  /** ManualCertReduce */
  ManualCertReduce = 'ManualCertReduce',
  /** ManualCertReduceNLE */
  ManualCertReduceNle = 'ManualCertReduceNLE',
  /** NormalExtension */
  NormalExtension = 'NormalExtension',
  /** SuspendedExtension */
  SuspendedExtension = 'SuspendedExtension'
}

export enum ChistType {
  /** AccommEdit */
  AccommEdit = 'AccommEdit',
  /** AuthEdit */
  AuthEdit = 'AuthEdit',
  /** BadgeEmailRemoval */
  BadgeEmailRemoval = 'BadgeEmailRemoval',
  /** BenefitEdit */
  BenefitEdit = 'BenefitEdit',
  /** BenefitVoucherEdit */
  BenefitVoucherEdit = 'BenefitVoucherEdit',
  /** CandidateAPIAuthChange */
  CandidateApiAuthChange = 'CandidateAPIAuthChange',
  /** CandidateBanning */
  CandidateBanning = 'CandidateBanning',
  /** CandidateEdit */
  CandidateEdit = 'CandidateEdit',
  /** CandidateEligAgrSigned */
  CandidateEligAgrSigned = 'CandidateEligAgrSigned',
  /** CandidateEmailAddrReset */
  CandidateEmailAddrReset = 'CandidateEmailAddrReset',
  /** CandidateExtBadgeRestrict */
  CandidateExtBadgeRestrict = 'CandidateExtBadgeRestrict',
  /** CandidateExtIDMove */
  CandidateExtIdMove = 'CandidateExtIDMove',
  /** CandidateGdpr */
  CandidateGdpr = 'CandidateGdpr',
  /** CandidateLogin */
  CandidateLogin = 'CandidateLogin',
  /** CandidateLogoAgrSigned */
  CandidateLogoAgrSigned = 'CandidateLogoAgrSigned',
  /** CandidateLogout */
  CandidateLogout = 'CandidateLogout',
  /** CandidateMerge */
  CandidateMerge = 'CandidateMerge',
  /** CandidatePrivacyNotice */
  CandidatePrivacyNotice = 'CandidatePrivacyNotice',
  /** CandidatePwdReset */
  CandidatePwdReset = 'CandidatePwdReset',
  /** CandidateRestrictTesting */
  CandidateRestrictTesting = 'CandidateRestrictTesting',
  /** CandidateWatch */
  CandidateWatch = 'CandidateWatch',
  /** CertEdit */
  CertEdit = 'CertEdit',
  /** CertLogoDownload */
  CertLogoDownload = 'CertLogoDownload',
  /** CertRegression */
  CertRegression = 'CertRegression',
  /** Comment */
  Comment = 'Comment',
  /** CookieAgrSigned */
  CookieAgrSigned = 'CookieAgrSigned',
  /** CreqEdit */
  CreqEdit = 'CreqEdit',
  /** CxEdit */
  CxEdit = 'CxEdit',
  /** ExamBulkUpload */
  ExamBulkUpload = 'ExamBulkUpload',
  /** ExamEdit */
  ExamEdit = 'ExamEdit',
  /** ExamEventEdit */
  ExamEventEdit = 'ExamEventEdit',
  /** ExamExtSecurityEvent */
  ExamExtSecurityEvent = 'ExamExtSecurityEvent',
  /** ExamReviewNote */
  ExamReviewNote = 'ExamReviewNote',
  /** ExamScoreReportDownload */
  ExamScoreReportDownload = 'ExamScoreReportDownload',
  /** ExamViolationEdit */
  ExamViolationEdit = 'ExamViolationEdit',
  /** ExamVoucherEdit */
  ExamVoucherEdit = 'ExamVoucherEdit',
  /** ExternalComment */
  ExternalComment = 'ExternalComment',
  /** FulfillmentCreate */
  FulfillmentCreate = 'FulfillmentCreate',
  /** FulfillmentEdit */
  FulfillmentEdit = 'FulfillmentEdit',
  /** FulfillmentElectronicDownload */
  FulfillmentElectronicDownload = 'FulfillmentElectronicDownload',
  /** OtherAchEdit */
  OtherAchEdit = 'OtherAchEdit',
  /** QstnrComment */
  QstnrComment = 'QstnrComment',
  /** QstnrEdit */
  QstnrEdit = 'QstnrEdit',
  /** QstnrItemApproved */
  QstnrItemApproved = 'QstnrItemApproved',
  /** QstnrItemEdit */
  QstnrItemEdit = 'QstnrItemEdit',
  /** QstnrPaidApplication */
  QstnrPaidApplication = 'QstnrPaidApplication',
  /** QstnrStatusChange */
  QstnrStatusChange = 'QstnrStatusChange',
  /** SecurityNote */
  SecurityNote = 'SecurityNote',
  /** StandingsDownload */
  StandingsDownload = 'StandingsDownload',
  /** VignetteEdit */
  VignetteEdit = 'VignetteEdit'
}

/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: CiscoCustomReports
 *
 */
export interface CiscoTools {
  /**
   * 
   * 
   * 
   *  - Requires All Features: CiscoCustomReportsNetAcad
   * 
   *  - Requires All Permissions: CiscoCustomReport.NetAcad.Modify
   *
   */
  netacadReport?: Maybe<Array<Maybe<NetacadReport>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: CiscoCustomReportsTPM
   * 
   *  - Requires All Permissions: CiscoCustomReport.TPM.Modify
   *
   */
  tpmReport?: Maybe<Array<Maybe<TpmReport>>>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: CiscoCustomReports
 *
 */
export interface CiscoToolsNetacadReportArgs {
  request: NetacadReportRequest;
  requestConfig?: InputMaybe<RequestConfig>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: CiscoCustomReports
 *
 */
export interface CiscoToolsTpmReportArgs {
  request: TpmReportRequest;
  requestConfig?: InputMaybe<RequestConfig>;
}

export enum ClType {
  /** Invalid */
  Invalid = 'Invalid',
  /** Normal */
  Normal = 'Normal',
  /** Suspended */
  Suspended = 'Suspended'
}

export interface ClaimBenefitRequest {
  benefitId?: InputMaybe<Scalars['Int']['input']>;
  candidateId: CandidateIdRequest;
}

export interface ClaimExamAuthorizationPackRequest {
  candidateId?: InputMaybe<CandidateIdRequest>;
  excatId: Scalars['Int']['input'];
}

export enum CliType {
  /** CEActivity */
  CeActivity = 'CEActivity',
  /** CertFee */
  CertFee = 'CertFee',
  /** Normal */
  Normal = 'Normal',
  /** PreRequisite */
  PreRequisite = 'PreRequisite'
}

/** Information about a CertMetrics client. */
export interface Client {
  id: Scalars['Int']['output'];
  idAuthority: DataProvider;
  name: Scalars['String']['output'];
}

export interface ClientDisplayNameRequest {
  clientAlias: Scalars['String']['input'];
}

export interface ClientFeatureListRequest {
  clientAlias?: InputMaybe<Scalars['String']['input']>;
  includeAvailable?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * The geography and its associated countries
 * 
 * 
 *  - Admin accounts only
 *
 */
export interface ClientGeography {
  /** All the countries that fall within the geography. */
  countries?: Maybe<Array<Maybe<IsoCountry>>>;
  /** When the geography was created by the client. */
  created: Scalars['CmDate']['output'];
  /** The id of the geography. */
  id: Scalars['Int']['output'];
  /** The name of the geography. */
  name: Scalars['String']['output'];
}

export interface ClientLocalization {
  cultureInfoName: Scalars['String']['output'];
  englishValueResolved?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  locType?: Maybe<LocType>;
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
}

export interface ClientLocalizationRequest {
  clientDbAlias: Scalars['String']['input'];
  filterNotFound?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  localizations?: InputMaybe<Array<InputMaybe<CmLocalizationItem>>>;
}

/**
 * The roles for users
 * 
 * 
 *  - Admin accounts only
 *
 */
export interface ClientRole {
  /** The filter associated with this role. */
  clientFilter?: Maybe<Filter>;
  /** The id of the filter associated with this role. */
  clientFilterId?: Maybe<Scalars['Int']['output']>;
  /** The date it was created. */
  created: Scalars['CmDate']['output'];
  /** The id of the role. */
  id: Scalars['Int']['output'];
  /** The name of the role. */
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Maybe<Permission>>>;
}

/** The name of the setting being controlled/defined. Names should be in PascalCase */
export interface ClientSetting {
  csetDatetime?: Maybe<Scalars['DateTime']['output']>;
  csetId: Scalars['Int']['output'];
  csetInt?: Maybe<Scalars['Int']['output']>;
  csetName: Scalars['String']['output'];
  csetNvarchar?: Maybe<Scalars['String']['output']>;
  csetVarchar?: Maybe<Scalars['String']['output']>;
}

/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsor {
  /** Lists current features for the client. */
  currentAccountFeatures?: Maybe<Array<Maybe<Feature>>>;
  /** The public client display name. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Tells the consumer whether emails are being sent/rejected for candidates */
  emailsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Lists enabled/available features for the client. */
  features?: Maybe<Array<Maybe<Feature>>>;
  /**
   * A specific hub localization.
   * 
   * 
   *  - Internal accounts only
   *
   */
  hubLocalization?: Maybe<HubLocalization>;
  /**
   * A list of hub localizations.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  hubLocalizationList?: Maybe<Array<Maybe<HubLocalization>>>;
  /**
   * A specific localization.
   * 
   * 
   *  - Must have localization enabled
   *
   */
  localization?: Maybe<LocalizationResponse>;
  /** A list of localizations. */
  localizationList?: Maybe<Array<Maybe<LocalizationResponse>>>;
  /** A list of all client resource strings by culture. */
  localizationListByCulture?: Maybe<Array<Maybe<LocalizationResponse>>>;
  /** A list of customized cultures in-use by the indicated client. */
  localizedCultures?: Maybe<Array<Maybe<CultureInfoResponse>>>;
  /**
   * 
   * 
   *
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Lists all possible features in CertMetrics.
   * 
   * 
   *  - Internal accounts only
   *
   */
  possibleFeatures?: Maybe<Array<Maybe<FeatureInfo>>>;
  /** A list of all regional markets. */
  regionalMarketList?: Maybe<Array<Maybe<RegionalMarket>>>;
  /** A list of supported cultures. */
  supportedCultures?: Maybe<Array<Maybe<CultureInfoResponse>>>;
  /** A list of supported localization types. */
  supportedLocalizationTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of system histories. */
  systemHistoryList?: Maybe<Array<Maybe<SystemHistory>>>;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorDisplayNameArgs {
  request: ClientDisplayNameRequest;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorFeaturesArgs {
  includeAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  request?: InputMaybe<ClientFeatureListRequest>;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorHubLocalizationArgs {
  request: RequestById;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorLocalizationArgs {
  request: GetLocalizationRequest;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorLocalizationListArgs {
  request: GetLocalizationListRequest;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorLocalizationListByCultureArgs {
  request: GetLocalizationListRequest;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorLocalizedCulturesArgs {
  request?: InputMaybe<GetLocalizedCulturesListRequest>;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorSupportedCulturesArgs {
  request?: InputMaybe<GetSupportedCulturesListRequest>;
}


/** Information about the CertMetrics client/sponsor. */
export interface ClientSponsorSystemHistoryListArgs {
  requestConfig?: InputMaybe<RequestConfig>;
}

export interface CmLocalizationItem {
  name: Scalars['String']['input'];
  type: LocType;
}

export enum CmSearchMethodEnum {
  /** Contains */
  Contains = 'Contains',
  /** EndsWith */
  EndsWith = 'EndsWith',
  /** Equals */
  Equals = 'Equals',
  /** GreaterThan */
  GreaterThan = 'GreaterThan',
  /** GreaterThanOrEquals */
  GreaterThanOrEquals = 'GreaterThanOrEquals',
  /** LessThan */
  LessThan = 'LessThan',
  /** LessThanOrEquals */
  LessThanOrEquals = 'LessThanOrEquals',
  /** StartsWith */
  StartsWith = 'StartsWith'
}

export interface CompleteCandidateSelfMergeRequest {
  jwt: Scalars['String']['input'];
}

export interface ComptiaBulkCeVoucherUploadRequest {
  batchId?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['CmDate']['input']>;
  voucherUploadList?: InputMaybe<Array<InputMaybe<ComptiaCeVoucherUploadRequest>>>;
}

export interface ComptiaBulkVerifyActivityImportRequest {
  activityCode?: InputMaybe<Scalars['String']['input']>;
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityDate?: InputMaybe<Scalars['CmDate']['input']>;
  activityPoints?: InputMaybe<Scalars['String']['input']>;
  activityProvider?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}

export interface ComptiaBulkVerifyActivityImportRequestList {
  requestList: Array<InputMaybe<ComptiaBulkVerifyActivityImportRequest>>;
}

export interface ComptiaBulkVerifyActivityImportResponse {
  activityCode?: Maybe<Scalars['String']['output']>;
  activityComments?: Maybe<Scalars['String']['output']>;
  activityDate?: Maybe<Scalars['CmDate']['output']>;
  activityPoints?: Maybe<Scalars['Int']['output']>;
  activityProvider?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
}

export interface ComptiaBulkVerifyCeVoucherResponse {
  batchId?: Maybe<Scalars['String']['output']>;
  candName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  redeemed?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tokenName?: Maybe<Scalars['String']['output']>;
  voucherId?: Maybe<Scalars['String']['output']>;
}

export interface ComptiaBulkVerifyCeVoucherTokenIdRequest {
  tokenId?: InputMaybe<Scalars['String']['input']>;
}

export interface ComptiaBulkVerifyCertRequest {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  careerId?: InputMaybe<Scalars['String']['input']>;
  ediPn?: InputMaybe<Scalars['String']['input']>;
  extraColumn1?: InputMaybe<Scalars['String']['input']>;
  extraColumn2?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
}

export interface ComptiaBulkVerifyCertRequestList {
  isDodRequest?: InputMaybe<Scalars['Boolean']['input']>;
  requestList: Array<InputMaybe<ComptiaBulkVerifyCertRequest>>;
}

export interface ComptiaCeRenewalStatusInternalResponse {
  candidateId?: Maybe<Scalars['String']['output']>;
  certExpireDate?: Maybe<Scalars['String']['output']>;
  certLastUpdate?: Maybe<Scalars['String']['output']>;
  certName?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
}

export interface ComptiaCeRenewalStatusRequest {
  candidateId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}

export interface ComptiaCeRenewalStatusRequestList {
  requestList: Array<InputMaybe<ComptiaCeRenewalStatusRequest>>;
}

export interface ComptiaCeRenewalStatusResponse {
  candidateId?: Maybe<Scalars['String']['output']>;
  certExpireDate?: Maybe<Scalars['String']['output']>;
  certLastUpdate?: Maybe<Scalars['String']['output']>;
  certName?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdate?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
}

export interface ComptiaCeVoucherBatch {
  batchId: Scalars['String']['output'];
  crcatName: Scalars['String']['output'];
  createdDate: Scalars['CmDate']['output'];
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  redeemedCount: Scalars['Int']['output'];
  revokedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
}

export interface ComptiaCeVoucherBatchDetails {
  /** The batch of that the voucher belongs to. */
  batchId?: Maybe<Scalars['String']['output']>;
  /** The voucher expiration date. */
  expires?: Maybe<Scalars['CmDate']['output']>;
  /** If available, the candidate who redemeed the voucher. */
  redeemedBy?: Maybe<Scalars['String']['output']>;
  /** If available, the date of voucher redemption. */
  redeemedDate?: Maybe<Scalars['CmDate']['output']>;
  /** The name of the voucher's linked requirement catalog. */
  requirementName: Scalars['String']['output'];
  /** The voucher status. */
  status: CeVoucherBatchDetailsStatus;
  /** The voucher external id. */
  voucherId?: Maybe<Scalars['String']['output']>;
}

export interface ComptiaCeVoucherBatchDetailsRequest {
  /** Batch ID to download details for. */
  batchId: Scalars['String']['input'];
}

export interface ComptiaCeVoucherBatchRequest {
  /** Optional batch ID to filter results */
  batchIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface ComptiaCeVoucherUploadRequest {
  type?: InputMaybe<Scalars['Int']['input']>;
  voucherNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface ComptiaCeBulkVerifyCeVoucherRequest {
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  tokenIds: Array<InputMaybe<ComptiaBulkVerifyCeVoucherTokenIdRequest>>;
}

export interface ComptiaCertVerificationResponse {
  candidateId?: Maybe<Scalars['String']['output']>;
  careerId?: Maybe<Scalars['String']['output']>;
  certActiveDate?: Maybe<Scalars['DateTime']['output']>;
  certClassification?: Maybe<Scalars['String']['output']>;
  certGroup?: Maybe<Scalars['String']['output']>;
  certId?: Maybe<Scalars['Int']['output']>;
  certInactiveDate?: Maybe<Scalars['DateTime']['output']>;
  certName?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Scalars['String']['output']>;
  ediPn?: Maybe<Scalars['String']['output']>;
  extraColumn1?: Maybe<Scalars['String']['output']>;
  extraColumn2?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleInitial?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  voucherId?: Maybe<Scalars['String']['output']>;
}

export interface ComptiaCreqVoucherDetailRequest {
  externalId: Scalars['String']['input'];
}

export interface ComptiaExamVoucherVerifyRequest {
  voucherId?: InputMaybe<Scalars['String']['input']>;
}

export interface ComptiaExamVoucherVerifyRequestList {
  requestList: Array<InputMaybe<ComptiaExamVoucherVerifyRequest>>;
}

export interface ComptiaExamVoucherVerifyRespnose {
  candidateName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  dateTaken?: Maybe<Scalars['DateTime']['output']>;
  examCode?: Maybe<Scalars['String']['output']>;
  examGrade?: Maybe<Scalars['String']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  noShow?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  voucherId?: Maybe<Scalars['String']['output']>;
}

export interface ComptiaFulfillmentVoucherBatch {
  batchId: Scalars['String']['output'];
  createdDate: Scalars['CmDate']['output'];
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  fcatName?: Maybe<Scalars['String']['output']>;
  redeemedCount: Scalars['Int']['output'];
  revokedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
}

export interface ComptiaFulfillmentVoucherBatchDetails {
  /** The batch that the voucher belongs to. */
  batchId?: Maybe<Scalars['String']['output']>;
  /** The voucher expiration date. */
  expires?: Maybe<Scalars['CmDate']['output']>;
  /** The name of the voucher's linked fulfillment catalog. */
  fulfillmentName?: Maybe<Scalars['String']['output']>;
  /** If available, the candidate who redeemed the voucher. */
  redeemedBy?: Maybe<Scalars['String']['output']>;
  /** If available, the date of voucher redemption. */
  redeemedDate?: Maybe<Scalars['CmDate']['output']>;
  /** The voucher status. */
  status: FulfillmentVoucherBatchDetailsStatus;
  /** The voucher external id. */
  voucherId?: Maybe<Scalars['String']['output']>;
}

export interface ComptiaFulfillmentVoucherBatchDetailsRequest {
  /** Batch ID to download details for. */
  batchId: Scalars['String']['input'];
}

export interface ComptiaFulfillmentVoucherBatchRequest {
  /** Optional batch ID to filter results */
  batchIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface ComptiaFulfillmentVoucherDetailRequest {
  externalId: Scalars['String']['input'];
}

/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReports {
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.CEActivityImportDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  bulkCEActivityImport?: Maybe<Array<Maybe<ComptiaBulkVerifyActivityImportResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires Any Features: ComptiaCustomDashboardReports
   * 
   *  - Requires Any Permissions: Comptia.Custom.Dashboard.Reports.CETokenLookupInternalDashboardReport, Comptia.Custom.Dashboard.Reports.CETokenLookupExternalDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  bulkVerifyCEVoucher?: Maybe<Array<Maybe<ComptiaBulkVerifyCeVoucherResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.CertVerificationDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  bulkVerifyCert?: Maybe<Array<Maybe<ComptiaCertVerificationResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.OptInVoucherVerificationDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  bulkVerifyVoucherIOUrl?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.VoucherVerificationDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  bulkVerifyVoucherUrl?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.CERenewalStatusInternalDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  cERenewalStatusInternalReport?: Maybe<Array<Maybe<ComptiaCeRenewalStatusInternalResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.CERenewalStatusExternalDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  cERenewalStatusReport?: Maybe<Array<Maybe<ComptiaCeRenewalStatusResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.DODCertVerificationDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  dodVerifyCert?: Maybe<Array<Maybe<ComptiaCertVerificationResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ComptiaCustomDashboardReports
   * 
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.ExamSecurityViolationLookupDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  examSecurityViolationLookup?: Maybe<Array<Maybe<ExamVerificationResponseGqlType>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ComptiaCustomDashboardReports
   * 
   *  - Requires All Permissions: Comptia.Custom.Dashboard.Reports.ExamVoucherVerificationDashboardReport
   * 
   *  - Must have candidate access
   *
   */
  examVoucherVerification?: Maybe<Array<Maybe<ComptiaExamVoucherVerifyRespnose>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Credential.ContinuingEducation.Vouchers.View
   *
   */
  fetchCEVoucherBatchDetails?: Maybe<Array<Maybe<ComptiaCeVoucherBatchDetails>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Credential.ContinuingEducation.Vouchers.View
   *
   */
  fetchCEVoucherBatches?: Maybe<Array<Maybe<ComptiaCeVoucherBatch>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialFulfillment
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.View
   *
   */
  fetchFulfillmentVoucherBatchDetails?: Maybe<Array<Maybe<ComptiaFulfillmentVoucherBatchDetails>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialFulfillment
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.View
   *
   */
  fetchFulfillmentVoucherBatches?: Maybe<Array<Maybe<ComptiaFulfillmentVoucherBatch>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialContinuingEducationCredentialContinuingEducationVouchers
   * 
   *  - Requires All Permissions: Credential.ContinuingEducation.Vouchers.View
   *
   */
  getCreqVoucherDetail?: Maybe<CreqVoucherDetail>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialFulfillmentFulfillmentVouchers
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.View
   *
   */
  getFulfillmentVoucherDetail?: Maybe<FulfillmentVoucherDetail>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsBulkCeActivityImportArgs {
  request: ComptiaBulkVerifyActivityImportRequestList;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsBulkVerifyCeVoucherArgs {
  request: ComptiaCeBulkVerifyCeVoucherRequest;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsBulkVerifyCertArgs {
  request: ComptiaBulkVerifyCertRequestList;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsCeRenewalStatusInternalReportArgs {
  request: ComptiaCeRenewalStatusRequestList;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsCeRenewalStatusReportArgs {
  request: ComptiaCeRenewalStatusRequestList;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsDodVerifyCertArgs {
  request: ComptiaBulkVerifyCertRequestList;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsExamSecurityViolationLookupArgs {
  request: MatchExamVerificationDataRequestGqlType;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsExamVoucherVerificationArgs {
  request: ComptiaExamVoucherVerifyRequestList;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsFetchCeVoucherBatchDetailsArgs {
  request?: InputMaybe<ComptiaCeVoucherBatchDetailsRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsFetchCeVoucherBatchesArgs {
  request?: InputMaybe<ComptiaCeVoucherBatchRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsFetchFulfillmentVoucherBatchDetailsArgs {
  request?: InputMaybe<ComptiaFulfillmentVoucherBatchDetailsRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsFetchFulfillmentVoucherBatchesArgs {
  request?: InputMaybe<ComptiaFulfillmentVoucherBatchRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsGetCreqVoucherDetailArgs {
  request: ComptiaCreqVoucherDetailRequest;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ComptiaCustomDashboardReports
 *
 */
export interface ComptiaReportsGetFulfillmentVoucherDetailArgs {
  request: ComptiaFulfillmentVoucherDetailRequest;
}

export interface ComptiaReportsMutations {
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialContinuingEducationCredentialContinuingEducationVouchers
   * 
   *  - Requires All Permissions: Credential.ContinuingEducation.Vouchers.View, Credential.ContinuingEducation.Vouchers.Modify
   * 
   *  - Must have candidate access
   *
   */
  bulkCEVoucherUpload?: Maybe<Array<Maybe<CreqVoucher>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialFulfillmentFulfillmentVouchers
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.View, Candidate.CredentialFulfillment.Modify
   *
   */
  bulkUploadFulfillmentVouchers?: Maybe<Array<Maybe<FulfillmentVoucher>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialContinuingEducationCredentialContinuingEducationVouchers
   * 
   *  - Requires All Permissions: Credential.ContinuingEducation.Vouchers.View, Credential.ContinuingEducation.Vouchers.Modify
   *
   */
  revokeCreqVoucher?: Maybe<CreqVoucher>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialFulfillmentFulfillmentVouchers
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.View, Candidate.CredentialFulfillment.Modify
   *
   */
  revokeFulfillmentVoucher?: Maybe<FulfillmentVoucher>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Credential.ContinuingEducation.Vouchers.View, Credential.ContinuingEducation.Vouchers.Modify
   *
   */
  updateCEVoucherBatches?: Maybe<Array<Maybe<ComptiaCeVoucherBatch>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CredentialFulfillmentFulfillmentVouchers
   * 
   *  - Requires All Permissions: Candidate.CredentialFulfillment.View, Candidate.CredentialFulfillment.Modify
   *
   */
  updateFulfillmentVoucherBatches?: Maybe<Array<Maybe<ComptiaFulfillmentVoucherBatch>>>;
}


export interface ComptiaReportsMutationsBulkCeVoucherUploadArgs {
  request: ComptiaBulkCeVoucherUploadRequest;
}


export interface ComptiaReportsMutationsBulkUploadFulfillmentVouchersArgs {
  request: BulkUploadFulfillmentVoucherRequest;
}


export interface ComptiaReportsMutationsRevokeCreqVoucherArgs {
  request: RevokeCreqVoucherRequest;
}


export interface ComptiaReportsMutationsRevokeFulfillmentVoucherArgs {
  request: RevokeFulfillmentVoucherRequest;
}


export interface ComptiaReportsMutationsUpdateCeVoucherBatchesArgs {
  request: ComptiaUpdateCeVoucherBatchRequestList;
}


export interface ComptiaReportsMutationsUpdateFulfillmentVoucherBatchesArgs {
  request: ComptiaUpdateFulfillmentVoucherBatchRequestList;
}

export interface ComptiaUpdateCeVoucherBatchRequest {
  /** The batch ID to update */
  batchId: Scalars['String']['input'];
  /** The expiration date to set for the batch */
  expirationDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** Whether to invalidate the batch */
  invalidate?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ComptiaUpdateCeVoucherBatchRequestList {
  /** The batches to update */
  batches: Array<InputMaybe<ComptiaUpdateCeVoucherBatchRequest>>;
}

export interface ComptiaUpdateFulfillmentVoucherBatchRequest {
  /** The batch ID to update */
  batchId: Scalars['String']['input'];
  /** The expiration date to set for the batch */
  expirationDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** Whether to invalidate the batch */
  invalidate?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ComptiaUpdateFulfillmentVoucherBatchRequestList {
  /** The batches to update */
  batches: Array<ComptiaUpdateFulfillmentVoucherBatchRequest>;
}

/** Contact information for a testing site */
export interface Contact {
  /** The fax number for the testing site */
  faxNumber?: Maybe<Scalars['String']['output']>;
  /** The phone number for the testing site */
  phoneNumber?: Maybe<Scalars['String']['output']>;
}

export interface ContinuingEducationIntent {
  /** The effective annual fee required for the CertFee logic folder. */
  annualFees?: Maybe<Scalars['Int']['output']>;
  /** The number of days remaining in the current CE cycle. */
  cycleDaysRemaining?: Maybe<Scalars['Int']['output']>;
  /** The start date of the current CE cycle. */
  cycleStartDate?: Maybe<Scalars['CmDate']['output']>;
  /** For a given intent, the cert's expire date. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  /** The date the Cert became Inactive. */
  feeDueDate?: Maybe<Scalars['CmDate']['output']>;
  /** The total fees required for renewal. */
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  /** For this intent, the type of activity the cycle stats are for. */
  type?: Maybe<CliType>;
}

export interface ContinuingEducationIntentRequest {
  /** For this intent, the type of activity the cycle stats are for. */
  type?: InputMaybe<CliType>;
}

export interface ContinuingEducationProgress {
  catalogList?: Maybe<Array<Maybe<CertRequirementCatalog>>>;
  /** The display status of the current logic track. Unique within a logic track by priority. */
  displayStatus?: Maybe<Scalars['String']['output']>;
  examCatalogList?: Maybe<Array<Maybe<ExamCatalog>>>;
  /** The date on or after which fees are due toward recertification - resolves on IncludeFeeDetails */
  feeDueDate?: Maybe<Scalars['CmDate']['output']>;
  /** Total amount of fees remaining for recertification - resolves on IncludeFeeDetails */
  feesRemaining?: Maybe<Scalars['Int']['output']>;
  requiredPoints: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['CmDate']['output']>;
  submittedPoints: Scalars['Int']['output'];
  type?: Maybe<CliType>;
  usedItemList?: Maybe<Array<Maybe<CertUsedItem>>>;
}

export interface ContinuingEducationProgressList {
  /** The logic track of the continuing education progress. */
  logic?: Maybe<CertLogic>;
  /** The list of continuing education progress for the current logic track at a given priority. */
  progressList?: Maybe<Array<Maybe<ContinuingEducationProgress>>>;
}

export interface ContinuingEducationProgressRequest {
  includeFeeDetails: Scalars['Boolean']['input'];
}

export interface CorruptExamRequest {
  comment: Scalars['String']['input'];
  dataProviderExternalId?: InputMaybe<Scalars['String']['input']>;
  examRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 *
 */
export interface CprCommand {
  ccatId?: InputMaybe<Scalars['Int']['input']>;
  /** The PK of the cert_logic row whose status should be used for this credential. */
  clId?: InputMaybe<Scalars['Int']['input']>;
  denyLinkedExtension?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate: Scalars['CmDate']['input'];
  expireDate?: InputMaybe<Scalars['CmDate']['input']>;
  inactiveDate?: InputMaybe<Scalars['CmDate']['input']>;
  type: CprCommandType;
}

export enum CprCommandType {
  /** Adjust */
  Adjust = 'Adjust',
  /** Cert */
  Cert = 'Cert',
  /** Extend */
  Extend = 'Extend',
  /** Omit */
  Omit = 'Omit',
  /** Reduce */
  Reduce = 'Reduce'
}

export enum CprState {
  /** Broadcast */
  Broadcast = 'Broadcast',
  /** Complete */
  Complete = 'Complete',
  /** Error */
  Error = 'Error',
  /** Queued */
  Queued = 'Queued',
  /** Rejected */
  Rejected = 'Rejected',
  /** Requested */
  Requested = 'Requested'
}

export enum CprType {
  /** CertRebuild */
  CertRebuild = 'CertRebuild',
  /** CertRebuildBulk */
  CertRebuildBulk = 'CertRebuildBulk',
  /** CertRegression */
  CertRegression = 'CertRegression',
  /** Invalid */
  Invalid = 'Invalid',
  /** Maintenance */
  Maintenance = 'Maintenance',
  /** ManualAdjustment */
  ManualAdjustment = 'ManualAdjustment',
  /** ManualCertify */
  ManualCertify = 'ManualCertify',
  /** ManualExtension */
  ManualExtension = 'ManualExtension',
  /** ManualReduction */
  ManualReduction = 'ManualReduction',
  /** Normal */
  Normal = 'Normal',
  /** NormalInRebuild */
  NormalInRebuild = 'NormalInRebuild',
  /** NormalWithoutTree */
  NormalWithoutTree = 'NormalWithoutTree'
}

export enum CraAction {
  /** Close */
  Close = 'Close',
  /** NoAction */
  NoAction = 'NoAction',
  /** PlaceOnHold */
  PlaceOnHold = 'PlaceOnHold',
  /** ReleaseHold */
  ReleaseHold = 'ReleaseHold'
}

export enum CraiActions {
  /** MarkInvalid */
  MarkInvalid = 'MarkInvalid',
  /** MarkPending */
  MarkPending = 'MarkPending',
  /** MarkValid */
  MarkValid = 'MarkValid',
  /** NoAction */
  NoAction = 'NoAction',
  /** RemoveFromAudit */
  RemoveFromAudit = 'RemoveFromAudit'
}

export enum CrcatCreateType {
  /** Normal */
  Normal = 'Normal',
  /** PostReview */
  PostReview = 'PostReview',
  /** PreReview */
  PreReview = 'PreReview'
}

export enum CrcatType {
  /** AdditionalAgreement */
  AdditionalAgreement = 'AdditionalAgreement',
  /** CEActivity */
  CeActivity = 'CEActivity',
  /** CertAgreement */
  CertAgreement = 'CertAgreement',
  /** Enrollment */
  Enrollment = 'Enrollment',
  /** ExternalCert */
  ExternalCert = 'ExternalCert',
  /** ExternalExam */
  ExternalExam = 'ExternalExam',
  /** Lab */
  Lab = 'Lab',
  /** Miscellaneous */
  Miscellaneous = 'Miscellaneous',
  /** Participation */
  Participation = 'Participation',
  /** ProgramFee */
  ProgramFee = 'ProgramFee',
  /** StandingLengthyCert */
  StandingLengthyCert = 'StandingLengthyCert',
  /** StandingMultiCert */
  StandingMultiCert = 'StandingMultiCert',
  /** Training */
  Training = 'Training'
}

export interface CreateAffiliationRequest {
  /** Makes the affiliation unable to be selected by a candidate. Does not remove the record from the database. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This pipe delimited list field, if not null, will require a candidate to enter something into the affiliation email field. The items in this field are the domains that are allowed in the email address. if this field is a blank stirng, anything can be entered. If sub-domains should match, start the pattern with the '@' character. To only include sub-domains, start the pattern with the '.' character. To turn this field into an exclusion list, start the pattern with the '!' character. */
  emailFormat?: InputMaybe<Scalars['String']['input']>;
  /** Determines if an email is required or not. If this field is left null, then an email can't be added at all. False means it can be added, but is not required. True means required. */
  emailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier used by any system outside certmetrics to identify the affiliation. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** This RegEx field, if not null, will require a candidate to enter something into the affiliation id field. This field determines how the information in the affiliation id field can look. If this field is a blank string, anything can be entered in affiliation id. */
  idFormat?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the affiliation. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** This RegEx field, if not null, will require a candidate to enter something into the company name field. This field determines how the information in the company name field can look. If this field is a blank string, anything can be entered in company name. */
  otherFormat?: InputMaybe<Scalars['String']['input']>;
  /** The group that this affiliation belongs to according to reports. If one affiliation belongs to a web group, they're all expected to. */
  reportGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines the type of affiliation. */
  type?: InputMaybe<AffType>;
  /** The group that this affiliation belongs to according to the website. This field is required to create a new affiliation. */
  webGroup?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateApiAccountRequest {
  /** If true, the api account is treated as if they have all permissions. This field is only editable by Admin accounts, and an api account cannot edit this field on their own account. */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the api account has access to all candidate accounts. */
  anyCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The email address associated with the api account account. When this is changed, it sends an email to the new and old addresses to ensure it isn't fraudulent. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** The phone number associated with the api account account. When this is changed, it sends an email to the new and old addresses to ensure it isn't fraudulent. */
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  /** If true, the api account will no longer be able to login. This field is only editable by Admin accounts, and an api account cannot edit this field on their own account. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The dp id that the api account is associated with. */
  dpId?: InputMaybe<Scalars['Int']['input']>;
  /** If true, the api account is not visible in the UI. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** The dp id that the api account is associated with for imports. */
  importDpId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If true, the api account is internal to Alpine. This field is only editable by Internal Admin accounts.
   * 
   * 
   *  - Internal accounts only
   *
   */
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** A comma dillimited list of ip addresses that this api account can login from. */
  ipWhiteList?: InputMaybe<Scalars['String']['input']>;
  /** The desired login id of the api account being created. */
  loginId?: InputMaybe<Scalars['String']['input']>;
  /** The login token for the api account. */
  loginToken: Scalars['String']['input'];
  /** The name of the api account. */
  name: Scalars['String']['input'];
  /** The url associated with the api account. */
  url?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface CreateBenefitCcatAssocRequest {
  bcatId: Scalars['Int']['input'];
  ccatId: Scalars['Int']['input'];
  grantEndDate?: InputMaybe<Scalars['CmDate']['input']>;
  grantStartDate: Scalars['CmDate']['input'];
}

export interface CreateCandidateExternalIdRequest {
  candidateId?: InputMaybe<CandidateIdRequest>;
  dataProvider: RequestByIdOrExternalId;
  externalId: Scalars['String']['input'];
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum CreateCandidateMergeLoserOverride {
  /** Addr1City */
  Addr1City = 'Addr1City',
  /** Addr1CountryCode */
  Addr1CountryCode = 'Addr1CountryCode',
  /** Addr1FaxNumber */
  Addr1FaxNumber = 'Addr1FaxNumber',
  /** Addr1Line1 */
  Addr1Line1 = 'Addr1Line1',
  /** Addr1Line2 */
  Addr1Line2 = 'Addr1Line2',
  /** Addr1Line3 */
  Addr1Line3 = 'Addr1Line3',
  /** Addr1PhoneNumber */
  Addr1PhoneNumber = 'Addr1PhoneNumber',
  /** Addr1PostalCode */
  Addr1PostalCode = 'Addr1PostalCode',
  /** Addr1State */
  Addr1State = 'Addr1State',
  /** Addr2City */
  Addr2City = 'Addr2City',
  /** Addr2CountryCode */
  Addr2CountryCode = 'Addr2CountryCode',
  /** Addr2FaxNumber */
  Addr2FaxNumber = 'Addr2FaxNumber',
  /** Addr2Line1 */
  Addr2Line1 = 'Addr2Line1',
  /** Addr2Line2 */
  Addr2Line2 = 'Addr2Line2',
  /** Addr2Line3 */
  Addr2Line3 = 'Addr2Line3',
  /** Addr2PhoneNumber */
  Addr2PhoneNumber = 'Addr2PhoneNumber',
  /** Addr2PostalCode */
  Addr2PostalCode = 'Addr2PostalCode',
  /** Addr2State */
  Addr2State = 'Addr2State',
  /** AffiliationAffiliateId */
  AffiliationAffiliateId = 'AffiliationAffiliateId',
  /** AffiliationEmail */
  AffiliationEmail = 'AffiliationEmail',
  /** AffiliationId */
  AffiliationId = 'AffiliationId',
  /** CompanyName */
  CompanyName = 'CompanyName',
  /** Email */
  Email = 'Email',
  /** LocAddr1City */
  LocAddr1City = 'LocAddr1City',
  /** LocAddr1Line1 */
  LocAddr1Line1 = 'LocAddr1Line1',
  /** LocAddr1Line2 */
  LocAddr1Line2 = 'LocAddr1Line2',
  /** LocAddr1Line3 */
  LocAddr1Line3 = 'LocAddr1Line3',
  /** LocAddr1PostalCode */
  LocAddr1PostalCode = 'LocAddr1PostalCode',
  /** LocAddr1State */
  LocAddr1State = 'LocAddr1State',
  /** LocCompanyName */
  LocCompanyName = 'LocCompanyName',
  /** NameFirst */
  NameFirst = 'NameFirst',
  /** NameLast */
  NameLast = 'NameLast',
  /** Password */
  Password = 'Password',
  /** PreferredNameFirst */
  PreferredNameFirst = 'PreferredNameFirst',
  /** PreferredNameLast */
  PreferredNameLast = 'PreferredNameLast'
}

export interface CreateCandidateMergeRequest {
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.MergeDetails.Modify
   *
   */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  loserCmcId?: InputMaybe<Scalars['Int']['input']>;
  loserOverrides?: InputMaybe<Array<InputMaybe<CreateCandidateMergeLoserOverride>>>;
  winnerCmcId?: InputMaybe<Scalars['Int']['input']>;
}

export interface CreateCandidateRequest {
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1Business?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1City?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1CountryCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1FaxNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1Line1?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1Line2?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1Line3?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1PostalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   *
   */
  addr1State?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2Business?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2City?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2CountryCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2FaxNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2Line1?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2Line2?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2Line3?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2PostalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   *
   */
  addr2State?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
   *
   */
  affiliation?: InputMaybe<UpdateCandidateAffiliationRequest>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   *
   */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /**
   * When the change is effective, creates Candidate's date of birth.
   * 
   * 
   *  - Requires All Permissions: Candidate.DateOfBirth.MOdify
   *
   */
  dateOfBirth?: InputMaybe<Scalars['CmDate']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   *
   */
  emailAddr?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   *
   */
  localizedAddr1City?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   *
   */
  localizedAddr1Line1?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   *
   */
  localizedAddr1Line2?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   *
   */
  localizedAddr1Line3?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   *
   */
  localizedAddr1PostalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   *
   */
  localizedAddr1State?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   *
   */
  localizedCompanyName?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   *
   */
  localizedNameFirst?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   *
   */
  localizedNameLast?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   *
   */
  nameFirst?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   *
   */
  nameLast?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationPreferredName
   *
   */
  preferredNameFirst?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationPreferredName
   *
   */
  preferredNameLast?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateCandidateSelfExtensionRequest {
  /** The candidate ID (cmc_id) */
  candidateId: CandidateIdRequest;
  /** The cert catalog ID (ccat_id). */
  ccatId: Scalars['Int']['input'];
}

export interface CreateCandidateSettingFilterRequest {
  /** The list of candidate setting ids to be assigned to a filter. */
  litemIdList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The name of the candidate setting filter to be created. */
  name: Scalars['String']['input'];
}

export interface CreateCandidateTranscriptRequest {
  addrDisplay?: InputMaybe<CtranAddrDisplay>;
  candidateId?: InputMaybe<CandidateIdRequest>;
  certDateOk?: InputMaybe<Scalars['Boolean']['input']>;
  creqDateOk?: InputMaybe<Scalars['Boolean']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayPreferredName?: InputMaybe<Scalars['Boolean']['input']>;
  examDateOk?: InputMaybe<Scalars['Boolean']['input']>;
  expireDate: Scalars['CmDate']['input'];
  imageOk?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllCerts?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllCreqs?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllExams?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllStandings?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  standingsDateOk?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CreateCertCatalogMetadataRequest {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['input'];
  /** The foreign key to the cert catalog this metadata belongs to. */
  ccatId: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 *
 */
export interface CreateCertCatalogRequest {
  /** The date on which the Cert track went active, and, if applicable, when the logic engine started processing against this track. */
  activeDate: Scalars['CmDate']['input'];
  /** The number of months that a granted cert should be active; zero means no expiration date. (This cannot be changed unless all certs on the ccat get rebuilt.) */
  activePeriod?: InputMaybe<Scalars['Short']['input']>;
  /** Determines if certs for this ccat should be included in the "cert active date calculation". (This cannot be changed unless all candidates with certs on the ccat get rebuilt.) Ccats are never "single use"; they are a status/state, so they count whenever they are active. */
  cadcExclude?: InputMaybe<Scalars['Boolean']['input']>;
  /** On or after this date, only extensions/re-certs will be processed (as long as the ccat has not been expired/retired yet). No new certifications can be achieved. This is used when a client wishes no new certs to be given, but to allow existing certs to be maintained. */
  ceFeePeriod?: InputMaybe<Scalars['Short']['input']>;
  /** The primary key of the associated cert group. */
  cgId: Scalars['Int']['input'];
  /** If true, certs will not show up on a candidate transcript. */
  ctranProhibited?: InputMaybe<Scalars['Boolean']['input']>;
  /** A short description of the cert catalog entry for public consumption. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Used to override default sorting. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** Indicates if the ccat is not a "real" certification and is hidden from candidates. Eligibilities (aka hidden ccats) allow the system to track arbitrary progress without presenting it to candidates---no possible confusion over whether or not it is an actual certification. Achievement of this type of ccat is expected to be used as a trigger-event for other functionality/features in the site (e.g. exam-vouchers, emails, special fulfillment, etc.) Eligibilities are to be used only if a real certification's logic is not sufficient for what the client needs. */
  eligibility: Scalars['Boolean']['input'];
  /** I.e., the retire date of the Cert track. After this date, no new Certs will be granted and Certs can no longer be extended on this track. */
  expireDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** See CcatExtensionType enum. Determines the way the achievement of a logic-tree extends a non-expired (active/suspended) certification. */
  extensionType?: InputMaybe<CcatExtensionType>;
  externalId: Scalars['String']['input'];
  /** If true, when a candidate initially certifies (first time ever), they are assigned the next number in the ccat's candidate certification number sequence. (These numbers are not reset during a rebuild.) */
  generateCcn?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, there is a logo attachment available to download for Candidates who hold an Active Cert in this Cert track. */
  logoDownload?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the Cert track */
  name: Scalars['String']['input'];
  /** The shortened name of the Cert track */
  nameAbbr?: InputMaybe<Scalars['String']['input']>;
  /** 2.0 only: This field is used exclusively for the open badging criteria url. */
  obCriteriaUrl?: InputMaybe<Scalars['String']['input']>;
  /** 2.0 only: This field is used exclusively for the open badging description. */
  obDescription?: InputMaybe<Scalars['String']['input']>;
  /** 2.0 only: This field is used exclusively for the open badging description html. */
  obDescriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** An optional, short description of the ccat, for public consumption (e.g. used in badging). No longer used for open badging criteria url in 2.0. See ob_description. */
  obEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** See CcatPathType enum. Determines the path-behavior (from logic-tree to logic-tree) for a cert. */
  pathType?: InputMaybe<CcatPathType>;
  /** The cut-off date is calculated as a number of months (specified here) prior to the ccat's active date. Null means any valid, active requirement counts (legacy rules). Zero means that all requirements must be completed on or after the ccat's active date to be valid towards achievement. */
  reqCutoff?: InputMaybe<Scalars['Byte']['input']>;
  /** The maximum age, in months, of completed requirements allowed to be counted towards achievement. This setting is used to assure completed requirements are "current". It is an additional restriction to each item's active period (e.g. between when an exam was taken and the result expires). */
  reqMaxAge?: InputMaybe<Scalars['Byte']['input']>;
  /** Suspended Certs Are Valid Towards Achievement */
  scavta?: InputMaybe<Scalars['Boolean']['input']>;
  /** On or after this date, only extensions/re-certs will be processed (as long as the ccat has not been expired/retired yet). No new certifications can be achieved. This is used when a client wishes no new certs to be given, but to allow existing certs to be maintained. */
  sunsetDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** The number of months after the track goes inactive that the track should be considered suspended. Zero means there is no suspend-period and the track goes inactive at the same time it expires. (This cannot be changed unless all certs on the ccat get rebuilt.) */
  suspendPeriod?: InputMaybe<Scalars['Short']['input']>;
  /** A public Url with information about the cert catalog entry. */
  url?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateCertGroupRequest {
  /** An optional classification/family/type of the group; if any groups have this set (non-null), then all groups should have one set. The distinct list of all values in the table define the set of classifications used. */
  classification?: InputMaybe<Scalars['String']['input']>;
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** Group display name. */
  name: Scalars['String']['input'];
  /** Optional grouping used instead of defaults built into the catalog. If using, must be on all groups. */
  program?: InputMaybe<Scalars['String']['input']>;
  /** Order of the program groups, if programs is used this must be set for all or alphabetical will be used. */
  programDisplayOrder?: InputMaybe<Scalars['Short']['input']>;
}

export interface CreateCertLogicItemMetadataRequest {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['input'];
  /** The foreign key to the cert logic item this metadata belongs to. */
  cliId: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateCertReqWithVoucher {
  activeDate: Scalars['CmDateTimeOffset']['input'];
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  voucherExternalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface CreateCertRequirementCatalogMetadataRequest {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['input'];
  /** The foreign key to the cert requirement catalog this metadata belongs to. */
  crcatId: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateCertRequirementCatalogRequest {
  /** Determines if requirements for this crcat should be included in the "cert active date calculation". Items are expected to be excluded from CADC when they don't track the achievement/completion/evidence of skills and/or knowledge. (E.g. when one makes a payment or agrees to something.) */
  cadcExclude: Scalars['Boolean']['input'];
  /** The group-name/key for the "create-macro group" (it is no longer a display-label; implementation went in a different direction). This field associates "equivalent" crcats for the purposes of the creation of multiple creqs at one time. Crcats in the same create-macro group MUST have identical values set in these columns, or they are ignored: crcat_type, crcat_valid_period, crcat_cadc_exclude, crcat_single_use, crcat_points, crcat_points_max, crcat_factor, crcat_factor_units, crcat_doc_required, crcat_provider_required, crcat_create_age. When this is set, crcat-overrides are ignored (they cannot be supported). */
  cmgLabel?: InputMaybe<Scalars['String']['input']>;
  /** The maximum age, in months, allowed to be used for the active-date when a candidate creates a new creq (e.g. via the web). When NULL, it means there is no limit. Otherwise, they must enter the active-date. The minimum date they are allowed to enter is this many months in the past. If this is zero, the active-date is the date of creation; the candidate cannot set it. */
  createAge?: InputMaybe<Scalars['Byte']['input']>;
  /** See CrcatCreateType enum. This determines how new creqs can be created and by whom. Normally, creqs are created via an import, or manually by a user. However, we now have ways to allow a candidate to create certain types of them. */
  createType?: InputMaybe<CrcatCreateType>;
  /** If this is true, creqs for this crcat are allowed to be displayed in a candidate transcript. The default works in the opposite manner of ccat-ctran-prohibited because it's unusual for creqs to be important enough to go on a transcript. */
  ctranEnabled: Scalars['Boolean']['input'];
  /** An optional, short description of the crcat, for public consumption (e.g. used in badging). No longer used for open badging criteria url in 2.0. See ob_description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. So the expected ORDER BY is "[non-null, then null-display-orders], display-order, [display-name]". */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** This is relevant only to crcats that can be created by a candidate. When true, the candidate is required to supply some sort of uploaded documentation-file during the creation process. Users, however, are not required, but still have the option to upload something. When false, the upload is optional, but allowed. When NULL, no documentation is allowed to be uploaded. */
  docRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Used to (optionally) indicate the last day a requirement is available to candidates. Null means no restriction. This does not affect cert-calculations. E.g. a requirement shouldn't be available for candidate "upload" if today isn't between the start and end dates. */
  endDate?: InputMaybe<Scalars['CmDate']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** This is the factor for converting between what a person is expected to enter and the actual point-value that should be used for creq-points. (i.e. if the entered number is in units other than "points") It is only used if points is greater than zero and factor-units is non-null. This should be null if people are supposed to directly enter the points; Null is the same as 1.0 (no conversion needed). As the creq is created, the number entered by the end-user gets multiplied by this to convert it to the number of points to store; any decimal portion is truncated (Math.Floor). If the result ends up being greater than points-max, that is used instead. For example, if this is 0.5, entering a 4 would yield 2 points; 5 would also yield 2 points. And if points-max was 4, any value entered over 8 would yield 4 points. */
  factor?: InputMaybe<Scalars['Decimal']['input']>;
  /** This is for display purposes; it indicates the text to use for the label that goes with the input where people enter the "value" of the creq being created. If this is null, factor should be treated as null also. Like factor, this is ignored if points is not greater than zero (since there will not be a reason to display anything point-related in the UI). When this is set, an attempt is made to fetch a resource of the name "CreqUnits.lbl.<this field>". If that fails, the field is used as-is. When this is null, "Points" is assumed ("CreqUnits.lbl.Points" is the default resource). For example, if this field was "Hours" and factor was 4, it means that the UI would be prompting people to enter a number of hours (if that's what the resource held). When a number was entered, it would be multiplied by 4 and the result, up to points-max, would be put into creq-points (e.g. 2 hours yields 8 points). */
  factorUnits?: InputMaybe<Scalars['String']['input']>;
  /** FK to cert-requirement-group. */
  groupId: Scalars['Int']['input'];
  /** For crcats where a candidate has the ability to create a creq themselves (i.e. by uploading proof/evidence of achievement), this provides a means for the client to present (English) instructions to the candidate. The purpose is to reduce "bad" evidence and keep the candidate culpable for their actions. For localization, text is placed into web-localization; the value of wloc-name will be of the format "Crcat.<crcat_id>.Instructions". */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this creq's points are allowed to be partially used or not. For example, if you need 4 points to attain a cert, and apply a creq worth 8 points, do you still have 4 points remaining (crcat_maximize_points = 1), or, are all 8 considered used (crcat_maximize_points = 0, the default behavior). */
  maximizePoints: Scalars['Boolean']['input'];
  /** The name of the requirement catalog entry. */
  name: Scalars['String']['input'];
  /** This field is used exclusively for the open badging criteria url. */
  obCriteriaUrl?: InputMaybe<Scalars['String']['input']>;
  /** This field is used exclusively for the open badging description. */
  obDescription?: InputMaybe<Scalars['String']['input']>;
  /** This field is used exclusively for the open badging description. */
  obDescriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** OpenBadge: When true, cert-requirements can be presented as badges. This cannot be true unless the crcat has a badge image, of course. */
  obEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This is the smallest value that creq-points should be set to when creating a new creq; points-max can be used to allow larger values to be used at creation of a creq. Null/Zero - This means that creq-points should be left at null---meaning points are not relevant for this crcat. (Negative numbers should not be used.) */
  points?: InputMaybe<Scalars['Short']['input']>;
  /** This represents the maximum number of points that can be awarded for completion of this crcat (and assigned to creq-points). If this is "Null" or less than crcat-points, it must be considered as if it had been set equal to crcat-points (meaning the value in crcat-points is what is used to assign to creq-points). */
  pointsMax?: InputMaybe<Scalars['Short']['input']>;
  /** This determines if the UI requires creq-provider to be set when creating/editing a creq. NULL - not required and don't show an input for it in the UI. false - not required, but allow it to be provided in the UI. true - required during insert/update in the UI. */
  providerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional url to display for scheduling. This should link to wherever a candidate needs to go in order to start the scheduling process. This will only show if the ExamScheduleLink feature is on. */
  schedulingUrl?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether or not a single item can be counted towards achievement of the same ccat multiple times or only a single time. It is normally set to true for an item that tracks evidence of knowledge or a skill, but false when it tracks a status or state. I.e. when true, items are "used" like exams (once per ccat), otherwise, it is like certifications ("used" as long as its active on the date in question). If this is changed on an existing item, you must rebuild every candidate who has achieved one (back to the earliest creq_active_date for each). */
  singleUse: Scalars['Boolean']['input'];
  /** This column is used to store the logic folders for Multi and Lengthy Standings. For documentation of the JSON objects used, please see the documentation in the AchievementEventHandler. */
  standingRule?: InputMaybe<Scalars['String']['input']>;
  /** Used to (optionally) indicate the first day a requirement is available to candidates. Null means no restriction. This does not affect cert-calculations. E.g. a requirement shouldn't be available for candidate "upload" if today isn't between the start and end dates. */
  startDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** See CrcatType enum. The type of requirement this describes. */
  type: CrcatType;
  /** An optional, public Url with extended information/criteria about the crcat (e.g. in badging, this is the criteria Url). No longer used for open badging criteria url in 2.0. See ob_criteria_url. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** How many months this item is valid for when created/completed/achieved; zero for no expiration (valid forever). */
  validPeriod: Scalars['Short']['input'];
}

export interface CreateCertRequirementGroupRequest {
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** Group display name. */
  name: Scalars['String']['input'];
  /** Optional grouping used instead of defaults built into the catalog. If using, must be on all groups. */
  program?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateCertRequirementRequest {
  activeDate: Scalars['CmDateTimeOffset']['input'];
  cmcId?: InputMaybe<Scalars['Int']['input']>;
  cocatId?: InputMaybe<Scalars['Int']['input']>;
  crcatExternalId?: InputMaybe<Scalars['String']['input']>;
  crcatId?: InputMaybe<Scalars['Int']['input']>;
  docLanguage?: InputMaybe<Scalars['String']['input']>;
  docNotes?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  historyComment?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Short']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  simulated?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CreateClientFeatureRequest {
  id: Scalars['Int']['input'];
}

export interface CreateCprRequest {
  candidateId: CandidateIdRequest;
  ccatId?: InputMaybe<Scalars['Int']['input']>;
  commands?: InputMaybe<CprCommand>;
  date?: InputMaybe<Scalars['CmDate']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type: CprType;
}

export interface CreateCrcatOverrideCatalogRequest {
  /** The Id of the CrcatOverrideGroup to which this catalog belongs. */
  cogId: Scalars['Int']['input'];
  /** Null means no override. Use 0 for no age restriction. */
  createAge?: InputMaybe<Scalars['Byte']['input']>;
  /** Used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** The latest date (inclusive) that the override is available to use when creating a creq; null for no restriction. */
  endDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** Null means no override. */
  factor?: InputMaybe<Scalars['Decimal']['input']>;
  /** The name of the override catalog. */
  name: Scalars['String']['input'];
  /** Null means no override. Use 0 for no points. */
  points?: InputMaybe<Scalars['Short']['input']>;
  /** Null means no override, not what it means in the crcat table, however, setting it to less than what is ultimately used for points still behaves the same way. */
  pointsMax?: InputMaybe<Scalars['Short']['input']>;
  /** The earliest date (inclusive) that the override is available to use when creating a creq; null for no restriction. */
  startDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** The number of days that the override is available to use when creating a creq; null for no restriction. */
  validPeriod?: InputMaybe<Scalars['Short']['input']>;
}

export interface CreateCrcatOverrideGroupRequest {
  /** The Id of the Crcat to override. */
  crcatId: Scalars['Int']['input'];
  /** Used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** The name of the override group. */
  name: Scalars['String']['input'];
}

/** Request parameters for creating an audit message. */
export interface CreateCreqAuditMessageRequest {
  /** The audit ID. */
  craId: Scalars['Int']['input'];
  /** The content of the audit message. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if only users can see the entry. Set to true to keep the candidate from viewing it. */
  private: Scalars['Boolean']['input'];
  /** Indicates if the message is to the candidate; if false, the entry was created by the candidate. */
  toCandidate: Scalars['Boolean']['input'];
}

export interface CreateEmailCatalogWithContextRequest {
  context: Scalars['String']['input'];
  contextId: Scalars['Int']['input'];
  type: EmcatType;
}

/**
 * Defines a request for an eTransaction.
 * 
 * 
 *  - Requires All Permissions: Ecommerce.Transactions.Modify
 * 
 *  - Must have candidate access
 *
 */
export interface CreateEtransactionRequest {
  candidateId: CandidateIdRequest;
  etransactionItemCatalogId: Scalars['Int']['input'];
}

export interface CreateExamAccommPackRequest {
  candidateId: CandidateIdRequest;
  docNotes?: InputMaybe<Scalars['String']['input']>;
  exapcatId: Scalars['Int']['input'];
  /**
   * 
   * 
   * 
   *  - Requires Any Permissions: Exam.Accommodations.Modify
   *
   */
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires Any Permissions: Exam.Accommodations.Modify
   *
   */
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires Any Permissions: Exam.Accommodations.Modify
   *
   */
  reviewState?: InputMaybe<ExapReviewState>;
}

export interface CreateExamAuthorizationNcarbRequest {
  activeDate: Scalars['DateTime']['input'];
  cmcId: Scalars['Int']['input'];
  excatId: Scalars['Int']['input'];
  expireDate: Scalars['DateTime']['input'];
}

export interface CreateExamAuthorizationRequest {
  /** The date on which the auth is active. */
  activeDate: Scalars['CmDate']['input'];
  /** External id of the candidate that this auth is for. */
  candidateExternalId: Scalars['String']['input'];
  /** Exam catalog external id. */
  examCode: Scalars['String']['input'];
  /** The date after which the auth expires. */
  expireDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** The date after which the auth may be sent to the testing data provider. */
  sendOkDate: Scalars['CmDate']['input'];
}

export interface CreateExamCatalogMetadataRequest {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['input'];
  /** The foreign key to the exam catalog this metadata belongs to. */
  excatId: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Exam
 *
 */
export interface CreateExamCatalogRequest {
  /** Determines if exams for this excat should be included in the cert active date calculation (this cannot be changed unless all candidates passing the exam get rebuild). Exams are always considered single use. */
  cadcExclude?: InputMaybe<Scalars['Boolean']['input']>;
  /** A short description of the exam catalog entry for public consumption. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** This is used to override the default sorting. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** The primary key of the associated exam group. */
  egId: Scalars['Int']['input'];
  /** I.e., the retire date of the exam catalog. After this date, new Exams will not be counted as achieved items for cert logic. */
  endDate?: InputMaybe<Scalars['CmDate']['input']>;
  externalId: Scalars['String']['input'];
  /** This should only have a value for beta exams. This is the primary key of the live version of this exam catalog. */
  liveExcatId?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the exam catalog */
  name: Scalars['String']['input'];
  /** The shortened name of the exam catalog */
  nameAbbr?: InputMaybe<Scalars['String']['input']>;
  /** 2.0 only: This field is used exclusively for the open badging criteria url. */
  obCriteriaUrl?: InputMaybe<Scalars['String']['input']>;
  /** 2.0 only: This field is used exclusively for the open badging description. */
  obDescription?: InputMaybe<Scalars['String']['input']>;
  /** 2.0 only: This field is used exclusively for the open badging description html. */
  obDescriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** Optional url to display for scheduling. This should link to wherever a candidate needs to go in order to start the scheduling process. */
  scheduleUrl?: InputMaybe<Scalars['String']['input']>;
  /** Stores the maximum score achievable, when known. This is used to calculate the percent correct, among other things. */
  scoreMax?: InputMaybe<Scalars['Decimal']['input']>;
  /** how Exam With Altered Grade. When true, we always show/reveal the exam result to candidates in the UI (ungraded results are normally not revealed), and custom text will be displayed for the grade instead of what is normally used. */
  sewag?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date on which the exam catalog went active. */
  startDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** A public Url with information about the exam catalog entry. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The number of months that a granted exam should be active; zero means no expiration date. (This cannot be changed unless all certs associated with this exam catalog are rebuilt.) */
  validPeriod?: InputMaybe<Scalars['Short']['input']>;
}

export interface CreateExamGroupRequest {
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** Group display name. */
  name: Scalars['String']['input'];
  /** Optional grouping used instead of defaults built into the catalog. If using, must be on all groups. */
  program?: InputMaybe<Scalars['String']['input']>;
  /** Order of the program groups, if programs is used this must be set for all or alphabetical will be used. */
  programDisplayOrder?: InputMaybe<Scalars['Short']['input']>;
}

export interface CreateExamItemCatalogRequest {
  comment?: InputMaybe<Scalars['String']['input']>;
  itemCorrectAnswer?: InputMaybe<Scalars['String']['input']>;
  itemName: Scalars['String']['input'];
  itemScoreMax?: InputMaybe<Scalars['Decimal']['input']>;
  itemScoreWeight?: InputMaybe<Scalars['Decimal']['input']>;
  languageId: Scalars['String']['input'];
  unscoredForms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

/** Allows for the creation of exam request manually. For standard exam imports in real-time, see the import exam request mutation. */
export interface CreateExamRequest {
  autoGenerateRegNum?: InputMaybe<Scalars['Boolean']['input']>;
  candidateId: CandidateIdRequest;
  correctItemCount?: InputMaybe<Scalars['Short']['input']>;
  dataProviderId?: InputMaybe<Scalars['Int']['input']>;
  dateTime: Scalars['CmDateTimeOffset']['input'];
  examAuthId?: InputMaybe<Scalars['String']['input']>;
  examComment?: InputMaybe<Scalars['String']['input']>;
  excatExternalId?: InputMaybe<Scalars['String']['input']>;
  excatId?: InputMaybe<Scalars['Int']['input']>;
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  grade: ExamGradeLabel;
  incorrectItemCount?: InputMaybe<Scalars['Short']['input']>;
  languageId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  rescored?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Decimal']['input']>;
  scoreScaled?: InputMaybe<Scalars['Decimal']['input']>;
  simulated?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<ExamState>;
  testCenterId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateExamSectionCatalogRequest {
  coverage?: InputMaybe<Scalars['String']['input']>;
  cutScore?: InputMaybe<Scalars['Decimal']['input']>;
  examForm: Scalars['String']['input'];
  high?: InputMaybe<Scalars['Decimal']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  low?: InputMaybe<Scalars['Decimal']['input']>;
  maxScore?: InputMaybe<Scalars['Decimal']['input']>;
  mid?: InputMaybe<Scalars['Decimal']['input']>;
  sectionName: Scalars['String']['input'];
}

export interface CreateExamViolationRequest {
  detail: Scalars['String']['input'];
  examId: Scalars['Int']['input'];
  type: ExamViolationType;
}

export interface CreateFilterRequest {
  criteriaList: Array<InputMaybe<FilterCriteriaRequest>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateGeographyRequest {
  /** The list of country codes to be assigned to a geography. */
  countryCodeList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The name of the geography to be created. */
  name: Scalars['String']['input'];
}

export interface CreateHubLocalizationListRequest {
  localizationList: Array<InputMaybe<CreateHubLocalizationRequest>>;
}

export interface CreateHubLocalizationRequest {
  description?: InputMaybe<Scalars['String']['input']>;
  featureId: Scalars['Int']['input'];
  htmlAllowed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  shared: Scalars['Boolean']['input'];
  type: LocType;
  uiType: LocUiType;
  value?: InputMaybe<Scalars['String']['input']>;
}

/** Information to request prometric hold */
export interface CreateInPersonExamHoldRequest {
  /** The unique identifier of the slot */
  slotId: Scalars['String']['input'];
}

export interface CreateLinkedExtensionRequest {
  activeDate?: InputMaybe<Scalars['CmDate']['input']>;
  expireDate?: InputMaybe<Scalars['CmDate']['input']>;
  greaterCcatId: Scalars['Int']['input'];
  jules?: InputMaybe<Scalars['Boolean']['input']>;
  lesserCcatId: Scalars['Int']['input'];
  scarble?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CreateLocalizationListRequest {
  /** The culture that all localizations will be applied to. */
  cultureName: Scalars['String']['input'];
  /** A list of localizations by key and value to operate on. */
  localizationList: Array<InputMaybe<LocalizationVm>>;
  /** See LocType enum for more information. */
  type: LocType;
}

export interface CreateMetadataAttributeRequest {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['input'];
  /** The foreign key to the metadata item this attribute belongs to. */
  mdiId: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateMetadataItemRequest {
  /** The external id for this record. Must be unique for a given type. */
  externalId: Scalars['String']['input'];
  /** The type of the metadata item, used to group metadata items together. */
  type: Scalars['String']['input'];
}

export interface CreateNewsArticleRequest {
  body: Scalars['String']['input'];
  ends?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  filterId?: InputMaybe<Scalars['Int']['input']>;
  headline: Scalars['String']['input'];
  newsDisplayOrder?: InputMaybe<Scalars['Int']['input']>;
  pictureLinkUrl?: InputMaybe<Scalars['String']['input']>;
  starts: Scalars['CmDateTimeOffset']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
}

/** Information to request prometric hodl */
export interface CreateOnlineExamHoldRequest {
  /** The unique identifier of the slot */
  slotId: Scalars['String']['input'];
  /** The unique identifier of the slot */
  timezone: Scalars['String']['input'];
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CandidateAccessLoginEMCOtherAchievements
 *
 */
export interface CreateOtherAchievementCatalogRequest {
  achievementName: Scalars['String']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  reimbursable?: InputMaybe<Scalars['Boolean']['input']>;
  vendor: Scalars['String']['input'];
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CandidateAccessLoginEMCOtherAchievements
 *
 */
export interface CreateOtherAchievementRequest {
  activeDate: Scalars['DateTime']['input'];
  candidateId?: InputMaybe<CandidateIdRequest>;
  catalogId?: InputMaybe<Scalars['Int']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId: Scalars['String']['input'];
  vendor: Scalars['String']['input'];
  verificationUrl: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CreatePhysicalFulfillmentRequest {
  candidateId: CandidateIdRequest;
  catalogId: Scalars['Int']['input'];
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  expedite?: InputMaybe<Scalars['Boolean']['input']>;
  trackable?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CreateRoleRequest {
  /** The id of the filter to which the role will be assigned. */
  filterId?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the role to be created. */
  name: Scalars['String']['input'];
  /** The list of permission names to be assigned to the role. */
  permissionNameList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface CreateSeertechCertRequirementRequest {
  candidateEmail: Scalars['String']['input'];
  communityId: Scalars['String']['input'];
  completionDate: Scalars['CmDateTimeOffset']['input'];
  courseId: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
}

export interface CreateTagDomainRequest {
  name: Scalars['String']['input'];
}

export interface CreateTestEmailRequest {
  context?: InputMaybe<EmcatContext>;
  contextId?: InputMaybe<Scalars['Int']['input']>;
  cultureName?: InputMaybe<Scalars['String']['input']>;
  type: EmcatType;
}

export interface CreateWebUserRequest {
  /** If true, the user is treated as if they have all permissions. This field is only editable by Admin accounts, and a user cannot edit this field on their own account. */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restricts the level that WebUsers can access candidates. Restricted, Filtered, or Unrestricted. */
  candRestrictType?: InputMaybe<WuserCandRestrictType>;
  /** When a (non-internal) user account is not for an employee of our client, this is used by the client to designate their employer. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** If true, the user will no longer be able to login. This field is only editable by Admin accounts, and a user cannot edit this field on their own account. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The email address associated with the user account. When this is changed, it sends an email to the new and old addresses to ensure it isn't fraudulent. */
  email: Scalars['String']['input'];
  /**
   * If true, the user is internal to Alpine. This field is only editable by Internal Admin accounts.
   * 
   * 
   *  - Internal accounts only
   *
   */
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The desired login id of the user being created. */
  login: Scalars['String']['input'];
  /** When set, this is a comma-delimited list of IP-addresses (simple wild-cards supported) that the user is restricted to logging-in from. This is ignored for an administrator. This field is only editable by Admin accounts. */
  loginLocation?: InputMaybe<Scalars['String']['input']>;
  /** The name of the user, usually the first and last names. */
  name: Scalars['String']['input'];
  /** What the new WebUser's password will be changed to in plain text. */
  newPassword: Scalars['String']['input'];
  /**
   * If set, this stores the CmRole value that determines basic permissions the user holds in Qlik. This field is only editable by Internal Admin accounts.
   * 
   * 
   *  - Requires All Features: ReportsAdvanced
   * 
   *  - Internal accounts only
   *
   */
  qlik?: InputMaybe<QlikCmRole>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: ShareCredlyBadging
 *
 */
export interface CredlyBadge {
  active: Scalars['DateTime']['output'];
  created?: Maybe<Scalars['DateTimeOffset']['output']>;
  credlyId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expires?: Maybe<Scalars['DateTime']['output']>;
  issuedTo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: CredlyBadgeState;
  templateExpireDate?: Maybe<Scalars['DateTime']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: ShareCredlyBadging
 *
 */
export interface CredlyBadgeCatalog {
  abbrName?: Maybe<Scalars['String']['output']>;
  allowDuplicateBadges?: Maybe<Scalars['Boolean']['output']>;
  catalogId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  templateExpireDate?: Maybe<Scalars['DateTime']['output']>;
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  templateStatus: CredlyBadgeTemplateStatus;
  type?: Maybe<CateidType>;
  validPeriod?: Maybe<Scalars['Short']['output']>;
}

export enum CredlyBadgeState {
  /** Accepted */
  Accepted = 'Accepted',
  /** Pending */
  Pending = 'Pending',
  /** Rejected */
  Rejected = 'Rejected',
  /** Revoked */
  Revoked = 'Revoked'
}

/** Possible values are: Active, Disabled, Inactive, or NotFound. */
export enum CredlyBadgeTemplateStatus {
  /** Active */
  Active = 'Active',
  /** Disabled */
  Disabled = 'Disabled',
  /** Inactive */
  Inactive = 'Inactive',
  /** NotFound */
  NotFound = 'NotFound'
}

/** Represents an audit of post-review certification requirements for a candidate. */
export interface CreqAudit {
  /** The candidate being audited. */
  cmcId: Scalars['Int']['output'];
  /** When the audit was completed; all items will have been set to a 'done' type state. Once an audit is completed, it should not be un-completed or changed or re-assigned to another auditor. */
  completed?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** The date and time when the audit was created. */
  created: Scalars['CmDateTimeOffset']['output'];
  /** When the audit is on-hold, this is set by the auditor to mark the maximum amount of time the candidate has to perform whatever task the auditor needs them to do. It is an auditor-defined deadline, and the auditor is responsible for taking action if the due date is missed. */
  due?: Maybe<Scalars['CmDate']['output']>;
  /** The unique identifier for the audit. */
  id: Scalars['Int']['output'];
  /** When true, the auditor considers the audit 'on-hold', which means it's on the candidate's plate. When waiting on the candidate, the due date can be used by the auditor to set up a soft deadline for the candidate (soft because the auditor is responsible for taking action if the deadline is missed, not the system). */
  onHold: Scalars['Boolean']['output'];
  /** When the audit was started by the auditor-user. An audit is started the first time the auditor-user views the audit. */
  started?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** The last time the audit changed. */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** The auditor-user responsible for the audit. This will be null if no user is assigned to work on it. */
  wuserId?: Maybe<Scalars['Int']['output']>;
}

/**
 * Represents a candidate that is available for audit review.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface CreqAuditCandidate {
  /** The date the candidate enrolled in the CE program. */
  ceEnrollment?: Maybe<Scalars['CmDate']['output']>;
  /** The intended path of the candidate's CE enrollment. */
  ceIntendedPath?: Maybe<Scalars['String']['output']>;
  /** The candidate ID being audited. */
  cmcId: Scalars['Int']['output'];
  /** The date and time when the audit was completed. */
  completed?: Maybe<Scalars['CmDate']['output']>;
  /** The unique identifier for the audit record. */
  craId: Scalars['Int']['output'];
  /** The date and time when the audit record was created. */
  created?: Maybe<Scalars['CmDate']['output']>;
  /** The due date and time for the audit. */
  due?: Maybe<Scalars['CmDate']['output']>;
  /** The first name of the candidate being audited. */
  nameFirst?: Maybe<Scalars['String']['output']>;
  /** The last name of the candidate being audited. */
  nameLast?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the audit is currently on hold. */
  onHold: Scalars['Boolean']['output'];
  /** The date and time when the audit was started. */
  started?: Maybe<Scalars['CmDate']['output']>;
  /** The status of the audit. */
  status: CreqAuditCandidateStatus;
  /** The date and time when the audit record was last updated. */
  updated?: Maybe<Scalars['CmDate']['output']>;
  /** The web user assigned to this audit. Null if no user is assigned. */
  user?: Maybe<WebUser>;
}

/** Contains a list of candidate CMC IDs to filter on. */
export interface CreqAuditCandidateRequest {
  /** A list of candidate CMC IDs to filter on. */
  cmcIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** An audit status to filter on. */
  status?: InputMaybe<CreqAuditCandidateStatus>;
  /** An assignee web user id to filter on. */
  wuserId?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * A stat summary of all audits.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface CreqAuditCandidateStats {
  /** The number of audits that are in progress. */
  inProgress: Scalars['Int']['output'];
  /** The number of audits that are new. */
  new: Scalars['Int']['output'];
  /** The number of audits that are on hold. */
  onHold: Scalars['Int']['output'];
  /** The number of audits that are past due. */
  pastDue: Scalars['Int']['output'];
  /** The total number of audits. */
  total: Scalars['Int']['output'];
  /** The number of audits that are unassigned. */
  unassigned: Scalars['Int']['output'];
  /** The number of audits that were completed in the last year. */
  yearToDate: Scalars['Int']['output'];
}

export enum CreqAuditCandidateStatus {
  /** Completed */
  Completed = 'Completed',
  /** InProgress */
  InProgress = 'InProgress',
  /** New */
  New = 'New',
  /** None */
  None = 'None',
  /** OnHold */
  OnHold = 'OnHold',
  /** PastDue */
  PastDue = 'PastDue',
  /** Unassigned */
  Unassigned = 'Unassigned'
}

/** Represents a certification requirement item that is part of an audit review. */
export interface CreqAuditItem {
  /** The audit ID this item belongs to. */
  craId: Scalars['Int']['output'];
  /** The certification requirement ID this audit item represents. */
  creqId: Scalars['Int']['output'];
  /** The unique identifier for the audit item. */
  id: Scalars['Int']['output'];
  /** Indicates if the audit item has been determined to be invalid. Null if no determination has been made. */
  invalid?: Maybe<Scalars['Boolean']['output']>;
  /** Notes provided by the auditor about this audit item. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The audit item's status. */
  status: AuditItemStatus;
  /** The date when the audit item was last updated. */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/** Represents a certification requirement item that is part of an audit review. Includes its related entities. */
export interface CreqAuditItemDetail {
  /** The certification requirement. */
  certRequirement?: Maybe<CertRequirement>;
  /** The id of the audit this item belongs to. */
  craId: Scalars['Int']['output'];
  /** The audit item. */
  creqAudit?: Maybe<CreqAudit>;
  /** The id of the creq this item corresponds to. */
  creqId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the audit record. */
  id: Scalars['Int']['output'];
  /** Indicates if the audit is invalid. Null if that determination has not been made. */
  invalid?: Maybe<Scalars['Boolean']['output']>;
  /** Space for an auditor to provide details about their audit of the item. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Previously audited cert requirements from the same catalog. */
  previouslyAuditedCreqs?: Maybe<Array<Maybe<PreviouslyAuditedItem>>>;
  /** The current status of the audit item. */
  status?: Maybe<AuditItemStatus>;
  /** The date when the item was last updated */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/** Request parameters for retrieving audit items for a specific candidate and audit. */
export interface CreqAuditItemRequest {
  /** The candidate ID for which to retrieve audit items. */
  cmcId?: InputMaybe<Scalars['Int']['input']>;
  /** The audit ID for which to retrieve items. */
  craId: Scalars['Int']['input'];
}

/** Represents a message in the audit conversation between candidate and auditor. */
export interface CreqAuditMessage {
  /** The audit ID this message belongs to. */
  craId: Scalars['Int']['output'];
  /** The date and time when the message was created. */
  created: Scalars['DateTime']['output'];
  /** The unique identifier for the audit message. */
  id: Scalars['Int']['output'];
  /** The content of the audit message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates if only users can see the entry. Set to true to keep the candidate from viewing it. */
  private: Scalars['Boolean']['output'];
  /** Indicates if the entry was generated by the system (not a user or candidate). */
  system: Scalars['Boolean']['output'];
  /** Indicates if the message is to the candidate; if false, the entry was created by the candidate. */
  toCandidate: Scalars['Boolean']['output'];
}

export enum CreqReviewState {
  /** None */
  None = 'None',
  /** PendingPostReview */
  PendingPostReview = 'PendingPostReview',
  /** PendingPreReview */
  PendingPreReview = 'PendingPreReview',
  /** Reviewed */
  Reviewed = 'Reviewed',
  /** UnderReview */
  UnderReview = 'UnderReview'
}

export enum CreqStatus {
  /** Active */
  Active = 'Active',
  /** InActive */
  InActive = 'InActive',
  /** Invalid */
  Invalid = 'Invalid'
}

export interface CreqVoucher {
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  batchId?: Maybe<Scalars['String']['output']>;
  cmcId?: Maybe<Scalars['Int']['output']>;
  cmcUseCount?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  crcatId: Scalars['Int']['output'];
  created: Scalars['CmDate']['output'];
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  discountMultiplier?: Maybe<Scalars['Decimal']['output']>;
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  revoked: Scalars['Boolean']['output'];
  useCount?: Maybe<Scalars['Int']['output']>;
}

export interface CreqVoucherDetail {
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  batchId?: Maybe<Scalars['String']['output']>;
  /** The candidate who redeemed the voucher (if redeemed) */
  candidate?: Maybe<Candidate>;
  /** The cert requirement created when the voucher was redeemed (if redeemed) */
  certRequirement?: Maybe<CertRequirement>;
  cmcId?: Maybe<Scalars['Int']['output']>;
  cmcUseCount?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  /** The cert requirement catalog information */
  crcat?: Maybe<CertRequirementCatalog>;
  crcatId: Scalars['Int']['output'];
  created: Scalars['CmDate']['output'];
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  discountMultiplier?: Maybe<Scalars['Decimal']['output']>;
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  revoked: Scalars['Boolean']['output'];
  useCount?: Maybe<Scalars['Int']['output']>;
}

export enum CtranAddrDisplay {
  /** Addr1 */
  Addr1 = 'Addr1',
  /** Addr2 */
  Addr2 = 'Addr2',
  /** LocAddr1 */
  LocAddr1 = 'LocAddr1',
  /** None */
  None = 'None'
}

export enum CtranDisplayMode {
  /** Badges */
  Badges = 'Badges',
  /** Normal */
  Normal = 'Normal'
}

/** Information about an ISO-defined culture. */
export interface Culture {
  id: Scalars['Int']['output'];
  isInvariant: Scalars['Boolean']['output'];
  isNeutral: Scalars['Boolean']['output'];
  isoCode: Scalars['String']['output'];
  isoDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  labelNative: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  winCode: Scalars['String']['output'];
  winDefault: Scalars['Boolean']['output'];
}

export interface CultureInfoResponse {
  /** The IetfBcp47 tag for the culture. */
  ietfBcp47Name: Scalars['String']['output'];
  /** The ISO 3 character name for the culture. */
  iso3CharName: Scalars['String']['output'];
  /** The label for the culture. */
  label: Scalars['String']['output'];
  /** The native label for the culture. */
  nativeLabel: Scalars['String']['output'];
  /** The Windows 3 character name for the culture. */
  windows3CharName: Scalars['String']['output'];
}

/** Information about an ISO-defined culture. */
export interface CulturesRequest {
  /** This will filter the results by only those with a flag of neutral. This list is used for the allowed cultures in cert requirements. */
  onlyNeutral?: InputMaybe<Scalars['Boolean']['input']>;
  /** This will filter the results so there is only 1 result per win code. This list is used for the allowed cultures in exams. */
  onlyUniqueWinCodes?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Contains data about a data provider, which is an entity that provides data to the CertMetrics system. Most commonly, these have their own unique Ids with which they identify candidate accounts. */
export interface DataProvider {
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  created: Scalars['CmDate']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  exauthActiveDateLimit?: Maybe<Scalars['Short']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  exauthAppointmentDateLimit?: Maybe<Scalars['Short']['output']>;
  /** The unique text-Id of the data provider. This is used more often than the DpId itself. */
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

/**
 * 
 * 
 * 
 *  - Internal accounts only
 * 
 *  - Admin accounts only
 *
 */
export interface DateRule {
  rulesByPosition?: Maybe<Array<Maybe<DateRuleByPosition>>>;
}

/**
 * 
 * 
 * 
 *  - Internal accounts only
 * 
 *  - Admin accounts only
 *
 */
export interface DateRuleByPosition {
  delayFailure?: Maybe<Scalars['Short']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  unparsedJson?: Maybe<Scalars['String']['output']>;
}

export interface DefaultClientLocalizationRequest {
  clientDbAlias: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  portal?: InputMaybe<PortalType>;
}

export interface DefaultClientLocalizationResponse {
  description?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  htmlAllowed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<LocType>;
  uiType?: Maybe<LocUiType>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface DeleteCandidateExternalIdRequest {
  candidateId?: InputMaybe<CandidateIdRequest>;
  id?: InputMaybe<Scalars['Int']['input']>;
}

export interface DeleteCandidateSettingFilterRequest {
  /** The id of the candidate setting filter to be deleted. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the candidate setting filter to be deleted. */
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface DeleteCertRequirementRequest {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
}

export interface DeleteClientFeatureRequest {
  id: Scalars['Int']['input'];
}

/** Removes the specified client setting from the client_settings table by either CsetId or CsetName (Id will be checked first). */
export interface DeleteClientSettingRequest {
  csetId?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the setting being controlled/defined. Names should be in PascalCase. */
  csetName?: InputMaybe<Scalars['String']['input']>;
}

export interface DeleteGeographyRequest {
  /** The id of the geography to be deleted. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the geography to be deleted. */
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface DeleteLinkedExtensionRequest {
  id: Scalars['Int']['input'];
}

export interface DeleteLocalizationListRequest {
  /** The culture that all localizations will be applied to. */
  cultureName: Scalars['String']['input'];
  /** A list of localizations by key and value to operate on. */
  localizationList: Array<InputMaybe<LocalizationVm>>;
  /** See LocType enum for more information. */
  type: LocType;
}

export interface DeleteRoleRequest {
  /** The id of the role to delete. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the role to delete. */
  name?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface DescriptionGqlType {
  culture?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
}

export interface DifferencesReport {
  remainingCandidates?: Maybe<Scalars['Long']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
}

/** Directional information for a testing site */
export interface Direction {
  /** The actual direction text */
  directionText?: Maybe<Scalars['String']['output']>;
  /** General memo about the direction */
  generalMemo?: Maybe<Scalars['String']['output']>;
  /** The name of the direction */
  name?: Maybe<Scalars['String']['output']>;
  /** Scheduling-specific memo about the direction */
  schedulingMemo?: Maybe<Scalars['String']['output']>;
}

export interface DownloadableReport {
  comment?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  directoryPath?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileNameWithoutExtension?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Long']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
}

/**
 * Returns a list of duplicate candidates.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Must have candidate access
 *
 */
export interface DuplicateCandidateResponse {
  cmcIdList?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * 
   * 
   * Sortable.
   */
  count: Scalars['Int']['output'];
  unique: Scalars['Int']['output'];
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  value?: Maybe<Scalars['String']['output']>;
}

/**
 * Represents an electronic transaction for a candidate.
 * 
 * 
 *  - Requires All Features: Ecommerce
 *
 */
export interface ETransaction {
  /** The date and time the transaction was created. */
  created: Scalars['DateTime']['output'];
  /** The external id of the transaction. */
  externalId: Scalars['String']['output'];
  /** The items in the transaction. */
  items?: Maybe<Array<Maybe<ETransactionItem>>>;
  /** The transaction's state. */
  state: EtState;
  /** The tax amount for the transaction. */
  tax?: Maybe<Scalars['Decimal']['output']>;
  /** The total cost of the transaction. */
  total: Scalars['Decimal']['output'];
  /** The internal id of the transaction. */
  transactionId: Scalars['Int']['output'];
}

/**
 * An item purchased in an eTransaction.
 * 
 * 
 *  - Requires All Features: Ecommerce
 *
 */
export interface ETransactionItem {
  /** The catalog item that was purchased. */
  catalog: EtransactionItemCatalog;
  /** The internal id of the item. */
  itemId: Scalars['Int']['output'];
  /** The total cost of the item. */
  total: Scalars['Decimal']['output'];
}

export enum EimgType {
  /** CandidatePhoto */
  CandidatePhoto = 'CandidatePhoto',
  /** Fingerprint */
  Fingerprint = 'Fingerprint',
  /** PalmVein */
  PalmVein = 'PalmVein',
  /** Signature */
  Signature = 'Signature'
}

/**
 * 
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 * 
 *  - Requires All Permissions: Candidate.CredentialFulfillment.View
 * 
 *  - Must have candidate access
 *
 */
export interface ElectronicFulfillment {
  catalogId: Scalars['Int']['output'];
  cmcId: Scalars['Int']['output'];
  created: Scalars['CmDateTimeOffset']['output'];
  downloads?: Maybe<Scalars['Int']['output']>;
  externalId: Scalars['String']['output'];
  /** Shows summary information on the associated fulfillment catalog. */
  fulfillmentCatalog?: Maybe<ElectronicFulfillmentCatalog>;
  id: Scalars['Int']['output'];
}

/**
 * 
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 *
 */
export interface ElectronicFulfillmentCatalog {
  certCatalog?: Maybe<CertCatalog>;
  /** When set, this indicates the Certification that the candidate must earn and have active in order to receive physical fulfillment, or be able to download electronic fulfillment. */
  certCatalogId?: Maybe<Scalars['Int']['output']>;
  /** Used to indicate if electronic fulfillment is available for download. When the value is false, this exclusively represents a fulfillment that is shipped to the candidate by a fulfillment house. */
  electronic: Scalars['Boolean']['output'];
  /** When set, this is the identifier for the client, the fulfillment house, or both indicating what specific kit is intended. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Internal id for the Fulfillment definition. */
  id: Scalars['Int']['output'];
  /** When set, this is a value that can be used either by the fulfillment house or on electronic fulfillment. When null, the CertCatalog.Name value is used. */
  name?: Maybe<Scalars['String']['output']>;
  /** When set, this is a value that can be used either by the fulfillment house or on electronic fulfillment. When null, the CertCatalog.NameAbbr value is used. */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** Indicates how often fulfillment can be queued for a candidate. Options are Manual, Once, EachNewItem, and Never. Never is used for fulfillment that is electronic only. */
  queueType: FcatQueueType;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface ElectronicFulfillmentCatalogDetail {
  certCatalog?: Maybe<CertCatalog>;
  /** When set, this indicates the Certification that the candidate must earn and have active in order to receive physical fulfillment, or be able to download electronic fulfillment. */
  certCatalogId?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  created: Scalars['CmDateTimeOffset']['output'];
  /** Used to indicate if electronic fulfillment is available for download. When the value is false, this exclusively represents a fulfillment that is shipped to the candidate by a fulfillment house. */
  electronic: Scalars['Boolean']['output'];
  /** When set, this is the identifier for the client, the fulfillment house, or both indicating what specific kit is intended. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Internal id for the Fulfillment definition. */
  id: Scalars['Int']['output'];
  /** When set, this is a value that can be used either by the fulfillment house or on electronic fulfillment. When null, the CertCatalog.Name value is used. */
  name?: Maybe<Scalars['String']['output']>;
  /** When set, this is a value that can be used either by the fulfillment house or on electronic fulfillment. When null, the CertCatalog.NameAbbr value is used. */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** Indicates how often fulfillment can be queued for a candidate. Options are Manual, Once, EachNewItem, and Never. Never is used for fulfillment that is electronic only. */
  queueType: FcatQueueType;
}

export interface EligibilityCatalog {
  activeDate?: Maybe<Scalars['DateTime']['output']>;
  ecatDelaySuccess: Scalars['Short']['output'];
  ecatDpConfig?: Maybe<Scalars['String']['output']>;
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  positionResetAge?: Maybe<Scalars['Int']['output']>;
  positionResetDate?: Maybe<Scalars['DateTime']['output']>;
}

/**
 * Shows details for an exam that the candidate is eligible to test for.
 * 
 * 
 *  - Requires All Features: ExamScheduling, Exam
 *
 */
export interface EligibleExam {
  actionUrlList?: Maybe<Array<Maybe<EligibleExamActionUrl>>>;
  /**
   * Indicates the last date the exam was being delivered.
   * @deprecated Use examCatalog.endDate
   */
  endDate?: Maybe<Scalars['CmDate']['output']>;
  /**
   * The active exam authorization pack (eligibility) for this candidate and exam candidate.
   * 
   * 
   *  - Requires All Features: ExamAuthorization
   *
   */
  examAuthorizationPack?: Maybe<ExamAuthorizationPack>;
  examCatalog?: Maybe<ExamCatalog>;
  /** @deprecated Use examCatalog.examGroup */
  examGroup?: Maybe<ExamGroup>;
  /**
   * Unique identifier of the exam as defined at the test delivery provider. Commonly known as the exam code.
   * 
   * Searchable.
   * 
   * Sortable.
   * @deprecated Use examCatalog.externalId
   */
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /**
   * The name of the exam.
   * 
   * Searchable.
   * 
   * Sortable.
   * @deprecated Use examCatalog.name
   */
  name: Scalars['String']['output'];
  /**
   * Indicates the date the exam started being delivered.
   * @deprecated Use examCatalog.startDate
   */
  startDate?: Maybe<Scalars['CmDate']['output']>;
}

export enum EligibleExamActionType {
  /** LiteweightRecertify */
  LiteweightRecertify = 'LiteweightRecertify',
  /** Schedule */
  Schedule = 'Schedule'
}

export interface EligibleExamActionUrl {
  dataProvider?: Maybe<DataProvider>;
  type?: Maybe<EligibleExamActionType>;
  url?: Maybe<Scalars['String']['output']>;
}

/** Shows high-level information about the Email definition. */
export interface EmailCatalog {
  /** Used to further specify email sending context - there must always be at least 1 default email for each type with context of null */
  context?: Maybe<EmcatContext>;
  /** An ID - the meaning is determined by the context field - always null if context is null */
  contextId?: Maybe<Scalars['Int']['output']>;
  contextItem?: Maybe<EmailContextOptionResponse>;
  /** If an email has been disabled it will not be sent */
  disabled: Scalars['Boolean']['output'];
  /** This gives the localizations for the current email catalog entry */
  emailLocalizationList?: Maybe<Array<Maybe<EmailLocalization>>>;
  /** The email address the email will appear to have been sent from. If this is not set, a default "no reply" address will be used. */
  from?: Maybe<Scalars['String']['output']>;
  /** The name the email will appear to have been sent from */
  fromLabel?: Maybe<Scalars['String']['output']>;
  /**
   * If an email has been hidden then it will not display in the users interface
   * 
   * 
   *  - Internal accounts only
   *
   */
  hidden: Scalars['Boolean']['output'];
  /** Unique ID for this email catalog entry */
  id: Scalars['Int']['output'];
  /** The email subject */
  subject: Scalars['String']['output'];
  /** Determines what event triggers this email to send */
  type: EmcatType;
  /** When the email catalog was last updated */
  updated: Scalars['CmDate']['output'];
  /** Who last update the email catalog */
  updator: Scalars['String']['output'];
  /** Set to true if this is a user, rather than a candidate email */
  userBased: Scalars['Boolean']['output'];
}

/** Shows full details about the Email definition. */
export interface EmailCatalogDetail {
  /** Any email addresses to BCC - comma-separated */
  bcc?: Maybe<Scalars['String']['output']>;
  /** The HTML email content */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** The plain-text email content */
  bodyPlain?: Maybe<Scalars['String']['output']>;
  /** Used to further specify email sending context - there must always be at least 1 default email for each type with context of null */
  context?: Maybe<EmcatContext>;
  /** An ID - the meaning is determined by the context field - always null if context is null */
  contextId?: Maybe<Scalars['Int']['output']>;
  contextItem?: Maybe<EmailContextOptionResponse>;
  /** If an email has been disabled it will not be sent */
  disabled: Scalars['Boolean']['output'];
  /** This gives the localizations for the current email catalog entry */
  emailLocalizationList?: Maybe<Array<Maybe<EmailLocalization>>>;
  /** The email address the email will appear to have been sent from. If this is not set, a default "no reply" address will be used. */
  from?: Maybe<Scalars['String']['output']>;
  /** The name the email will appear to have been sent from */
  fromLabel?: Maybe<Scalars['String']['output']>;
  /**
   * If an email has been hidden then it will not display in the users interface
   * 
   * 
   *  - Internal accounts only
   *
   */
  hidden: Scalars['Boolean']['output'];
  /** Unique ID for this email catalog entry */
  id: Scalars['Int']['output'];
  /** The email subject */
  subject: Scalars['String']['output'];
  /** The substitutions available for use in the email template */
  substitutions: Array<Maybe<EmailCatalogSubstitution>>;
  /** Determines what event triggers this email to send */
  type: EmcatType;
  /** When the email catalog was last updated */
  updated: Scalars['CmDate']['output'];
  /** Who last update the email catalog */
  updator: Scalars['String']['output'];
  /** Set to true if this is a user, rather than a candidate email */
  userBased: Scalars['Boolean']['output'];
}

/**
 * Shows selectors available in email templates.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Permissions: Email.Catalog.View
 *
 */
export interface EmailCatalogSubstitution {
  /** A description of the value that will be inserted */
  description: Scalars['String']['output'];
  /** The same as selector, provided for caching purposes */
  id: Scalars['String']['output'];
  /** The unique string to be replaced with mail-merge style values in an email template */
  selector: Scalars['String']['output'];
}

export interface EmailContextListResponse {
  context?: Maybe<EmcatContext>;
  id?: Maybe<EmcatContext>;
  typeList?: Maybe<Array<Maybe<EmcatType>>>;
}

export interface EmailContextOptionResponse {
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  type: EmcatContext;
}

/** Contains localizations for email catalog items */
export interface EmailLocalization {
  /** The HTML email body */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** The plain-text email body */
  bodyPlain?: Maybe<Scalars['String']['output']>;
  /** Unique ID for the email catalog this localizes */
  catalogId: Scalars['Int']['output'];
  /** The culture / localization this applies to */
  cultureInfoName: Scalars['String']['output'];
  /** Unique ID for this email localization entry */
  id: Scalars['Int']['output'];
  /** The email subject */
  subject: Scalars['String']['output'];
  /** When the localization was last updated */
  updated: Scalars['CmDate']['output'];
  /** Who last updated the localization */
  updator: Scalars['String']['output'];
}

export interface EmailRequest {
  /**
   * The number of attempts taken to send this email
   * 
   * 
   *  - Internal accounts only
   *
   */
  attempts: Scalars['Byte']['output'];
  /** The HTML email body */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** The plain-text email body */
  bodyPlain?: Maybe<Scalars['String']['output']>;
  /** The candidate this request was for */
  cmcId?: Maybe<Scalars['Int']['output']>;
  /** When the email was sent */
  completed?: Maybe<Scalars['CmDate']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  elapsed?: Maybe<Scalars['Int']['output']>;
  /** Shows summary information on the associated email catalog. */
  emailCatalog?: Maybe<EmailCatalog>;
  /** The email catalog entry this request was derived from */
  emcatId?: Maybe<Scalars['Int']['output']>;
  /** The email address this was sent from */
  from?: Maybe<Scalars['String']['output']>;
  /** The sender name for this email */
  fromLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** When the email was requested */
  requested: Scalars['CmDate']['output'];
  /** Was this email resent */
  resend?: Maybe<Scalars['Boolean']['output']>;
  /** The current state the email is in */
  state: EmrState;
  /** A text description of the current state */
  stateMessage?: Maybe<Scalars['String']['output']>;
  /** The email subject line */
  subject?: Maybe<Scalars['String']['output']>;
  /** Email address to send to */
  to?: Maybe<Scalars['String']['output']>;
  /** Name to send to */
  toLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The web user this request was for, used if CmcId is null
   * 
   *  - Disallowed Account Types: Candidate
   */
  webUserId?: Maybe<Scalars['Int']['output']>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface EmailRequestDetail {
  /**
   * The number of attempts taken to send this email
   * 
   * 
   *  - Internal accounts only
   *
   */
  attempts: Scalars['Byte']['output'];
  /** The HTML email body */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** The plain-text email body */
  bodyPlain?: Maybe<Scalars['String']['output']>;
  /** The candidate this request was for */
  cmcId?: Maybe<Scalars['Int']['output']>;
  /** When the email was sent */
  completed?: Maybe<Scalars['CmDate']['output']>;
  contextId?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  elapsed?: Maybe<Scalars['Int']['output']>;
  /** Shows summary information on the associated email catalog. */
  emailCatalog?: Maybe<EmailCatalog>;
  /** Shows detailed information on the associated email catalog. */
  emailCatalogDetail?: Maybe<EmailCatalogDetail>;
  /** The email catalog entry this request was derived from */
  emcatId?: Maybe<Scalars['Int']['output']>;
  /** The email address this was sent from */
  from?: Maybe<Scalars['String']['output']>;
  /** The sender name for this email */
  fromLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** When the email was requested */
  requested: Scalars['CmDate']['output'];
  /** Was this email resent */
  resend?: Maybe<Scalars['Boolean']['output']>;
  /** The current state the email is in */
  state: EmrState;
  /** A text description of the current state */
  stateMessage?: Maybe<Scalars['String']['output']>;
  /** The email subject line */
  subject?: Maybe<Scalars['String']['output']>;
  /** Email address to send to */
  to?: Maybe<Scalars['String']['output']>;
  /** Name to send to */
  toLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The web user this request was for, used if CmcId is null
   * 
   *  - Disallowed Account Types: Candidate
   */
  webUserId?: Maybe<Scalars['Int']['output']>;
}

export enum EmcatContext {
  /** Benefits */
  Bcat = 'Bcat',
  /** Benefit Group */
  BenefitGroup = 'BenefitGroup',
  /** Certifications */
  Ccat = 'Ccat',
  /** Certification Group */
  CertGroup = 'CertGroup',
  /** Other Requirements */
  Crcat = 'Crcat',
  /** Other Requirement Group */
  CrcatGroup = 'CrcatGroup',
  /** Other Requirement Type */
  CrcatType = 'CrcatType',
  /** Exam Violation Type */
  EvType = 'EvType',
  /** Exam Group */
  ExamGroup = 'ExamGroup',
  /** Exams */
  Excat = 'Excat',
  /** Fulfillments */
  Fcat = 'Fcat',
  /** Questionnaires */
  Qcat = 'Qcat',
  /** Questionnaire Group */
  QcatGroup = 'QcatGroup',
  /** Questionnaire Results */
  Qrcat = 'Qrcat',
  /** Questionnaire Result Group */
  QrcatGroup = 'QrcatGroup'
}

export interface EmcatContextOptionListRequest {
  context: EmcatContext;
}

export enum EmcatType {
  /** AccountVerification */
  AccountVerification = 'AccountVerification',
  /** AuditComplete */
  AuditComplete = 'AuditComplete',
  /** AuditOnHold */
  AuditOnHold = 'AuditOnHold',
  /** AuditOnHoldReminder */
  AuditOnHoldReminder = 'AuditOnHoldReminder',
  /** BadAddress */
  BadAddress = 'BadAddress',
  /** BenefitExpirationLong */
  BenefitExpirationLong = 'BenefitExpirationLong',
  /** BenefitExpirationMedium */
  BenefitExpirationMedium = 'BenefitExpirationMedium',
  /** BenefitExpirationShort */
  BenefitExpirationShort = 'BenefitExpirationShort',
  /** BenefitExpired */
  BenefitExpired = 'BenefitExpired',
  /** CandidateBanned */
  CandidateBanned = 'CandidateBanned',
  /** CertExpired */
  CertExpired = 'CertExpired',
  /** CertExtension */
  CertExtension = 'CertExtension',
  /** CertRequirementCreated */
  CertRequirementCreated = 'CertRequirementCreated',
  /** CertSuspended */
  CertSuspended = 'CertSuspended',
  /** CertSuspension2L */
  CertSuspension2L = 'CertSuspension2L',
  /** CertSuspension3L */
  CertSuspension3L = 'CertSuspension3L',
  /** CertSuspension4L */
  CertSuspension4L = 'CertSuspension4L',
  /** CertSuspensionLong */
  CertSuspensionLong = 'CertSuspensionLong',
  /** CertSuspensionMedium */
  CertSuspensionMedium = 'CertSuspensionMedium',
  /** CertSuspensionShort */
  CertSuspensionShort = 'CertSuspensionShort',
  /** Certification */
  Certification = 'Certification',
  /** Eligibility */
  Eligibility = 'Eligibility',
  /** ExamAccommodation */
  ExamAccommodation = 'ExamAccommodation',
  /** ExamAuthExpirationLong */
  ExamAuthExpirationLong = 'ExamAuthExpirationLong',
  /** ExamAuthExpirationMedium */
  ExamAuthExpirationMedium = 'ExamAuthExpirationMedium',
  /** ExamAuthExpirationShort */
  ExamAuthExpirationShort = 'ExamAuthExpirationShort',
  /** ExamAuthExpired */
  ExamAuthExpired = 'ExamAuthExpired',
  /** ExamEligibility */
  ExamEligibility = 'ExamEligibility',
  /** ExamExpirationLong */
  ExamExpirationLong = 'ExamExpirationLong',
  /** ExamExpirationMedium */
  ExamExpirationMedium = 'ExamExpirationMedium',
  /** ExamExpirationShort */
  ExamExpirationShort = 'ExamExpirationShort',
  /** ExamScheduleReminder */
  ExamScheduleReminder = 'ExamScheduleReminder',
  /** ExamScoreReportAvailable */
  ExamScoreReportAvailable = 'ExamScoreReportAvailable',
  /** ExamViolationAdvancedSecurityRuleInvalidated */
  ExamViolationAdvancedSecurityRuleInvalidated = 'ExamViolationAdvancedSecurityRuleInvalidated',
  /** ExamViolationAdvancedSecurityRuleWarning */
  ExamViolationAdvancedSecurityRuleWarning = 'ExamViolationAdvancedSecurityRuleWarning',
  /** ExamViolationInvalidated */
  ExamViolationInvalidated = 'ExamViolationInvalidated',
  /** ExamViolationWarning */
  ExamViolationWarning = 'ExamViolationWarning',
  /** Expire2L */
  Expire2L = 'Expire2L',
  /** Expire3L */
  Expire3L = 'Expire3L',
  /** Expire4L */
  Expire4L = 'Expire4L',
  /** ExpireLong */
  ExpireLong = 'ExpireLong',
  /** ExpireMedium */
  ExpireMedium = 'ExpireMedium',
  /** ExpireShort */
  ExpireShort = 'ExpireShort',
  /** FailedExamReschedule */
  FailedExamReschedule = 'FailedExamReschedule',
  /** FirstExam */
  FirstExam = 'FirstExam',
  /** Fulfillment */
  Fulfillment = 'Fulfillment',
  /** Invalid */
  Invalid = 'Invalid',
  /** ItemUnderReview */
  ItemUnderReview = 'ItemUnderReview',
  /** Merge */
  Merge = 'Merge',
  /** MergeConfirmation */
  MergeConfirmation = 'MergeConfirmation',
  /** MergeDenied */
  MergeDenied = 'MergeDenied',
  /** MergeRejected */
  MergeRejected = 'MergeRejected',
  /** MergeRequest */
  MergeRequest = 'MergeRequest',
  /** Miscellaneous */
  Miscellaneous = 'Miscellaneous',
  /** NewBenefit */
  NewBenefit = 'NewBenefit',
  /** NewCandidate */
  NewCandidate = 'NewCandidate',
  /** NewExam */
  NewExam = 'NewExam',
  /** NewFailedExam */
  NewFailedExam = 'NewFailedExam',
  /** NewPassedExam */
  NewPassedExam = 'NewPassedExam',
  /** OtherRequirementStatusChange */
  OtherRequirementStatusChange = 'OtherRequirementStatusChange',
  /** PaymentReminderLong */
  PaymentReminderLong = 'PaymentReminderLong',
  /** PaymentReminderMedium */
  PaymentReminderMedium = 'PaymentReminderMedium',
  /** PaymentReminderShort */
  PaymentReminderShort = 'PaymentReminderShort',
  /** QuestionnaireApproved */
  QuestionnaireApproved = 'QuestionnaireApproved',
  /** QuestionnaireDeficient */
  QuestionnaireDeficient = 'QuestionnaireDeficient',
  /** QuestionnaireDenied */
  QuestionnaireDenied = 'QuestionnaireDenied',
  /** QuestionnaireEligible */
  QuestionnaireEligible = 'QuestionnaireEligible',
  /** QuestionnaireExpireLong */
  QuestionnaireExpireLong = 'QuestionnaireExpireLong',
  /** QuestionnaireExpireMedium */
  QuestionnaireExpireMedium = 'QuestionnaireExpireMedium',
  /** QuestionnaireExpireShort */
  QuestionnaireExpireShort = 'QuestionnaireExpireShort',
  /** QuestionnaireExpired */
  QuestionnaireExpired = 'QuestionnaireExpired',
  /** QuestionnaireResultExpireLong */
  QuestionnaireResultExpireLong = 'QuestionnaireResultExpireLong',
  /** QuestionnaireResultExpireMedium */
  QuestionnaireResultExpireMedium = 'QuestionnaireResultExpireMedium',
  /** QuestionnaireResultExpireShort */
  QuestionnaireResultExpireShort = 'QuestionnaireResultExpireShort',
  /** QuestionnaireResultExpired */
  QuestionnaireResultExpired = 'QuestionnaireResultExpired',
  /** RestrictTesting */
  RestrictTesting = 'RestrictTesting',
  /** RollingClockExpirationChange */
  RollingClockExpirationChange = 'RollingClockExpirationChange',
  /** StandingCreated */
  StandingCreated = 'StandingCreated',
  /** StandingExpireLong */
  StandingExpireLong = 'StandingExpireLong',
  /** StandingExpireMedium */
  StandingExpireMedium = 'StandingExpireMedium',
  /** StandingExpireShort */
  StandingExpireShort = 'StandingExpireShort',
  /** StandingExpired */
  StandingExpired = 'StandingExpired',
  /** WebBadgeEmailSig */
  WebBadgeEmailSig = 'WebBadgeEmailSig',
  /** WebConversationAlert */
  WebConversationAlert = 'WebConversationAlert',
  /** WebEmailAddrReset */
  WebEmailAddrReset = 'WebEmailAddrReset',
  /** WebFirstTimeLogin */
  WebFirstTimeLogin = 'WebFirstTimeLogin',
  /** WebForgotPassword */
  WebForgotPassword = 'WebForgotPassword',
  /** WebNameChange */
  WebNameChange = 'WebNameChange',
  /** WebSelfRegistration */
  WebSelfRegistration = 'WebSelfRegistration',
  /** WebTranscript */
  WebTranscript = 'WebTranscript',
  /** WebUserEmailAddressChanged */
  WebUserEmailAddressChanged = 'WebUserEmailAddressChanged',
  /** WebUserForgotPassword */
  WebUserForgotPassword = 'WebUserForgotPassword',
  /** WebUserTwoStepAuthentication */
  WebUserTwoStepAuthentication = 'WebUserTwoStepAuthentication'
}

export interface EmployeeSelfRegistrationRequest {
  affiliation: UpdateCandidateAffiliationRequest;
  clientAlias: Scalars['String']['input'];
  emailAddr: Scalars['String']['input'];
  nameFirst: Scalars['String']['input'];
  nameLast: Scalars['String']['input'];
}

export enum EmrState {
  /** Complete */
  Complete = 'Complete',
  /** Error */
  Error = 'Error',
  /** Queued */
  Queued = 'Queued',
  /** Rejected */
  Rejected = 'Rejected',
  /** Requested */
  Requested = 'Requested'
}

export enum EtState {
  /** Failure */
  Failure = 'Failure',
  /** Pending */
  Pending = 'Pending',
  /** Success */
  Success = 'Success',
  /** Void */
  Void = 'Void'
}

export enum EticatType {
  /** Crcat */
  Crcat = 'Crcat',
  /** Fcat */
  Fcat = 'Fcat',
  /** None */
  None = 'None'
}

/**
 * This defines the types of items that can be created as part of an e-transaction.
 * 
 * 
 *  - Requires All Features: Ecommerce
 *
 */
export interface EtransactionItemCatalog {
  /** When set, this indicates that this item will purchase an item represented by a Certification Requirement. */
  certRequirementCatalog?: Maybe<CertRequirementCatalog>;
  /** When set, indicates that this item may only be purchased by candidates whose primary address is set to the country indicated here. */
  country?: Maybe<IsoCountry>;
  /**  This is the value we supply to PayPal to identify an item in the shopping-cart/transaction that we submit to them. They echo this back to us, so it is not directly important to PayPal, but it is how we identify what was purchased when PayPal notifies our system of a completed purchase. */
  externalId: Scalars['String']['output'];
  /** When set, this indicates that this item will purchase a fulfillment item. This contains high-level information about that fulfillment item. */
  fulfillmentCatalog?: Maybe<PhysicalFulfillmentCatalog>;
  /**
   * Internal id.
   * 
   * 
   *  - Internal accounts only
   *
   */
  id: Scalars['Int']['output'];
  /** The label to display on the web to indicate what is going to be purchased. */
  name: Scalars['String']['output'];
  /** This is the cost of the item; what we require PayPal to charge the shopper when they want to purchase the item this row represents. */
  price: Scalars['Decimal']['output'];
  /** Indicates the maximum number of times the candidate can purchase this item. Zero means no limit (they can buy as many as they wish). NULL means the item is disabled (no purchasing allowed). */
  purchaseMax?: Maybe<Scalars['Int']['output']>;
  /** When true, this item is eligible for taxes. */
  taxEligible: Scalars['Boolean']['output'];
  /** Indicates what kind of item will be created with a purchase of this item. Available options are Fcat (Fulfillment) and Crcat (CertRequirement). */
  type: EticatType;
}

/**
 * Shows high-level information about the Exam.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Must have candidate access
 *
 */
export interface Exam {
  /** When true, indicates that the exam had a state of either Invalid or Under Review but has since been marked as valid toward certification. */
  approved: Scalars['Boolean']['output'];
  /** Indicates the authorization id that was used to take the Exam. */
  authorizationId?: Maybe<Scalars['String']['output']>;
  catalog?: Maybe<ExamCatalog>;
  catalogId: Scalars['Int']['output'];
  /** The candidate for this exam */
  cmcId: Scalars['Int']['output'];
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  /** The unique Id (PK) of the data provider that delivered the Exam. This is considered the domain/context/scope within which the Exam.RegistrationNumber is unique. */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  /** The date and time the exam was taken. The time is the local time where the exam was taken. No time zone offset is supplied for that reason. Only the date portion of this is used to calculate cert.ActiveDate values. */
  dateTime: Scalars['DateTime']['output'];
  /**
   * The discount applied to this exam, if any.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.View
   *
   */
  discount?: Maybe<ExamDiscount>;
  /** When set, indicates the last date on which the exam can be used toward certification. This value is only set for exams with passing grades. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  grade?: Maybe<ExamGradeLabel>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  hideUntil?: Maybe<Scalars['CmDate']['output']>;
  /** The unique id of this exam */
  id: Scalars['Int']['output'];
  /** The 3-char Windows API language code that indicates the language the Exam was delivered in. */
  languageId?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Int']['output']>;
  /** This is the unique identifier of the Exam at the test delivery vendor. */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Indicates if the exam has been rescored (beta exams, etc.). Any non-null value indicates that there has been a rescore. Most commonly the value is 'r'. */
  rescored?: Maybe<Scalars['String']['output']>;
  /**
   * The primary score Field<> for the Exam. This is typically the raw score. Depending on publishing practices, this could contain a scaled score.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  score?: Maybe<Scalars['Decimal']['output']>;
  /**
   * When true, indicates that a score report is available for download.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportUrl?: Maybe<Scalars['String']['output']>;
  /**
   * A processed score value, set by the Exam delivery vendor using an algorithm to obfuscate the raw Exam score value for more secure public consumption.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  scoreScaled?: Maybe<Scalars['Decimal']['output']>;
  /** When true, indicates that the exam was created via the web site, not imported through daily feeds or API creation. */
  simulated: Scalars['Boolean']['output'];
  /** Exams can either be in a valid (OK) state or in a state that cannot be used toward certification. States that cannot be used toward certification are: Invalid, UnderReview, Hidden, and Corrupted. */
  state: ExamState;
  /** Indicates if the exam is Active or has Expired. */
  status: Scalars['String']['output'];
  /** More information about the data provider's test center. */
  testCenter?: Maybe<TestCenter>;
  /** This is the id of the testing center for the exam delivery vendor that delivered the exam. */
  testCenterId?: Maybe<Scalars['String']['output']>;
  /** This indicates that a voucher was used as part or all of payment when the candidate registered to take the Exam. */
  voucherId?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: VmwareItsScoreReports
   *
   */
  vueItsScoreReportUrl?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows information about the Exam Accommodation.
 * 
 * 
 *  - Requires All Features: ExamAccommodations
 * 
 *  - Requires All Permissions: Exam.Accommodations.View
 *
 */
export interface ExamAccomm {
  catalog?: Maybe<ExamAccommCatalog>;
  cmcId: Scalars['Int']['output'];
  /** Stores notes from users to be sent to external systems. */
  externalNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** When the exam accommodation was last changed or created. */
  updated: Scalars['DateTime']['output'];
}

/**
 * Shows information about the Exam Accommodation Catalog.
 * 
 * 
 *  - Requires All Features: ExamAccommodations
 *
 */
export interface ExamAccommCatalog {
  /** More information about the data provider. */
  dataProvider?: Maybe<DataProvider>;
  /** An optional brief description. */
  description?: Maybe<Scalars['String']['output']>;
  /** When true, indicates that accommodation cannot be created for a candidate. Does not affect existing accommodations. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the Exam Accommodation Pack definition. */
  exapcatId: Scalars['Int']['output'];
  /** The exam accommodations unique identifier. */
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** If true, a candidate with this accommodation is not allowed to schedule exams at a physical location. */
  restrictSchedulePhysical?: Maybe<Scalars['Boolean']['output']>;
  /** If true, a candidate with this accommodation is not allowed to exams remotely. */
  restrictScheduleRemote?: Maybe<Scalars['Boolean']['output']>;
}

/**
 * Shows information about the Exam Accommodation Pack.
 * 
 * 
 *  - Requires All Features: ExamAccommodations
 * 
 *  - Requires All Permissions: Exam.Accommodations.View
 *
 */
export interface ExamAccommPack {
  catalog?: Maybe<ExamAccommPackCatalog>;
  cmcId: Scalars['Int']['output'];
  /** The date this pack was created. */
  created: Scalars['DateTime']['output'];
  /** Optional notes that web users can leave about the document for this pack. */
  docNotes?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  examAccommList?: Maybe<Array<Maybe<ExamAccomm>>>;
  /** The last day this pack can be used. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  id: Scalars['Int']['output'];
  /** The date that the ReviewState last changed. */
  reviewDate?: Maybe<Scalars['CmDate']['output']>;
  /** Optional notes that web users can leave when reviewing this pack. */
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewState: ExapReviewState;
  /** The last time this pack was updates */
  updated?: Maybe<Scalars['DateTime']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows information about the Exam Accommodation Pack Catalog.
 * 
 * 
 *  - Requires All Features: ExamAccommodations
 *
 */
export interface ExamAccommPackCatalog {
  /** If true, a web user must approve an accommodation under this pack that was created by a candidate before it is applied to them. */
  approvalRequired: Scalars['Boolean']['output'];
  /** If true, a candidate is able to create accommodations under this pack for themselves. */
  candidateCreate: Scalars['Boolean']['output'];
  /** An optional brief description. */
  description?: Maybe<Scalars['String']['output']>;
  /** When true, indicates that accommodations under this pack cannot be created for a candidate. Does not affect existing accommodations. */
  disabled: Scalars['Boolean']['output'];
  /** Gets the exam accomm catalogs associated with this pack catalog. */
  examAccommCatalogList?: Maybe<Array<Maybe<ExamAccommCatalog>>>;
  id: Scalars['Int']['output'];
  /** The exam accommodation pack generic identifier across all data providers. */
  label: Scalars['String']['output'];
}

/** Shows detailed information about the Exam Accommodation Pack. */
export interface ExamAccommPackDetail {
  catalog?: Maybe<ExamAccommPackCatalog>;
  cmcId: Scalars['Int']['output'];
  /** The date this pack was created. */
  created: Scalars['DateTime']['output'];
  /** Optional notes that web users can leave about the document for this pack. */
  docNotes?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  examAccommList?: Maybe<Array<Maybe<ExamAccomm>>>;
  /** The last day this pack can be used. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  id: Scalars['Int']['output'];
  /** The date that the ReviewState last changed. */
  reviewDate?: Maybe<Scalars['CmDate']['output']>;
  /** Optional notes that web users can leave when reviewing this pack. */
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewState: ExapReviewState;
  /** The last time this pack was updates */
  updated?: Maybe<Scalars['DateTime']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows high-level information about the Exam Attribute.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: Candidate.ExamDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamAttribute {
  /** The associated exam attribute catalog. */
  catalog?: Maybe<ExamAttributeCatalog>;
  /** The associated exam attribute catalog id */
  catalogId: Scalars['Int']['output'];
  /** The unique id for this exam attribute. */
  id: Scalars['Int']['output'];
  /** This attribute's value */
  value?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows all information about the Exam Attribute Catalog.
 * 
 * 
 *  - Requires All Features: Exam
 *
 */
export interface ExamAttributeCatalog {
  /** The external id for this exam attribute catalog */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The unique id for this exam attribute catalog */
  id: Scalars['Int']['output'];
  /** The attribute label text */
  label?: Maybe<Scalars['String']['output']>;
}

export interface ExamAuthHistory {
  activeDate?: Maybe<Scalars['DateTime']['output']>;
  completed?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  examDateTime?: Maybe<Scalars['DateTime']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  excatId?: Maybe<Scalars['Int']['output']>;
  excatName?: Maybe<Scalars['String']['output']>;
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  expkId?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  requested?: Maybe<Scalars['DateTime']['output']>;
  revoked?: Maybe<Scalars['Boolean']['output']>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows data provider specific information about the Exam Authorization.
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface ExamAuthorization {
  attempts?: Maybe<Scalars['Byte']['output']>;
  completed?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  created: Scalars['CmDateTimeOffset']['output'];
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique id for this entry. */
  id: Scalars['Int']['output'];
  requested?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  sendOkDate?: Maybe<Scalars['CmDate']['output']>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<ExauthState>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  updateData?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows data provider agnostic information about the Exam Authorization.
 * 
 * 
 *  - Must have candidate access
 *
 */
export interface ExamAuthorizationPack {
  /** The date that the candidate is eligible. */
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  /** The current status of the auth package. */
  authPackageState?: Maybe<AuthPackageStateEnum>;
  /** Indicates that a candidate has requested the authorization, and that it has been queued to be sent to the data provider. */
  claimed: Scalars['Boolean']['output'];
  current: Scalars['Boolean']['output'];
  currentExamAuthorizationList?: Maybe<Array<Maybe<ExamAuthorization>>>;
  editable: Scalars['Boolean']['output'];
  examAuthorizationList?: Maybe<Array<Maybe<ExamAuthorization>>>;
  examCatalog?: Maybe<ExamCatalog>;
  /** The last date that the candidate is eligible. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  /** The unique id for this entry at data providers - null if not yet claimed. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The unique id for this entry. */
  id: Scalars['Int']['output'];
  /** Indicates that this eligibility was manually granted, or a manual change was made to this eligibility. */
  manual?: Maybe<Scalars['Boolean']['output']>;
  revokable: Scalars['Boolean']['output'];
  /** Indicates that this eligibility was manually revoked. */
  revoked?: Maybe<Scalars['Boolean']['output']>;
  /** The date that associated authorizations can be sent to the data providers. */
  sendOkDate?: Maybe<Scalars['CmDate']['output']>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  used: Scalars['Boolean']['output'];
}

export interface ExamAuthorizationResponse {
  activeDate?: Maybe<Scalars['DateTime']['output']>;
  completed?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  excatId?: Maybe<Scalars['Int']['output']>;
  excatName?: Maybe<Scalars['String']['output']>;
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  expkId?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hideActions?: Maybe<Scalars['Boolean']['output']>;
  requested?: Maybe<Scalars['DateTime']['output']>;
  revoked?: Maybe<Scalars['Boolean']['output']>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
}

export interface ExamBatch {
  candidateFirstName?: Maybe<Scalars['String']['output']>;
  candidateLastName?: Maybe<Scalars['String']['output']>;
  cmcId: Scalars['Int']['output'];
  examCatalogName?: Maybe<Scalars['String']['output']>;
  examDateTime?: Maybe<Scalars['DateTime']['output']>;
  examGrade?: Maybe<ExamGradeLabel>;
  examGroupName?: Maybe<Scalars['String']['output']>;
  examId: Scalars['Int']['output'];
  examRegistrationNumber?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  scoreReportBatchCreator?: Maybe<Scalars['String']['output']>;
  scoreReportBatchDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface ExamBatchRequest {
  examGradeLabel?: InputMaybe<ExamGradeLabel>;
  excatId?: InputMaybe<Scalars['Int']['input']>;
  jurisdictionId: Scalars['Int']['input'];
  /** If true, will return previously batched certs. If false, will return certs that can be batched. Null is treated as false. */
  rebatch?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * Shows high-level information about the Exam definition.
 * 
 * 
 *  - Requires All Features: Exam
 *
 */
export interface ExamCatalog {
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareCertMetricsBadging
   *
   */
  badgeCatalog?: Maybe<BadgeCatalog>;
  /** An optional brief description of the Exam. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * This value is used to override the default sorting, which is alphabetical. ExamCatalog will sort by items with a DisplayOrder value, in that order, then alphabetically.
   * 
   * Sortable.
   */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  egEditable?: Maybe<Scalars['Boolean']['output']>;
  eligibilityCatalog?: Maybe<EligibilityCatalog>;
  /** Indicates the last date the exam was being delivered. */
  endDate?: Maybe<Scalars['CmDate']['output']>;
  examGroup?: Maybe<ExamGroup>;
  /**
   * Unique identifier of the exam as defined at the test delivery provider. Commonly known as the exam code.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  externalId: Scalars['String']['output'];
  /** Unique identifier for the Exam group definition. */
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  maximizePoints?: Maybe<Scalars['Boolean']['output']>;
  /** Custom metadata attributes for this exam catalog entry. */
  metadata?: Maybe<Array<Maybe<ExamCatalogMetadata>>>;
  /**
   * The name of the exam.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  name: Scalars['String']['output'];
  /**
   * The abbreviated name of the exam.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  pointsMax?: Maybe<Scalars['Int']['output']>;
  /**
   * An optional url that links to where the Candidate can schedule the Exam.
   * 
   * 
   *  - Requires All Features: ExamSchedulingUrl
   *
   */
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  /**
   * When true, indicates that score reports are available to download for Exams of this type.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If ScoreReport is true, this indicates the latest Exam.Date for which score reorts can be generated. Exams taken after this date will not have a score report generated.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportEndDate?: Maybe<Scalars['CmDate']['output']>;
  scoreReportFailAvailable: Scalars['Boolean']['output'];
  scoreReportPassAvailable: Scalars['Boolean']['output'];
  /**
   * If ScoreReport is true, this indicates the earliest Exam.Date for which score reports can be generated. Exams taken prior to this date will not have a score report generated.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportStartDate?: Maybe<Scalars['CmDate']['output']>;
  /** When true, a grade will show for all exams, including ungraded exams, and the candidate will be shown alternate text, such as 'Completed' instead of the normal grade text. */
  showExamWithAlteredGrade: Scalars['Boolean']['output'];
  /** Indicates the date the exam started being delivered. */
  startDate?: Maybe<Scalars['CmDate']['output']>;
  /** Indicates if the Exam Catalog entry is Active (being delivered), Inactive, Future, or Beta. */
  status: ExamCatalogStatus;
  /**
   * An optional public url to show more information about the Exam.
   * 
   * 
   *  - Requires All Features: ExamInformationUrl
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /** Indicates the number of months the exam will be considered valid toward certification. This determines the ExpireDate of the exam. ExpireDate is only set on exams with a passing grade. When this value is 0, this indicates that the exam is good forever, and no ExpireDate value is set. */
  validPeriod: Scalars['Short']['output'];
}

/**
 * Shows more detailed information about the Exam definition.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Permissions: Exam.Catalog.View
 *
 */
export interface ExamCatalogDetail {
  /**
   * When true, indicates that if the exam is used toward certification achievement, the Exam.Date will not be part of the Cert.ActiveDate calculation.
   * 
   *  - Disallowed Account Types: Candidate
   */
  activeDateCalcExclude: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  activeDateRule?: Maybe<DateRule>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ShareCertMetricsBadging
   *
   */
  badgeCatalog?: Maybe<BadgeCatalog>;
  /** Any catalog external ids associated with the exam. */
  catalogExternalIdList?: Maybe<Array<Maybe<CatalogExternalId>>>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  created: Scalars['CmDateTimeOffset']['output'];
  /** An optional brief description of the Exam. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * This value is used to override the default sorting, which is alphabetical. ExamCatalog will sort by items with a DisplayOrder value, in that order, then alphabetically.
   * 
   * Sortable.
   */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  egEditable?: Maybe<Scalars['Boolean']['output']>;
  eligibilityCatalog?: Maybe<EligibilityCatalog>;
  /** Indicates the last date the exam was being delivered. */
  endDate?: Maybe<Scalars['CmDate']['output']>;
  examGroup?: Maybe<ExamGroup>;
  /** This defines the exam item catalog */
  examItemCatalogList?: Maybe<Array<Maybe<ExamItemCatalog>>>;
  /** This defines the sections that are defined for Exam records of this ExamCatalog type. This is typically used to provide section-level feedback on score reports. */
  examSectionCatalogList?: Maybe<Array<Maybe<ExamSectionCatalog>>>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  expireDateRule?: Maybe<DateRule>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  exportDateRule?: Maybe<DateRule>;
  /**
   * Unique identifier of the exam as defined at the test delivery provider. Commonly known as the exam code.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  externalId: Scalars['String']['output'];
  /** Unique identifier for the Exam group definition. */
  groupId: Scalars['Int']['output'];
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  historyList?: Maybe<Array<Maybe<SystemHistory>>>;
  id: Scalars['Int']['output'];
  /** If the exam is a beta version, this is the ExamCatalog.Id of the live exam. */
  liveCatalogId?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  liveExamCatalog?: Maybe<ExamCatalog>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  logicRule?: Maybe<LogicRule>;
  /**
   * Defines the maximum score that can be achieved on the exam.
   * 
   *  - Disallowed Account Types: Candidate
   */
  maxScore?: Maybe<Scalars['Decimal']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  maximizePoints?: Maybe<Scalars['Boolean']['output']>;
  /** Custom metadata attributes for this exam catalog entry. */
  metadata?: Maybe<Array<Maybe<ExamCatalogMetadata>>>;
  /**
   * The name of the exam.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  name: Scalars['String']['output'];
  /**
   * The abbreviated name of the exam.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  pointsMax?: Maybe<Scalars['Int']['output']>;
  /** Returns the list of Cert tracks that use this Cert track in logic processing. */
  relatedCertCatalogList?: Maybe<Array<Maybe<CertCatalog>>>;
  /**
   * An optional url that links to where the Candidate can schedule the Exam.
   * 
   * 
   *  - Requires All Features: ExamSchedulingUrl
   *
   */
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  /**
   * When true, indicates that score reports are available to download for Exams of this type.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If ScoreReport is true, this indicates the latest Exam.Date for which score reorts can be generated. Exams taken after this date will not have a score report generated.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportEndDate?: Maybe<Scalars['CmDate']['output']>;
  scoreReportFailAvailable: Scalars['Boolean']['output'];
  /**
   * A link to upload the score report template for this excat. You must specify the language in the query string e.g. ?language=en
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportFailUploadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportList?: Maybe<Array<Maybe<CatalogAttachment>>>;
  scoreReportPassAvailable: Scalars['Boolean']['output'];
  /**
   * A link to upload the score report template for this excat. You must specify the language in the query string e.g. ?language=en
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportPassUploadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * If ScoreReport is true, this indicates the earliest Exam.Date for which score reports can be generated. Exams taken prior to this date will not have a score report generated.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportStartDate?: Maybe<Scalars['CmDate']['output']>;
  /** When true, a grade will show for all exams, including ungraded exams, and the candidate will be shown alternate text, such as 'Completed' instead of the normal grade text. */
  showExamWithAlteredGrade: Scalars['Boolean']['output'];
  /** Indicates the date the exam started being delivered. */
  startDate?: Maybe<Scalars['CmDate']['output']>;
  /** Indicates if the Exam Catalog entry is Active (being delivered), Inactive, Future, or Beta. */
  status: ExamCatalogStatus;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /**
   * An optional public url to show more information about the Exam.
   * 
   * 
   *  - Requires All Features: ExamInformationUrl
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /** Indicates the number of months the exam will be considered valid toward certification. This determines the ExpireDate of the exam. ExpireDate is only set on exams with a passing grade. When this value is 0, this indicates that the exam is good forever, and no ExpireDate value is set. */
  validPeriod: Scalars['Short']['output'];
}

/** Custom metadata attribute for an exam catalog entry. */
export interface ExamCatalogMetadata {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['output'];
  /** Foreign key to the exam catalog record this metadata belongs to. */
  examCatalogId: Scalars['Int']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** The value of the attribute. */
  value?: Maybe<Scalars['String']['output']>;
}

export enum ExamCatalogStatus {
  /** Active */
  Active = 'Active',
  /** Beta */
  Beta = 'Beta',
  /** Future */
  Future = 'Future',
  /** Inactive */
  Inactive = 'Inactive'
}

/**
 * Shows exam comment information.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Exam
 * 
 *  - Must have candidate access
 *
 */
export interface ExamComment {
  /** When this record was created */
  created: Scalars['CmDateTimeOffset']['output'];
  /** The unique id for this comment. */
  id: Scalars['Int']['output'];
  /** The name of the file this row originated from. This is NULL if the row didn't come from an import. */
  importSource?: Maybe<Scalars['String']['output']>;
  /** Indicates if the exam was rescored and this comment was part of the rescoring */
  rescored: Scalars['Boolean']['output'];
  /** This indicates the scope of the subject value */
  source?: Maybe<Scalars['String']['output']>;
  /** The comment subject */
  subject?: Maybe<Scalars['String']['output']>;
  /** The comment itself */
  text?: Maybe<Scalars['String']['output']>;
  /** When this record was last updated */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * Shows detailed information about the Exam record.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: Candidate.ExamDetails.View
 *
 */
export interface ExamDetail {
  /** Additional details for this exam. */
  additionalExamDetails?: Maybe<AdditionalExamDetails>;
  /** When true, indicates that the exam had a state of either Invalid or Under Review but has since been marked as valid toward certification. */
  approved: Scalars['Boolean']['output'];
  attemptNumber?: Maybe<Scalars['Short']['output']>;
  /**
   * The attributes for this exam.
   * 
   *  - Disallowed Account Types: Candidate
   */
  attributeList?: Maybe<Array<Maybe<ExamAttribute>>>;
  /** Indicates the authorization id that was used to take the Exam. */
  authorizationId?: Maybe<Scalars['String']['output']>;
  catalog?: Maybe<ExamCatalog>;
  catalogId: Scalars['Int']['output'];
  /** The candidate for this exam */
  cmcId: Scalars['Int']['output'];
  /**
   * The comments for this exam.
   * 
   *  - Disallowed Account Types: Candidate
   */
  commentList?: Maybe<Array<Maybe<ExamComment>>>;
  /** When the Exam record was originally created in CertMetrics. */
  created: Scalars['CmDateTimeOffset']['output'];
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  /** The unique Id (PK) of the data provider that delivered the Exam. This is considered the domain/context/scope within which the Exam.RegistrationNumber is unique. */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  /** The date and time the exam was taken. The time is the local time where the exam was taken. No time zone offset is supplied for that reason. Only the date portion of this is used to calculate cert.ActiveDate values. */
  dateTime: Scalars['DateTime']['output'];
  daysExtension?: Maybe<Scalars['Short']['output']>;
  /**
   * The discount applied to this exam, if any.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.View
   *
   */
  discount?: Maybe<ExamDiscount>;
  /** Holds the authorization ID of this exam. */
  examAuthId?: Maybe<Scalars['String']['output']>;
  /** When set, indicates the last date on which the exam can be used toward certification. This value is only set for exams with passing grades. */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  /** The name of the Exam form as defined by the client. */
  form?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<ExamGradeLabel>;
  /** When set, this indicates the date the Exam was first graded by the CertMetrics system. Typically applies to beta Exams. */
  graded?: Maybe<Scalars['CmDate']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  hideUntil?: Maybe<Scalars['CmDate']['output']>;
  /** The unique id of this exam */
  id: Scalars['Int']['output'];
  /** The images for this exam */
  imageList?: Maybe<Array<Maybe<ExamImage>>>;
  /** When set, indicates the name of the file that this Exam originated from. */
  importSource?: Maybe<Scalars['String']['output']>;
  /** The items for this exam. */
  itemList?: Maybe<Array<Maybe<ExamItem>>>;
  /** The survey items for this exam */
  itemSurveyList?: Maybe<Array<Maybe<ExamItemSurvey>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  itemsCorrect?: Maybe<Scalars['Short']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  itemsIncorrect?: Maybe<Scalars['Short']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  itemsSkipped?: Maybe<Scalars['Short']['output']>;
  /** The 3-char Windows API language code that indicates the language the Exam was delivered in. */
  languageId?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  masteredSectionCount?: Maybe<Scalars['Short']['output']>;
  /**
   * The minimum score (Exam.Score) needed to achieve a passing grade.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  masteryScore?: Maybe<Scalars['Decimal']['output']>;
  /** An indication of the 'medium' or delivery mode of the Exam as defined by the Exam delivery vendor. */
  mediumIndicator?: Maybe<Scalars['String']['output']>;
  /** The original import source when the exam was first created. */
  originalImportSource?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Int']['output']>;
  /** Holds the ID of the proctor of this exam. */
  proctorId?: Maybe<Scalars['String']['output']>;
  /** This is the unique identifier of the Exam at the test delivery vendor. */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** When set, indicates the last time the Exam was reimported. */
  reimported?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** Indicates if the exam has been rescored (beta exams, etc.). Any non-null value indicates that there has been a rescore. Most commonly the value is 'r'. */
  rescored?: Maybe<Scalars['String']['output']>;
  /**
   * The primary score Field<> for the Exam. This is typically the raw score. Depending on publishing practices, this could contain a scaled score.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  score?: Maybe<Scalars['Decimal']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  scoreRasch?: Maybe<Scalars['Decimal']['output']>;
  /** When set, this indicates the WebUser that first created this score report as part of a batch in CertMetrics. */
  scoreReportBatchCreator?: Maybe<Scalars['String']['output']>;
  /** When set, this indicates the first date the score report was created as part of a batch by a CertMetrics WebUser. */
  scoreReportBatchDate?: Maybe<Scalars['CmDate']['output']>;
  /**
   * When true, indicates that a score report is available for download.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportUrl?: Maybe<Scalars['String']['output']>;
  /**
   * When set, indicates that a manual score change has been made. Shows the revised score.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  scoreRevised?: Maybe<Scalars['Decimal']['output']>;
  /**
   * A processed score value, set by the Exam delivery vendor using an algorithm to obfuscate the raw Exam score value for more secure public consumption.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  scoreScaled?: Maybe<Scalars['Decimal']['output']>;
  /** The sections for this exam */
  sectionList?: Maybe<Array<Maybe<ExamSection>>>;
  /** When true, indicates that the exam was created via the web site, not imported through daily feeds or API creation. */
  simulated: Scalars['Boolean']['output'];
  standardError?: Maybe<Scalars['Decimal']['output']>;
  /** Exams can either be in a valid (OK) state or in a state that cannot be used toward certification. States that cannot be used toward certification are: Invalid, UnderReview, Hidden, and Corrupted. */
  state: ExamState;
  /** Indicates if the exam is Active or has Expired. */
  status: Scalars['String']['output'];
  /** More information about the data provider's test center. */
  testCenter?: Maybe<TestCenter>;
  /** This is the id of the testing center for the exam delivery vendor that delivered the exam. */
  testCenterId?: Maybe<Scalars['String']['output']>;
  /** Holds the Theta Score of this exam. */
  thetaScore?: Maybe<Scalars['String']['output']>;
  /** The number of extra minutes the Candidate was given to complete the Exam, in excess of what is normally allotted. */
  timeExtension?: Maybe<Scalars['Short']['output']>;
  /** The number of milliseconds spent on the exam. Will always be non-negative. */
  timeSpent?: Maybe<Scalars['Seconds']['output']>;
  /** The Exam title as sent by the Exam delivery vendor. */
  title?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** The client-defined version number of the Exam. */
  version?: Maybe<Scalars['String']['output']>;
  /** The violations for this exam */
  violationList?: Maybe<Array<Maybe<ExamViolation>>>;
  /** This indicates that a voucher was used as part or all of payment when the candidate registered to take the Exam. */
  voucherId?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: VmwareItsScoreReports
   *
   */
  vueItsScoreReportUrl?: Maybe<Scalars['String']['output']>;
}

/**
 * Returns the discount information for an exam.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Exam
 *
 */
export interface ExamDiscount {
  /** The access code of the discount. */
  accessCode?: Maybe<Scalars['String']['output']>;
  /** The amount of the discount. */
  amount: Scalars['Decimal']['output'];
  /** The "client reporting code" of the discount. */
  clientReportingCode?: Maybe<Scalars['String']['output']>;
  /** The "client reporting code description" of the discount. */
  clientReportingCodeDescription?: Maybe<Scalars['String']['output']>;
  /** The currency code of the discount (ISO-4217). Default value is "USD". */
  currency: Scalars['String']['output'];
  /** The exam that this discount was used on. */
  exam: Exam;
  /** The discount identifier. */
  id: Scalars['Int']['output'];
  /** The name of the discount. */
  name?: Maybe<Scalars['String']['output']>;
  /** The promo code of the discount. */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** The "voucher number" of the discount. This is unrelated to the exam_voucher and voucher tables. */
  voucherNumber?: Maybe<Scalars['String']['output']>;
  /** The "voucher sales order number" of the discount. This is unrelated to the exam_voucher and voucher tables. */
  voucherSalesOrderNumber?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows exam event information.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: Candidate.ExamEvents.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamEvent {
  actionUrlList?: Maybe<Array<Maybe<ExamEventActionUrl>>>;
  /** This is indicates the authorization ID that was used when the candidate registered to take the exam */
  authId?: Maybe<Scalars['String']['output']>;
  catalog?: Maybe<ExamCatalog>;
  /** The exam catalog item id associated with this event */
  catalogId: Scalars['Int']['output'];
  /** The candidate this event is associated with */
  cmcId: Scalars['Int']['output'];
  /** When this event was created */
  created: Scalars['CmDateTimeOffset']['output'];
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  /** The unique Id (PK) of the data provider that delivered the Exam. This is considered the domain/context/scope within which the Exam.RegistrationNumber is unique. */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  /** The date/time of the event. E.g. when the appointment was scheduled */
  dateTime?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /**
   * The discount applied to this exam event, if any.
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.View
   *
   */
  discount?: Maybe<ExamEventDiscount>;
  /** The unique id of this exam event */
  id: Scalars['Int']['output'];
  /** The name of the file this row originated from. This is NULL if the row didn't come from an import. */
  importSource?: Maybe<Scalars['String']['output']>;
  /** The 3-char Windows API language code that indicates the language the Exam was delivered in. */
  languageId?: Maybe<Scalars['String']['output']>;
  /** The ID of the event at the data provider. */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** More information about the data provider's test center. */
  testCenter?: Maybe<TestCenter>;
  /** This is the id of the testing center for the exam delivery vendor that delivered the exam. */
  testCenterId?: Maybe<Scalars['String']['output']>;
  /** Distinguishes the different things we can get from a data provider that, while they come with exam-data, are not exams. */
  type: ExevtType;
  /** When this event was updated */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** This is indicates the voucher that was used when the candidate registered to take the exam */
  voucherId?: Maybe<Scalars['String']['output']>;
}

export enum ExamEventActionType {
  /** Cancel */
  Cancel = 'Cancel',
  /** LiteweightRecertify */
  LiteweightRecertify = 'LiteweightRecertify',
  /** Reschedule */
  Reschedule = 'Reschedule',
  /** View */
  View = 'View'
}

export interface ExamEventActionUrl {
  type?: Maybe<ExamEventActionType>;
  url?: Maybe<Scalars['String']['output']>;
}

/**
 * Returns the discount information for an exam event.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Exam
 *
 */
export interface ExamEventDiscount {
  accessCode?: Maybe<Scalars['String']['output']>;
  clientReportingCode?: Maybe<Scalars['String']['output']>;
  clientReportingCodeDescription?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  /** The exam event associated with this discount. */
  examEvent: ExamEvent;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  totalDiscountAmount: Scalars['Decimal']['output'];
  voucherNumber?: Maybe<Scalars['String']['output']>;
  vtsVoucherSalesOrderNumber?: Maybe<Scalars['String']['output']>;
}

export enum ExamGradeLabel {
  /** Fail */
  Fail = 'Fail',
  /** Pass */
  Pass = 'Pass',
  /** Ungraded */
  Ungraded = 'Ungraded'
}

/**
 * This is for the grouping of exam definitions (excats).
 * 
 * 
 *  - Requires All Features: Exam
 *
 */
export interface ExamGroup {
  /** Color to be used in the exam group card in hex (#000000) format. */
  color?: Maybe<Scalars['String']['output']>;
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. ExamGroup will sort by items with a DisplayOrder value, in that order, then alphabetically. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  id: Scalars['Int']['output'];
  /** Group display name. */
  name: Scalars['String']['output'];
  /** Optional Grouping used instead of defaults built into the catalog. If using, must be on all groups */
  program?: Maybe<Scalars['String']['output']>;
  /** Color to be used in the exam group text in hex (#000000) format. */
  textColor?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows exam image information.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: Candidate.ExamImages.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamImage {
  /** The associated exam */
  exam?: Maybe<Exam>;
  /** The unique id for this item */
  id: Scalars['Int']['output'];
  /** The type of this image */
  type?: Maybe<EimgType>;
  /** The datetime this image was updated */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** The url for this image */
  url?: Maybe<Scalars['String']['output']>;
}

export interface ExamImageSecurityConfigurationGqlType {
  unparsedConfig?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows exam item information.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: Candidate.ExamDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamItem {
  /**
   * The correct answer for this item
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamKey.View
   *
   */
  correctAnswer?: Maybe<Scalars['String']['output']>;
  /** When this row was created */
  created: Scalars['CmDateTimeOffset']['output'];
  /** The distractor count */
  distractorCount?: Maybe<Scalars['Short']['output']>;
  /** The corresponding item catalog for this exam item. */
  examItemCatalog?: Maybe<ExamItemCatalog>;
  /** Shows detailed information about the ExamItem record. */
  examItemDetail?: Maybe<ExamItemDetail>;
  /** The unique id for this item */
  id: Scalars['Int']['output'];
  /** The name of the file this row originated from. NULL if the row didn't come from an import. */
  importSource?: Maybe<Scalars['String']['output']>;
  /** Learning resources for this item */
  learningResources?: Maybe<Scalars['String']['output']>;
  /** The identifying name for this item */
  name?: Maybe<Scalars['String']['output']>;
  /** The order this item was presented in */
  orderPresented?: Maybe<Scalars['Short']['output']>;
  /** If this item was part of a rescoring */
  rescored: Scalars['Boolean']['output'];
  /**
   * The item's response
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  response?: Maybe<Scalars['String']['output']>;
  /** When exam-item-response data exists for an item, this will either be " + " or " * ". The value " + " means that all of the response data is of the same type, while " * " means there are multiple types */
  responseType?: Maybe<Scalars['String']['output']>;
  /**
   * The score on this item
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  score?: Maybe<Scalars['Decimal']['output']>;
  /** Returns the score weight from exam item catalog */
  scoreWeight?: Maybe<Scalars['Decimal']['output']>;
  /** Returns true if an item has been scored, false otherwise. */
  scored?: Maybe<Scalars['Boolean']['output']>;
  /** The calculated score status for the Exam Item. */
  scoredStatus?: Maybe<ExamScoredStatusEnum>;
  /** A listing of ordinals that link items in an exam to sections in the same exam */
  sectionOrdinal?: Maybe<Scalars['String']['output']>;
  /** A single character status for the item */
  status?: Maybe<Scalars['String']['output']>;
  /** The time spent on this item in seconds */
  timeSpent?: Maybe<Scalars['Seconds']['output']>;
  /** When this row was last updated */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * Shows information about the exam item catalog
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Permissions: Exam.Catalog.Items.View
 *
 */
export interface ExamItemCatalog {
  /** This field is for item-definition-level comments that users may wish to store in our system. The main purpose is to provide a way to have comments about an item to be displayed on an item-level (psychometric) report. */
  comment?: Maybe<Scalars['String']['output']>;
  /** The unique id for this item catalog */
  id: Scalars['Int']['output'];
  /**
   * For items we score, this contains the correct answer (AKA answer key). For dichotomous scoring, a simple string-equality test is used to decide between correct (1) and incorrect (0).
   * 
   * 
   *  - Requires All Permissions: Exam.Catalog.Items.Key.View
   *
   */
  itemCorrectAnswer?: Maybe<Scalars['String']['output']>;
  /** The name stored in the item table. */
  itemName: Scalars['String']['output'];
  /** The maximum score possible for the item. Used for polytomous scoring. */
  itemScoreMax?: Maybe<Scalars['Decimal']['output']>;
  /** Used in score calculation for the exam. It indicates the item's "weight" towards the final score with regard to other items. */
  itemScoreWeight?: Maybe<Scalars['Decimal']['output']>;
  /** The 3-char Windows API language code that indicates the language the Exam was delivered in. */
  languageId: Scalars['String']['output'];
  /** An optional list of values which indicate the forms in which the item is considered un-scored. */
  unscoredForms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

/**
 * Shows detailed information about the ExamItem record.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: ExamMSFTExamDetails
 *
 */
export interface ExamItemDetail {
  /** Whether or not the exam item is part of a case study. */
  caseStudy?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** The ID of the exam_item that this detail record belongs to. */
  itemId: Scalars['Int']['output'];
  /** The time in seconds that "Open Book" was used by the candidate on this exam item. */
  itemTimeSeconds?: Maybe<Scalars['Int']['output']>;
  /** The max points possible for the exam item. */
  maxPointsPossible?: Maybe<Scalars['Int']['output']>;
  /** Whether or not this was the first exam item that the candidate used the "Open Book" feature on, for the exam. */
  obFirst?: Maybe<Scalars['Boolean']['output']>;
  /** The number of "Open Book" pages that were viewed by the candidate for this exam item. */
  obPages?: Maybe<Scalars['Int']['output']>;
  /** Whether "or not Open Book" was used on this exam item. */
  obUsed?: Maybe<Scalars['Boolean']['output']>;
}

/**
 * Shows exam item survey information.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: Candidate.ExamDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamItemSurvey {
  /** When this survey item was created. */
  created: Scalars['CmDateTimeOffset']['output'];
  /** The unique id of this survey. */
  id: Scalars['Int']['output'];
  /** The name of the file this row originated from. This is NULL if the row didn't come from an import. */
  importSource?: Maybe<Scalars['String']['output']>;
  /** The identifier for this survey item */
  name?: Maybe<Scalars['String']['output']>;
  /** Shows if this survey item was part of an exam rescoring */
  rescored?: Maybe<Scalars['Boolean']['output']>;
  /** The response */
  response?: Maybe<Scalars['String']['output']>;
  /** The response type */
  responseType?: Maybe<Scalars['String']['output']>;
  /** The time spent on this survey item in seconds */
  timeSpent?: Maybe<Scalars['Seconds']['output']>;
  /** The survey item title */
  title?: Maybe<Scalars['String']['output']>;
  /** When this survey item was last updated */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

export interface ExamListRequest {
  /** Determines whether to include corrupted exams in the request. */
  includeCorrupted?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum ExamScoredStatusEnum {
  /** NonItem */
  NonItem = 'NonItem',
  /** Scored */
  Scored = 'Scored',
  /** Unscored */
  Unscored = 'Unscored'
}

/**
 * Shows exam section information.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: Candidate.ExamDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamSection {
  /** When this item was created */
  created: Scalars['CmDateTimeOffset']['output'];
  grade?: Maybe<ExamSectionGradeLabel>;
  /** The unique id of this section */
  id: Scalars['Int']['output'];
  /** The name of the file this row originated from. This is NULL if the row didn't come from an import. */
  importSource?: Maybe<Scalars['String']['output']>;
  /**
   * The number of items correct on this section
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  itemsCorrect?: Maybe<Scalars['Short']['output']>;
  /**
   * The number of items incorrect on this section
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  itemsIncorrect?: Maybe<Scalars['Short']['output']>;
  /**
   * The number of items skipped on this section
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  itemsSkipped?: Maybe<Scalars['Short']['output']>;
  /**
   * The mastery score
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  masteryScore?: Maybe<Scalars['Decimal']['output']>;
  /** The identifier for this section */
  name?: Maybe<Scalars['String']['output']>;
  /** This is the numeric ID of the section within the exam. It is a legacy Field<> introduced solely because of how sections are linked to items in the CNM11 format. Normally, the sec-name field should be used when choosing an "external ID" for sections; when this is null, but the item-section-ordinal field is not, look in sec-name */
  ordinal?: Maybe<Scalars['Short']['output']>;
  /** Indicates if this section has been involved in an exam rescoring */
  rescored: Scalars['Boolean']['output'];
  /**
   * The section grade
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  score?: Maybe<Scalars['Decimal']['output']>;
  /** The maximum score achievable in the section, when known. */
  scoreMax?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Indicates if this section was scored
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  scored: Scalars['Boolean']['output'];
  /**
   * The scoring algorithm used
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.View
   *
   */
  scoringAlgorithm?: Maybe<Scalars['String']['output']>;
  /** The standard error */
  standardError?: Maybe<Scalars['Decimal']['output']>;
  /** Holds the Theta Score of this exam section. */
  thetaScore?: Maybe<Scalars['String']['output']>;
  /** The label/description of the section */
  title?: Maybe<Scalars['String']['output']>;
  /** When this item was last updated */
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * Returns generic details about an exam section
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: ExamSectionCatalog
 * 
 *  - Requires All Permissions: Exam.Catalog.Sections.View
 *
 */
export interface ExamSectionCatalog {
  /** The percentage of the exam items that are contained in this section. */
  coverage?: Maybe<Scalars['String']['output']>;
  /** The minimum score required to pass */
  cutScore?: Maybe<Scalars['Decimal']['output']>;
  /** The exam form the section belongs to */
  examForm: Scalars['String']['output'];
  /** A score higher than this indicates strong performance on this section */
  high?: Maybe<Scalars['Decimal']['output']>;
  /** The unique id of the record */
  id: Scalars['Int']['output'];
  /** The label e.g. 'JavaScript is flawless, discuss' */
  label?: Maybe<Scalars['String']['output']>;
  /** A score higher than this indicates weak performance on this section */
  low?: Maybe<Scalars['Decimal']['output']>;
  /** The maximum score possible on this section */
  maxScore?: Maybe<Scalars['Decimal']['output']>;
  /** A score higher than this indicates acceptable performance on this section */
  mid?: Maybe<Scalars['Decimal']['output']>;
  /** The section name e.g. '1.1' */
  sectionName: Scalars['String']['output'];
}

export enum ExamSectionGradeLabel {
  /** Fail */
  Fail = 'Fail',
  /** Pass */
  Pass = 'Pass',
  /** Ungraded */
  Ungraded = 'Ungraded'
}

export enum ExamState {
  /** Corrupted */
  Corrupted = 'Corrupted',
  /** Hidden */
  Hidden = 'Hidden',
  /** Invalid */
  Invalid = 'Invalid',
  /** OK */
  Ok = 'OK',
  /** UnderReview */
  UnderReview = 'UnderReview'
}

/**
 * Returns a list of exams under review.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: ExamSecurity
 * 
 *  - Requires All Permissions: Exam.ReviewList.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamUnderReviewResponse {
  candidate?: Maybe<Candidate>;
  catalog?: Maybe<ExamCatalog>;
  cmcId: Scalars['Int']['output'];
  dateTime: Scalars['CmDateTimeOffset']['output'];
  dpExternalId?: Maybe<Scalars['String']['output']>;
  emailRequestList?: Maybe<Array<Maybe<EmailRequest>>>;
  examRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Returns latest exam review note for an exam. */
  examReviewNote?: Maybe<CandidateHistory>;
  examUpdated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  examViolationList?: Maybe<Array<Maybe<ExamViolation>>>;
  id: Scalars['Int']['output'];
}

export interface ExamValidationRequest {
  dataProviderExternalId: Scalars['String']['input'];
  examRegistrationNumber: Scalars['String']['input'];
  examState: ExamState;
  note: Scalars['String']['input'];
  notifyCandidate?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum ExamValidationUpdateStatus {
  /** DuplicateRecords */
  DuplicateRecords = 'DuplicateRecords',
  /** NotFound */
  NotFound = 'NotFound',
  /** Success */
  Success = 'Success'
}

export interface ExamVerificationResponseGqlType {
  address?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  dpName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  examCode?: Maybe<Scalars['String']['output']>;
  examCountry?: Maybe<Scalars['String']['output']>;
  examDate?: Maybe<Scalars['String']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  testCenter?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows exam violation information.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Permissions: Candidate.ExamViolations.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamViolation {
  /** When this violation was created */
  created: Scalars['CmDateTimeOffset']['output'];
  /** Extra detail about a violation when needed. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Extra detail about a violation when needed for face recognition. */
  detailFaceRecognitionParsed?: Maybe<ExamViolationFaceRecognitionDetail>;
  /** Extra detail about a violation when needed for rsi. */
  detailRsiParsed?: Maybe<ExamViolationDetail>;
  /** The associated exam */
  exam?: Maybe<Exam>;
  id: Scalars['Int']['output'];
  /** This is meant for use by a violation-detection script to further identify a specify sub-type; it's up to each script to define how this is used (or not). It is useful because some specialized requests require different handling than the default (e.g. some send an email while some don't). */
  subtype?: Maybe<Scalars['String']['output']>;
  /** Indicates the type of violation the exam is guilty of */
  type: ExamViolationType;
}

/**
 * Shows details of exam violations.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Must have candidate access
 *
 */
export interface ExamViolationDetail {
  /** The list of Rsi Zscore matches */
  rsiFlaggedPair: Array<Maybe<FlaggedPair>>;
  /** The number of other exams that this exam overlaps on Rsi with */
  rsiOverlapCount: Scalars['Int']['output'];
  /** The list of Rsi overlap matches */
  rsiOverlapFlaggedPair: Array<Maybe<FlaggedOverlapPair>>;
  /** The number of other exams that matched on Rsi ZScore */
  rsiZScoreCount: Scalars['Int']['output'];
  /** The list of Ssi Zscore matches */
  ssiFlaggedPair: Array<Maybe<FlaggedPair>>;
  /** The number of other exams that this exam overlaps on Ssi with */
  ssiOverlapCount: Scalars['Int']['output'];
  /** The list of Ssi overlap matches */
  ssiOverlapFlaggedPair: Array<Maybe<FlaggedOverlapPair>>;
  /** The number of other exams that matched on Ssi ZScore */
  ssiZScoreCount: Scalars['Int']['output'];
}

/**
 * Shows details of face recognition exam violations.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Must have candidate access
 *
 */
export interface ExamViolationFaceRecognitionDetail {
  /** Confidence of the match */
  confidence: Scalars['Decimal']['output'];
  /** Cmc Id the image matched against */
  matchedCmcId: Scalars['Int']['output'];
}

export enum ExamViolationType {
  /** AdvancedSecurityRule */
  AdvancedSecurityRule = 'AdvancedSecurityRule',
  /** CandidateRelated */
  CandidateRelated = 'CandidateRelated',
  /** Collusion */
  Collusion = 'Collusion',
  /** DifferentialPerformance */
  DifferentialPerformance = 'DifferentialPerformance',
  /** FaceRecognition */
  FaceRecognition = 'FaceRecognition',
  /** FailThenFail */
  FailThenFail = 'FailThenFail',
  /** FailThenPass */
  FailThenPass = 'FailThenPass',
  /** ItemExposure */
  ItemExposure = 'ItemExposure',
  /** NoViolation */
  NoViolation = 'NoViolation',
  /** Null */
  Null = 'Null',
  /** Order */
  Order = 'Order',
  /** PassThenFail */
  PassThenFail = 'PassThenFail',
  /** PassThenPass */
  PassThenPass = 'PassThenPass',
  /** PoorPerformance */
  PoorPerformance = 'PoorPerformance',
  /** Psychometric */
  Psychometric = 'Psychometric',
  /** Rsi */
  Rsi = 'Rsi',
  /** ScoreChange */
  ScoreChange = 'ScoreChange',
  /** ScoreTooHighTimeTooShort */
  ScoreTooHighTimeTooShort = 'ScoreTooHighTimeTooShort',
  /** ScoredUnscoredPerformance */
  ScoredUnscoredPerformance = 'ScoredUnscoredPerformance',
  /** TimeTooShort */
  TimeTooShort = 'TimeTooShort',
  /** TimeTooShortForTooManyItems */
  TimeTooShortForTooManyItems = 'TimeTooShortForTooManyItems',
  /** TotalExceeded */
  TotalExceeded = 'TotalExceeded',
  /** TrojanItem */
  TrojanItem = 'TrojanItem',
  /** Voucher */
  Voucher = 'Voucher'
}

/**
 * Shows exam voucher information.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Permissions: Exam.CertMetricsVouchers.View
 * 
 *  - Must have candidate access
 *
 */
export interface ExamVoucher {
  /** The first date this voucher is usable for registration (it is active on this date). Null means it was active from the beginning of time. */
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  /** When the voucher was assigned to the candidate. */
  assigned?: Maybe<Scalars['CmDate']['output']>;
  /** Used to group a set of vouchers together. */
  batchId?: Maybe<Scalars['String']['output']>;
  /** This indicates the candidate the voucher has been assigned to. */
  cmcId?: Maybe<Scalars['Int']['output']>;
  /** When this voucher was created */
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  dataProvider?: Maybe<DataProvider>;
  /** Optional, custom data that only applies to the data-provider, and is used in a custom way for that provider when it exists. */
  dataProviderData?: Maybe<Scalars['String']['output']>;
  /** When this is not null, the record represents a discount/coupon code (not a single-use voucher). In which case, this is the value used at the data provider when scheduling to take an exam. */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** The associated exam catalog */
  examCatalog?: Maybe<ExamCatalog>;
  /** The unique ID of the voucher data (aka coupon/discount code). */
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  importDataProvider?: Maybe<DataProvider>;
  /** The name of the file this row originated from. This is NULL if the row didn't come from an import. */
  importSource?: Maybe<Scalars['String']['output']>;
  /** The last date the voucher is usable for registration (it is still active on this date)---as reported to us during import. Null means it never goes inactive. */
  inactiveDate?: Maybe<Scalars['CmDate']['output']>;
  /** True when the voucher is no longer valid. */
  invalid?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if an unassigned voucher is available to be assigned to a candidate. (Inactive vouchers should not be assigned, regardless this setting.)  */
  isUsable?: Maybe<Scalars['Boolean']['output']>;
  maxAttempts?: Maybe<Scalars['Int']['output']>;
  maxRetakes?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

export enum ExapReviewState {
  /** Approved */
  Approved = 'Approved',
  /** Denied */
  Denied = 'Denied',
  /** None */
  None = 'None',
  /** Pending */
  Pending = 'Pending',
  /** Revoked */
  Revoked = 'Revoked'
}

export enum ExauthState {
  /** Complete */
  Complete = 'Complete',
  /** Error */
  Error = 'Error',
  /** Queued */
  Queued = 'Queued',
  /** Rejected */
  Rejected = 'Rejected',
  /** Requested */
  Requested = 'Requested'
}

export enum ExevtType {
  /** Aborted */
  Aborted = 'Aborted',
  /** ApptOK */
  ApptOk = 'ApptOK',
  /** Canceled */
  Canceled = 'Canceled',
  /** Corrupted */
  Corrupted = 'Corrupted',
  /** Exam */
  Exam = 'Exam',
  /** NoShow */
  NoShow = 'NoShow'
}

export enum FcatQueueType {
  /** EachNewItem */
  EachNewItem = 'EachNewItem',
  /** Manual */
  Manual = 'Manual',
  /** Never */
  Never = 'Never',
  /** Once */
  Once = 'Once'
}

/** Client/sponsor feature information */
export interface Feature {
  description: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  devNotes?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  editEdInternal: Scalars['Boolean']['output'];
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   */
  editEdSponsor: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  key: HubFeature;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
}

/** Feature information */
export interface FeatureInfo {
  children?: Maybe<Array<Maybe<FeatureInfo>>>;
  description: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  devNotes?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  editEdInternal: Scalars['Boolean']['output'];
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, Candidate
   */
  editEdSponsor: Scalars['Boolean']['output'];
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  editMamuInternal: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  key: HubFeature;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
}

export interface FetchDelayListRequest {
  viewUnfilteredData: Scalars['Boolean']['input'];
  wuserId: Scalars['Int']['input'];
}

export interface FetchDelayListResponse {
  csetDefault?: Maybe<Scalars['Int']['output']>;
  csetInt?: Maybe<Scalars['Int']['output']>;
  lcatName?: Maybe<Scalars['String']['output']>;
  litemExternalId?: Maybe<Scalars['String']['output']>;
  litemId?: Maybe<Scalars['Int']['output']>;
  litemName?: Maybe<Scalars['String']['output']>;
}

export interface FetchExamAuthHistoryRequest {
  cmcId?: InputMaybe<Scalars['Int']['input']>;
}

export interface FetchExamAuthsRequest {
  cmcId?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface FetchQueuedJobRequest {
  jobId: Scalars['String']['input'];
}

/**
 * A grouping of filter criteria
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires Any Features: Announcements, CandidateSegmentation
 * 
 *  - Requires All Permissions: Announcements.Catalog.View
 *
 */
export interface Filter {
  criteriaList?: Maybe<Array<Maybe<FilterCriteria>>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  updator?: Maybe<Scalars['String']['output']>;
}

/**
 * A filter criteria
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires Any Features: Announcements, CandidateSegmentation
 * 
 *  - Requires All Permissions: Announcements.Catalog.View
 *
 */
export interface FilterCriteria {
  and?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  not?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  requiredCount?: Maybe<Scalars['Int']['output']>;
  rule?: Maybe<CfcRule>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Announcements
 * 
 *  - Requires All Permissions: Announcements.Catalog.View
 *
 */
export interface FilterCriteriaRequest {
  and: Scalars['Boolean']['input'];
  idList: Array<InputMaybe<Scalars['String']['input']>>;
  not: Scalars['Boolean']['input'];
  order: Scalars['Byte']['input'];
  requiredCount: Scalars['Int']['input'];
  rule: CfcRule;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Must have candidate access
 *
 */
export interface FlaggedOverlapPair {
  /** The number of matching items */
  count: Scalars['Int']['output'];
  /** The id of the matching exam */
  examId: Scalars['Int']['output'];
  /** Expected value "factor" for Z-score calculation */
  expectedCount?: Maybe<Scalars['Decimal']['output']>;
  /** The candidate name, cmcId, registration number, exam date, and test center id of the matching exam */
  matchingExam?: Maybe<MatchingExam>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Must have candidate access
 *
 */
export interface FlaggedPair {
  /** The number of matching items */
  count: Scalars['Int']['output'];
  /** The id of the matching exam */
  examId: Scalars['Int']['output'];
  /** Expected value "factor" for Z-score calculation */
  expectedCount?: Maybe<Scalars['Decimal']['output']>;
  /** The candidate name, cmcId, registration number, exam date, and test center id of the matching exam */
  matchingExam?: Maybe<MatchingExam>;
  /** The probability of Zscore between the matched and matching exams */
  probability: Scalars['String']['output'];
  /** The Zscore between the matched and matching exams */
  zscore: Scalars['Decimal']['output'];
}

export enum FulfStatus {
  /** Failed */
  Failed = 'Failed',
  /** Null */
  Null = 'Null',
  /** OK */
  Ok = 'OK'
}

/**
 * Represents a voucher that can be used to purchase a fulfillment.
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 * 
 *  - Requires All Permissions: Candidate.CredentialFulfillment.View, Candidate.CredentialFulfillment.Modify
 *
 */
export interface FulfillmentVoucher {
  /** If set, this is the date after which the voucher can be used. */
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  /** The batch ID of the voucher */
  batchId?: Maybe<Scalars['String']['output']>;
  /** The ID of the candidate that redeemed this voucher, if any */
  cmcId?: Maybe<Scalars['Int']['output']>;
  /** If set, this is the total number of times an individual candidate can use a voucher. */
  cmcUseCount?: Maybe<Scalars['Int']['output']>;
  /** Optional field for users to provide comments about the voucher. */
  comments?: Maybe<Scalars['String']['output']>;
  /** When this voucher was created */
  created: Scalars['CmDate']['output'];
  /** When set, this value discounts the amount of the associated fee by amount dollars. */
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  /** When set, this value discounts the amount of the associated fee by multiplier percent. */
  discountMultiplier?: Maybe<Scalars['Decimal']['output']>;
  /** The date after which the voucher can no longer be redeemed. Null if it never expires */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  /** The unique voucher code that candidates must enter to redeem the voucher */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the fulfillment catalog this voucher is associated with */
  fcatId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** If true, the voucher cannot be redeemed even if it hasn't expired */
  revoked: Scalars['Boolean']['output'];
  /** The total number of times this voucher can be used. */
  useCount?: Maybe<Scalars['Int']['output']>;
}

export enum FulfillmentVoucherBatchDetailsStatus {
  /** Expired */
  Expired = 'Expired',
  /** Redeemed */
  Redeemed = 'Redeemed',
  /** Revoked */
  Revoked = 'Revoked',
  /** Valid */
  Valid = 'Valid'
}

/**
 * Represents a voucher that can be used to purchase a fulfillment.
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 * 
 *  - Requires All Permissions: Candidate.CredentialFulfillment.View, Candidate.CredentialFulfillment.Modify
 *
 */
export interface FulfillmentVoucherDetail {
  /** If set, this is the date after which the voucher can be used. */
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  /** The batch ID of the voucher */
  batchId?: Maybe<Scalars['String']['output']>;
  /** The candidate who redeemed the voucher (if redeemed) */
  candidate?: Maybe<Candidate>;
  /** The ID of the candidate that redeemed this voucher, if any */
  cmcId?: Maybe<Scalars['Int']['output']>;
  /** If set, this is the total number of times an individual candidate can use a voucher. */
  cmcUseCount?: Maybe<Scalars['Int']['output']>;
  /** Optional field for users to provide comments about the voucher. */
  comments?: Maybe<Scalars['String']['output']>;
  /** When this voucher was created */
  created: Scalars['CmDate']['output'];
  /** When set, this value discounts the amount of the associated fee by amount dollars. */
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  /** When set, this value discounts the amount of the associated fee by multiplier percent. */
  discountMultiplier?: Maybe<Scalars['Decimal']['output']>;
  /** The date after which the voucher can no longer be redeemed. Null if it never expires */
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  /** The unique voucher code that candidates must enter to redeem the voucher */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The fulfillment catalog information */
  fcat?: Maybe<PhysicalFulfillmentCatalog>;
  /** The ID of the fulfillment catalog this voucher is associated with */
  fcatId: Scalars['Int']['output'];
  /** The fulfillment created when the voucher was redeemed (if redeemed) */
  fulfillment?: Maybe<PhysicalFulfillment>;
  id: Scalars['Int']['output'];
  /** If true, the voucher cannot be redeemed even if it hasn't expired */
  revoked: Scalars['Boolean']['output'];
  /** The total number of times this voucher can be used. */
  useCount?: Maybe<Scalars['Int']['output']>;
}

export interface GenerateShortLivedTokenRequest {
  targetMethod?: InputMaybe<Scalars['String']['input']>;
  targetUrl: Scalars['String']['input'];
}

export interface GetLocalizationListRequest {
  clientAlias?: InputMaybe<Scalars['String']['input']>;
  /** The culture of the localizations. */
  cultureName: Scalars['String']['input'];
  /** See PortalType enum for more information. */
  portalType?: InputMaybe<PortalType>;
}

export interface GetLocalizationRequest {
  /** The culture of the localization. */
  cultureName: Scalars['String']['input'];
  /** The localization name (key). */
  name: Scalars['String']['input'];
  /** See PortalType enum for more information. */
  type: LocType;
}

export interface GetLocalizedCulturesListRequest {
  clientAlias: Scalars['String']['input'];
}

export interface GetSupportedCulturesListRequest {
  clientAlias: Scalars['String']['input'];
}

export interface GrantExamAuthorizationPackRequest {
  activeDate: Scalars['CmDateTimeOffset']['input'];
  candidateId: CandidateIdRequest;
  excatId: Scalars['Int']['input'];
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  sendOkDate: Scalars['CmDateTimeOffset']['input'];
}

/** Hub Feature Enum */
export enum HubFeature {
  /** AWSCustomReports */
  AwsCustomReports = 'AWSCustomReports',
  /** AWSCustomReports.RemoveDataDownloadButtons */
  AwsCustomReportsRemoveDataDownloadButtons = 'AWSCustomReportsRemoveDataDownloadButtons',
  /** AWSCustomReports.VerifyVoucherCode */
  AwsCustomReportsVerifyVoucherCode = 'AWSCustomReportsVerifyVoucherCode',
  /** AddCandidateId */
  AddCandidateId = 'AddCandidateId',
  /** AnnouncementPage */
  AnnouncementPage = 'AnnouncementPage',
  /** Announcements */
  Announcements = 'Announcements',
  /** BanAndInvalidateTool */
  BanAndInvalidateTool = 'BanAndInvalidateTool',
  /** Benefit */
  Benefit = 'Benefit',
  /** Benefit.BrandVia_Vmware */
  BenefitBrandViaVmware = 'BenefitBrandVia_Vmware',
  /** Benefit.Lineup */
  BenefitLineup = 'BenefitLineup',
  /** Benefit.RecentActivity */
  BenefitRecentActivity = 'BenefitRecentActivity',
  /** BulkCandidateTools */
  BulkCandidateTools = 'BulkCandidateTools',
  /** BulkCandidateTools.AWSCustomBanEmailBulkTool */
  BulkCandidateToolsAwsCustomBanEmailBulkTool = 'BulkCandidateToolsAWSCustomBanEmailBulkTool',
  /** CandidateAccess */
  CandidateAccess = 'CandidateAccess',
  /** CandidateAccess.BannedLandingPage */
  CandidateAccessBannedLandingPage = 'CandidateAccessBannedLandingPage',
  /** CandidateAccess.CandidateAccess.Integration.Egress.CdiScorpion */
  CandidateAccessCandidateAccessIntegrationEgressCdiScorpion = 'CandidateAccessCandidateAccessIntegrationEgressCdiScorpion',
  /** CandidateAccess.CandidatePortalDefaultView */
  CandidateAccessCandidatePortalDefaultView = 'CandidateAccessCandidatePortalDefaultView',
  /** CandidateAccess.CmIdCpNavigation */
  CandidateAccessCmIdCpNavigation = 'CandidateAccessCmIdCpNavigation',
  /** CandidateAccess.Integration */
  CandidateAccessIntegration = 'CandidateAccessIntegration',
  /** CandidateAccess.Integration.Egress */
  CandidateAccessIntegrationEgress = 'CandidateAccessIntegrationEgress',
  /** CandidateAccess.Integration.Egress.Brandvia */
  CandidateAccessIntegrationEgressBrandvia = 'CandidateAccessIntegrationEgressBrandvia',
  /** CandidateAccess.Integration.Egress.Examity */
  CandidateAccessIntegrationEgressExamity = 'CandidateAccessIntegrationEgressExamity',
  /** CandidateAccess.Integration.Egress.Examity.Scheduling */
  CandidateAccessIntegrationEgressExamityScheduling = 'CandidateAccessIntegrationEgressExamityScheduling',
  /** CandidateAccess.Integration.Egress.Examity.Scheduling.Cancel */
  CandidateAccessIntegrationEgressExamitySchedulingCancel = 'CandidateAccessIntegrationEgressExamitySchedulingCancel',
  /** CandidateAccess.Integration.Egress.Examity.Scheduling.Reschedule */
  CandidateAccessIntegrationEgressExamitySchedulingReschedule = 'CandidateAccessIntegrationEgressExamitySchedulingReschedule',
  /** CandidateAccess.Integration.Egress.Examity.Scheduling.Schedule */
  CandidateAccessIntegrationEgressExamitySchedulingSchedule = 'CandidateAccessIntegrationEgressExamitySchedulingSchedule',
  /** CandidateAccess.Integration.Egress.Examity.Scheduling.View */
  CandidateAccessIntegrationEgressExamitySchedulingView = 'CandidateAccessIntegrationEgressExamitySchedulingView',
  /** CandidateAccess.Integration.Egress.Examity.Scheduling.ViewAppointments */
  CandidateAccessIntegrationEgressExamitySchedulingViewAppointments = 'CandidateAccessIntegrationEgressExamitySchedulingViewAppointments',
  /** CandidateAccess.Integration.Egress.Kryterion */
  CandidateAccessIntegrationEgressKryterion = 'CandidateAccessIntegrationEgressKryterion',
  /** CandidateAccess.Integration.Egress.Kryterion.Scheduling */
  CandidateAccessIntegrationEgressKryterionScheduling = 'CandidateAccessIntegrationEgressKryterionScheduling',
  /** CandidateAccess.Integration.Egress.Kryterion.Scheduling.Cancel */
  CandidateAccessIntegrationEgressKryterionSchedulingCancel = 'CandidateAccessIntegrationEgressKryterionSchedulingCancel',
  /** CandidateAccess.Integration.Egress.Kryterion.Scheduling.Reschedule */
  CandidateAccessIntegrationEgressKryterionSchedulingReschedule = 'CandidateAccessIntegrationEgressKryterionSchedulingReschedule',
  /** CandidateAccess.Integration.Egress.Kryterion.Scheduling.Schedule */
  CandidateAccessIntegrationEgressKryterionSchedulingSchedule = 'CandidateAccessIntegrationEgressKryterionSchedulingSchedule',
  /** CandidateAccess.Integration.Egress.Kryterion.Scheduling.View */
  CandidateAccessIntegrationEgressKryterionSchedulingView = 'CandidateAccessIntegrationEgressKryterionSchedulingView',
  /** CandidateAccess.Integration.Egress.Kryterion.Scheduling.ViewAppointments */
  CandidateAccessIntegrationEgressKryterionSchedulingViewAppointments = 'CandidateAccessIntegrationEgressKryterionSchedulingViewAppointments',
  /** CandidateAccess.Integration.Egress.OidcEgress */
  CandidateAccessIntegrationEgressOidcEgress = 'CandidateAccessIntegrationEgressOidcEgress',
  /** CandidateAccess.Integration.Egress.OidcEgress.Caveon */
  CandidateAccessIntegrationEgressOidcEgressCaveon = 'CandidateAccessIntegrationEgressOidcEgressCaveon',
  /** CandidateAccess.Integration.Egress.OidcEgress.Caveon.Scheduling */
  CandidateAccessIntegrationEgressOidcEgressCaveonScheduling = 'CandidateAccessIntegrationEgressOidcEgressCaveonScheduling',
  /** CandidateAccess.Integration.Egress.OidcEgress.Caveon.Scheduling.Cancel */
  CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingCancel = 'CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingCancel',
  /** CandidateAccess.Integration.Egress.OidcEgress.Caveon.Scheduling.Reschedule */
  CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingReschedule = 'CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingReschedule',
  /** CandidateAccess.Integration.Egress.OidcEgress.Caveon.Scheduling.Schedule */
  CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingSchedule = 'CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingSchedule',
  /** CandidateAccess.Integration.Egress.OidcEgress.Caveon.Scheduling.View */
  CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingView = 'CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingView',
  /** CandidateAccess.Integration.Egress.OidcEgress.Caveon.Scheduling.ViewAppointments */
  CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingViewAppointments = 'CandidateAccessIntegrationEgressOidcEgressCaveonSchedulingViewAppointments',
  /** CandidateAccess.Integration.Egress.OidcEgress.Certiverse */
  CandidateAccessIntegrationEgressOidcEgressCertiverse = 'CandidateAccessIntegrationEgressOidcEgressCertiverse',
  /** CandidateAccess.Integration.Egress.OidcEgress.Certiverse.Scheduling */
  CandidateAccessIntegrationEgressOidcEgressCertiverseScheduling = 'CandidateAccessIntegrationEgressOidcEgressCertiverseScheduling',
  /** CandidateAccess.Integration.Egress.PearsonVue */
  CandidateAccessIntegrationEgressPearsonVue = 'CandidateAccessIntegrationEgressPearsonVue',
  /** CandidateAccess.Integration.Egress.PearsonVue.Scheduling */
  CandidateAccessIntegrationEgressPearsonVueScheduling = 'CandidateAccessIntegrationEgressPearsonVueScheduling',
  /** CandidateAccess.Integration.Egress.PearsonVue.Scheduling.Cancel */
  CandidateAccessIntegrationEgressPearsonVueSchedulingCancel = 'CandidateAccessIntegrationEgressPearsonVueSchedulingCancel',
  /** CandidateAccess.Integration.Egress.PearsonVue.Scheduling.Reschedule */
  CandidateAccessIntegrationEgressPearsonVueSchedulingReschedule = 'CandidateAccessIntegrationEgressPearsonVueSchedulingReschedule',
  /** CandidateAccess.Integration.Egress.PearsonVue.Scheduling.Schedule */
  CandidateAccessIntegrationEgressPearsonVueSchedulingSchedule = 'CandidateAccessIntegrationEgressPearsonVueSchedulingSchedule',
  /** CandidateAccess.Integration.Egress.PearsonVue.Scheduling.View */
  CandidateAccessIntegrationEgressPearsonVueSchedulingView = 'CandidateAccessIntegrationEgressPearsonVueSchedulingView',
  /** CandidateAccess.Integration.Egress.PearsonVue.Scheduling.ViewAppointments */
  CandidateAccessIntegrationEgressPearsonVueSchedulingViewAppointments = 'CandidateAccessIntegrationEgressPearsonVueSchedulingViewAppointments',
  /** CandidateAccess.Integration.Egress.Psi */
  CandidateAccessIntegrationEgressPsi = 'CandidateAccessIntegrationEgressPsi',
  /** CandidateAccess.Integration.Egress.Psi.Scheduling */
  CandidateAccessIntegrationEgressPsiScheduling = 'CandidateAccessIntegrationEgressPsiScheduling',
  /** CandidateAccess.Integration.Egress.Psi.Scheduling.Cancel */
  CandidateAccessIntegrationEgressPsiSchedulingCancel = 'CandidateAccessIntegrationEgressPsiSchedulingCancel',
  /** CandidateAccess.Integration.Egress.Psi.Scheduling.Reschedule */
  CandidateAccessIntegrationEgressPsiSchedulingReschedule = 'CandidateAccessIntegrationEgressPsiSchedulingReschedule',
  /** CandidateAccess.Integration.Egress.Psi.Scheduling.Schedule */
  CandidateAccessIntegrationEgressPsiSchedulingSchedule = 'CandidateAccessIntegrationEgressPsiSchedulingSchedule',
  /** CandidateAccess.Integration.Egress.Psi.Scheduling.View */
  CandidateAccessIntegrationEgressPsiSchedulingView = 'CandidateAccessIntegrationEgressPsiSchedulingView',
  /** CandidateAccess.Integration.Egress.Psi.Scheduling.ViewAppointments */
  CandidateAccessIntegrationEgressPsiSchedulingViewAppointments = 'CandidateAccessIntegrationEgressPsiSchedulingViewAppointments',
  /** CandidateAccess.Integration.Egress.Qualified */
  CandidateAccessIntegrationEgressQualified = 'CandidateAccessIntegrationEgressQualified',
  /** CandidateAccess.Integration.Egress.Qualified.Scheduling */
  CandidateAccessIntegrationEgressQualifiedScheduling = 'CandidateAccessIntegrationEgressQualifiedScheduling',
  /** CandidateAccess.Integration.Egress.Qualified.Scheduling.Cancel */
  CandidateAccessIntegrationEgressQualifiedSchedulingCancel = 'CandidateAccessIntegrationEgressQualifiedSchedulingCancel',
  /** CandidateAccess.Integration.Egress.Qualified.Scheduling.Reschedule */
  CandidateAccessIntegrationEgressQualifiedSchedulingReschedule = 'CandidateAccessIntegrationEgressQualifiedSchedulingReschedule',
  /** CandidateAccess.Integration.Egress.Qualified.Scheduling.Schedule */
  CandidateAccessIntegrationEgressQualifiedSchedulingSchedule = 'CandidateAccessIntegrationEgressQualifiedSchedulingSchedule',
  /** CandidateAccess.Integration.Egress.Qualified.Scheduling.View */
  CandidateAccessIntegrationEgressQualifiedSchedulingView = 'CandidateAccessIntegrationEgressQualifiedSchedulingView',
  /** CandidateAccess.Integration.Egress.Qualified.Scheduling.ViewAppointments */
  CandidateAccessIntegrationEgressQualifiedSchedulingViewAppointments = 'CandidateAccessIntegrationEgressQualifiedSchedulingViewAppointments',
  /** CandidateAccess.Integration.Egress.TestWise */
  CandidateAccessIntegrationEgressTestWise = 'CandidateAccessIntegrationEgressTestWise',
  /** CandidateAccess.Integration.Egress.Testrun */
  CandidateAccessIntegrationEgressTestrun = 'CandidateAccessIntegrationEgressTestrun',
  /** CandidateAccess.Integration.Egress.Xvoucher */
  CandidateAccessIntegrationEgressXvoucher = 'CandidateAccessIntegrationEgressXvoucher',
  /** CandidateAccess.Integration.Egress.Zendesk */
  CandidateAccessIntegrationEgressZendesk = 'CandidateAccessIntegrationEgressZendesk',
  /** CandidateAccess.Integration.Ingress */
  CandidateAccessIntegrationIngress = 'CandidateAccessIntegrationIngress',
  /** CandidateAccess.Integration.Ingress.Jwt */
  CandidateAccessIntegrationIngressJwt = 'CandidateAccessIntegrationIngressJwt',
  /** CandidateAccess.Integration.Ingress.Oidc */
  CandidateAccessIntegrationIngressOidc = 'CandidateAccessIntegrationIngressOidc',
  /** CandidateAccess.Integration.Ingress.Oidc.LogIdToken */
  CandidateAccessIntegrationIngressOidcLogIdToken = 'CandidateAccessIntegrationIngressOidcLogIdToken',
  /** CandidateAccess.Integration.Ingress.Oidc.OidcLogging */
  CandidateAccessIntegrationIngressOidcOidcLogging = 'CandidateAccessIntegrationIngressOidcOidcLogging',
  /** CandidateAccess.Integration.Ingress.WsTrust */
  CandidateAccessIntegrationIngressWsTrust = 'CandidateAccessIntegrationIngressWsTrust',
  /** CandidateAccess.Integration.XvoucherSsoEgress */
  CandidateAccessIntegrationXvoucherSsoEgress = 'CandidateAccessIntegrationXvoucherSsoEgress',
  /** CandidateAccess.Login */
  CandidateAccessLogin = 'CandidateAccessLogin',
  /** CandidateAccess.Login.ChangePassword */
  CandidateAccessLoginChangePassword = 'CandidateAccessLoginChangePassword',
  /** CandidateAccess.Login.EMCEmployeeRegistration */
  CandidateAccessLoginEmcEmployeeRegistration = 'CandidateAccessLoginEMCEmployeeRegistration',
  /** CandidateAccess.Login.EMCOtherAchievements */
  CandidateAccessLoginEmcOtherAchievements = 'CandidateAccessLoginEMCOtherAchievements',
  /** CandidateAccess.Login.Email */
  CandidateAccessLoginEmail = 'CandidateAccessLoginEmail',
  /** CandidateAccess.Login.SelfRegistration */
  CandidateAccessLoginSelfRegistration = 'CandidateAccessLoginSelfRegistration',
  /** CandidateAccess.Login.UsernameOrEmail */
  CandidateAccessLoginUsernameOrEmail = 'CandidateAccessLoginUsernameOrEmail',
  /** CandidateAccess.ShowCertProgress */
  CandidateAccessShowCertProgress = 'CandidateAccessShowCertProgress',
  /** CandidateAccess.ShowHelpDeskButton */
  CandidateAccessShowHelpDeskButton = 'CandidateAccessShowHelpDeskButton',
  /** CandidateData.BulkImport */
  CandidateDataBulkImport = 'CandidateDataBulkImport',
  /** CandidatePreferences */
  CandidatePreferences = 'CandidatePreferences',
  /** CandidatePreferences.CandidateDirectory */
  CandidatePreferencesCandidateDirectory = 'CandidatePreferencesCandidateDirectory',
  /** CandidatePreferences.CandidateEmailLanguage */
  CandidatePreferencesCandidateEmailLanguage = 'CandidatePreferencesCandidateEmailLanguage',
  /** CandidatePreferences.DisableEmails */
  CandidatePreferencesDisableEmails = 'CandidatePreferencesDisableEmails',
  /** CandidatePreferences.ThirdPartyApiAccess */
  CandidatePreferencesThirdPartyApiAccess = 'CandidatePreferencesThirdPartyApiAccess',
  /** CandidateProfile */
  CandidateProfile = 'CandidateProfile',
  /** CandidateProfile.Addresses */
  CandidateProfileAddresses = 'CandidateProfileAddresses',
  /** CandidateProfile.Addresses.CiscoRestrictCandidateCountryUpdates */
  CandidateProfileAddressesCiscoRestrictCandidateCountryUpdates = 'CandidateProfileAddressesCiscoRestrictCandidateCountryUpdates',
  /** CandidateProfile.Addresses.Localized */
  CandidateProfileAddressesLocalized = 'CandidateProfileAddressesLocalized',
  /** CandidateProfile.Addresses.Primary */
  CandidateProfileAddressesPrimary = 'CandidateProfileAddressesPrimary',
  /** CandidateProfile.Addresses.Primary.RequireMinimum */
  CandidateProfileAddressesPrimaryRequireMinimum = 'CandidateProfileAddressesPrimaryRequireMinimum',
  /** CandidateProfile.Addresses.Secondary */
  CandidateProfileAddressesSecondary = 'CandidateProfileAddressesSecondary',
  /** CandidateProfile.CustomData */
  CandidateProfileCustomData = 'CandidateProfileCustomData',
  /** CandidateProfile.CustomData.Attributes */
  CandidateProfileCustomDataAttributes = 'CandidateProfileCustomDataAttributes',
  /** CandidateProfile.CustomData.Settings */
  CandidateProfileCustomDataSettings = 'CandidateProfileCustomDataSettings',
  /** CandidateProfile.DateOfBirth */
  CandidateProfileDateOfBirth = 'CandidateProfileDateOfBirth',
  /** CandidateProfile.Education */
  CandidateProfileEducation = 'CandidateProfileEducation',
  /** CandidateProfile.ExternalIds */
  CandidateProfileExternalIds = 'CandidateProfileExternalIds',
  /** CandidateProfile.LocalizedInformation */
  CandidateProfileLocalizedInformation = 'CandidateProfileLocalizedInformation',
  /** CandidateProfile.ManageCandidateId */
  CandidateProfileManageCandidateId = 'CandidateProfileManageCandidateId',
  /** CandidateProfile.PrimaryInformation */
  CandidateProfilePrimaryInformation = 'CandidateProfilePrimaryInformation',
  /** CandidateProfile.PrimaryInformation.Affiliation */
  CandidateProfilePrimaryInformationAffiliation = 'CandidateProfilePrimaryInformationAffiliation',
  /** CandidateProfile.PrimaryInformation.Affiliation.Required */
  CandidateProfilePrimaryInformationAffiliationRequired = 'CandidateProfilePrimaryInformationAffiliationRequired',
  /** CandidateProfile.PrimaryInformation.Affiliation.Search */
  CandidateProfilePrimaryInformationAffiliationSearch = 'CandidateProfilePrimaryInformationAffiliationSearch',
  /** CandidateProfile.PrimaryInformation.DuplicatePhoneNumberQueue */
  CandidateProfilePrimaryInformationDuplicatePhoneNumberQueue = 'CandidateProfilePrimaryInformationDuplicatePhoneNumberQueue',
  /** CandidateProfile.PrimaryInformation.EmailCandidateEdit */
  CandidateProfilePrimaryInformationEmailCandidateEdit = 'CandidateProfilePrimaryInformationEmailCandidateEdit',
  /** CandidateProfile.PrimaryInformation.NameUpdate */
  CandidateProfilePrimaryInformationNameUpdate = 'CandidateProfilePrimaryInformationNameUpdate',
  /** CandidateProfile.PrimaryInformation.PreferredName */
  CandidateProfilePrimaryInformationPreferredName = 'CandidateProfilePrimaryInformationPreferredName',
  /** CandidateProfile.PrimaryInformation.PreferredName.CandidateEdit */
  CandidateProfilePrimaryInformationPreferredNameCandidateEdit = 'CandidateProfilePrimaryInformationPreferredNameCandidateEdit',
  /** CandidateProfile.PrimaryInformation.RequireEmailConfirmation */
  CandidateProfilePrimaryInformationRequireEmailConfirmation = 'CandidateProfilePrimaryInformationRequireEmailConfirmation',
  /** CandidateProfile.PrimaryInformation.RequireMinimum */
  CandidateProfilePrimaryInformationRequireMinimum = 'CandidateProfilePrimaryInformationRequireMinimum',
  /** CandidateProfile.PrimaryInformation.RequireNameVerification */
  CandidateProfilePrimaryInformationRequireNameVerification = 'CandidateProfilePrimaryInformationRequireNameVerification',
  /** CandidateProfile.PrimaryInformation.RequireRomanizedName */
  CandidateProfilePrimaryInformationRequireRomanizedName = 'CandidateProfilePrimaryInformationRequireRomanizedName',
  /** CandidateProfile.RestrictCandidateCountryUpdates */
  CandidateProfileRestrictCandidateCountryUpdates = 'CandidateProfileRestrictCandidateCountryUpdates',
  /** CandidateProfile.ShowClientPrimaryID */
  CandidateProfileShowClientPrimaryId = 'CandidateProfileShowClientPrimaryID',
  /** CandidateProfile.WorkHistory */
  CandidateProfileWorkHistory = 'CandidateProfileWorkHistory',
  /** CandidateProfile.ZendeskHistory */
  CandidateProfileZendeskHistory = 'CandidateProfileZendeskHistory',
  /** CandidateSegmentation */
  CandidateSegmentation = 'CandidateSegmentation',
  /** CiscoCustomPermissions */
  CiscoCustomPermissions = 'CiscoCustomPermissions',
  /** CiscoCustomReports */
  CiscoCustomReports = 'CiscoCustomReports',
  /** CiscoCustomReports.NetAcad */
  CiscoCustomReportsNetAcad = 'CiscoCustomReportsNetAcad',
  /** CiscoCustomReports.TPM */
  CiscoCustomReportsTpm = 'CiscoCustomReportsTPM',
  /** ClientMetadata */
  ClientMetadata = 'ClientMetadata',
  /** ClientSettingsModify */
  ClientSettingsModify = 'ClientSettingsModify',
  /** ComptiaCustomCertificationEndpoint */
  ComptiaCustomCertificationEndpoint = 'ComptiaCustomCertificationEndpoint',
  /** ComptiaCustomDashboardReports */
  ComptiaCustomDashboardReports = 'ComptiaCustomDashboardReports',
  /** Core */
  Core = 'Core',
  /** Credential */
  Credential = 'Credential',
  /** Credential.Achievements */
  CredentialAchievements = 'CredentialAchievements',
  /** Credential.Achievements.Certificate */
  CredentialAchievementsCertificate = 'CredentialAchievementsCertificate',
  /** Credential.Achievements.LogoDownload */
  CredentialAchievementsLogoDownload = 'CredentialAchievementsLogoDownload',
  /** Credential.Achievements.RecentActivity */
  CredentialAchievementsRecentActivity = 'CredentialAchievementsRecentActivity',
  /** Credential.Agreement */
  CredentialAgreement = 'CredentialAgreement',
  /** Credential.Agreement.AtLogin */
  CredentialAgreementAtLogin = 'CredentialAgreementAtLogin',
  /** Credential.ComptiaSelfExtend */
  CredentialComptiaSelfExtend = 'CredentialComptiaSelfExtend',
  /** Credential.ContinuingEducation */
  CredentialContinuingEducation = 'CredentialContinuingEducation',
  /** Credential.ContinuingEducation.CECourseName */
  CredentialContinuingEducationCeCourseName = 'CredentialContinuingEducationCECourseName',
  /** Credential.ContinuingEducation.CEMaxPoints */
  CredentialContinuingEducationCeMaxPoints = 'CredentialContinuingEducationCEMaxPoints',
  /** Credential.ContinuingEducation.CEProgress */
  CredentialContinuingEducationCeProgress = 'CredentialContinuingEducationCEProgress',
  /** Credential.ContinuingEducation.CandidateCEUEdit */
  CredentialContinuingEducationCandidateCeuEdit = 'CredentialContinuingEducationCandidateCEUEdit',
  /** Credential.ContinuingEducation.CiscoCustomDisplayExamCatalogPoints */
  CredentialContinuingEducationCiscoCustomDisplayExamCatalogPoints = 'CredentialContinuingEducationCiscoCustomDisplayExamCatalogPoints',
  /** Credential.ContinuingEducation.CiscoDisplayExamActiveAge */
  CredentialContinuingEducationCiscoDisplayExamActiveAge = 'CredentialContinuingEducationCiscoDisplayExamActiveAge',
  /** Credential.ContinuingEducation.CredentialContinuingEducationVouchers */
  CredentialContinuingEducationCredentialContinuingEducationVouchers = 'CredentialContinuingEducationCredentialContinuingEducationVouchers',
  /** Credential.ContinuingEducation.HideTracks */
  CredentialContinuingEducationHideTracks = 'CredentialContinuingEducationHideTracks',
  /** Credential.CredentialDisplayStatusOverrides */
  CredentialCredentialDisplayStatusOverrides = 'CredentialCredentialDisplayStatusOverrides',
  /** Credential.CredentialShowInactiveDate */
  CredentialCredentialShowInactiveDate = 'CredentialCredentialShowInactiveDate',
  /** Credential.ElectronicCertificate */
  CredentialElectronicCertificate = 'CredentialElectronicCertificate',
  /** Credential.ElectronicCertificate.Batch */
  CredentialElectronicCertificateBatch = 'CredentialElectronicCertificateBatch',
  /** Credential.ElectronicCertificate.PublicDownload */
  CredentialElectronicCertificatePublicDownload = 'CredentialElectronicCertificatePublicDownload',
  /** Credential.Fulfillment */
  CredentialFulfillment = 'CredentialFulfillment',
  /** Credential.Fulfillment.FulfillmentVouchers */
  CredentialFulfillmentFulfillmentVouchers = 'CredentialFulfillmentFulfillmentVouchers',
  /** Credential.Fulfillment.RecentActivity */
  CredentialFulfillmentRecentActivity = 'CredentialFulfillmentRecentActivity',
  /** Credential.Fulfillment.SuppressFulfillmentBanner */
  CredentialFulfillmentSuppressFulfillmentBanner = 'CredentialFulfillmentSuppressFulfillmentBanner',
  /** Credential.Fulfillment.SuppressQueueTypeNever */
  CredentialFulfillmentSuppressQueueTypeNever = 'CredentialFulfillmentSuppressQueueTypeNever',
  /** Credential.HiddenEligibilities */
  CredentialHiddenEligibilities = 'CredentialHiddenEligibilities',
  /** Credential.HideCertLogic */
  CredentialHideCertLogic = 'CredentialHideCertLogic',
  /** Credential.LogoDownload */
  CredentialLogoDownload = 'CredentialLogoDownload',
  /** Credential.LogoDownload.Agreement */
  CredentialLogoDownloadAgreement = 'CredentialLogoDownloadAgreement',
  /** Credential.ProgramNumber */
  CredentialProgramNumber = 'CredentialProgramNumber',
  /** Credential.RecentActivity */
  CredentialRecentActivity = 'CredentialRecentActivity',
  /** Credential.RecertLogic */
  CredentialRecertLogic = 'CredentialRecertLogic',
  /** Credential.Url */
  CredentialUrl = 'CredentialUrl',
  /** Credential.UseStarted */
  CredentialUseStarted = 'CredentialUseStarted',
  /** Credential.Verification */
  CredentialVerification = 'CredentialVerification',
  /** Ecommerce */
  Ecommerce = 'Ecommerce',
  /** Ecommerce.Fulfillment */
  EcommerceFulfillment = 'EcommerceFulfillment',
  /** Ecommerce.OtherRequirement */
  EcommerceOtherRequirement = 'EcommerceOtherRequirement',
  /** Ecommerce.ShowTransactionHistory */
  EcommerceShowTransactionHistory = 'EcommerceShowTransactionHistory',
  /** Ecommerce.Xvoucher */
  EcommerceXvoucher = 'EcommerceXvoucher',
  /** Exam */
  Exam = 'Exam',
  /** Exam.Accommodations */
  ExamAccommodations = 'ExamAccommodations',
  /** Exam.Accommodations.CandidateSelfSelect */
  ExamAccommodationsCandidateSelfSelect = 'ExamAccommodationsCandidateSelfSelect',
  /** Exam.Accommodations.ShowAccommWidget */
  ExamAccommodationsShowAccommWidget = 'ExamAccommodationsShowAccommWidget',
  /** Exam.Appointments */
  ExamAppointments = 'ExamAppointments',
  /** Exam.Appointments.ExamAppointmentsCloudEventNotifications */
  ExamAppointmentsExamAppointmentsCloudEventNotifications = 'ExamAppointmentsExamAppointmentsCloudEventNotifications',
  /** Exam.Appointments.ExamAppointmentsCloudEventNotifications.ExamAppointmentsCloudEventNotificationsLogging */
  ExamAppointmentsExamAppointmentsCloudEventNotificationsExamAppointmentsCloudEventNotificationsLogging = 'ExamAppointmentsExamAppointmentsCloudEventNotificationsExamAppointmentsCloudEventNotificationsLogging',
  /** Exam.Appointments.ExamAppointmentsDashboardUpcomingAppointments */
  ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments = 'ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments',
  /** Exam.Appointments.ExamAppointmentsStandardAppointments */
  ExamAppointmentsExamAppointmentsStandardAppointments = 'ExamAppointmentsExamAppointmentsStandardAppointments',
  /** Exam.Authorization */
  ExamAuthorization = 'ExamAuthorization',
  /** Exam.AutoGenerateRegistrationNumber */
  ExamAutoGenerateRegistrationNumber = 'ExamAutoGenerateRegistrationNumber',
  /** Exam.CertMetricsVouchers */
  ExamCertMetricsVouchers = 'ExamCertMetricsVouchers',
  /** Exam.ComptiaAnsiCriteria */
  ExamComptiaAnsiCriteria = 'ExamComptiaAnsiCriteria',
  /** Exam.EnableDataProviders */
  ExamEnableDataProviders = 'ExamEnableDataProviders',
  /** Exam.ExamSchedulingInternal */
  ExamExamSchedulingInternal = 'ExamExamSchedulingInternal',
  /** Exam.FacebookExamScheduling */
  ExamFacebookExamScheduling = 'ExamFacebookExamScheduling',
  /** Exam.InformationUrl */
  ExamInformationUrl = 'ExamInformationUrl',
  /** Exam.LogScorpionExamResult */
  ExamLogScorpionExamResult = 'ExamLogScorpionExamResult',
  /** Exam.MSFTExamDetails */
  ExamMsftExamDetails = 'ExamMSFTExamDetails',
  /** Exam.NCARBCertBatching */
  ExamNcarbCertBatching = 'ExamNCARBCertBatching',
  /** Exam.NCARBExamAuthorizations */
  ExamNcarbExamAuthorizations = 'ExamNCARBExamAuthorizations',
  /** Exam.NCARBHideExamExpireDate */
  ExamNcarbHideExamExpireDate = 'ExamNCARBHideExamExpireDate',
  /** Exam.RecentActivity */
  ExamRecentActivity = 'ExamRecentActivity',
  /** Exam.Scheduling */
  ExamScheduling = 'ExamScheduling',
  /** ExamScheduling.Intellum */
  ExamSchedulingIntellum = 'ExamSchedulingIntellum',
  /** Exam.SchedulingUrl */
  ExamSchedulingUrl = 'ExamSchedulingUrl',
  /** Exam.Scheduling_Ncarb */
  ExamSchedulingNcarb = 'ExamScheduling_Ncarb',
  /** Exam.Scheduling_Ncarb.Accommodations */
  ExamSchedulingNcarbAccommodations = 'ExamScheduling_NcarbAccommodations',
  /** Exam.Scheduling_Ncarb.AuthorizationDetail */
  ExamSchedulingNcarbAuthorizationDetail = 'ExamScheduling_NcarbAuthorizationDetail',
  /** Exam.ScoreReports */
  ExamScoreReports = 'ExamScoreReports',
  /** Exam.ScoreReports.Batch */
  ExamScoreReportsBatch = 'ExamScoreReportsBatch',
  /** Exam.SectionCatalog */
  ExamSectionCatalog = 'ExamSectionCatalog',
  /** Exam.Security */
  ExamSecurity = 'ExamSecurity',
  /** Exam.ShowExpireDate */
  ExamShowExpireDate = 'ExamShowExpireDate',
  /** Exam.ShowScaledScore */
  ExamShowScaledScore = 'ExamShowScaledScore',
  /** Exam.TestCenterRestriction */
  ExamTestCenterRestriction = 'ExamTestCenterRestriction',
  /** Exam.Verification */
  ExamVerification = 'ExamVerification',
  /** Jurisdictions */
  Jurisdictions = 'Jurisdictions',
  /** MergeCandidates */
  MergeCandidates = 'MergeCandidates',
  /** MergeCandidates.BulkMergeTool */
  MergeCandidatesBulkMergeTool = 'MergeCandidatesBulkMergeTool',
  /** MergeCandidates.CandidateSecurity */
  MergeCandidatesCandidateSecurity = 'MergeCandidatesCandidateSecurity',
  /** MergeCandidates.CandidateSelfMerge */
  MergeCandidatesCandidateSelfMerge = 'MergeCandidatesCandidateSelfMerge',
  /** MergeCandidates.CandidateSelfMerge.AWSCustomSelfMergeSecurity */
  MergeCandidatesCandidateSelfMergeAwsCustomSelfMergeSecurity = 'MergeCandidatesCandidateSelfMergeAWSCustomSelfMergeSecurity',
  /** MergeCandidates.CandidateSelfMerge.CandidateSelfMergeNonMatching */
  MergeCandidatesCandidateSelfMergeCandidateSelfMergeNonMatching = 'MergeCandidatesCandidateSelfMergeCandidateSelfMergeNonMatching',
  /** MergeCandidates.MergeQueueAttributeData */
  MergeCandidatesMergeQueueAttributeData = 'MergeCandidatesMergeQueueAttributeData',
  /** NCARBCustomHideCatalogs */
  NcarbCustomHideCatalogs = 'NCARBCustomHideCatalogs',
  /** NCARBHideCandidateDemographicPages */
  NcarbHideCandidateDemographicPages = 'NCARBHideCandidateDemographicPages',
  /** NCARBHideSponsorSettings */
  NcarbHideSponsorSettings = 'NCARBHideSponsorSettings',
  /** NCARBJurisdictions */
  NcarbJurisdictions = 'NCARBJurisdictions',
  /** NcarbReports */
  NcarbReports = 'NcarbReports',
  /** OtherRequirement */
  OtherRequirement = 'OtherRequirement',
  /** OtherRequirement.AdvancedSelection */
  OtherRequirementAdvancedSelection = 'OtherRequirementAdvancedSelection',
  /** OtherRequirement.AtlassianCredentialUploadCandidateAccess */
  OtherRequirementAtlassianCredentialUploadCandidateAccess = 'OtherRequirementAtlassianCredentialUploadCandidateAccess',
  /** OtherRequirement.CredentialUploadItemsCandidateAccess */
  OtherRequirementCredentialUploadItemsCandidateAccess = 'OtherRequirementCredentialUploadItemsCandidateAccess',
  /** OtherRequirement.InformationUrl */
  OtherRequirementInformationUrl = 'OtherRequirementInformationUrl',
  /** OtherRequirement.LiteWeightRecertifyFacebook */
  OtherRequirementLiteWeightRecertifyFacebook = 'OtherRequirementLiteWeightRecertifyFacebook',
  /** OtherRequirement.OtherRequirementSeertechCustomApiImportSnowflake */
  OtherRequirementOtherRequirementSeertechCustomApiImportSnowflake = 'OtherRequirementOtherRequirementSeertechCustomApiImportSnowflake',
  /** OtherRequirement.RecentActivity */
  OtherRequirementRecentActivity = 'OtherRequirementRecentActivity',
  /** OtherRequirement.SchedulingUrl */
  OtherRequirementSchedulingUrl = 'OtherRequirementSchedulingUrl',
  /** OtherRequirement.ShowOverrideName */
  OtherRequirementShowOverrideName = 'OtherRequirementShowOverrideName',
  /** OtherRequirement.Upload */
  OtherRequirementUpload = 'OtherRequirementUpload',
  /** OtherRequirement.Upload.CandidateAccess */
  OtherRequirementUploadCandidateAccess = 'OtherRequirementUploadCandidateAccess',
  /** OtherRequirement.Upload.CandidateAccess.Audits */
  OtherRequirementUploadCandidateAccessAudits = 'OtherRequirementUploadCandidateAccessAudits',
  /** OtherRequirement.Upload.CandidateAccess.DeleteItems */
  OtherRequirementUploadCandidateAccessDeleteItems = 'OtherRequirementUploadCandidateAccessDeleteItems',
  /** OtherRequirement.Upload.CandidateAccess.InitialCertification */
  OtherRequirementUploadCandidateAccessInitialCertification = 'OtherRequirementUploadCandidateAccessInitialCertification',
  /** OtherRequirement.Upload.CandidateAccess.InitialCertification.RequireStarted */
  OtherRequirementUploadCandidateAccessInitialCertificationRequireStarted = 'OtherRequirementUploadCandidateAccessInitialCertificationRequireStarted',
  /** OtherRequirement.Upload.CandidateAccess.Miscellaneous */
  OtherRequirementUploadCandidateAccessMiscellaneous = 'OtherRequirementUploadCandidateAccessMiscellaneous',
  /** OtherRequirement.Upload.CandidateAccess.Recertification */
  OtherRequirementUploadCandidateAccessRecertification = 'OtherRequirementUploadCandidateAccessRecertification',
  /** OtherRequirement.Vouchers */
  OtherRequirementVouchers = 'OtherRequirementVouchers',
  /** Questionnaires */
  Questionnaires = 'Questionnaires',
  /** Reports */
  Reports = 'Reports',
  /** Reports.Advanced */
  ReportsAdvanced = 'ReportsAdvanced',
  /** Reports.Standard */
  ReportsStandard = 'ReportsStandard',
  /** Reports.Standard.ContinuingEducation */
  ReportsStandardContinuingEducation = 'ReportsStandardContinuingEducation',
  /** Reports.Standard.CredentialAchievement */
  ReportsStandardCredentialAchievement = 'ReportsStandardCredentialAchievement',
  /** Reports.Standard.Dell */
  ReportsStandardDell = 'ReportsStandardDell',
  /** Reports.Standard.ExamEligibility */
  ReportsStandardExamEligibility = 'ReportsStandardExamEligibility',
  /** Reports.Standard.Financial */
  ReportsStandardFinancial = 'ReportsStandardFinancial',
  /** Reports.Standard.Microsoft */
  ReportsStandardMicrosoft = 'ReportsStandardMicrosoft',
  /** Reports.Standard.Psychometric */
  ReportsStandardPsychometric = 'ReportsStandardPsychometric',
  /** Reports.Standard.Questionnaire */
  ReportsStandardQuestionnaire = 'ReportsStandardQuestionnaire',
  /** Reports.Standard.QuestionnaireDetail */
  ReportsStandardQuestionnaireDetail = 'ReportsStandardQuestionnaireDetail',
  /** Reports.Standard.ReportsCustomComptia */
  ReportsStandardReportsCustomComptia = 'ReportsStandardReportsCustomComptia',
  /** Reports.Standard.Security */
  ReportsStandardSecurity = 'ReportsStandardSecurity',
  /** Reports.Standard.StandardBadge */
  ReportsStandardStandardBadge = 'ReportsStandardStandardBadge',
  /** Reports.Standard.StandardBenefit */
  ReportsStandardStandardBenefit = 'ReportsStandardStandardBenefit',
  /** Reports.Standard.StandardCredential */
  ReportsStandardStandardCredential = 'ReportsStandardStandardCredential',
  /** Reports.Standard.StandardDemographic */
  ReportsStandardStandardDemographic = 'ReportsStandardStandardDemographic',
  /** Reports.Standard.StandardExam */
  ReportsStandardStandardExam = 'ReportsStandardStandardExam',
  /** Reports.Standard.StandardFulfillment */
  ReportsStandardStandardFulfillment = 'ReportsStandardStandardFulfillment',
  /** Share */
  Share = 'Share',
  /** Share.AccredibleBadging */
  ShareAccredibleBadging = 'ShareAccredibleBadging',
  /** Share.AccredibleBadging.Sso */
  ShareAccredibleBadgingSso = 'ShareAccredibleBadgingSso',
  /** Share.CertMetricsBadging */
  ShareCertMetricsBadging = 'ShareCertMetricsBadging',
  /** Share.CertMetricsBadging.Facebook */
  ShareCertMetricsBadgingFacebook = 'ShareCertMetricsBadgingFacebook',
  /** Share.CertMetricsBadging.Linkedin */
  ShareCertMetricsBadgingLinkedin = 'ShareCertMetricsBadgingLinkedin',
  /** Share.CertMetricsBadging.Twitter */
  ShareCertMetricsBadgingTwitter = 'ShareCertMetricsBadgingTwitter',
  /** Share.CredlyBadging */
  ShareCredlyBadging = 'ShareCredlyBadging',
  /** Share.CredlyBadging.Sso */
  ShareCredlyBadgingSso = 'ShareCredlyBadgingSso',
  /** Share.Transcript */
  ShareTranscript = 'ShareTranscript',
  /** Share.Transcript.AllowAchievements */
  ShareTranscriptAllowAchievements = 'ShareTranscriptAllowAchievements',
  /** Share.Transcript.AllowCredentials */
  ShareTranscriptAllowCredentials = 'ShareTranscriptAllowCredentials',
  /** Share.Transcript.AllowExams */
  ShareTranscriptAllowExams = 'ShareTranscriptAllowExams',
  /** Share.Transcript.AllowOtherRequirements */
  ShareTranscriptAllowOtherRequirements = 'ShareTranscriptAllowOtherRequirements',
  /** Share.Transcript.SendEmails */
  ShareTranscriptSendEmails = 'ShareTranscriptSendEmails',
  /** Share.Transcript.ShowCredentialInactiveDate */
  ShareTranscriptShowCredentialInactiveDate = 'ShareTranscriptShowCredentialInactiveDate',
  /** SnowflakeDisplayBadgeId */
  SnowflakeDisplayBadgeId = 'SnowflakeDisplayBadgeId',
  /** Tagging */
  Tagging = 'Tagging',
  /** ThetaScoreDisplayInUI */
  ThetaScoreDisplayInUi = 'ThetaScoreDisplayInUI',
  /** Tools */
  Tools = 'Tools',
  /** Tools.NCARBTools */
  ToolsNcarbTools = 'ToolsNCARBTools',
  /** Tools.SnowflakeTools */
  ToolsSnowflakeTools = 'ToolsSnowflakeTools',
  /** UploadExamsTool */
  UploadExamsTool = 'UploadExamsTool',
  /** UserAccess */
  UserAccess = 'UserAccess',
  /** UserAccess.Integration */
  UserAccessIntegration = 'UserAccessIntegration',
  /** UserAccess.Integration.Jwt */
  UserAccessIntegrationJwt = 'UserAccessIntegrationJwt',
  /** UserAccess.Integration.Oidc */
  UserAccessIntegrationOidc = 'UserAccessIntegrationOidc',
  /** UserAccess.Integration.Oidc.LogIdToken */
  UserAccessIntegrationOidcLogIdToken = 'UserAccessIntegrationOidcLogIdToken',
  /** UserAccess.Integration.WsTrust */
  UserAccessIntegrationWsTrust = 'UserAccessIntegrationWsTrust',
  /** UserTwoStepAuthentication */
  UserTwoStepAuthentication = 'UserTwoStepAuthentication',
  /** ValidationCodeVerification */
  ValidationCodeVerification = 'ValidationCodeVerification',
  /** VmwareExamVoucherVerification */
  VmwareExamVoucherVerification = 'VmwareExamVoucherVerification',
  /** VmwareItsScoreReports */
  VmwareItsScoreReports = 'VmwareItsScoreReports'
}

/**
 * A definition for a hub localization.
 * 
 * 
 *  - Internal accounts only
 * 
 *  - Admin accounts only
 *
 */
export interface HubLocalization {
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<FeatureInfo>;
  featureId?: Maybe<Scalars['Int']['output']>;
  htmlAllowed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<LocType>;
  uiType?: Maybe<LocUiType>;
  value?: Maybe<Scalars['String']['output']>;
}

/** Hub Permission Enum */
export enum HubPermission {
  /** AccredibleBadging.Admin.Modify */
  AccredibleBadgingAdminModify = 'AccredibleBadgingAdminModify',
  /** AccredibleBadging.Admin.View */
  AccredibleBadgingAdminView = 'AccredibleBadgingAdminView',
  /** AccredibleBadging.CandidateSettings.View */
  AccredibleBadgingCandidateSettingsView = 'AccredibleBadgingCandidateSettingsView',
  /** AccredibleBadging.Catalog.View */
  AccredibleBadgingCatalogView = 'AccredibleBadgingCatalogView',
  /** Affiliation.Catalog.Modify */
  AffiliationCatalogModify = 'AffiliationCatalogModify',
  /** Affiliation.Catalog.View */
  AffiliationCatalogView = 'AffiliationCatalogView',
  /** Announcements.Catalog.Modify */
  AnnouncementsCatalogModify = 'AnnouncementsCatalogModify',
  /** Announcements.Catalog.View */
  AnnouncementsCatalogView = 'AnnouncementsCatalogView',
  /** BannedCandidateList.View */
  BannedCandidateListView = 'BannedCandidateListView',
  /** Benefit.Catalog.Modify */
  BenefitCatalogModify = 'BenefitCatalogModify',
  /** Benefit.Catalog.View */
  BenefitCatalogView = 'BenefitCatalogView',
  /** Candidate.Affiliation.Modify */
  CandidateAffiliationModify = 'CandidateAffiliationModify',
  /** Candidate.Affiliation.View */
  CandidateAffiliationView = 'CandidateAffiliationView',
  /** Candidate.AuditHistory.Modify */
  CandidateAuditHistoryModify = 'CandidateAuditHistoryModify',
  /** Candidate.AuditHistory.View */
  CandidateAuditHistoryView = 'CandidateAuditHistoryView',
  /** Candidate.BannedInvalidateData.Modify */
  CandidateBannedInvalidateDataModify = 'CandidateBannedInvalidateDataModify',
  /** Candidate.BannedStatus.Modify */
  CandidateBannedStatusModify = 'CandidateBannedStatusModify',
  /** Candidate.BannedStatus.View */
  CandidateBannedStatusView = 'CandidateBannedStatusView',
  /** Candidate.Benefit.Modify */
  CandidateBenefitModify = 'CandidateBenefitModify',
  /** Candidate.Benefit.View */
  CandidateBenefitView = 'CandidateBenefitView',
  /** Candidate.CertMetricsBadging.View */
  CandidateCertMetricsBadgingView = 'CandidateCertMetricsBadgingView',
  /** Candidate.CredentialAchievements.View */
  CandidateCredentialAchievementsView = 'CandidateCredentialAchievementsView',
  /** Candidate.CredentialAgreements.Modify */
  CandidateCredentialAgreementsModify = 'CandidateCredentialAgreementsModify',
  /** Candidate.CredentialAgreements.View */
  CandidateCredentialAgreementsView = 'CandidateCredentialAgreementsView',
  /** Candidate.CredentialDetails.Modify */
  CandidateCredentialDetailsModify = 'CandidateCredentialDetailsModify',
  /** Candidate.CredentialDetails.View */
  CandidateCredentialDetailsView = 'CandidateCredentialDetailsView',
  /** Candidate.CredentialFulfillment.Modify */
  CandidateCredentialFulfillmentModify = 'CandidateCredentialFulfillmentModify',
  /** Candidate.CredentialFulfillment.View */
  CandidateCredentialFulfillmentView = 'CandidateCredentialFulfillmentView',
  /** Candidate.Credentials.View */
  CandidateCredentialsView = 'CandidateCredentialsView',
  /** Candidate.CredlyBadgingSettings.View */
  CandidateCredlyBadgingSettingsView = 'CandidateCredlyBadgingSettingsView',
  /** CandidateData.BulkImport.Manage */
  CandidateDataBulkImportManage = 'CandidateDataBulkImportManage',
  /** Candidate.DateOfBirth.MOdify */
  CandidateDateOfBirthMOdify = 'CandidateDateOfBirthMOdify',
  /** Candidate.DateOfBirth.View */
  CandidateDateOfBirthView = 'CandidateDateOfBirthView',
  /** Candidate.ElectronicCertificate.View */
  CandidateElectronicCertificateView = 'CandidateElectronicCertificateView',
  /** Candidate.EmailHistory.Modify */
  CandidateEmailHistoryModify = 'CandidateEmailHistoryModify',
  /** Candidate.EmailHistory.View */
  CandidateEmailHistoryView = 'CandidateEmailHistoryView',
  /** Candidate.EmailPreferences.Modify */
  CandidateEmailPreferencesModify = 'CandidateEmailPreferencesModify',
  /** Candidate.EmailPreferences.Toggle.View */
  CandidateEmailPreferencesToggleView = 'CandidateEmailPreferencesToggleView',
  /** Candidate.EmailPreferences.View */
  CandidateEmailPreferencesView = 'CandidateEmailPreferencesView',
  /** Candidate.ExamDetails.Modify */
  CandidateExamDetailsModify = 'CandidateExamDetailsModify',
  /** Candidate.ExamDetails.View */
  CandidateExamDetailsView = 'CandidateExamDetailsView',
  /** Candidate.ExamEvents.View */
  CandidateExamEventsView = 'CandidateExamEventsView',
  /** Candidate.ExamImages.View */
  CandidateExamImagesView = 'CandidateExamImagesView',
  /** Candidate.ExamKey.View */
  CandidateExamKeyView = 'CandidateExamKeyView',
  /** Candidate.ExamScoring.Modify */
  CandidateExamScoringModify = 'CandidateExamScoringModify',
  /** Candidate.ExamScoring.View */
  CandidateExamScoringView = 'CandidateExamScoringView',
  /** Candidate.ExamViolations.Modify */
  CandidateExamViolationsModify = 'CandidateExamViolationsModify',
  /** Candidate.ExamViolations.View */
  CandidateExamViolationsView = 'CandidateExamViolationsView',
  /** Candidate.Exams.View */
  CandidateExamsView = 'CandidateExamsView',
  /** Candidate.History.Modify */
  CandidateHistoryModify = 'CandidateHistoryModify',
  /** Candidate.History.View */
  CandidateHistoryView = 'CandidateHistoryView',
  /** Candidate.ImportSettings.Modify */
  CandidateImportSettingsModify = 'CandidateImportSettingsModify',
  /** Candidate.ImportSettings.View */
  CandidateImportSettingsView = 'CandidateImportSettingsView',
  /** Candidate.Merge.Create */
  CandidateMergeCreate = 'CandidateMergeCreate',
  /** Candidate.MergeDetails.Modify */
  CandidateMergeDetailsModify = 'CandidateMergeDetailsModify',
  /** Candidate.MergeDetails.View */
  CandidateMergeDetailsView = 'CandidateMergeDetailsView',
  /** Candidate.MergeHistory.View */
  CandidateMergeHistoryView = 'CandidateMergeHistoryView',
  /** Candidate.MergeSettings.Modify */
  CandidateMergeSettingsModify = 'CandidateMergeSettingsModify',
  /** Candidate.MergeSettings.View */
  CandidateMergeSettingsView = 'CandidateMergeSettingsView',
  /** Candidate.OtherAchievement.Modify */
  CandidateOtherAchievementModify = 'CandidateOtherAchievementModify',
  /** Candidate.OtherAchievement.View */
  CandidateOtherAchievementView = 'CandidateOtherAchievementView',
  /** CandidateProfile.Create */
  CandidateProfileCreate = 'CandidateProfileCreate',
  /** CandidateProfile.LocalizedAddress.Modify */
  CandidateProfileLocalizedAddressModify = 'CandidateProfileLocalizedAddressModify',
  /** CandidateProfile.LocalizedAddress.View */
  CandidateProfileLocalizedAddressView = 'CandidateProfileLocalizedAddressView',
  /** CandidateProfile.LocalizedInformation.Modify */
  CandidateProfileLocalizedInformationModify = 'CandidateProfileLocalizedInformationModify',
  /** CandidateProfile.LocalizedInformation.View */
  CandidateProfileLocalizedInformationView = 'CandidateProfileLocalizedInformationView',
  /** CandidateProfile.ManageCandidateId.Modify */
  CandidateProfileManageCandidateIdModify = 'CandidateProfileManageCandidateIdModify',
  /** CandidateProfile.PreferredName.Modify */
  CandidateProfilePreferredNameModify = 'CandidateProfilePreferredNameModify',
  /** CandidateProfile.PreferredName.View */
  CandidateProfilePreferredNameView = 'CandidateProfilePreferredNameView',
  /** CandidateProfile.PrimaryAddress.Modify */
  CandidateProfilePrimaryAddressModify = 'CandidateProfilePrimaryAddressModify',
  /** CandidateProfile.PrimaryAddress.View */
  CandidateProfilePrimaryAddressView = 'CandidateProfilePrimaryAddressView',
  /** CandidateProfile.PrimaryInformation.Modify */
  CandidateProfilePrimaryInformationModify = 'CandidateProfilePrimaryInformationModify',
  /** CandidateProfile.PrimaryInformation.Names.Modify */
  CandidateProfilePrimaryInformationNamesModify = 'CandidateProfilePrimaryInformationNamesModify',
  /** CandidateProfile.PrimaryInformation.View */
  CandidateProfilePrimaryInformationView = 'CandidateProfilePrimaryInformationView',
  /** CandidateProfile.SecondaryAddress.Modify */
  CandidateProfileSecondaryAddressModify = 'CandidateProfileSecondaryAddressModify',
  /** CandidateProfile.SecondaryAddress.View */
  CandidateProfileSecondaryAddressView = 'CandidateProfileSecondaryAddressView',
  /** Candidate.ReassignData */
  CandidateReassignData = 'CandidateReassignData',
  /** Candidate.Requirements.AdditionalAgreement.Modify */
  CandidateRequirementsAdditionalAgreementModify = 'CandidateRequirementsAdditionalAgreementModify',
  /** Candidate.Requirements.AdditionalAgreement.View */
  CandidateRequirementsAdditionalAgreementView = 'CandidateRequirementsAdditionalAgreementView',
  /** Candidate.Requirements.ContinuingEducation.Modify */
  CandidateRequirementsContinuingEducationModify = 'CandidateRequirementsContinuingEducationModify',
  /** Candidate.Requirements.ContinuingEducation.View */
  CandidateRequirementsContinuingEducationView = 'CandidateRequirementsContinuingEducationView',
  /** Candidate.Requirements.Enrollment.Modify */
  CandidateRequirementsEnrollmentModify = 'CandidateRequirementsEnrollmentModify',
  /** Candidate.Requirements.Enrollment.View */
  CandidateRequirementsEnrollmentView = 'CandidateRequirementsEnrollmentView',
  /** Candidate.Requirements.ExternalCert.Modify */
  CandidateRequirementsExternalCertModify = 'CandidateRequirementsExternalCertModify',
  /** Candidate.Requirements.ExternalCert.View */
  CandidateRequirementsExternalCertView = 'CandidateRequirementsExternalCertView',
  /** Candidate.Requirements.ExternalExam.Modify */
  CandidateRequirementsExternalExamModify = 'CandidateRequirementsExternalExamModify',
  /** Candidate.Requirements.ExternalExam.View */
  CandidateRequirementsExternalExamView = 'CandidateRequirementsExternalExamView',
  /** Candidate.Requirements.Lab.Modify */
  CandidateRequirementsLabModify = 'CandidateRequirementsLabModify',
  /** Candidate.Requirements.Lab.View */
  CandidateRequirementsLabView = 'CandidateRequirementsLabView',
  /** Candidate.Requirements.Miscellaneous.Modify */
  CandidateRequirementsMiscellaneousModify = 'CandidateRequirementsMiscellaneousModify',
  /** Candidate.Requirements.Miscellaneous.View */
  CandidateRequirementsMiscellaneousView = 'CandidateRequirementsMiscellaneousView',
  /** Candidate.Requirements.Participation.Modify */
  CandidateRequirementsParticipationModify = 'CandidateRequirementsParticipationModify',
  /** Candidate.Requirements.Participation.View */
  CandidateRequirementsParticipationView = 'CandidateRequirementsParticipationView',
  /** Candidate.Requirements.ProgramFee.Modify */
  CandidateRequirementsProgramFeeModify = 'CandidateRequirementsProgramFeeModify',
  /** Candidate.Requirements.ProgramFee.View */
  CandidateRequirementsProgramFeeView = 'CandidateRequirementsProgramFeeView',
  /** Candidate.Requirements.Training.Modify */
  CandidateRequirementsTrainingModify = 'CandidateRequirementsTrainingModify',
  /** Candidate.Requirements.Training.View */
  CandidateRequirementsTrainingView = 'CandidateRequirementsTrainingView',
  /** Candidate.RestrictTestingStatus.Modify */
  CandidateRestrictTestingStatusModify = 'CandidateRestrictTestingStatusModify',
  /** Candidate.RestrictTestingStatus.View */
  CandidateRestrictTestingStatusView = 'CandidateRestrictTestingStatusView',
  /** Candidate.Search */
  CandidateSearch = 'CandidateSearch',
  /** Candidate.SecuritySettings.Password.Modify */
  CandidateSecuritySettingsPasswordModify = 'CandidateSecuritySettingsPasswordModify',
  /** Candidate.SecuritySettings.View */
  CandidateSecuritySettingsView = 'CandidateSecuritySettingsView',
  /** Candidate.Segmentation.Modify */
  CandidateSegmentationModify = 'CandidateSegmentationModify',
  /** Candidate.Segmentation.View */
  CandidateSegmentationView = 'CandidateSegmentationView',
  /** Candidate.SponsorSettings.Attributes.Modify */
  CandidateSponsorSettingsAttributesModify = 'CandidateSponsorSettingsAttributesModify',
  /** Candidate.SponsorSettings.Attributes.View */
  CandidateSponsorSettingsAttributesView = 'CandidateSponsorSettingsAttributesView',
  /** Candidate.SponsorSettings.Settings.Modify */
  CandidateSponsorSettingsSettingsModify = 'CandidateSponsorSettingsSettingsModify',
  /** Candidate.SponsorSettings.Settings.View */
  CandidateSponsorSettingsSettingsView = 'CandidateSponsorSettingsSettingsView',
  /** Candidate.Transcripts.View */
  CandidateTranscriptsView = 'CandidateTranscriptsView',
  /** Candidate.WatchStatus.Modify */
  CandidateWatchStatusModify = 'CandidateWatchStatusModify',
  /** Candidate.WatchStatus.View */
  CandidateWatchStatusView = 'CandidateWatchStatusView',
  /** CertMetrics.Badging.Catalog.Modify */
  CertMetricsBadgingCatalogModify = 'CertMetricsBadgingCatalogModify',
  /** CertMetricsBadging.Catalog.View */
  CertMetricsBadgingCatalogView = 'CertMetricsBadgingCatalogView',
  /** CiscoCustomPermissionForQlikSurveyApp */
  CiscoCustomPermissionForQlikSurveyApp = 'CiscoCustomPermissionForQlikSurveyApp',
  /** CiscoCustomPermissionForSsrsCandidateMergeReport */
  CiscoCustomPermissionForSsrsCandidateMergeReport = 'CiscoCustomPermissionForSsrsCandidateMergeReport',
  /** CiscoCustomReport.NetAcad.Modify */
  CiscoCustomReportNetAcadModify = 'CiscoCustomReportNetAcadModify',
  /** CiscoCustomReport.NetAcad.View */
  CiscoCustomReportNetAcadView = 'CiscoCustomReportNetAcadView',
  /** CiscoCustomReport.TPM.Modify */
  CiscoCustomReportTpmModify = 'CiscoCustomReportTPMModify',
  /** CiscoCustomReport.TPM.View */
  CiscoCustomReportTpmView = 'CiscoCustomReportTPMView',
  /** ClientSettings.Modify */
  ClientSettingsModify = 'ClientSettingsModify',
  /** ClientSettings.View */
  ClientSettingsView = 'ClientSettingsView',
  /** Comptia.Custom.Dashboard.Reports.CEActivityImportDashboardReport */
  ComptiaCustomDashboardReportsCeActivityImportDashboardReport = 'ComptiaCustomDashboardReportsCEActivityImportDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.CERenewalStatusExternalDashboardReport */
  ComptiaCustomDashboardReportsCeRenewalStatusExternalDashboardReport = 'ComptiaCustomDashboardReportsCERenewalStatusExternalDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.CERenewalStatusInternalDashboardReport */
  ComptiaCustomDashboardReportsCeRenewalStatusInternalDashboardReport = 'ComptiaCustomDashboardReportsCERenewalStatusInternalDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.CETokenLookupExternalDashboardReport */
  ComptiaCustomDashboardReportsCeTokenLookupExternalDashboardReport = 'ComptiaCustomDashboardReportsCETokenLookupExternalDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.CETokenLookupInternalDashboardReport */
  ComptiaCustomDashboardReportsCeTokenLookupInternalDashboardReport = 'ComptiaCustomDashboardReportsCETokenLookupInternalDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.CertVerificationDashboardReport */
  ComptiaCustomDashboardReportsCertVerificationDashboardReport = 'ComptiaCustomDashboardReportsCertVerificationDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.DODCertVerificationDashboardReport */
  ComptiaCustomDashboardReportsDodCertVerificationDashboardReport = 'ComptiaCustomDashboardReportsDODCertVerificationDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.ExamSecurityViolationLookupDashboardReport */
  ComptiaCustomDashboardReportsExamSecurityViolationLookupDashboardReport = 'ComptiaCustomDashboardReportsExamSecurityViolationLookupDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.ExamVoucherVerificationDashboardReport */
  ComptiaCustomDashboardReportsExamVoucherVerificationDashboardReport = 'ComptiaCustomDashboardReportsExamVoucherVerificationDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.OptInVoucherVerificationDashboardReport */
  ComptiaCustomDashboardReportsOptInVoucherVerificationDashboardReport = 'ComptiaCustomDashboardReportsOptInVoucherVerificationDashboardReport',
  /** Comptia.Custom.Dashboard.Reports.VoucherVerificationDashboardReport */
  ComptiaCustomDashboardReportsVoucherVerificationDashboardReport = 'ComptiaCustomDashboardReportsVoucherVerificationDashboardReport',
  /** CredentialAchievements.Catalog.Modify */
  CredentialAchievementsCatalogModify = 'CredentialAchievementsCatalogModify',
  /** CredentialAchievements.Catalog.View */
  CredentialAchievementsCatalogView = 'CredentialAchievementsCatalogView',
  /** CredentialAgreements.Catalog.Modify */
  CredentialAgreementsCatalogModify = 'CredentialAgreementsCatalogModify',
  /** CredentialAgreements.Catalog.View */
  CredentialAgreementsCatalogView = 'CredentialAgreementsCatalogView',
  /** Credential.Catalog.Modify */
  CredentialCatalogModify = 'CredentialCatalogModify',
  /** Credential.Catalog.View */
  CredentialCatalogView = 'CredentialCatalogView',
  /** Credential.ContinuingEducation.Vouchers.Modify */
  CredentialContinuingEducationVouchersModify = 'CredentialContinuingEducationVouchersModify',
  /** Credential.ContinuingEducation.Vouchers.View */
  CredentialContinuingEducationVouchersView = 'CredentialContinuingEducationVouchersView',
  /** CredentialFulfillment.Catalog.View */
  CredentialFulfillmentCatalogView = 'CredentialFulfillmentCatalogView',
  /** Credly.Admin.Modify */
  CredlyAdminModify = 'CredlyAdminModify',
  /** Credly.Admin.View */
  CredlyAdminView = 'CredlyAdminView',
  /** Credly.Catalog.View */
  CredlyCatalogView = 'CredlyCatalogView',
  /** DuplicateCandidates.AffiliationId.View */
  DuplicateCandidatesAffiliationIdView = 'DuplicateCandidatesAffiliationIdView',
  /** DuplicateCandidates.Demographics.View */
  DuplicateCandidatesDemographicsView = 'DuplicateCandidatesDemographicsView',
  /** DuplicateCandidates.Email.View */
  DuplicateCandidatesEmailView = 'DuplicateCandidatesEmailView',
  /** DuplicateCandidates.Phone.View */
  DuplicateCandidatesPhoneView = 'DuplicateCandidatesPhoneView',
  /** Ecommerce.Catalog.View */
  EcommerceCatalogView = 'EcommerceCatalogView',
  /** Ecommerce.Transactions.Modify */
  EcommerceTransactionsModify = 'EcommerceTransactionsModify',
  /** Ecommerce.Transactions.View */
  EcommerceTransactionsView = 'EcommerceTransactionsView',
  /** Email.Catalog.Modify */
  EmailCatalogModify = 'EmailCatalogModify',
  /** Email.Catalog.View */
  EmailCatalogView = 'EmailCatalogView',
  /** Exam.Accommodations.Modify */
  ExamAccommodationsModify = 'ExamAccommodationsModify',
  /** Exam.Accommodations.View */
  ExamAccommodationsView = 'ExamAccommodationsView',
  /** Exam.Appointments.CloudEventNotifications */
  ExamAppointmentsCloudEventNotifications = 'ExamAppointmentsCloudEventNotifications',
  /** Exam.Appointments.Modify */
  ExamAppointmentsModify = 'ExamAppointmentsModify',
  /** Exam.Appointments.View */
  ExamAppointmentsView = 'ExamAppointmentsView',
  /** Exam.Authorizations.Modify */
  ExamAuthorizationsModify = 'ExamAuthorizationsModify',
  /** Exam.Authorizations.View */
  ExamAuthorizationsView = 'ExamAuthorizationsView',
  /** Exam.Catalog.Items.Key.View */
  ExamCatalogItemsKeyView = 'ExamCatalogItemsKeyView',
  /** Exam.Catalog.Items.Modify */
  ExamCatalogItemsModify = 'ExamCatalogItemsModify',
  /** Exam.Catalog.Items.View */
  ExamCatalogItemsView = 'ExamCatalogItemsView',
  /** Exam.Catalog.Modify */
  ExamCatalogModify = 'ExamCatalogModify',
  /** Exam.Catalog.Sections.Modify */
  ExamCatalogSectionsModify = 'ExamCatalogSectionsModify',
  /** Exam.Catalog.Sections.View */
  ExamCatalogSectionsView = 'ExamCatalogSectionsView',
  /** Exam.Catalog.View */
  ExamCatalogView = 'ExamCatalogView',
  /** Exam.CertMetricsVouchers.Modify */
  ExamCertMetricsVouchersModify = 'ExamCertMetricsVouchersModify',
  /** Exam.CertMetricsVouchers.View */
  ExamCertMetricsVouchersView = 'ExamCertMetricsVouchersView',
  /** ExamRecentImportList.View */
  ExamRecentImportListView = 'ExamRecentImportListView',
  /** ExamRecentReimportList.View */
  ExamRecentReimportListView = 'ExamRecentReimportListView',
  /** Exam.ReviewList.View */
  ExamReviewListView = 'ExamReviewListView',
  /** Exam.Scheduling.View */
  ExamSchedulingView = 'ExamSchedulingView',
  /** Exam.UploadExamsTool.Modify */
  ExamUploadExamsToolModify = 'ExamUploadExamsToolModify',
  /** Exam.UploadExamsTool.View */
  ExamUploadExamsToolView = 'ExamUploadExamsToolView',
  /** Impersonate.Candidate */
  ImpersonateCandidate = 'ImpersonateCandidate',
  /** ImportActivity.View */
  ImportActivityView = 'ImportActivityView',
  /** Jurisdictions.Modify */
  JurisdictionsModify = 'JurisdictionsModify',
  /** Jurisdictions.View */
  JurisdictionsView = 'JurisdictionsView',
  /** MergeList.View */
  MergeListView = 'MergeListView',
  /** NCARBJurisdictions.ExamScoreReports */
  NcarbJurisdictionsExamScoreReports = 'NCARBJurisdictionsExamScoreReports',
  /** NCARBJurisdictions.Settings.View */
  NcarbJurisdictionsSettingsView = 'NCARBJurisdictionsSettingsView',
  /** Ncarb.Exam.Authorizations.Modify */
  NcarbExamAuthorizationsModify = 'NcarbExamAuthorizationsModify',
  /** Ncarb.Exam.Authorizations.View */
  NcarbExamAuthorizationsView = 'NcarbExamAuthorizationsView',
  /** Ncarb.ScoreReports.BatchedDownloads.Modify */
  NcarbScoreReportsBatchedDownloadsModify = 'NcarbScoreReportsBatchedDownloadsModify',
  /** Ncarb.ScoreReports.BatchedDownloads.View */
  NcarbScoreReportsBatchedDownloadsView = 'NcarbScoreReportsBatchedDownloadsView',
  /** Ncarb.ScoreReports.Delay.Modify */
  NcarbScoreReportsDelayModify = 'NcarbScoreReportsDelayModify',
  /** Ncarb.ScoreReports.Delay.View */
  NcarbScoreReportsDelayView = 'NcarbScoreReportsDelayView',
  /** OtherAchievement.Catalog.Modify */
  OtherAchievementCatalogModify = 'OtherAchievementCatalogModify',
  /** OtherAchievement.Catalog.View */
  OtherAchievementCatalogView = 'OtherAchievementCatalogView',
  /** OtherRequirements.AdvancedSelection.Modify */
  OtherRequirementsAdvancedSelectionModify = 'OtherRequirementsAdvancedSelectionModify',
  /** OtherRequirements.AdvancedSelection.View */
  OtherRequirementsAdvancedSelectionView = 'OtherRequirementsAdvancedSelectionView',
  /** OtherRequirements.ReviewList.View */
  OtherRequirementsReviewListView = 'OtherRequirementsReviewListView',
  /** OtherRequirements.SeertechCustomApiImport.Modify */
  OtherRequirementsSeertechCustomApiImportModify = 'OtherRequirementsSeertechCustomApiImportModify',
  /** OtherRequirements.SeertechCustomApiImport.View */
  OtherRequirementsSeertechCustomApiImportView = 'OtherRequirementsSeertechCustomApiImportView',
  /** Reports.Advanced.App.Affiliation */
  ReportsAdvancedAppAffiliation = 'ReportsAdvancedAppAffiliation',
  /** Reports.Advanced.App.Candidate */
  ReportsAdvancedAppCandidate = 'ReportsAdvancedAppCandidate',
  /** Reports.Advanced.App.CertRequirement */
  ReportsAdvancedAppCertRequirement = 'ReportsAdvancedAppCertRequirement',
  /** Reports.Advanced.App.Certification */
  ReportsAdvancedAppCertification = 'ReportsAdvancedAppCertification',
  /** Reports.Advanced.App.Exam */
  ReportsAdvancedAppExam = 'ReportsAdvancedAppExam',
  /** Reports.Advanced.App.Psychometric */
  ReportsAdvancedAppPsychometric = 'ReportsAdvancedAppPsychometric',
  /** Reports.Advanced.PiiAllowed */
  ReportsAdvancedPiiAllowed = 'ReportsAdvancedPiiAllowed',
  /** Reports.Custom.Comptia.Modify */
  ReportsCustomComptiaModify = 'ReportsCustomComptiaModify',
  /** Reports.Custom.Comptia.View */
  ReportsCustomComptiaView = 'ReportsCustomComptiaView',
  /** Reports.Custom.Dell.IIG.Modify */
  ReportsCustomDellIigModify = 'ReportsCustomDellIIGModify',
  /** Reports.Custom.Dell.IIG.View */
  ReportsCustomDellIigView = 'ReportsCustomDellIIGView',
  /** Reports.Custom.Ncarb.Eligibility.View */
  ReportsCustomNcarbEligibilityView = 'ReportsCustomNcarbEligibilityView',
  /** Reports.Standard.ContinuingEducation.View */
  ReportsStandardContinuingEducationView = 'ReportsStandardContinuingEducationView',
  /** Reports.Standard.CredentialAchievement.View */
  ReportsStandardCredentialAchievementView = 'ReportsStandardCredentialAchievementView',
  /** Reports.Standard.ExamEligibility.View */
  ReportsStandardExamEligibilityView = 'ReportsStandardExamEligibilityView',
  /** Reports.Standard.Financial.View */
  ReportsStandardFinancialView = 'ReportsStandardFinancialView',
  /** Reports.Standard.MicrosoftPsychometricComment.View */
  ReportsStandardMicrosoftPsychometricCommentView = 'ReportsStandardMicrosoftPsychometricCommentView',
  /** Reports.Standard.Psychometric.View */
  ReportsStandardPsychometricView = 'ReportsStandardPsychometricView',
  /** Reports.Standard.QuestionnaireDetail.View */
  ReportsStandardQuestionnaireDetailView = 'ReportsStandardQuestionnaireDetailView',
  /** Reports.Standard.Questionnaire.View */
  ReportsStandardQuestionnaireView = 'ReportsStandardQuestionnaireView',
  /** Reports.Standard.Security.View */
  ReportsStandardSecurityView = 'ReportsStandardSecurityView',
  /** Reports.Standard.StandardBadge.View */
  ReportsStandardStandardBadgeView = 'ReportsStandardStandardBadgeView',
  /** Reports.Standard.StandardBenefit.View */
  ReportsStandardStandardBenefitView = 'ReportsStandardStandardBenefitView',
  /** Reports.Standard.StandardCredential.View */
  ReportsStandardStandardCredentialView = 'ReportsStandardStandardCredentialView',
  /** Reports.Standard.StandardDemographic.View */
  ReportsStandardStandardDemographicView = 'ReportsStandardStandardDemographicView',
  /** Reports.Standard.StandardExam.View */
  ReportsStandardStandardExamView = 'ReportsStandardStandardExamView',
  /** Reports.Standard.StandardFulfillment.View */
  ReportsStandardStandardFulfillmentView = 'ReportsStandardStandardFulfillmentView',
  /** Reports.Standard.StandardOtherRequirement */
  ReportsStandardStandardOtherRequirement = 'ReportsStandardStandardOtherRequirement',
  /** Reports.Standard.System.View */
  ReportsStandardSystemView = 'ReportsStandardSystemView',
  /** Reports.Standard.View */
  ReportsStandardView = 'ReportsStandardView',
  /** Requirements.AdditionalAgreement.Catalog.Modify */
  RequirementsAdditionalAgreementCatalogModify = 'RequirementsAdditionalAgreementCatalogModify',
  /** Requirements.AdditionalAgreement.Catalog.View */
  RequirementsAdditionalAgreementCatalogView = 'RequirementsAdditionalAgreementCatalogView',
  /** Requirements.ContinuingEducation.Catalog.Modify */
  RequirementsContinuingEducationCatalogModify = 'RequirementsContinuingEducationCatalogModify',
  /** Requirements.ContinuingEducation.Catalog.View */
  RequirementsContinuingEducationCatalogView = 'RequirementsContinuingEducationCatalogView',
  /** Requirements.Enrollment.Catalog.Modify */
  RequirementsEnrollmentCatalogModify = 'RequirementsEnrollmentCatalogModify',
  /** Requirements.Enrollment.Catalog.View */
  RequirementsEnrollmentCatalogView = 'RequirementsEnrollmentCatalogView',
  /** Requirements.ExternalCert.Catalog.Modify */
  RequirementsExternalCertCatalogModify = 'RequirementsExternalCertCatalogModify',
  /** Requirements.ExternalCert.Catalog.View */
  RequirementsExternalCertCatalogView = 'RequirementsExternalCertCatalogView',
  /** Requirements.ExternalExam.Catalog.Modify */
  RequirementsExternalExamCatalogModify = 'RequirementsExternalExamCatalogModify',
  /** Requirements.ExternalExam.Catalog.View */
  RequirementsExternalExamCatalogView = 'RequirementsExternalExamCatalogView',
  /** Requirements.Lab.Catalog.Modify */
  RequirementsLabCatalogModify = 'RequirementsLabCatalogModify',
  /** Requirements.Lab.Catalog.View */
  RequirementsLabCatalogView = 'RequirementsLabCatalogView',
  /** Requirements.Miscellaneous.Catalog.Modify */
  RequirementsMiscellaneousCatalogModify = 'RequirementsMiscellaneousCatalogModify',
  /** Requirements.Miscellaneous.Catalog.View */
  RequirementsMiscellaneousCatalogView = 'RequirementsMiscellaneousCatalogView',
  /** Requirements.Participation.Catalog.Modify */
  RequirementsParticipationCatalogModify = 'RequirementsParticipationCatalogModify',
  /** Requirements.Participation.Catalog.View */
  RequirementsParticipationCatalogView = 'RequirementsParticipationCatalogView',
  /** Requirements.ProgramFee.Catalog.Modify */
  RequirementsProgramFeeCatalogModify = 'RequirementsProgramFeeCatalogModify',
  /** Requirements.ProgramFee.Catalog.View */
  RequirementsProgramFeeCatalogView = 'RequirementsProgramFeeCatalogView',
  /** Requirements.Training.Catalog.Modify */
  RequirementsTrainingCatalogModify = 'RequirementsTrainingCatalogModify',
  /** Requirements.Training.Catalog.View */
  RequirementsTrainingCatalogView = 'RequirementsTrainingCatalogView',
  /** SponsorAttribute.Catalog.View */
  SponsorAttributeCatalogView = 'SponsorAttributeCatalogView',
  /** SponsorSetting.Catalog.View */
  SponsorSettingCatalogView = 'SponsorSettingCatalogView',
  /** System.Localization.Modify */
  SystemLocalizationModify = 'SystemLocalizationModify',
  /** System.Localization.View */
  SystemLocalizationView = 'SystemLocalizationView',
  /** Tagging.Catalog.Modify */
  TaggingCatalogModify = 'TaggingCatalogModify',
  /** Tagging.Catalog.View */
  TaggingCatalogView = 'TaggingCatalogView',
  /** VerifyValidationCode.Modify */
  VerifyValidationCodeModify = 'VerifyValidationCodeModify',
  /** VerifyValidationCode.View */
  VerifyValidationCodeView = 'VerifyValidationCodeView',
  /** VerifyVoucherCodes.Modify */
  VerifyVoucherCodesModify = 'VerifyVoucherCodesModify',
  /** VerifyVoucherCodes.View */
  VerifyVoucherCodesView = 'VerifyVoucherCodesView',
  /** ViewCandidateExternalIds.Modify */
  ViewCandidateExternalIdsModify = 'ViewCandidateExternalIdsModify',
  /** ViewCandidateExternalIds.View */
  ViewCandidateExternalIdsView = 'ViewCandidateExternalIdsView',
  /** WatchedCandidateList.View */
  WatchedCandidateListView = 'WatchedCandidateListView'
}

/** Any comment information for an exam result. As not all exams have comment data, this is not required. */
export interface ImportExamCommentRequest {
  /**
   * An indication of what type of data the comment is in reference to; the domain or source. Combined with the context-id, this is expected to be unique for a given exam-id.
   * Normally, the values in this column are one of three values: "Exam", "Item", "Survey", or "Section". Comments are most commonly tied directly to an item on the exam, or are at the exam level.
   */
  context?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID, within the indicated context, that identifies the data the comment is in reference to. Combined with the context, this is expected to be unique for a given exam-id.
   * E.g. when the context is "Item", this column will store an "item_name" value (which links it to data delivered in the "Item" file). When "Survey", the value links to "surv_item_name". When "Section", the value links to "sect_id". 
   * When the context is "Exam", it depends on how the exam was built and published. If only one exam-level comment is possible, this is often the same value as "exam_id". If multiple exam-level comments are possible, something like "AdminComment", "ExhibitA", "ExitComment", etc is used for the different comments. These values are normally interpreted by people to derive location and meaning, so internal, numeric Id values are not very useful for exam-level comments.
   */
  contextId?: InputMaybe<Scalars['String']['input']>;
  /** The comment/response text. */
  response?: InputMaybe<Scalars['String']['input']>;
}

export interface ImportExamItemRequest {
  correctAnswer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderPresented?: InputMaybe<Scalars['Short']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Decimal']['input']>;
  sectionOrdinal?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}

/** Allows for importing of exams, values submitted via this method with be merged with existing data (i.e. an upsert will be performed). */
export interface ImportExamRequest {
  authId?: InputMaybe<Scalars['String']['input']>;
  candidateId: CandidateIdRequest;
  commentList?: InputMaybe<Array<InputMaybe<ImportExamCommentRequest>>>;
  correctItemCount?: InputMaybe<Scalars['Short']['input']>;
  dataProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** When the exam was taken/administered. Expressed in local time. If a timezone is given it will be converted to US mountain time. */
  dateTime: Scalars['CmDateTimeOffset']['input'];
  /** The code/ID (Unique key) of the exam the candidate took. This is normally a code in the form of “<group/client ID>-<series ID>”; e.g. “101-001”, “AB0-123”, etc.).  Together with the title of the exam, this is what the candidate will usually know the exam as. */
  excatExternalId?: InputMaybe<Scalars['String']['input']>;
  excatId?: InputMaybe<Scalars['Int']['input']>;
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  grade: ExamGradeLabel;
  incorrectItemCount?: InputMaybe<Scalars['Short']['input']>;
  itemList?: InputMaybe<Array<InputMaybe<ImportExamItemRequest>>>;
  itemsSkipped?: InputMaybe<Scalars['Short']['input']>;
  languageId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  registrationNumber: Scalars['String']['input'];
  rescored?: InputMaybe<Scalars['String']['input']>;
  /** The exam’s total raw score. This is the raw score, not scaled. */
  score?: InputMaybe<Scalars['Decimal']['input']>;
  scoreScaled?: InputMaybe<Scalars['Decimal']['input']>;
  sectionList?: InputMaybe<Array<InputMaybe<ImportExamSectionRequest>>>;
  simulated?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<ExamState>;
  surveyList?: InputMaybe<Array<InputMaybe<ImportExamSurveyRequest>>>;
  /** The ID of the test center at which this exam was taken. */
  testCenterId?: InputMaybe<Scalars['String']['input']>;
  /** The number of seconds the candidate spent to complete the exam. */
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
}

export interface ImportExamSectionRequest {
  algorithm?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<ExamGradeLabel>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemsCorrect?: InputMaybe<Scalars['Short']['input']>;
  itemsIncorrect?: InputMaybe<Scalars['Short']['input']>;
  itemsSkipped?: InputMaybe<Scalars['Short']['input']>;
  passingScore?: InputMaybe<Scalars['Decimal']['input']>;
  score?: InputMaybe<Scalars['Decimal']['input']>;
  scoreMax?: InputMaybe<Scalars['Decimal']['input']>;
  scored?: InputMaybe<Scalars['Boolean']['input']>;
  stdError?: InputMaybe<Scalars['Decimal']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface ImportExamSurveyRequest {
  itemName?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Request parameters for fetching available in-person exam times */
export interface InPersonAvailableLocationsRequest {
  /** The end date to search for available times */
  endDate: Scalars['DateTime']['input'];
  /** The exam code of the exam we want to look at */
  examCode: Scalars['String']['input'];
  /** The latitude coordinate of the search location */
  latitude: Scalars['Float']['input'];
  /** The longitude coordinate of the search location */
  longitude: Scalars['Float']['input'];
  /** The number of results to skip for pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** The start date to search for available times */
  startDate: Scalars['DateTime']['input'];
  /** The number of results to return */
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface InsertCandidateHistory {
  candidateId?: InputMaybe<CandidateIdRequest>;
  message: Scalars['String']['input'];
  targetId?: InputMaybe<Scalars['Int']['input']>;
  type: ChistType;
}

export interface InsertWebUserHistory {
  message: Scalars['String']['input'];
  type: WuhType;
  webUserId?: InputMaybe<WebUserIdRequest>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface InstructionGqlType {
  culture?: Maybe<Scalars['String']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
}

/** Information about an ISO-defined country. */
export interface IsoCountry {
  auxiliary?: Maybe<IsoCountryAuxiliary>;
  /** This is the unique 3-char ISO-3166-1 code for the country. */
  code: Scalars['String']['output'];
  /** This is the unique 2-char ISO 3166-1 code for the country. */
  code2Char: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  id: Scalars['Int']['output'];
  /** The ISO number assigned to the country. */
  isoNumber: Scalars['Short']['output'];
  /** The name of the country. */
  name: Scalars['String']['output'];
  /** When true, this indicates that ISO has not defined any subdivisions for this country. When NULL, no subdivision code information is defined in the system. */
  noSubdivision?: Maybe<Scalars['Boolean']['output']>;
  /** Country Code Prefix (AKA 'Country Calling Code', 'Country Dial -in Code'). This is a 1-3 digit number that is dialed to make a call to another country; it is dialed after the International Direct Dialing Prefix.Source. */
  phoneCcPrefix?: Maybe<Scalars['String']['output']>;
  /** International Direct Dialing Prefix (AKA 'International Call Prefix', 'International Access Code', 'Dial -out Code', 'Exit Code'). When making an international call, dial this value first (it's a 'trunk prefix'), followed by the Country Code Prefix. */
  phoneIddPrefix?: Maybe<Scalars['String']['output']>;
  subdivisions?: Maybe<Array<Maybe<IsoCountrySubdivision>>>;
}


/** Information about an ISO-defined country. */
export interface IsoCountryAuxiliaryArgs {
  request?: InputMaybe<IsoCountryAuxiliaryRequest>;
}

/** Client specific configuration for ISO countries. */
export interface IsoCountryAuxiliary {
  /** The IC code for this ISO country */
  id: Scalars['String']['output'];
  /** True if this country is not permitted as a selection. */
  prohibited: Scalars['Boolean']['output'];
  /** Use this to sort country lists - order by Auxiliary.SortGroup first and then by Name. */
  sortGroup?: Maybe<Scalars['Byte']['output']>;
}

/** A request object that can be used to query ISO country auxiliary data. */
export interface IsoCountryAuxiliaryRequest {
  /** The client alias to use when getting ISO country auxiliary data. */
  clientAlias?: InputMaybe<Scalars['String']['input']>;
}

/** Information about an ISO-defined country subdivision (state/province/etc.). */
export interface IsoCountrySubdivision {
  /** The subdivision code; unique only within a country. This is the country-specific portion of GlobalCode value. */
  code: Scalars['String']['output'];
  /** This is the unique 3-char ISO-3166-1 code for the country that this subdivision belongs to. */
  countryCode: Scalars['String']['output'];
  /** The full, globally-unique ISO subdivision code. */
  globalCode: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  id: Scalars['Int']['output'];
  /** The name of the country. */
  name: Scalars['String']['output'];
}

export enum ItemNodeType {
  /** CertAchieved */
  CertAchieved = 'CertAchieved',
  /** Folder */
  Folder = 'Folder'
}

/** An item in the site exam itinerary */
export interface ItinerarySite {
  /** The list of tests in this site itinerary item */
  tests?: Maybe<Array<Maybe<TestSites>>>;
}

/**
 * A jurisdiction
 * 
 * 
 *  - Requires All Features: NCARBJurisdictions
 * 
 *  - Requires All Permissions: Jurisdictions.View
 *
 */
export interface Jurisdiction {
  /** CSetId has a value if the jurisdiction is manual, otherwise it is automatic. */
  cSetId?: Maybe<Scalars['Int']['output']>;
  catName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
}

/** Contains a variety of helper links for Kryterion candidate egress sso. */
export interface KryterionSsoEgress {
  dashboard?: Maybe<Scalars['String']['output']>;
}

/** Information from the legacy scheduling system */
export interface LegacyInfo {
  /** Legacy lab identifier */
  labId: Scalars['Int']['output'];
  /** Legacy seat identifier */
  seatId: Scalars['Int']['output'];
}

export enum LocType {
  /** CandidatePortalExternalUrl */
  CandidatePortalExternalUrl = 'CandidatePortalExternalUrl',
  /** CandidatePortalString */
  CandidatePortalString = 'CandidatePortalString',
  /** CandidatePortalSystemUrl */
  CandidatePortalSystemUrl = 'CandidatePortalSystemUrl',
  /** InternalPortalExternalUrl */
  InternalPortalExternalUrl = 'InternalPortalExternalUrl',
  /** InternalPortalString */
  InternalPortalString = 'InternalPortalString',
  /** InternalPortalSystemUrl */
  InternalPortalSystemUrl = 'InternalPortalSystemUrl',
  /** SponsorPortalExternalUrl */
  SponsorPortalExternalUrl = 'SponsorPortalExternalUrl',
  /** SponsorPortalString */
  SponsorPortalString = 'SponsorPortalString',
  /** SponsorPortalSystemUrl */
  SponsorPortalSystemUrl = 'SponsorPortalSystemUrl'
}

export enum LocUiType {
  /** Button */
  Button = 'Button',
  /** ColumnHeading */
  ColumnHeading = 'ColumnHeading',
  /** Content */
  Content = 'Content',
  /** FieldError */
  FieldError = 'FieldError',
  /** FieldHint */
  FieldHint = 'FieldHint',
  /** FieldLabel */
  FieldLabel = 'FieldLabel',
  /** ImageInformation */
  ImageInformation = 'ImageInformation',
  /** MenuItem */
  MenuItem = 'MenuItem',
  /** NotificationMessage */
  NotificationMessage = 'NotificationMessage',
  /** SystemValue */
  SystemValue = 'SystemValue',
  /** Title */
  Title = 'Title'
}

export interface LocalizationResponse {
  /** The culture for the localization. */
  cultureName: Scalars['String']['output'];
  /** The fallback value if this field is not customized. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Information to aid in localizing this value. */
  description?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<FeatureInfo>;
  /** Specifies if an html editor should be used for this field. */
  htmlAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Information to aid in localizing this value. Returns true when a localization has been set by the user. */
  isCustomized?: Maybe<Scalars['Boolean']['output']>;
  /** The name (key) of the localization. */
  name: Scalars['String']['output'];
  /** The localization path value, unique per portal. */
  path?: Maybe<Scalars['String']['output']>;
  /** See PortalType enum for more information. */
  portalType?: Maybe<PortalType>;
  /** If true, this value may appear in multiple places. Changing it in one place will change it everywhere. */
  shared?: Maybe<Scalars['Boolean']['output']>;
  /** See LocType enum for more information. */
  type?: Maybe<LocType>;
  /** The type of UI item this localization is used on. */
  uiType?: Maybe<LocUiType>;
  /** The localizations value. */
  value?: Maybe<Scalars['String']['output']>;
}

/** A definition for a localization. */
export interface LocalizationVm {
  /** The name (key) of the localization. */
  name: Scalars['String']['input'];
  /** The value to be assigned to the localization. */
  value?: InputMaybe<Scalars['String']['input']>;
}

/** Location information for a testing site */
export interface Location {
  /** The address of the location */
  address?: Maybe<Address>;
  /** Contact information for the location */
  contact?: Maybe<Contact>;
  /** The coordinates of the location [longitude, latitude] */
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Directions to the location */
  directions?: Maybe<Array<Maybe<Direction>>>;
  /** The distance to the location */
  distance?: Maybe<Scalars['Float']['output']>;
  /** The timezone of the location */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** The timezone offset */
  timeZoneOffset?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 * 
 *  - Internal accounts only
 * 
 *  - Admin accounts only
 *
 */
export interface LogicRule {
  rulesByPosition?: Maybe<Array<Maybe<LogicRuleByPosition>>>;
}

/**
 * 
 * 
 * 
 *  - Internal accounts only
 * 
 *  - Admin accounts only
 *
 */
export interface LogicRuleByPosition {
  position?: Maybe<Scalars['Int']['output']>;
  unparsedJson?: Maybe<Scalars['String']['output']>;
}

export interface MatchExamVerificationDataRequestGqlType {
  registrationIds: Array<InputMaybe<Scalars['String']['input']>>;
}

export interface MatchingExam {
  cmcId: Scalars['Int']['output'];
  examDate: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  testCenterId?: Maybe<Scalars['String']['output']>;
}

export enum MergeRequestState {
  /** Approved */
  Approved = 'Approved',
  /** Complete */
  Complete = 'Complete',
  /** Queued */
  Queued = 'Queued',
  /** Rejected */
  Rejected = 'Rejected',
  /** Requested */
  Requested = 'Requested'
}

export enum MergeState {
  /** MergeRequest */
  MergeRequest = 'MergeRequest',
  /** Merged */
  Merged = 'Merged',
  /** UnMerged */
  UnMerged = 'UnMerged'
}

/** An attribute (key-value pair) associated with a metadata item. */
export interface MetadataAttribute {
  /** The name of the attribute (key). */
  attributeName: Scalars['String']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** Foreign key to the metadata item this attribute belongs to. */
  mdiId: Scalars['Int']['output'];
  /** The value of the attribute. */
  value?: Maybe<Scalars['String']['output']>;
}

/** A metadata item entry used to store client-specific metadata that doesn't link to other data. */
export interface MetadataItem {
  /** The attributes (key-value pairs) associated with this metadata item. */
  attributes?: Maybe<Array<Maybe<MetadataAttribute>>>;
  /** The external id for this record. Must be unique for a given type. */
  externalId: Scalars['String']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** The type of the metadata item, used to group metadata items together. */
  type: Scalars['String']['output'];
}

/** Request parameters for filtering metadata items. */
export interface MetadataItemListRequest {
  /** Filter by metadata item external ID (case insensitive). */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by metadata item type (case insensitive). */
  type?: InputMaybe<Scalars['String']['input']>;
}

export enum NavType {
  /** CandidatePortal */
  CandidatePortal = 'CandidatePortal',
  /** InternalPortal */
  InternalPortal = 'InternalPortal',
  /** SponsorPortal */
  SponsorPortal = 'SponsorPortal'
}

/** A node in a navigation tree. */
export interface Navigation {
  /** The culture/language of the Label. */
  cultureInfoName?: Maybe<Scalars['String']['output']>;
  /** The custom display order for the node. */
  displayOrder?: Maybe<Scalars['Int']['output']>;
  /** The Id of the node. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The display-label for the node. */
  label?: Maybe<Scalars['String']['output']>;
  /** The Id of the parent node; null for root nodes. */
  parentId?: Maybe<Scalars['Int']['output']>;
  /** This is the key to use to fetch the label for the node from the localization resources; you need the resource-type to use this. */
  resourceKey?: Maybe<Scalars['String']['output']>;
  /** This is the type of resource that the resource-key corresponds to. */
  resourceType: LocType;
  /** The type of the node. */
  type: NavType;
  /** The url for the node. */
  url?: Maybe<Scalars['String']['output']>;
}

export interface NavigationListRequestVm {
  /** Indicates how the labels of the nodes in the tree are localized (language). The default is 'en'. */
  culture?: InputMaybe<Scalars['String']['input']>;
  /** The type of navigation tree to fetch. The default is 'CandidatePortal'. Supported options are 'CandidatePortal', 'SponsorPortal', 'InternalPortal'. */
  type?: InputMaybe<NavType>;
}

/** A definition for a navigation node. */
export interface NavigationRequestVm {
  /** The relative number that determines how the navigation node is ordered against its peers. */
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  /** A guid to identify external navigation nodes. If this field is populated, ExternalUrl must also be populated. This field shouldn't be provided if the node is interal. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The url external navigation nodes redirect to. Shouldn't be populated if Id is populated. Is required if ExternalId is provided. */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** The SVG text for the icon associated with the navigation node. This icon will override any default. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The Id of the navigation node (not the client navigation node). This links to the navigation table, and shouldn't be provided if the node is a link to an external site */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** If the navigation node is a child node, this is the Id of its parent. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
}

export interface NcarbNeedsEligibilityRequest {
  areFilterId: Scalars['Int']['input'];
  jurisdictionFilterId: Scalars['Int']['input'];
}

export interface NcarbNeedsEligibilityResponse {
  ceiExternalId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cmcId: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  litemExternalId?: Maybe<Scalars['String']['output']>;
  ncarbRecordNo?: Maybe<Scalars['String']['output']>;
  recordSummaryLink?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: NcarbReports
 *
 */
export interface NcarbReports {
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Must have candidate access
   *
   */
  ncarbNeedsEligibility?: Maybe<Array<Maybe<NcarbNeedsEligibilityResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Must have candidate access
   *
   */
  ncarbNeedsEligibilityCount?: Maybe<Scalars['Int']['output']>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: NcarbReports
 *
 */
export interface NcarbReportsNcarbNeedsEligibilityArgs {
  request?: InputMaybe<NcarbNeedsEligibilityRequest>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ExamNCARBCertBatching
 *
 */
export interface NcarbToolsMutations {
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamNCARBExamAuthorizations
   *
   */
  createExamAuthorization?: Maybe<ExamAuthorization>;
  /**
   * 
   * 
   *
   */
  switchToAutomaticJurisdictions?: Maybe<Array<Maybe<Jurisdiction>>>;
  /**
   * 
   * 
   *
   */
  switchToManualJurisdictions?: Maybe<Array<Maybe<Jurisdiction>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamNCARBExamAuthorizations
   *
   */
  updateExamAuthorization?: Maybe<Array<Maybe<ExamAuthorization>>>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ExamNCARBCertBatching
 *
 */
export interface NcarbToolsMutationsCreateExamAuthorizationArgs {
  request?: InputMaybe<CreateExamAuthorizationNcarbRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ExamNCARBCertBatching
 *
 */
export interface NcarbToolsMutationsSwitchToAutomaticJurisdictionsArgs {
  request?: InputMaybe<SwitchToAutomaticJurisdictionsRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ExamNCARBCertBatching
 *
 */
export interface NcarbToolsMutationsSwitchToManualJurisdictionsArgs {
  request?: InputMaybe<SwitchToManualJurisdictionsRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ExamNCARBCertBatching
 *
 */
export interface NcarbToolsMutationsUpdateExamAuthorizationArgs {
  request?: InputMaybe<UpdateExamAuthorizationNcarbRequest>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ToolsNCARBTools
 *
 */
export interface NcarbToolsQueries {
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamNCARBCertBatching
   *
   */
  certBatchingList?: Maybe<Array<Maybe<CertBatch>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamScoreReportsBatch
   * 
   *  - Requires All Permissions: Ncarb.ScoreReports.BatchedDownloads.Modify, Ncarb.ScoreReports.BatchedDownloads.View
   *
   */
  examBatchingList?: Maybe<Array<Maybe<ExamBatch>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamScoreReportsBatch, ExamScoreReports
   * 
   *  - Requires All Permissions: ClientSettings.View
   *
   */
  fetchDelayClientSettings?: Maybe<Array<Maybe<ClientSetting>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamScoreReportsBatch, ExamScoreReports
   * 
   *  - Requires All Permissions: ClientSettings.View
   *
   */
  fetchDelayList?: Maybe<Array<Maybe<FetchDelayListResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamNCARBExamAuthorizations
   *
   */
  fetchExamAuthHistory?: Maybe<Array<Maybe<ExamAuthHistory>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamNCARBExamAuthorizations
   *
   */
  fetchExamAuths?: Maybe<Array<Maybe<ExamAuthorizationResponse>>>;
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: NCARBJurisdictions
   *
   */
  jurisdictionList?: Maybe<Array<Maybe<Jurisdiction>>>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ToolsNCARBTools
 *
 */
export interface NcarbToolsQueriesCertBatchingListArgs {
  request?: InputMaybe<CertBatchRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ToolsNCARBTools
 *
 */
export interface NcarbToolsQueriesExamBatchingListArgs {
  request?: InputMaybe<ExamBatchRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ToolsNCARBTools
 *
 */
export interface NcarbToolsQueriesFetchDelayListArgs {
  request?: InputMaybe<FetchDelayListRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ToolsNCARBTools
 *
 */
export interface NcarbToolsQueriesFetchExamAuthHistoryArgs {
  request?: InputMaybe<FetchExamAuthHistoryRequest>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: ToolsNCARBTools
 *
 */
export interface NcarbToolsQueriesFetchExamAuthsArgs {
  request?: InputMaybe<FetchExamAuthsRequest>;
}

export interface NetacadReport {
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  candidateEmail?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  candidateFirstName?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  candidateLastName?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  cscoId?: Maybe<Scalars['String']['output']>;
  losingCscoIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  winningCscoId?: Maybe<Scalars['String']['output']>;
}

export interface NetacadReportRequest {
  externalIdList: Array<InputMaybe<Scalars['String']['input']>>;
}

/**
 * Returns a detail view of newly imported exams.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: ExamRecentImportList.View
 *
 */
export interface NewlyImportedExamDetail {
  /** The Candidate for the exam. */
  candidate?: Maybe<Candidate>;
  /** The exam catalog entry for this exam. */
  catalog?: Maybe<ExamCatalog>;
  /**
   * The Cmc Id on the exam.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  cmcId?: Maybe<Scalars['Int']['output']>;
  /**
   * The date the exam was imported/created.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  created?: Maybe<Scalars['DateTime']['output']>;
  dataProvider?: Maybe<DataProvider>;
  /**
   * The data provider Id.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  /** The date the exam was sat by the candidate. */
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the file this exam originated from. */
  examImportSource?: Maybe<Scalars['String']['output']>;
  /**
   * The Exam Id.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The original import source when the exam was first created. */
  originalImportSource?: Maybe<Scalars['String']['output']>;
  /** The registration number for the exam. */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** The most recent re-import date of the exam. */
  reimported?: Maybe<Scalars['DateTime']['output']>;
  /** The test center Id the exam was done at. */
  testCenterId?: Maybe<Scalars['String']['output']>;
}

/**
 * Returns a count of exams imported on a specific date.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: ExamRecentImportList.View
 *
 */
export interface NewlyImportedExams {
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  created?: Maybe<Scalars['DateTime']['output']>;
  dataProvider?: Maybe<DataProvider>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

/**
 * A news article summary
 * 
 * 
 *  - Requires All Features: Announcements
 *
 */
export interface NewsArticle {
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  ends?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  newsDisplayOrder?: Maybe<Scalars['Int']['output']>;
  pictureLinkUrl?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  reads?: Maybe<Scalars['Int']['output']>;
  starts?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  views?: Maybe<Scalars['Int']['output']>;
}

/**
 * A news article
 * 
 * 
 *  - Requires All Features: Announcements
 *
 */
export interface NewsArticleDetail {
  body?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  ends?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  filter?: Maybe<Filter>;
  headline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  newsDisplayOrder?: Maybe<Scalars['Int']['output']>;
  pictureLinkUrl?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  reads?: Maybe<Scalars['Int']['output']>;
  starts?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  views?: Maybe<Scalars['Int']['output']>;
}

/** Request parameters for fetching available online exam times */
export interface OnlineAvailableExamTimesRequest {
  /** The end date to search for available times */
  endDate: Scalars['DateTime']['input'];
  /** The exam code of the exam we want to look at */
  examCode: Scalars['String']['input'];
  /** The number of results to skip for pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** The start date to search for available times */
  startDate: Scalars['DateTime']['input'];
  /** The number of results to return */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The timezone for the available exam times */
  timezone: Scalars['String']['input'];
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CandidateAccessLoginEMCOtherAchievements
 *
 */
export interface OtherAchievementCatalog {
  /**
   * Used to indicate if this other achievement has been disabled.
   * 
   *  - Disallowed Account Types: Candidate
   */
  disabled: Scalars['Boolean']['output'];
  /** When set, this is the identifier for the client. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Internal id for the Other Achievement definition. */
  id: Scalars['Int']['output'];
  /** The name for the Other Achievement. */
  name?: Maybe<Scalars['String']['output']>;
  /** Used to indicate if this other achievement is eligible for reimbursement. */
  reimbursable: Scalars['Boolean']['output'];
  /** When this other achievement was last updated. */
  updated: Scalars['CmDateTimeOffset']['output'];
  /** When set, this is the other achievement vendor. */
  vendor?: Maybe<Scalars['String']['output']>;
}

export interface PaddleData {
  /** List of possible subscriptions. */
  catalog?: Maybe<Array<Maybe<TestrunSubscriptionConfiguration>>>;
  /** The primary Paddle ID for the candidate. */
  primaryPaddleId?: Maybe<Scalars['String']['output']>;
  /** List of active subscriptions for the candidate. */
  subscriptions?: Maybe<Array<Maybe<PaddleSubscriptionResponseData>>>;
}

export interface PaddleItemData {
  /** The next billing date for this item. */
  next_billed_at?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The previous billing date for this item. */
  previously_billed_at?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The price information for this item. */
  price?: Maybe<PaddlePriceData>;
}

export interface PaddlePriceData {
  /** The price ID. */
  id?: Maybe<Scalars['String']['output']>;
}

export interface PaddleSubscriptionResponseData {
  /** The creation date of the subscription. */
  created_at?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The currency code for the subscription. */
  currency_code?: Maybe<Scalars['String']['output']>;
  /** The customer ID associated with the subscription. */
  customer_id?: Maybe<Scalars['String']['output']>;
  /** The subscription ID. */
  id?: Maybe<Scalars['String']['output']>;
  /** The items included in the subscription. */
  items?: Maybe<Array<Maybe<PaddleItemData>>>;
  /** The next billing date for the subscription. */
  next_billed_at?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The status of the subscription. */
  status?: Maybe<Scalars['String']['output']>;
}

/** Contains a variety of helper links for PearsonVue candidate egress sso. */
export interface PearsonVueSsoEgress {
  dashboard?: Maybe<Scalars['String']['output']>;
  scheduleAppointments?: Maybe<Scalars['String']['output']>;
  viewAppointments?: Maybe<Scalars['String']['output']>;
}

/**
 * Shows information about a pending Exam Accommodation.
 * 
 * 
 *  - Requires All Features: ExamAccommodations
 * 
 *  - Requires All Permissions: Exam.Accommodations.View
 *
 */
export interface PendingExamAccomm {
  candidate?: Maybe<Candidate>;
  created: Scalars['CmDateTimeOffset']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
}

export enum PermType {
  /** InternalPortal */
  InternalPortal = 'InternalPortal',
  /** SponsorPortal */
  SponsorPortal = 'SponsorPortal'
}

/** This is the permissions that determines what a user can see and do. */
export interface Permission {
  clientRoles?: Maybe<Array<Maybe<ClientRole>>>;
  /** The description of what the permission pertains to. */
  description: Scalars['String']['output'];
  featureEnabled: Scalars['Boolean']['output'];
  /** Group that the permission resides in. */
  groupName: Scalars['String']['output'];
  /** The permission Id. */
  id: Scalars['Int']['output'];
  key: HubPermission;
  /** The client friendly name of the permission. */
  label: Scalars['String']['output'];
  /** The internal name of the permission; this is unique by type. */
  name: Scalars['String']['output'];
  /** The type of the permission. */
  portalType: PermType;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 * 
 *  - Requires All Permissions: Candidate.CredentialFulfillment.View
 * 
 *  - Must have candidate access
 *
 */
export interface PhysicalFulfillment {
  catalogId: Scalars['Int']['output'];
  /** The cert associated with a phsyical fulfillment. */
  cert?: Maybe<Cert>;
  cmcId: Scalars['Int']['output'];
  completed?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  created: Scalars['CmDateTimeOffset']['output'];
  expedite: Scalars['Boolean']['output'];
  exportOkDate?: Maybe<Scalars['CmDate']['output']>;
  exported?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  /** Shows summary information on the associated fulfillment catalog. */
  fulfillmentCatalog?: Maybe<PhysicalFulfillmentCatalog>;
  id: Scalars['Int']['output'];
  manual: Scalars['Boolean']['output'];
  pendingDmgr?: Maybe<Scalars['Boolean']['output']>;
  pendingRequeue?: Maybe<Scalars['Boolean']['output']>;
  purchased?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<FulfStatus>;
  tracking: Scalars['Boolean']['output'];
  trackingCarrier?: Maybe<Scalars['String']['output']>;
  trackingCodeList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 *
 */
export interface PhysicalFulfillmentCatalog {
  /** When true, if a fulfillment item is unable to be delivered, a new fulfillment record will be created to retry sending the kit. */
  autoRequeue: Scalars['Boolean']['output'];
  /**
   * When true, indicates that this Fulfillment item can be purchased by the candidate.
   * 
   * 
   *  - Requires All Features: EcommerceFulfillment
   *
   */
  canPurchase?: Maybe<Scalars['Boolean']['output']>;
  certCatalog?: Maybe<CertCatalog>;
  /** When set, this indicates the Certification that the candidate must earn and have active in order to receive physical fulfillment, or be able to download electronic fulfillment. */
  certCatalogId?: Maybe<Scalars['Int']['output']>;
  /** This is a description of what is included in the physical fulfillment kit. The default value is 'Kit'. This information typically is not relevant for fulfillment that is electronic only. */
  description: Scalars['String']['output'];
  /** Used to indicate if electronic fulfillment is available for download. When the value is false, this exclusively represents a fulfillment that is shipped to the candidate by a fulfillment house. */
  electronic: Scalars['Boolean']['output'];
  /** When set, this is the identifier for the client, the fulfillment house, or both indicating what specific kit is intended. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Internal id for the Fulfillment definition. */
  id: Scalars['Int']['output'];
  /** When set, this is a value that can be used either by the fulfillment house or on electronic fulfillment. When null, the CertCatalog.Name value is used. */
  name?: Maybe<Scalars['String']['output']>;
  /** When set, this is a value that can be used either by the fulfillment house or on electronic fulfillment. When null, the CertCatalog.NameAbbr value is used. */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** Indicates how often fulfillment can be queued for a candidate. Options are Manual, Once, EachNewItem, and Never. Never is used for fulfillment that is electronic only. */
  queueType: FcatQueueType;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface PhysicalFulfillmentCatalogDetail {
  /** When true, if a fulfillment item is unable to be delivered, a new fulfillment record will be created to retry sending the kit. */
  autoRequeue: Scalars['Boolean']['output'];
  /** Defines a list of countries which, if the candidate resides in one of those countries, the candidate cannot be granted physical fulfillment kits. */
  blockedCountries?: Maybe<Array<Maybe<IsoCountry>>>;
  /**
   * When true, indicates that this Fulfillment item can be purchased by the candidate.
   * 
   * 
   *  - Requires All Features: EcommerceFulfillment
   *
   */
  canPurchase?: Maybe<Scalars['Boolean']['output']>;
  certCatalog?: Maybe<CertCatalog>;
  /** When set, this indicates the Certification that the candidate must earn and have active in order to receive physical fulfillment, or be able to download electronic fulfillment. */
  certCatalogId?: Maybe<Scalars['Int']['output']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  created: Scalars['CmDateTimeOffset']['output'];
  /** This is a description of what is included in the physical fulfillment kit. The default value is 'Kit'. This information typically is not relevant for fulfillment that is electronic only. */
  description: Scalars['String']['output'];
  /**
   * When set, indicates that the item may be purchased and provides more information about the purchasing structure.
   * 
   * 
   *  - Requires All Features: EcommerceFulfillment
   *
   */
  eTransactionItemCatalogList?: Maybe<Array<Maybe<EtransactionItemCatalog>>>;
  /** Used to indicate if electronic fulfillment is available for download. When the value is false, this exclusively represents a fulfillment that is shipped to the candidate by a fulfillment house. */
  electronic: Scalars['Boolean']['output'];
  /** When set, this is the identifier for the client, the fulfillment house, or both indicating what specific kit is intended. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Internal id for the Fulfillment definition. */
  id: Scalars['Int']['output'];
  /** When set, this is a value that can be used either by the fulfillment house or on electronic fulfillment. When null, the CertCatalog.Name value is used. */
  name?: Maybe<Scalars['String']['output']>;
  /** When set, this is a value that can be used either by the fulfillment house or on electronic fulfillment. When null, the CertCatalog.NameAbbr value is used. */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** Indicates how often fulfillment can be queued for a candidate. Options are Manual, Once, EachNewItem, and Never. Never is used for fulfillment that is electronic only. */
  queueType: FcatQueueType;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: CredentialFulfillment
 * 
 *  - Requires All Permissions: Candidate.CredentialFulfillment.View
 * 
 *  - Must have candidate access
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface PhysicalFulfillmentDetail {
  catalogId: Scalars['Int']['output'];
  /** The cert associated with a phsyical fulfillment. */
  cert?: Maybe<Cert>;
  cmcId: Scalars['Int']['output'];
  completed?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  created: Scalars['CmDateTimeOffset']['output'];
  expedite: Scalars['Boolean']['output'];
  exportOkDate?: Maybe<Scalars['CmDate']['output']>;
  exported?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  /** Shows summary information on the associated fulfillment catalog. */
  fulfillmentCatalog?: Maybe<PhysicalFulfillmentCatalog>;
  /** Shows summary information on the associated fulfillment catalog. */
  fulfillmentCatalogDetail?: Maybe<PhysicalFulfillmentCatalogDetail>;
  id: Scalars['Int']['output'];
  manual: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pendingDmgr?: Maybe<Scalars['Boolean']['output']>;
  pendingRequeue?: Maybe<Scalars['Boolean']['output']>;
  purchased?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<FulfStatus>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  tracking: Scalars['Boolean']['output'];
  trackingCarrier?: Maybe<Scalars['String']['output']>;
  trackingCodeList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export enum PortalType {
  /** CandidatePortal */
  CandidatePortal = 'CandidatePortal',
  /** InternalPortal */
  InternalPortal = 'InternalPortal',
  /** SponsorPortal */
  SponsorPortal = 'SponsorPortal'
}

/**
 * Represents a certification requirement item that has been audited already.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface PreviouslyAuditedItem {
  activeDate: Scalars['CmDate']['output'];
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  catalogId: Scalars['Int']['output'];
  certRequirementCatalog?: Maybe<CertRequirementCatalog>;
  cmcId: Scalars['Int']['output'];
  creqCrvId?: Maybe<Scalars['Int']['output']>;
  creqVoucher?: Maybe<CreqVoucher>;
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  docChangeable?: Maybe<Scalars['Boolean']['output']>;
  docLanguage?: Maybe<Scalars['String']['output']>;
  docNotes?: Maybe<Scalars['String']['output']>;
  docUploadUrl?: Maybe<Scalars['String']['output']>;
  docUrl?: Maybe<Scalars['String']['output']>;
  /** Whether documentation is available. */
  documentation?: Maybe<Scalars['Boolean']['output']>;
  expireDate?: Maybe<Scalars['CmDate']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  importSource?: Maybe<Scalars['String']['output']>;
  invalid: Scalars['Boolean']['output'];
  /** Previously used items within the same catalog. */
  items?: Maybe<Array<Maybe<CreqAuditItem>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementShowOverrideName
   *
   */
  override?: Maybe<CertRequirementCatalogOverrideCatalog>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialContinuingEducation
   *
   */
  points?: Maybe<Scalars['Short']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  /** Indicates what part of the review process the requirement is in. None indicates that no review is needed. */
  reviewState: CreqReviewState;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CredentialAchievementsCertificate
   *
   */
  standingECertUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CreqStatus>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/** Response containing proctor hold information from Prometric */
export interface ProctorHoldResponse {
  /** Candidate's timezone offset */
  candidateTimezoneOffset?: Maybe<Scalars['String']['output']>;
  /** When the proctor hold expires */
  expirationDateTime: Scalars['CmDateTimeOffset']['output'];
  /** Unique identifier for the proctor hold */
  id: Scalars['ID']['output'];
  /** Legacy system information */
  legacy?: Maybe<LegacyInfo>;
  /** Associated proctor slot information */
  slot?: Maybe<PrometricInfo>;
  /** The appointment time for this hold */
  startDate?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** The URI of the proctor hold */
  uri?: Maybe<Scalars['String']['output']>;
}

/** Response containing booking information from Prometric */
export interface PrometricBookingResponse {
  /** Information about the candidate */
  candidate?: Maybe<PrometricInfo>;
  /** The API URL for the booking */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the booking */
  id?: Maybe<Scalars['String']['output']>;
  /** List of tests in the booking */
  tests?: Maybe<Array<Maybe<PrometricBookingTest>>>;
}

/** Information about a session in a booking */
export interface PrometricBookingSession {
  /** The confirmation number for the session */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  /** The exam form code for the session */
  examFormCode?: Maybe<Scalars['String']['output']>;
  /** Hold information for the session */
  hold?: Maybe<PrometricInfo>;
  /** The unique identifier of the session */
  id?: Maybe<Scalars['String']['output']>;
  /** The session identifier */
  sessionId?: Maybe<Scalars['Int']['output']>;
}

/** Information about a test in a booking */
export interface PrometricBookingTest {
  /** CNATT flag for the test */
  cnatt?: Maybe<Scalars['Boolean']['output']>;
  /** Eligibility information for the test */
  eligibility?: Maybe<PrometricInfo>;
  /** Information about the exam */
  exam?: Maybe<PrometricInfo>;
  /** List of sessions for this test */
  sessions?: Maybe<Array<Maybe<PrometricBookingSession>>>;
  /** The status of the test */
  status?: Maybe<Scalars['String']['output']>;
}

/** Response model for Prometric hold information */
export interface PrometricHoldResponse {
  /** The expiration date and time of the hold */
  expirationDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** The API URL for the hold */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the hold */
  id?: Maybe<Scalars['String']['output']>;
  /** The start time for the proctor */
  proctorStart?: Maybe<Scalars['DateTime']['output']>;
  /** The time zone of the proctor */
  proctorTimeZone?: Maybe<Scalars['String']['output']>;
  /** The slot information for this hold */
  slot?: Maybe<PrometricInfo>;
  /** The appointment time for this hold */
  startDate?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/** Information about id and href for Prometric */
export interface PrometricInfo {
  /** The API URL for the candidate */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the candidate */
  id?: Maybe<Scalars['String']['output']>;
}

/** An item in the exam itinerary */
export interface PrometricItineraryItem {
  /** The list of tests in this itinerary item */
  tests?: Maybe<Array<Maybe<PrometricTest>>>;
}

/** A suggested time slot for an exam */
export interface PrometricSlot {
  /** The duration of the slot in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  /** The API URL for the slot */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the slot */
  id?: Maybe<Scalars['String']['output']>;
  /** The start date and time for this slot */
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
}

/** Response containing exam itinerary and suggested time slots */
export interface PrometricSlotSuggestionResponse {
  /** The list of items in the exam itinerary */
  itinerary?: Maybe<Array<Maybe<PrometricItineraryItem>>>;
  /** The list of suggested time slots */
  suggestions?: Maybe<Array<Maybe<PrometricSuggestion>>>;
}

/** A suggestion containing available time slots */
export interface PrometricSuggestion {
  /** The list of available time slots in this suggestion */
  slots?: Maybe<Array<Maybe<PrometricSlot>>>;
}

/** Test information in an itinerary */
export interface PrometricTest {
  /** The duration of the test in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Reference to the exam being taken */
  exam?: Maybe<PrometricInfo>;
  /** The session number for this test */
  session?: Maybe<Scalars['Int']['output']>;
}

/** Contains a variety of helper links for Psi candidate egress sso. */
export interface PsiSsoEgress {
  dashboard?: Maybe<Scalars['String']['output']>;
  scheduleAppointments?: Maybe<Scalars['String']['output']>;
  viewAppointments?: Maybe<Scalars['String']['output']>;
}

export interface PublicEcertDownload {
  activeDate?: Maybe<Scalars['CmDate']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
}

export interface PublicEcertRequest {
  clientDbAlias: Scalars['String']['input'];
  examDate: Scalars['CmDate']['input'];
  lastName: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
}

export enum QlikCmRole {
  /** Consumer */
  Consumer = 'Consumer',
  /** Contributor */
  Contributor = 'Contributor',
  /** Creator */
  Creator = 'Creator',
  /** NoRole */
  NoRole = 'NoRole'
}

/**
 * Contains endpoints to fetch the results of queued asynchronous bulk requests.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface QueuedJobs {
  /**
   * Fetches a bulk corrupt exam job result.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools
   *
   */
  fetchBulkCorruptExamResult?: Maybe<Array<Maybe<BulkCorruptExamResponse>>>;
  /**
   * Fetches a bulk exam validation job result.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, Exam
   * 
   *  - Requires All Permissions: Candidate.ExamDetails.Modify
   *
   */
  fetchBulkExamValidationResult?: Maybe<Array<Maybe<BulkExamValidation>>>;
  /**
   * Fetches a bulk candidate auxiliary update job result.
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools
   * 
   *  - Requires All Permissions: Candidate.BannedStatus.View, Candidate.BannedStatus.Modify, Candidate.WatchStatus.View, Candidate.WatchStatus.Modify
   * 
   *  - Must have candidate access
   *
   */
  fetchBulkUpdateCandidateAuxiliaryResult?: Maybe<Array<Maybe<UpdateCandidateAuxiliaryResponse>>>;
}


/**
 * Contains endpoints to fetch the results of queued asynchronous bulk requests.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface QueuedJobsFetchBulkCorruptExamResultArgs {
  request: FetchQueuedJobRequest;
}


/**
 * Contains endpoints to fetch the results of queued asynchronous bulk requests.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface QueuedJobsFetchBulkExamValidationResultArgs {
  request: FetchQueuedJobRequest;
}


/**
 * Contains endpoints to fetch the results of queued asynchronous bulk requests.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface QueuedJobsFetchBulkUpdateCandidateAuxiliaryResultArgs {
  request: FetchQueuedJobRequest;
}

export interface ReassignCandidateDataRequest {
  certRequirementIdList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  examIdList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fromCmcId: Scalars['Int']['input'];
  identificationIdList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  toCmcId: Scalars['Int']['input'];
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface ReassignClaimedBenefitRequest {
  benefitId: Scalars['Int']['input'];
  candidateId: CandidateIdRequest;
}

/**
 * Returns a detail view of hte recently re-imported exams.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: ExamRecentReimportList.View
 *
 */
export interface RecentlyReImportedExamDetail {
  /** The Candidate on the exam. Resolving the Candidate on a large page limit will substantially increase query times. */
  candidate?: Maybe<Candidate>;
  /** The exam catalog entry for this exam. */
  catalog?: Maybe<ExamCatalog>;
  /**
   * The Cmc Id on the exam.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  cmcId?: Maybe<Scalars['Int']['output']>;
  /** The exam code. */
  code?: Maybe<Scalars['String']['output']>;
  /** The data provider object. */
  dataProvider?: Maybe<DataProvider>;
  /**
   * The data provider Id.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  /** The date the exam was sat by the candidate. */
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The Exam Id.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The original import source when the exam was first created. */
  originalImportSource?: Maybe<Scalars['String']['output']>;
  /**
   * The date the exam was reimported.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  reImported?: Maybe<Scalars['DateTime']['output']>;
  /** The registration number for the exam. */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** The test center Id the exam was done at. */
  testCenterId?: Maybe<Scalars['String']['output']>;
}

/**
 * Returns a list of the recently re-imported exams.
 * 
 * 
 *  - Requires All Features: Exam
 * 
 *  - Requires All Permissions: ExamRecentReimportList.View
 *
 */
export interface RecentlyReImportedExams {
  /** The data provider object. */
  dataProvider?: Maybe<DataProvider>;
  /**
   * The data provider Id
   * 
   * Searchable.
   * 
   * Sortable.
   */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  /**
   * The date that the exam was re-imported.
   * 
   * Searchable.
   * 
   * Sortable.
   */
  reImported?: Maybe<Scalars['DateTime']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface RedeemFulfillmentVoucherRequest {
  /** The candidate to redeem the voucher for. */
  cmcId?: InputMaybe<Scalars['Int']['input']>;
  /** Identifies the fulfillment catalog to use when redeeming the a voucher without a specific fcat. */
  fcatId?: InputMaybe<Scalars['Int']['input']>;
  /** The external id of the voucher to redeem. */
  voucherId: Scalars['String']['input'];
}

export interface RefreshZendeskHistoryRequest {
  /** The cmc id of the candidate whose history should be refreshed. */
  cmcId: Scalars['Int']['input'];
}

export interface RegionalMarket {
  /** The country that's a part of the indicated region. */
  country?: Maybe<IsoCountry>;
  id: Scalars['Int']['output'];
  /** The region that the country is a part of. */
  name: Scalars['String']['output'];
}

export interface ReleaseFulfillmentRequest {
  candidateId: CandidateIdRequest;
  fulfillmentIdList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
}

/**
 * Request parameters for removing audits from the system.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
 * 
 *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
 *
 */
export interface RemoveCreqAuditRequestList {
  /** A list of creq audit ids to remove. */
  craIds: Array<InputMaybe<Scalars['Int']['input']>>;
}

export enum RemoveCreqAuditResponse {
  /** PartialOnHold */
  PartialOnHold = 'PartialOnHold',
  /** Success */
  Success = 'Success'
}

export interface RequestByDateRange {
  /** The date to end the range at. */
  end?: InputMaybe<Scalars['CmDate']['input']>;
  /** The date to start the range from. */
  start?: InputMaybe<Scalars['CmDate']['input']>;
}

export interface RequestByExternalId {
  /** A unique string representing the item being requested. */
  externalId: Scalars['String']['input'];
}

export interface RequestById {
  /** A unique integer representing the item being requested. */
  id: Scalars['Int']['input'];
}

export interface RequestByIdOrExternalId {
  /** A unique string representing the item being requested. Has a lower priority than Id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** A unique integer representing the item being requested. Has a higher priority over ExternalId. */
  id?: InputMaybe<Scalars['Int']['input']>;
}

/** This is used to provide server side pagination. */
export interface RequestConfig {
  /** How many entries (rows) to return. */
  pageLimit?: InputMaybe<Scalars['Int']['input']>;
  /** How many entries (rows) to skip. */
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
  /** The list of fields and values to search by. */
  searchList?: InputMaybe<Array<InputMaybe<SearchRequest>>>;
  /** A list of fields, in order, to sort by. */
  sortList?: InputMaybe<Array<InputMaybe<SortRequest>>>;
}

export interface RetakeSecurityConfigurationGqlType {
  unparsedConfig?: Maybe<Scalars['String']['output']>;
}

export interface RevokeCreqVoucherRequest {
  externalId: Scalars['String']['input'];
  invalidateRequirement?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface RevokeExamAuthorizationPackRequest {
  candidateId: CandidateIdRequest;
  expkId: Scalars['Int']['input'];
}

export interface RevokeFulfillmentVoucherRequest {
  externalId: Scalars['String']['input'];
}

export enum RtdType {
  /** Normal */
  Normal = 'Normal',
  /** WebGroup */
  WebGroup = 'WebGroup',
  /** WebProgram */
  WebProgram = 'WebProgram'
}

export enum RtiCatIdType {
  /** Ccat */
  Ccat = 'Ccat',
  /** Crcat */
  Crcat = 'Crcat',
  /** Excat */
  Excat = 'Excat',
  /** Invalid */
  Invalid = 'Invalid',
  /** Oa */
  Oa = 'Oa'
}

export interface ScoreComparisonSecurityConfigurationGqlType {
  unparsedConfig?: Maybe<Scalars['String']['output']>;
}

/** The name and value to search on for a table request. */
export interface SearchRequest {
  /** The field to search by. */
  searchField?: InputMaybe<Scalars['String']['input']>;
  /** The method by which to search against the SearchField. */
  searchMethod?: InputMaybe<CmSearchMethodEnum>;
  /** The value to search against the SearchField. */
  searchValue?: InputMaybe<Scalars['String']['input']>;
}

export interface SecurityConfigurationsGqlType {
  automationScriptsSecurity?: Maybe<AutomationScriptsSecurityGqlType>;
  candidateSecurityConfiguration?: Maybe<CandidateSecurityConfigurationGqlType>;
  examImageSecurityConfiguration?: Maybe<ExamImageSecurityConfigurationGqlType>;
  retakeSecurityConfiguration?: Maybe<RetakeSecurityConfigurationGqlType>;
  scoreComparisonSecurityConfiguration?: Maybe<ScoreComparisonSecurityConfigurationGqlType>;
  similarityIndexConfiguration?: Maybe<SimilarityIndexConfigurationGqlType>;
  timeSpentSecurityConfiguration?: Maybe<TimeSpentSecurityConfigurationGqlType>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Credential
 * 
 *  - Requires All Permissions: Candidate.CredentialDetails.View
 * 
 *  - Must have candidate access
 *
 */
export interface SelfExtensionCertProcessRequest {
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  date?: Maybe<Scalars['CmDate']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Byte']['output']>;
  requested?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  state?: Maybe<CprState>;
  type?: Maybe<CprType>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

export interface SelfRegisteredCandidateAccount {
  cmcId: Scalars['Int']['output'];
  dpExternalId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
}

export interface SelfRegistration {
  clientAlias: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface SelfRegistrationRequest {
  addr1Business?: InputMaybe<Scalars['String']['input']>;
  addr1City?: InputMaybe<Scalars['String']['input']>;
  addr1CountryCode?: InputMaybe<Scalars['String']['input']>;
  addr1FaxNumber?: InputMaybe<Scalars['String']['input']>;
  addr1Line1?: InputMaybe<Scalars['String']['input']>;
  addr1Line2?: InputMaybe<Scalars['String']['input']>;
  addr1Line3?: InputMaybe<Scalars['String']['input']>;
  addr1PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  addr1PostalCode?: InputMaybe<Scalars['String']['input']>;
  addr1State?: InputMaybe<Scalars['String']['input']>;
  addr2Business?: InputMaybe<Scalars['String']['input']>;
  addr2City?: InputMaybe<Scalars['String']['input']>;
  addr2CountryCode?: InputMaybe<Scalars['String']['input']>;
  addr2FaxNumber?: InputMaybe<Scalars['String']['input']>;
  addr2Line1?: InputMaybe<Scalars['String']['input']>;
  addr2Line2?: InputMaybe<Scalars['String']['input']>;
  addr2Line3?: InputMaybe<Scalars['String']['input']>;
  addr2PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  addr2PostalCode?: InputMaybe<Scalars['String']['input']>;
  addr2State?: InputMaybe<Scalars['String']['input']>;
  affiliation?: InputMaybe<UpdateCandidateAffiliationRequest>;
  clientAlias?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  emailAddr?: InputMaybe<Scalars['String']['input']>;
  localizedAddr1City?: InputMaybe<Scalars['String']['input']>;
  localizedAddr1Line1?: InputMaybe<Scalars['String']['input']>;
  localizedAddr1Line2?: InputMaybe<Scalars['String']['input']>;
  localizedAddr1Line3?: InputMaybe<Scalars['String']['input']>;
  localizedAddr1PostalCode?: InputMaybe<Scalars['String']['input']>;
  localizedAddr1State?: InputMaybe<Scalars['String']['input']>;
  localizedCompanyName?: InputMaybe<Scalars['String']['input']>;
  localizedNameFirst?: InputMaybe<Scalars['String']['input']>;
  localizedNameLast?: InputMaybe<Scalars['String']['input']>;
  nameFirst?: InputMaybe<Scalars['String']['input']>;
  nameLast?: InputMaybe<Scalars['String']['input']>;
  preferredNameFirst?: InputMaybe<Scalars['String']['input']>;
  preferredNameLast?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
}

export interface SelfRegistrationResponse {
  email?: Maybe<Scalars['String']['output']>;
}

export interface SendTestEmail {
  /** The context id for this request e.g. catalog id */
  contextId?: InputMaybe<Scalars['Int']['input']>;
  /** The culture for this request. */
  culture?: InputMaybe<Scalars['String']['input']>;
  /** The test email to send mail to. */
  email: Scalars['String']['input'];
  /** The context for this email. Optional. */
  emcatContext?: InputMaybe<EmcatContext>;
  /** The email catalog type for this request. */
  emcatType: EmcatType;
}

export interface SendTranscriptEmailRequest {
  /** The candidate ID (cmc_id) */
  candidateId: CandidateIdRequest;
  /** The language/culture code for the email (e.g., 'en', 'es', 'ja'). If not provided, will default to 'en'. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** The recipient email address */
  recipientEmail: Scalars['String']['input'];
  /** The transcript external ID (ctran_external_id) */
  transcriptId: Scalars['String']['input'];
  /** The transcript URL */
  transcriptUrl: Scalars['String']['input'];
  /** URL token value ({URL}) */
  url?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Defines arbitrary lists of items that a candidate can be associated with.
 * 
 * 
 *  - Requires All Features: CandidateProfileCustomDataSettings
 *
 */
export interface SettingCatalog {
  /** Indicates if a candidate can edit their own selection(s)/association(s) with items in the list  */
  candidateEdit: Scalars['Boolean']['output'];
  /**
   * Indicates if candidates can see their own selection(s)/association(s) to items in the list
   * 
   *  - Disallowed Account Types: Candidate
   */
  candidateView: Scalars['Boolean']['output'];
  /** The description of what the list means to the candidate. */
  description?: Maybe<Scalars['String']['output']>;
  /** This is used to override the default sorting of the lists: alphabetical by the name being displayed.  */
  displayOrder?: Maybe<Scalars['Int']['output']>;
  /** This is a unique ID to be used */
  externalId?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates if this setting can be used to restrict WebUser access to Candidates based on the selection made.
   * 
   *  - Disallowed Account Types: Candidate
   */
  forWebFilter: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** When false, a candidate should only be associated with a single item (or none) from the list; a drop-down in the UI.  */
  multiSelect: Scalars['Boolean']['output'];
  /** The display name of the setting. */
  name: Scalars['String']['output'];
  /** The abbreviated name of the list.  */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates if only the candidate is allowed to edit their selections/associations to items in the list.
   * 
   *  - Disallowed Account Types: Candidate
   */
  protectedEdit: Scalars['Boolean']['output'];
  /** Indicates if candidates are required to have at least one selection (association to items) in the list. Only relevant when candidates are allowed to edit their selections/associations.  */
  required: Scalars['Boolean']['output'];
  /** The items/options defined for this list. */
  settingItems?: Maybe<Array<Maybe<SettingItem>>>;
  /**
   * Indicates if a non-admin user can edit the associations with items in a viewable list.
   * 
   *  - Disallowed Account Types: Candidate
   */
  userEdit: Scalars['Boolean']['output'];
  /**
   * Indicates if users can see association(s) to items in the list (theirs or others);
   * 
   *  - Disallowed Account Types: Candidate
   */
  userView: Scalars['Boolean']['output'];
}

/**
 * Defines an item (options) within a custom-settings list in the catalog. These are what a candidate selects as part of what is considered their settings.
 * 
 * 
 *  - Requires All Features: CandidateProfileCustomDataSettings
 *
 */
export interface SettingItem {
  /** This is used to control the sorting of the list-items when displayed. When NULL, order is by name (ASC). NULL display-orders always come after non-NULL. */
  displayOrder?: Maybe<Scalars['Short']['output']>;
  /** This is a unique ID to be used (instead of the Id) */
  externalId?: Maybe<Scalars['String']['output']>;
  /** This is used to define and associate an item with a name that is to be used to group items in a list together.  */
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** The display name/label/text of the item. */
  name: Scalars['String']['output'];
  /** The abbreviated name/label/text of the item. */
  nameAbbr?: Maybe<Scalars['String']['output']>;
  /** The catalog/definition of the item. */
  settingCatalog?: Maybe<SettingCatalog>;
  settingCatalogId: Scalars['Int']['output'];
}

export enum ShistType {
  /** EditBcat */
  EditBcat = 'EditBcat',
  /** EditCcat */
  EditCcat = 'EditCcat',
  /** EditCg */
  EditCg = 'EditCg',
  /** EditClientFeature */
  EditClientFeature = 'EditClientFeature',
  /** EditClientRole */
  EditClientRole = 'EditClientRole',
  /** EditClientRolePermissions */
  EditClientRolePermissions = 'EditClientRolePermissions',
  /** EditCocat */
  EditCocat = 'EditCocat',
  /** EditCog */
  EditCog = 'EditCog',
  /** EditCrcat */
  EditCrcat = 'EditCrcat',
  /** EditCrg */
  EditCrg = 'EditCrg',
  /** EditEg */
  EditEg = 'EditEg',
  /** EditEmcat */
  EditEmcat = 'EditEmcat',
  /** EditExcat */
  EditExcat = 'EditExcat',
  /** EditIcat */
  EditIcat = 'EditIcat',
  /** EditLocalization */
  EditLocalization = 'EditLocalization',
  /** EditNewsArticle */
  EditNewsArticle = 'EditNewsArticle',
  /** EditSecat */
  EditSecat = 'EditSecat'
}

export interface SignLatestAgreementRequest {
  candidateId?: InputMaybe<CandidateIdRequest>;
  /** When the signature happened. */
  effective?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
}

export interface SimilarityIndexConfigurationGqlType {
  unparsedConfig?: Maybe<Scalars['String']['output']>;
}

/** Response containing available testing sites and times */
export interface SiteAvailabilityResponse {
  /** The list of available testing sites */
  results?: Maybe<Array<Maybe<SiteResult>>>;
  /** The total number of results */
  totalResults?: Maybe<Scalars['Int']['output']>;
}

/** Request parameters for finding available exam slots at a specific site */
export interface SiteAvailableSlotsRequest {
  /** The end date to search for available slots (inclusive) */
  endDate: Scalars['DateTime']['input'];
  /** The exam code */
  examCode: Scalars['String']['input'];
  /** The unique identifier of the site to search for available slots */
  siteId: Scalars['String']['input'];
  /** The start date to search for available slots (inclusive) */
  startDate: Scalars['DateTime']['input'];
}

/** Information about a testing site */
export interface SiteResult {
  /** List of available dates and times at this site */
  availability?: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
  /** The API URL for the site */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the site */
  id?: Maybe<Scalars['String']['output']>;
  /** The location information for the site */
  location?: Maybe<Location>;
  /** The management type identifier for the site */
  managementTypeId?: Maybe<Scalars['Int']['output']>;
  /** The site prefix */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The type of testing site */
  type?: Maybe<Scalars['String']['output']>;
}

/** Response containing exam itinerary and available time slots for a site */
export interface SiteSlotsAvailabilityResponse {
  /** The list of items in the site exam itinerary */
  itinerary?: Maybe<Array<Maybe<ItinerarySite>>>;
  /** The list of suggested time slots for the site */
  suggestions?: Maybe<Array<Maybe<SuggestionSiteSlots>>>;
}

/** A time slot for an exam at a specific site */
export interface SlotSite {
  /** The duration of the slot in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  /** The group identifier for this slot */
  groupId?: Maybe<Scalars['Int']['output']>;
  /** The API URL for the slot */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the slot */
  id?: Maybe<Scalars['String']['output']>;
  /** The session identifier for this slot */
  sessionId?: Maybe<Scalars['Int']['output']>;
  /** The start date and time for this slot */
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
}

export interface SnowflakeBulkUploadCommunityIdRequest {
  communityId: Scalars['String']['input'];
  snowId: Scalars['String']['input'];
}

export interface SnowflakeBulkUploadCommunityIdRequestList {
  requestList: Array<InputMaybe<SnowflakeBulkUploadCommunityIdRequest>>;
}

export interface SnowflakeBulkUploadCommunityIdResponse {
  candidateId?: Maybe<Scalars['String']['output']>;
  snowId?: Maybe<Scalars['String']['output']>;
  updateStatus?: Maybe<BulkUploadCommunityIdUpdateStatus>;
}

export interface SnowflakeBulkUploadOtherRequirementRequest {
  completionDate: Scalars['CmDate']['input'];
  /** ILT course identifier (creq external id) */
  courseId?: InputMaybe<Scalars['String']['input']>;
  /** A unique creqId for each training completed by a candidate stored in the creq_external_ID */
  recordId?: InputMaybe<Scalars['String']['input']>;
  /** CM External Id */
  snowId?: InputMaybe<Scalars['String']['input']>;
}

export interface SnowflakeBulkUploadOtherRequirementRequestList {
  requestList: Array<InputMaybe<SnowflakeBulkUploadOtherRequirementRequest>>;
}

export interface SnowflakeBulkUploadOtherRequirementResponse {
  completionDate?: Maybe<Scalars['CmDate']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
  snowId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
}

export interface SnowflakeToolsMutations {
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: CandidateProfile.ManageCandidateId.Modify
   * 
   *  - Must have candidate access
   *
   */
  bulkUploadCommunityId?: Maybe<Array<Maybe<SnowflakeBulkUploadCommunityIdResponse>>>;
  /**
   * 
   * 
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, OtherRequirementUpload
   * 
   *  - Requires Any Features: CredentialAchievements, OtherRequirement, CredentialAgreement, CredentialContinuingEducation
   * 
   *  - Requires All Permissions: Candidate.Requirements.Miscellaneous.Modify, Candidate.CredentialAgreements.Modify, Candidate.Requirements.ExternalCert.Modify, Candidate.Requirements.ContinuingEducation.Modify, Candidate.Requirements.ProgramFee.Modify, Candidate.Requirements.Enrollment.Modify, Candidate.Requirements.Training.Modify, Candidate.Requirements.Lab.Modify, Candidate.Requirements.ExternalExam.Modify, Candidate.Requirements.Participation.Modify, Candidate.Requirements.AdditionalAgreement.Modify
   * 
   *  - Must have candidate access
   *
   */
  bulkUploadOtherRequirement?: Maybe<Array<Maybe<SnowflakeBulkUploadOtherRequirementResponse>>>;
}


export interface SnowflakeToolsMutationsBulkUploadCommunityIdArgs {
  request: SnowflakeBulkUploadCommunityIdRequestList;
}


export interface SnowflakeToolsMutationsBulkUploadOtherRequirementArgs {
  request: SnowflakeBulkUploadOtherRequirementRequestList;
}

/** The name and sort direction for a table request. */
export interface SortRequest {
  /** Whether the sorting will be Descending or not. Defaults to false. */
  sortDescending?: InputMaybe<Scalars['Boolean']['input']>;
  /** The field to sort by. */
  sortField?: InputMaybe<Scalars['String']['input']>;
}

/** Contains a variety of helper links for candidate egress sso. */
export interface SsoEgress {
  certiverse?: Maybe<CertiverseSsoEgress>;
  kryterion?: Maybe<KryterionSsoEgress>;
  pearsonVue?: Maybe<PearsonVueSsoEgress>;
  psi?: Maybe<PsiSsoEgress>;
  xvoucher?: Maybe<XvoucherSsoEgress>;
}

export interface StagingActivityResponse {
  elapsed?: Maybe<Scalars['Seconds']['output']>;
  elapsedImport?: Maybe<Scalars['Seconds']['output']>;
  elapsedMatching?: Maybe<Scalars['Seconds']['output']>;
  elapsedPostImport?: Maybe<Scalars['Seconds']['output']>;
  elapsedSanitation?: Maybe<Scalars['Seconds']['output']>;
  elapsedVerification?: Maybe<Scalars['Seconds']['output']>;
  errors?: Maybe<Scalars['Int']['output']>;
  inserted?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  script: Scalars['String']['output'];
  skipped?: Maybe<Scalars['Int']['output']>;
  started: Scalars['CmDateTimeOffset']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
}

export interface StagingCandidate {
  address1City?: Maybe<Scalars['String']['output']>;
  address1CountryCode?: Maybe<Scalars['String']['output']>;
  address1Line1?: Maybe<Scalars['String']['output']>;
  address1Line2?: Maybe<Scalars['String']['output']>;
  address1Line3?: Maybe<Scalars['String']['output']>;
  address1PostalCode?: Maybe<Scalars['String']['output']>;
  address1State?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  dataProvider?: Maybe<DataProvider>;
  email?: Maybe<Scalars['String']['output']>;
  emailMatchCount?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isConfidentMatch?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdate?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  matchedCandidate?: Maybe<Candidate>;
  state?: Maybe<StagingState>;
  stateMessage?: Maybe<Scalars['String']['output']>;
}

export enum StagingCandidateAction {
  /** CreateNew */
  CreateNew = 'CreateNew',
  /** Merge */
  Merge = 'Merge',
  /** MergeAndApprove */
  MergeAndApprove = 'MergeAndApprove',
  /** Reject */
  Reject = 'Reject'
}

export interface StagingCertRequirement {
  certRequirementCatalog?: Maybe<CertRequirementCatalog>;
  certRequirementCatalogExternalId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  dataProvider?: Maybe<DataProvider>;
  email?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdate?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  matchedCandidate?: Maybe<Candidate>;
  state?: Maybe<StagingState>;
  stateMessage?: Maybe<Scalars['String']['output']>;
}

export enum StagingCertRequirementAction {
  /** Reject */
  Reject = 'Reject'
}

export interface StagingExam {
  authorizationId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  dataProvider?: Maybe<DataProvider>;
  dataProviderCandidateId?: Maybe<Scalars['String']['output']>;
  examCatalog?: Maybe<ExamCatalog>;
  examDateTime?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  matchedCandidate?: Maybe<Candidate>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  seriesCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StagingState>;
  stateMessage?: Maybe<Scalars['String']['output']>;
  testCenterId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export enum StagingExamAction {
  /** AdjustAuthorizationId */
  AdjustAuthorizationId = 'AdjustAuthorizationId',
  /** AdjustDate */
  AdjustDate = 'AdjustDate',
  /** Reject */
  Reject = 'Reject',
  /** Retry */
  Retry = 'Retry'
}

export interface StagingImportActivity {
  candidates?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  creqs?: Maybe<Scalars['Int']['output']>;
  dataProvider?: Maybe<DataProvider>;
  elapsed?: Maybe<Scalars['Milliseconds']['output']>;
  exams?: Maybe<Scalars['Int']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Int']['output']>;
  records?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Scalars['Int']['output']>;
  sections?: Maybe<Scalars['Int']['output']>;
  started: Scalars['CmDateTimeOffset']['output'];
  surveys?: Maybe<Scalars['Int']['output']>;
}

export interface StagingImportActivityRequest {
  fileName?: InputMaybe<Scalars['String']['input']>;
  importDate?: InputMaybe<Scalars['CmDate']['input']>;
}

export enum StagingState {
  /** Completed */
  Completed = 'Completed',
  /** CompletedRejected */
  CompletedRejected = 'CompletedRejected',
  /** CompletedSkipped */
  CompletedSkipped = 'CompletedSkipped',
  /** Import */
  Import = 'Import',
  /** ImportInvalidData */
  ImportInvalidData = 'ImportInvalidData',
  /** ImportMissingConfig */
  ImportMissingConfig = 'ImportMissingConfig',
  /** ImportMissingData */
  ImportMissingData = 'ImportMissingData',
  /** ImportWaitRetry */
  ImportWaitRetry = 'ImportWaitRetry',
  /** Matching */
  Matching = 'Matching',
  /** MatchingInvalidData */
  MatchingInvalidData = 'MatchingInvalidData',
  /** MatchingMismatch */
  MatchingMismatch = 'MatchingMismatch',
  /** MatchingMissingConfig */
  MatchingMissingConfig = 'MatchingMissingConfig',
  /** MatchingMissingData */
  MatchingMissingData = 'MatchingMissingData',
  /** MatchingNeitherMatched */
  MatchingNeitherMatched = 'MatchingNeitherMatched',
  /** MatchingOrphanWaitRetry */
  MatchingOrphanWaitRetry = 'MatchingOrphanWaitRetry',
  /** MatchingWaitRetry */
  MatchingWaitRetry = 'MatchingWaitRetry',
  /** PostImport */
  PostImport = 'PostImport',
  /** PostImportInvalidData */
  PostImportInvalidData = 'PostImportInvalidData',
  /** PostImportMissingConfig */
  PostImportMissingConfig = 'PostImportMissingConfig',
  /** PostImportMissingData */
  PostImportMissingData = 'PostImportMissingData',
  /** PostImportWaitRetry */
  PostImportWaitRetry = 'PostImportWaitRetry',
  /** Sanitation */
  Sanitation = 'Sanitation',
  /** SanitationInvalidData */
  SanitationInvalidData = 'SanitationInvalidData',
  /** SanitationInvalidDate */
  SanitationInvalidDate = 'SanitationInvalidDate',
  /** SanitationMissingConfig */
  SanitationMissingConfig = 'SanitationMissingConfig',
  /** SanitationMissingData */
  SanitationMissingData = 'SanitationMissingData',
  /** SanitationMissingDpID */
  SanitationMissingDpId = 'SanitationMissingDpID',
  /** SanitationWaitRetry */
  SanitationWaitRetry = 'SanitationWaitRetry',
  /** Verification */
  Verification = 'Verification',
  /** VerificationDubiousMatch */
  VerificationDubiousMatch = 'VerificationDubiousMatch',
  /** VerificationInvalidData */
  VerificationInvalidData = 'VerificationInvalidData',
  /** VerificationMissingConfig */
  VerificationMissingConfig = 'VerificationMissingConfig',
  /** VerificationMissingData */
  VerificationMissingData = 'VerificationMissingData',
  /** VerificationNameMismatch */
  VerificationNameMismatch = 'VerificationNameMismatch',
  /** VerificationOrphanWaitRetry */
  VerificationOrphanWaitRetry = 'VerificationOrphanWaitRetry',
  /** VerificationWaitRetry */
  VerificationWaitRetry = 'VerificationWaitRetry'
}

/**
 * 
 * 
 * 
 *  - Requires Any Permissions: CredentialAchievements.Catalog.View
 *
 */
export interface StandingRule {
  catalog?: Maybe<CertCatalog>;
  /** The recursive list of Standing Rules in this Standing Rule. */
  children?: Maybe<Array<Maybe<StandingRule>>>;
  duration?: Maybe<Scalars['Int']['output']>;
  /** Whether this Standing Rule is a terminating item in the recursive list. */
  itemType?: Maybe<ItemNodeType>;
  numRequired?: Maybe<Scalars['Byte']['output']>;
  /** The cert's external Id. */
  targetExternalId?: Maybe<Scalars['String']['output']>;
}

export interface StartCandidateSelfMergeRequest {
  canVerifyEmail: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
}

/** A suggestion containing available time slots for a site */
export interface SuggestionSiteSlots {
  /** The list of available time slots in this site suggestion */
  slots?: Maybe<Array<Maybe<SlotSite>>>;
}

export interface SwitchToAutomaticJurisdictionsRequest {
  cSetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
}

export interface SwitchToManualJurisdictionsRequest {
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface SystemHistory {
  created: Scalars['CmDateTimeOffset']['output'];
  /** Indicates the account that created the system history entry. */
  creator: Scalars['String']['output'];
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  id: Scalars['Int']['output'];
  /** The message that was logged */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * This points to the appropriate record.
   * 
   * Searchable.
   */
  targetId?: Maybe<Scalars['Int']['output']>;
  /**
   * The type of the history entry.
   * 
   * Searchable.
   */
  type: ShistType;
}

/**
 * An organisational section of tags.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Tagging
 * 
 *  - Requires All Permissions: Tagging.Catalog.View
 *
 */
export interface TagDomain {
  /** Whether or not this tag has been disabled. */
  disabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** The name of the domain. */
  name: Scalars['String']['output'];
  /** The item names for this domain */
  tagItemNameList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The type of domain, used by internal scripts to identify non-editable domains.
   * 
   * 
   *  - Requires All Permissions: Tagging.Catalog.View
   *
   */
  type: RtdType;
}

/** An organizational section of tags. */
export interface TagDomainDetail {
  /** Whether or not this tag has been disabled. */
  disabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** The name of the domain. */
  name: Scalars['String']['output'];
  /** The items for this domain */
  tagItemList?: Maybe<Array<Maybe<TagItem>>>;
  /** The item names for this domain */
  tagItemNameList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The type of domain, used by internal scripts to identify non-editable domains.
   * 
   * 
   *  - Requires All Permissions: Tagging.Catalog.View
   *
   */
  type: RtdType;
}


/** An organizational section of tags. */
export interface TagDomainDetailTagItemListArgs {
  request?: InputMaybe<RequestByExternalId>;
}

/**
 * A tag linked to a catalog.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Features: Tagging
 * 
 *  - Requires All Permissions: Tagging.Catalog.View
 *
 */
export interface TagItem {
  catalogId: Scalars['Int']['output'];
  /** The type of catalog referred to in the CatalogId. */
  catalogType: RtiCatIdType;
  /** When set, this indicates that this relates to a Certification. */
  certCatalog?: Maybe<CertCatalog>;
  /** When set, this indicates that this relates to a Certification Requirement. */
  certRequirementCatalog?: Maybe<CertRequirementCatalog>;
  /** When set, this indicates that this relates to an Exam. */
  examCatalog?: Maybe<ExamCatalog>;
  id: Scalars['Int']['output'];
  /** When set, this indicates that this relates to an Other Achievement. */
  otherAchievementCatalog?: Maybe<OtherAchievementCatalog>;
  /** The name of the tag. */
  tagName: Scalars['String']['output'];
}

/** Information about a test delivery vendor's unique Test Center location. */
export interface TestCenter {
  /** The country that this test center is in. */
  country?: Maybe<IsoCountry>;
  /** This is the unique 3-char ISO-3166-1 code for the country that this test center belongs to. */
  countryCode: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   *
   */
  created: Scalars['DateTime']['output'];
  /** More information about the data provider indicated by the DpId (e.g. a data provider has its own ExternalId). */
  dataProvider?: Maybe<DataProvider>;
  /** The unique Id (PK) of the data provider that delivered the Exam. This is considered the domain/context/scope within which the Exam.RegistrationNumber is unique. */
  dataProviderId?: Maybe<Scalars['Int']['output']>;
  /** The full, globally-unique ISO subdivision code. */
  examTestCenterId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** The name of the Test Center per the test delivery vendor. */
  name: Scalars['String']['output'];
}

/** Test information in a site itinerary */
export interface TestSites {
  /** The duration of the test in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Reference to the exam being taken at the site */
  exam?: Maybe<PrometricInfo>;
  /** The session number for this test */
  session?: Maybe<Scalars['Int']['output']>;
}

export interface TestrunSubscriptionConfiguration {
  /** The tlanguage code. */
  language?: Maybe<Scalars['String']['output']>;
  /** The paddle price ID. */
  paddlePriceId?: Maybe<Scalars['String']['output']>;
  /** The testrun program ID. */
  programId?: Maybe<Scalars['String']['output']>;
}

export interface TimeSpentSecurityConfigurationGqlType {
  unparsedConfig?: Maybe<Scalars['String']['output']>;
}

/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface Tools {
  /**
   * Lists all client exports available to test run.
   * 
   * 
   *  - Internal accounts only
   *
   */
  availableExports?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  awsTools?: Maybe<AwsTools>;
  /** A list of all banned candidates. */
  bannedCandidateList?: Maybe<Array<Maybe<BannedCandidatesReport>>>;
  /**
   * A list of all benefit vouchers that have a limited number available, along with the number still available.
   * 
   * 
   *  - Requires All Permissions: Benefit.Catalog.View
   *
   */
  benefitVoucherCount?: Maybe<Array<Maybe<VoucherCount>>>;
  /** A list of all cert requirements under review. */
  certRequirementUnderReviewList?: Maybe<Array<Maybe<CertRequirementUnderReviewResponse>>>;
  ciscoTools?: Maybe<CiscoTools>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ComptiaCustomDashboardReports
   *
   */
  comptiaReports?: Maybe<ComptiaReports>;
  /**
   * The currently selected client.
   * 
   * 
   *  - Internal accounts only
   *
   */
  currentClient?: Maybe<Scalars['String']['output']>;
  /**
   * A list of all the currently enabled clients by their default client alias.
   * 
   * 
   *  - Internal accounts only
   *
   */
  defaultClientAliasList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Gets the logic xml.
   * 
   * 
   *  - Internal accounts only
   *
   */
  downloadLogic?: Maybe<Scalars['String']['output']>;
  /** A list of all downloadable reports for this user. */
  downloadableReportList?: Maybe<Array<Maybe<DownloadableReport>>>;
  /**
   * A list of all duplicate candidate badge ids
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
   * 
   *  - Requires All Permissions: DuplicateCandidates.Email.View
   *
   */
  duplicateCandidateBadgeList?: Maybe<Array<Maybe<DuplicateCandidateResponse>>>;
  /**
   * A list of all duplicate candidates by name, country and company
   * 
   * 
   *  - Requires All Permissions: DuplicateCandidates.Email.View
   *
   */
  duplicateCandidateDemographicsList?: Maybe<Array<Maybe<DuplicateCandidateResponse>>>;
  /**
   * A count of all duplicate candidate email addresses
   * 
   * 
   *  - Requires All Permissions: DuplicateCandidates.Email.View
   *
   */
  duplicateCandidateEmailAddressCount?: Maybe<Scalars['Int']['output']>;
  /**
   * A list of all duplicate candidate email addresses
   * 
   * 
   *  - Requires All Permissions: DuplicateCandidates.Email.View
   *
   */
  duplicateCandidateEmailAddressList?: Maybe<Array<Maybe<DuplicateCandidateResponse>>>;
  /**
   * A list of all duplicate candidate phone numbers
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationDuplicatePhoneNumberQueue
   * 
   *  - Requires All Permissions: DuplicateCandidates.Phone.View
   *
   */
  duplicateCandidatePhoneNumberList?: Maybe<Array<Maybe<DuplicateCandidateResponse>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: Exam
   *
   */
  examEventDiscountList?: Maybe<Array<Maybe<ExamEventDiscount>>>;
  /** A list of all exams under review. */
  examUnderReviewList?: Maybe<Array<Maybe<ExamUnderReviewResponse>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: NcarbReports
   * 
   *  - Requires All Permissions: Reports.Custom.Ncarb.Eligibility.View
   *
   */
  ncarbReports?: Maybe<NcarbReports>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ToolsNCARBTools
   *
   */
  ncarbToolsQueries?: Maybe<NcarbToolsQueries>;
  /** The detail type for newly imported exams from the last 30 days. */
  newlyImportedExamDetail?: Maybe<Array<Maybe<NewlyImportedExamDetail>>>;
  /** A list of all newly imported exams from the last 30 days. */
  newlyImportedExamsList?: Maybe<Array<Maybe<NewlyImportedExams>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ExamAccommodations
   * 
   *  - Requires All Permissions: Exam.Accommodations.View
   *
   */
  pendingExamAccommList?: Maybe<Array<Maybe<PendingExamAccomm>>>;
  /** The detail type for the recently re-imported exams from the last 30 days. */
  recentlyReImportedExamsDetail?: Maybe<Array<Maybe<RecentlyReImportedExamDetail>>>;
  /** A list of all recently re-imported exams from the last 30 days. */
  recentlyReImportedExamsList?: Maybe<Array<Maybe<RecentlyReImportedExams>>>;
  securityConfigurations?: Maybe<SecurityConfigurationsGqlType>;
  /**
   * Daily summary of staging data.
   * 
   * 
   *  - Internal accounts only
   *
   */
  stagingActivityList?: Maybe<Array<Maybe<StagingActivityResponse>>>;
  /**
   * A count of all current staging issues that require resolution.
   * 
   * 
   *  - Internal accounts only
   *
   */
  stagingCandidateErrorCount?: Maybe<Scalars['Int']['output']>;
  /**
   * A complete list of all current staging issues that require resolution.
   * 
   * 
   *  - Internal accounts only
   *
   */
  stagingCandidateErrorList?: Maybe<Array<Maybe<StagingCandidate>>>;
  /**
   * A count of all current staging issues that require resolution.
   * 
   * 
   *  - Internal accounts only
   *
   */
  stagingCertRequirementErrorCount?: Maybe<Scalars['Int']['output']>;
  /**
   * A complete list of all current staging issues that require resolution.
   * 
   * 
   *  - Internal accounts only
   *
   */
  stagingCertRequirementErrorList?: Maybe<Array<Maybe<StagingCertRequirement>>>;
  /**
   * A count of all current staging issues that require resolution.
   * 
   * 
   *  - Internal accounts only
   *
   */
  stagingExamErrorCount?: Maybe<Scalars['Int']['output']>;
  /**
   * A complete list of all current staging issues that require resolution.
   * 
   * 
   *  - Internal accounts only
   *
   */
  stagingExamErrorList?: Maybe<Array<Maybe<StagingExam>>>;
  /**
   * A complete list of all current staging exams that are pending information.
   * 
   * 
   *  - Internal accounts only
   *
   */
  stagingExamPendingList?: Maybe<Array<Maybe<StagingExam>>>;
  /**
   * Daily summary of staging import data.
   * 
   * 
   *  - Requires All Permissions: ImportActivity.View
   *
   */
  stagingImportActivityList?: Maybe<Array<Maybe<StagingImportActivity>>>;
  /**
   * Filter staging imports.
   * 
   * 
   *  - Requires All Permissions: ImportActivity.View
   *
   */
  stagingImportFileList?: Maybe<Array<Maybe<StagingImportActivity>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ValidationCodeVerification
   * 
   *  - Requires All Permissions: VerifyValidationCode.Modify
   *
   */
  validationCode?: Maybe<Array<Maybe<ValidationCode>>>;
  vmwareTools?: Maybe<VmwareTools>;
  /** A list of all watched candidates. */
  watchedCandidateList?: Maybe<Array<Maybe<WatchedCandidatesReport>>>;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsDuplicateCandidateEmailAddressCountArgs {
  requestConfig?: InputMaybe<RequestConfig>;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsDuplicateCandidateEmailAddressListArgs {
  requestConfig?: InputMaybe<RequestConfig>;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsNewlyImportedExamDetailArgs {
  request?: InputMaybe<RequestConfig>;
  requestConfig?: InputMaybe<RequestConfig>;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsNewlyImportedExamsListArgs {
  request?: InputMaybe<RequestConfig>;
  requestConfig?: InputMaybe<RequestConfig>;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsRecentlyReImportedExamsDetailArgs {
  request?: InputMaybe<RequestConfig>;
  requestConfig?: InputMaybe<RequestConfig>;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsRecentlyReImportedExamsListArgs {
  request?: InputMaybe<RequestConfig>;
  requestConfig?: InputMaybe<RequestConfig>;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsStagingActivityListArgs {
  request: RequestByDateRange;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsStagingImportActivityListArgs {
  request: RequestByDateRange;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsStagingImportFileListArgs {
  request: StagingImportActivityRequest;
}


/**
 * Contains a variety of helper tools for web users.
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 */
export interface ToolsValidationCodeArgs {
  request: ValidationCodeRequest;
  requestConfig?: InputMaybe<RequestConfig>;
}

export interface TpmReport {
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  candidateFirstName?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  candidateLastName?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  ciscoId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['CmDate']['output']>;
  externalLoginId?: Maybe<Scalars['String']['output']>;
  initialPrivilegedDate?: Maybe<Scalars['CmDate']['output']>;
  program?: Maybe<Scalars['String']['output']>;
}

export interface TpmReportRequest {
  ccatIdList: Array<InputMaybe<Scalars['Int']['input']>>;
  externalIdList: Array<InputMaybe<Scalars['String']['input']>>;
}

export interface UnrevokeExamAuthorizationPackRequest {
  candidateId: CandidateIdRequest;
  expkId: Scalars['Int']['input'];
}

export interface UpdateAffiliationRequest {
  /** Makes the affiliation unable to be selected by a candidate. Does not remove the record from the database. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This pipe delimited list field, if not null, will require a candidate to enter something into the affiliation email field. The items in this field are the domains that are allowed in the email address. if this field is a blank stirng, anything can be entered. If sub-domains should match, start the pattern with the '@' character. To only include sub-domains, start the pattern with the '.' character. To turn this field into an exclusion list, start the pattern with the '!' character. */
  emailFormat?: InputMaybe<Scalars['String']['input']>;
  /** Determines if an email is required or not. If this field is left null, then an email can't be added at all. False means it can be added, but is not required. True means required. */
  emailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier used by any system outside certmetrics to identify the affiliation. If provided without the Id field, the mutation will attempt to update by this externalId. If no match is found, it will create a new affiliation with an externalId with the provided value. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The certmetrics id for the affiliation. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** This RegEx field, if not null, will require a candidate to enter something into the affiliation id field. This field determines how the information in the affiliation id field can look. If this field is a blank string, anything can be entered in affiliation id. */
  idFormat?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the affiliation. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** This RegEx field, if not null, will require a candidate to enter something into the company name field. This field determines how the information in the company name field can look. If this field is a blank string, anything can be entered in company name. */
  otherFormat?: InputMaybe<Scalars['String']['input']>;
  /** The group that this affiliation belongs to according to reports. If one affiliation belongs to a web group, they're all expected to. */
  reportGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines the type of affiliation. */
  type?: InputMaybe<AffType>;
  /** The group that this affiliation belongs to according to the website. This field is required to create a new affiliation. */
  webGroup?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Internal accounts only
 * 
 *  - Admin accounts only
 *
 */
export interface UpdateApiAccountRequest {
  /** If true, the api account is treated as if they have all permissions. */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If this is true, the account is allowed to access any candidate's data without consulting candidate-api-account or the candidate's API access code.
   * .
   */
  anyCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The api account being updated, either the id, or login id. */
  apiAccountId?: InputMaybe<ApiAccountIdRequest>;
  /** If true, the LoginToken will be replaced with an auto-generated guid. */
  autoGenerateLoginToken?: InputMaybe<Scalars['Boolean']['input']>;
  /** The email address of the person who is responsible for things on the client-side for this account. It is primarily important so we can notify the people on the other side of updates, down-times, etc. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the person who is responsible for things on the client-side for this account. It is primarily important so we can notify the people on the other side of updates, down-times, etc. */
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  /** If true, the api account is not allowed to access the api. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is true, candidates cannot see the account on the web site; they cannot allow/disallow the account&'s access to their data. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines the authority/context of the candidate client-id (from candidate-external-id) used in the API. When not set, use dp-id=1 (the id for the internal client-id). */
  idAuthority?: InputMaybe<Scalars['Int']['input']>;
  /** Link to cm_hub.dbo.data_provider. For data being created via the API this must NOT be NULL. */
  importDpId?: InputMaybe<Scalars['Int']['input']>;
  /** If true, the api account is internal to Alpine. */
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The login id for the api account. This is a method to authenticate with our api in the username/password methodology */
  loginId?: InputMaybe<Scalars['String']['input']>;
  /** The api account's login token used to access our api. */
  loginToken?: InputMaybe<Scalars['String']['input']>;
  /** The name of the api account. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the client-side's web site. This is so we have a link to send the candidates to when they want to find out more about the account---when they're deciding whether or not to grant the account access to their data. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** A comma-delimited list of IPv4/IPv6 networks that are allowed to create access tokens via this account.  If this is null/empty-string, the whitelist defaults to localhost (127.0.0.1/8). */
  whitelist?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateApiAccountRoles {
  /** The api account being updated, either the id, or login id. */
  apiAccountId?: InputMaybe<ApiAccountIdRequest>;
  /** A list of client role ids to add to the api account. */
  clientRolesToAdd?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of client role ids to delete from the api account. */
  clientRolesToDelete?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
}

export interface UpdateBadgeCatalogRequest {
  criteriaUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface UpdateBenefitCatalogLocaliedFieldsRequest {
  benefitCatalogId: Scalars['Int']['input'];
  /** The culture the instruction is localized for. */
  culture: Scalars['String']['input'];
  /** The description for the specific culture. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The instruction for the specific culture. */
  instruction?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateBenefitCatalogRequest {
  /** Indicates the last date that a candidate is able to claim a granted benefit. */
  claimEndDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** Used to override default sorting. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** A non-unique token to be used with all benefits granted of this type. */
  globalToken?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the associated benefit group. */
  groupId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  /** The name of the benefit. */
  name?: InputMaybe<Scalars['String']['input']>;
  nameAbbr?: InputMaybe<Scalars['String']['input']>;
  /** When true, indicates that the benefit should be visible, even if there is no underlying cert. */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** A url to be used to redirect candidates to if necessary by a benefit. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Indicates the last date candidates can view the benefit. */
  viewEndDate?: InputMaybe<Scalars['CmDate']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface UpdateBenefitCcatAssocRequest {
  bcatId: Scalars['Int']['input'];
  ccatId: Scalars['Int']['input'];
  grantEndDate?: InputMaybe<Scalars['CmDate']['input']>;
}

export interface UpdateBenefitGroupRequest {
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  id: Scalars['Int']['input'];
  /** Group display name. */
  name?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
 *
 */
export interface UpdateCandidateAffiliationRequest {
  /** The unique identifier for the Candidate at the affiliated organization. This value is restricted by the AffAffidFormat configured setting. */
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  /** The email address that the Candidate is known by at the affiliated organization. This value is restricted by the AffEmailRequired and AffEmailFormat configured settings. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the Affiliation that the Candidate will now be affiliated with. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A Candidate-supplied name of the affiliated organization. This value is restricted by the AffOtherFormat configured setting. */
  otherAffiliationName?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCandidateAttributeListRequest {
  /** A list of attributes to add/update for the candidate and their values. */
  attributeListToAdd?: InputMaybe<Array<InputMaybe<UpdateCandidateAttributeRequestVmGqlType>>>;
  /** A list of attributes to remove from the candidate (the value field will be ignored). */
  attributeListToDelete?: InputMaybe<Array<InputMaybe<UpdateCandidateAttributeRequestVmGqlType>>>;
  candidateId?: InputMaybe<CandidateIdRequest>;
}

export interface UpdateCandidateAttributeRequestVmGqlType {
  /** The name of the attribute to add/update or delete. */
  name: Scalars['String']['input'];
  /** When adding/updating, the value of the attribute to be created. When deleting, this value is ignored and should be null. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCandidateAuxiliaryRequest {
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
   *
   */
  affOtherOk?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.BannedStatus.Modify
   *
   */
  bannedUntil?: InputMaybe<Scalars['CmDate']['input']>;
  candidateId?: InputMaybe<CandidateIdRequest>;
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: ShareCertMetricsBadging
   *
   */
  certMetricsBadgingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: ShareCertMetricsBadging
   *
   */
  certMetricsBadgingIdentity?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.ImportSettings.Modify
   *
   */
  dmgrProtected?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.EmailPreferences.Modify
   *
   */
  emailLanguage?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.ImportSettings.Modify
   *
   */
  emailProtected?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   */
  fpHint?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   */
  fpPhrase?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  invalidateAllData?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.ImportSettings.Modify
   *
   */
  nameProtected?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: ApiAccount, WebUser
   *  - Requires All Features: CandidatePreferencesDisableEmails
   *
   */
  restrictEmcats?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires Any Features: ShareCredlyBadging, ShareAccredibleBadging
   * 
   *  - Admin accounts only
   *
   */
  restrictExternalBadging?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamTestCenterRestriction
   * 
   *  - Requires All Permissions: Candidate.RestrictTestingStatus.View, Candidate.RestrictTestingStatus.Modify
   *
   */
  restrictTesting?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamTestCenterRestriction, BulkCandidateTools
   *
   */
  token1?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamTestCenterRestriction, BulkCandidateTools
   *
   */
  token2?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamTestCenterRestriction, BulkCandidateTools
   *
   */
  token3?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: ExamTestCenterRestriction, BulkCandidateTools
   *
   */
  token4?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token5?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token6?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token7?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token8?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token9?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token10?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token11?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token12?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token13?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token14?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token15?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token16?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token17?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token18?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token19?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token20?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token21?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token22?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token23?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token24?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token25?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token26?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token27?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token28?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token29?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token30?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token31?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token32?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token33?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token34?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token35?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token36?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token37?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token38?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token39?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token40?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token41?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token42?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token43?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token44?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token45?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token46?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token47?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token48?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token49?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token50?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token51?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token52?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token53?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: BulkCandidateTools, BulkCandidateToolsAWSCustomBanEmailBulkTool
   *
   */
  token54?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.MergeSettings.Modify
   *
   */
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Permissions: Candidate.WatchStatus.Modify
   *
   */
  watchUntil?: InputMaybe<Scalars['CmDate']['input']>;
}

export interface UpdateCandidateAuxiliaryResponse {
  bannedEndDate?: Maybe<Scalars['DateTime']['output']>;
  candidateId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  restrictTesting?: Maybe<Scalars['Boolean']['output']>;
  updateStatus?: Maybe<Scalars['String']['output']>;
  watchEndDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface UpdateCandidateExternalIdRequest {
  candidateId?: InputMaybe<CandidateIdRequest>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileManageCandidateId
   * 
   *  - Requires All Permissions: CandidateProfile.ManageCandidateId.Modify
   *
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdateCandidateMergeRequest {
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.MergeDetails.Modify
   *
   */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  loserOverrides?: InputMaybe<Array<InputMaybe<CreateCandidateMergeLoserOverride>>>;
}

export interface UpdateCandidatePasswordRequest {
  candidateId?: InputMaybe<CandidateIdRequest>;
  /** When the change is effective. If this is equal - to or older than what is already in the system, the request is rejected. */
  effective?: InputMaybe<Scalars['String']['input']>;
  /** What the candidate's password will be changed to in plain text. */
  newPassword: Scalars['String']['input'];
  /** What the candidate's password currently is in plain text. */
  oldPassword?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCandidateRequest {
  /** Normally, a request will be rejected if no actual change will be made (assuming all other validation passes). But when this is true, that type of request would be accepted. */
  acceptIfNoChange?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1Business?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1City?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1CountryCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1FaxNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1Line1?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1Line2?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1Line3?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1PostalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesPrimary
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryAddress.Modify
   *
   */
  addr1State?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2Business?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2City?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2CountryCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2FaxNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2Line1?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2Line2?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2Line3?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2PostalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesSecondary
   * 
   *  - Requires All Permissions: CandidateProfile.SecondaryAddress.Modify
   *
   */
  addr2State?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationAffiliation
   * 
   *  - Requires All Permissions: Candidate.Affiliation.Modify
   *
   */
  affiliation?: InputMaybe<UpdateCandidateAffiliationRequest>;
  candidateId?: InputMaybe<CandidateIdRequest>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.Modify
   *
   */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /**
   * When the change is effective, updates the candidate's date of birth.
   * 
   * 
   *  - Requires All Permissions: Candidate.DateOfBirth.MOdify
   *
   */
  dateOfBirth?: InputMaybe<Scalars['CmDate']['input']>;
  /** When the change is effective. If this is equal - to or older than what is already in the system, the request is rejected. */
  effective?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.Modify
   *
   */
  emailAddr?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.Modify
   *
   */
  localizedAddr1City?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.Modify
   *
   */
  localizedAddr1Line1?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.Modify
   *
   */
  localizedAddr1Line2?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.Modify
   *
   */
  localizedAddr1Line3?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.Modify
   *
   */
  localizedAddr1PostalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileAddressesLocalized
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedAddress.Modify
   *
   */
  localizedAddr1State?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedInformation.Modify
   *
   */
  localizedCompanyName?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedInformation.Modify
   *
   */
  localizedNameFirst?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfileLocalizedInformation
   * 
   *  - Requires All Permissions: CandidateProfile.LocalizedInformation.Modify
   *
   */
  localizedNameLast?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.Names.Modify
   *
   */
  nameFirst?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformation
   * 
   *  - Requires All Permissions: CandidateProfile.PrimaryInformation.Names.Modify
   *
   */
  nameLast?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationPreferredName
   * 
   *  - Requires All Permissions: CandidateProfile.PreferredName.Modify
   *
   */
  preferredNameFirst?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: CandidateProfilePrimaryInformationPreferredName
   * 
   *  - Requires All Permissions: CandidateProfile.PreferredName.Modify
   *
   */
  preferredNameLast?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCandidateSettingFilterRequest {
  /** The id of the candidate setting filter to be updated. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The list of candidate setting ids to be assigned to a filter. */
  litemIdList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The name of the candidate setting filter to be updated. */
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCandidateSettingListRequest {
  candidateId?: InputMaybe<CandidateIdRequest>;
  /** A list of setting ids to add for the candidate. */
  settingListToAdd?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of setting ids to remove from the candidate. */
  settingListToDelete?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
}

export interface UpdateCandidateTranscriptInclusionsRequest {
  candidateId?: InputMaybe<CandidateIdRequest>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inclusions: Array<InputMaybe<RequestById>>;
}

export interface UpdateCandidateTranscriptRequest {
  addrDisplay?: InputMaybe<CtranAddrDisplay>;
  certDateOk?: InputMaybe<Scalars['Boolean']['input']>;
  creqDateOk?: InputMaybe<Scalars['Boolean']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayPreferredName?: InputMaybe<Scalars['Boolean']['input']>;
  examDateOk?: InputMaybe<Scalars['Boolean']['input']>;
  expireDate?: InputMaybe<Scalars['CmDate']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageOk?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllCerts?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllCreqs?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllExams?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllStandings?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  standingsDateOk?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdateCatalogAttachmentRequest {
  catchId?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetId?: InputMaybe<Scalars['Int']['input']>;
}

export interface UpdateCertCatalogMetadataRequest {
  /** The name of the attribute (key). */
  attributeName?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the cert catalog metadata to update. */
  id: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCertCatalogRequest {
  /** The date on which the Cert track went active, and, if applicable, when the logic engine started processing against this track. */
  activeDate?: InputMaybe<Scalars['CmDate']['input']>;
  /**
   * Enable the e-cert on this catalog.
   * 
   * 
   *  - Requires All Features: CredentialElectronicCertificate
   *
   */
  certificateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Enables the uploading of e-certs. Can not be disabled once enabled.
   * 
   * 
   *  - Requires All Features: CredentialElectronicCertificate
   *
   */
  certificateUploadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A short description of the cert catalog entry for public consumption. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Used to override default sorting. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  expireDate?: InputMaybe<Scalars['CmDate']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the associated cert group. */
  groupId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Should logo downloads be available to candidates.
   * 
   * 
   *  - Requires All Features: CredentialLogoDownload
   *
   */
  logoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAbbr?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  sunsetDate?: InputMaybe<Scalars['CmDate']['input']>;
  /**
   * If true, certs will not show up on a candidate transcript.
   * 
   * 
   *  - Requires All Features: ShareTranscript
   *
   */
  transcriptProhibited?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A public Url with information about the cert catalog entry.
   * 
   * 
   *  - Requires All Features: CredentialUrl
   *
   */
  url?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCertGroupRequest {
  /** An optional classification/family/type of the group; if any groups have this set (non-null), then all groups should have one set. The distinct list of all values in the table define the set of classifications used. */
  classification?: InputMaybe<Scalars['String']['input']>;
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  id: Scalars['Int']['input'];
  /** Group display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional grouping used instead of defaults built into the catalog. If using, must be on all groups. */
  program?: InputMaybe<Scalars['String']['input']>;
  /** Order of the program groups, if programs is used this must be set for all or alphabetical will be used. */
  programDisplayOrder?: InputMaybe<Scalars['Short']['input']>;
}

export interface UpdateCertLogicItemMetadataRequest {
  /** The name of the attribute (key). */
  attributeName?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the cert logic item metadata to update. */
  id: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCertLogicVersionRequest {
  approved: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
}

export interface UpdateCertRequirementCatalogMetadataRequest {
  /** The name of the attribute (key). */
  attributeName?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the cert requirement catalog metadata to update. */
  id: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCertRequirementCatalogRequest {
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  docRequired?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['CmDate']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** Catalog display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  providerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingUrl?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['CmDate']['input']>;
  transcriptEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCertRequirementGroupRequest {
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  id: Scalars['Int']['input'];
  /** Group display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional grouping used instead of defaults built into the catalog. If using, must be on all groups. */
  program?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCertRequirementRequest {
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  activeDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  cocatId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   *  - Requires All Features: OtherRequirementUploadCandidateAccess
   *
   */
  docChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  docLanguage?: InputMaybe<Scalars['String']['input']>;
  docNotes?: InputMaybe<Scalars['String']['input']>;
  emailComment?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  historyComment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  points?: InputMaybe<Scalars['Short']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  reviewState?: InputMaybe<CreqReviewState>;
  /**
   * 
   * 
   *  - Disallowed Account Types: Candidate
   */
  simulated?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdateClientFeatureRequest {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
}

/** Updates an existing client setting in the the client_settings table. */
export interface UpdateClientSettingRequest {
  /** The use of this field is determined by the setting; it may or may not be used at all. */
  csetDatetime?: InputMaybe<Scalars['CmDate']['input']>;
  csetId: Scalars['Int']['input'];
  /** The use of this field is determined by the setting; it may or may not be used at all. */
  csetInt?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the setting being controlled/defined. Names should be in PascalCase. */
  csetName?: InputMaybe<Scalars['String']['input']>;
  /** The use of this field is determined by the setting; it may or may not be used at all. This is used as COALESCE(nvarchar, varchar). */
  csetNvarchar?: InputMaybe<Scalars['String']['input']>;
  /** The use of this field is determined by the setting; it may or may not be used at all. This is used as COALESCE(nvarchar, varchar). */
  csetVarchar?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCrcatOverrideCatalogRequest {
  /** The Id of the CrcatOverrideGroup to which this catalog belongs. */
  cogId: Scalars['Int']['input'];
  /** Null means no override. Use 0 for no age restriction. */
  createAge?: InputMaybe<Scalars['Byte']['input']>;
  /** Used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** The latest date (inclusive) that the override is available to use when creating a creq; null for no restriction. */
  endDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** Null means no override. */
  factor?: InputMaybe<Scalars['Decimal']['input']>;
  /** The Id of the CrcatOverrideCatalog to update. */
  id: Scalars['Int']['input'];
  /** The name of the override catalog. */
  name: Scalars['String']['input'];
  /** Null means no override. Use 0 for no points. */
  points?: InputMaybe<Scalars['Short']['input']>;
  /** Null means no override, not what it means in the crcat table, however, setting it to less than what is ultimately used for points still behaves the same way. */
  pointsMax?: InputMaybe<Scalars['Short']['input']>;
  /** The earliest date (inclusive) that the override is available to use when creating a creq; null for no restriction. */
  startDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** The number of days that the override is available to use when creating a creq; null for no restriction. */
  validPeriod?: InputMaybe<Scalars['Short']['input']>;
}

export interface UpdateCredlyTemplateExpireDateRequest {
  catId: Scalars['Int']['input'];
  expireDate: Scalars['CmDate']['input'];
  templateId: Scalars['String']['input'];
  typeId: CateidType;
}

/**
 * Request parameters for updating an audit item.
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface UpdateCreqAuditItemRequest {
  /** The audit ID. */
  craId: Scalars['Int']['input'];
  /** The action to perform on the audit item. */
  craiAction: CraiActions;
  /** The audit item ID. */
  craiId: Scalars['Int']['input'];
  /** Notes about the audit item. */
  craiNotes?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Request parameters for updating an audit.
 * 
 * 
 *  - Requires All Features: OtherRequirementUploadCandidateAccessAudits
 * 
 *  - Requires All Permissions: Candidate.AuditHistory.Modify, Candidate.AuditHistory.View
 *
 */
export interface UpdateCreqAuditRequest {
  /** The action to take on the audit. No action to only insert a message. */
  action: CraAction;
  /** The cmc id of the candidate the audit belongs to. */
  cmcId: Scalars['Int']['input'];
  /** The due date for the audit, when set. Required when placing on hold. */
  dueDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** The id of the audit to edit. */
  id: Scalars['Int']['input'];
  /** Required when closing or placing on hold. */
  message: Scalars['String']['input'];
  /** Whether the message is private or not. */
  private?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdateEmailCatalogRequest {
  bcc?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  fromLabel?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
}

export interface UpdateEmailLocalizationRequest {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyPlain?: InputMaybe<Scalars['String']['input']>;
  catalogId: Scalars['Int']['input'];
  cultureInfoName?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateExamAccommPackRequest {
  docNotes?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires Any Permissions: Exam.Accommodations.Modify
   *
   */
  expireDate?: InputMaybe<Scalars['CmDate']['input']>;
  id: Scalars['Int']['input'];
  /**
   * 
   * 
   * 
   *  - Requires Any Permissions: Exam.Accommodations.Modify
   *
   */
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  /**
   * 
   * 
   * 
   *  - Requires Any Permissions: Exam.Accommodations.Modify
   *
   */
  reviewState?: InputMaybe<ExapReviewState>;
}

export interface UpdateExamAccommRequest {
  externalNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
}

export interface UpdateExamAuthorizationNcarbRequest {
  activeDate?: InputMaybe<Scalars['DateTime']['input']>;
  cmcId: Scalars['Int']['input'];
  expireDate?: InputMaybe<Scalars['DateTime']['input']>;
  expkId: Scalars['Int']['input'];
  isRevoked?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdateExamAuthorizationPackRequest {
  activeDate: Scalars['CmDateTimeOffset']['input'];
  candidateId: CandidateIdRequest;
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  expkId: Scalars['Int']['input'];
  sendOkDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
}

export interface UpdateExamCatalogMetadataRequest {
  /** The name of the attribute (key). */
  attributeName?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the exam catalog metadata to update. */
  id: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateExamCatalogRequest {
  /** A short description of the cert catalog entry for public consumption. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Used to override default sorting. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  /** The last date the exam is to be delivered. Does not affect cert-calculations. */
  endDate?: InputMaybe<Scalars['CmDate']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the associated exam group. */
  groupId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** When true, the maximum number of CE points will be used for the exam. */
  maximizePoints?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAbbr?: InputMaybe<Scalars['String']['input']>;
  /** The minimum number of CE points earned by this exam. */
  points?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of CE points that can be earned by this exam. */
  pointsMax?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A url to display for scheduling. This takes a candidate to wherever they need to go to start scheduling.
   * 
   * 
   *  - Requires All Features: ExamSchedulingUrl
   *
   */
  schedulingUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indicated whether score reports are generated for the exam catalog record. Both pass and fail score reports must be uploaded prior to setting this to true.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The last date candidates are able to download score reports for this exam catalog record.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportEndDate?: InputMaybe<Scalars['CmDate']['input']>;
  /**
   * The date that candidates can begin downloading score reports for this exam catalog record.
   * 
   * 
   *  - Requires All Features: ExamScoreReports
   *
   */
  scoreReportStartDate?: InputMaybe<Scalars['CmDate']['input']>;
  /** When true, always show/reveal the exam result to candidates (ungraded results are normally not revealed), and custom text will be displayed for the grade instead of what is normally used. */
  showAlteredGrade?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date the exam is to start being delivered. Does not affect cert-calculations. */
  startDate?: InputMaybe<Scalars['CmDate']['input']>;
  /**
   * A public Url with information about the exam catalog entry.
   * 
   * 
   *  - Requires All Features: ExamInformationUrl
   *
   */
  url?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateExamGroupRequest {
  /** This is used to override the default sorting, which is alphabetical by the name being displayed. */
  displayOrder?: InputMaybe<Scalars['Short']['input']>;
  id: Scalars['Int']['input'];
  /** Group display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional grouping used instead of defaults built into the catalog. If using, must be on all groups. */
  program?: InputMaybe<Scalars['String']['input']>;
  /** Order of the program groups, if programs is used this must be set for all or alphabetical will be used. */
  programDisplayOrder?: InputMaybe<Scalars['Short']['input']>;
}

export interface UpdateExamItemCatalogRequest {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  itemCorrectAnswer?: InputMaybe<Scalars['String']['input']>;
  itemScoreMax?: InputMaybe<Scalars['Decimal']['input']>;
  itemScoreWeight?: InputMaybe<Scalars['Decimal']['input']>;
  unscoredForms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface UpdateExamRequest {
  comment?: InputMaybe<Scalars['String']['input']>;
  examAuthId?: InputMaybe<Scalars['String']['input']>;
  examComment?: InputMaybe<Scalars['String']['input']>;
  expireDate?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<ExamGradeLabel>;
  hideUntil?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  id: Scalars['Int']['input'];
  /**
   * 
   * 
   * 
   *  - Requires All Permissions: Candidate.ExamScoring.Modify
   *
   */
  scaledScore?: InputMaybe<Scalars['Decimal']['input']>;
  score?: InputMaybe<Scalars['Decimal']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can either be OK or Invalid - other options are not permitted at this endpoint. */
  state?: InputMaybe<ExamState>;
  version?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateExamSectionCatalogRequest {
  coverage?: InputMaybe<Scalars['String']['input']>;
  cutScore?: InputMaybe<Scalars['Decimal']['input']>;
  examForm?: InputMaybe<Scalars['String']['input']>;
  high?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  low?: InputMaybe<Scalars['Decimal']['input']>;
  maxScore?: InputMaybe<Scalars['Decimal']['input']>;
  mid?: InputMaybe<Scalars['Decimal']['input']>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Updates exam voucher information.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Permissions: Exam.CertMetricsVouchers.Modify
 * 
 *  - Must have candidate access
 *
 */
export interface UpdateExamVoucherRequest {
  activeDate?: InputMaybe<Scalars['CmDate']['input']>;
  candidateId?: InputMaybe<CandidateIdRequest>;
  dataProviderData?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  inactiveDate?: InputMaybe<Scalars['CmDate']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
}

export interface UpdateFilterRequest {
  criteriaList: Array<InputMaybe<FilterCriteriaRequest>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateFulfillmentCatalogRequest {
  /** The fulfillment catalog id to update. */
  id: Scalars['Int']['input'];
  /** The name of the fulfillment catalog item. When null, the CertCatalog.Name value is used. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The abbreviation of the fulfillment catalog item. When null, the CertCatalog.NameAbbr value is used. */
  nameAbbr?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateGeographyRequest {
  /** The list of country codes to be assigned to a geography. */
  countryCodeList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The id of the geography to be updated. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the geography to be updated. */
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateHubLocalizationRequest {
  description?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  type: LocType;
  uiType?: InputMaybe<LocUiType>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateLocalizationListRequest {
  /** The culture that all localizations will be applied to. */
  cultureName: Scalars['String']['input'];
  /** A list of localizations by key and value to operate on. */
  localizationList: Array<InputMaybe<LocalizationVm>>;
  /** See LocType enum for more information. */
  type: LocType;
}

export interface UpdateMetadataAttributeRequest {
  /** The name of the attribute (key). */
  attributeName?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the metadata attribute to update. */
  id: Scalars['Int']['input'];
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateMetadataItemRequest {
  /** The external id for this record. Must be unique for a given type. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The primary key of the metadata item to update. */
  id: Scalars['Int']['input'];
  /** The type of the metadata item, used to group metadata items together. */
  type?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateNavigationRequest {
  /** The full navigation tree for the given type. */
  navNodes?: InputMaybe<Array<InputMaybe<NavigationRequestVm>>>;
}

export interface UpdateNewsArticleRequest {
  body?: InputMaybe<Scalars['String']['input']>;
  ends?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  filterId?: InputMaybe<Scalars['Int']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  newsDisplayOrder?: InputMaybe<Scalars['Int']['input']>;
  pictureLinkUrl?: InputMaybe<Scalars['String']['input']>;
  starts?: InputMaybe<Scalars['CmDateTimeOffset']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CandidateAccessLoginEMCOtherAchievements
 *
 */
export interface UpdateOtherAchievementCatalogRequest {
  achievementName?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reimbursable?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
}

/**
 * 
 * 
 * 
 *  - Requires Any Features: CandidateAccessLoginEMCOtherAchievements
 *
 */
export interface UpdateOtherAchievementRequest {
  activeDate?: InputMaybe<Scalars['DateTime']['input']>;
  catalogId?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  vendor?: InputMaybe<Scalars['String']['input']>;
  verificationUrl?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdatePhysicalFulfillmentRequest {
  exportOkDate?: InputMaybe<Scalars['CmDate']['input']>;
  id: Scalars['Int']['input'];
}

export interface UpdateRoleRequest {
  /** The id of the filter to which the role will be assigned. */
  filterId?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the role to be updated. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the role to be updated. If changed, the name will be updated. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The list of permission names to be assigned to the role. */
  permissionNameList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface UpdateStagingCandidateRequest {
  action: StagingCandidateAction;
  id: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateStagingCertRequirementRequest {
  action: StagingCertRequirementAction;
  id: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateStagingExamRequest {
  action: StagingExamAction;
  authorizationId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['CmDate']['input']>;
  id: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateTagDomainRequest {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tagListToAdd?: InputMaybe<Array<InputMaybe<UpdateTagItemRequest>>>;
  tagListToDelete?: InputMaybe<Array<InputMaybe<UpdateTagItemRequest>>>;
}

export interface UpdateTagItemRequest {
  catalogId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: RtiCatIdType;
}

export interface UpdateWebUserCandidateSettingFilters {
  /** A list of candidate setting filter ids to add to the user. */
  litemFiltersToAdd?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of candidate setting filter ids to delete from the user. */
  litemFiltersToDelete?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The user being updated, either the id, or login id. */
  webUserId?: InputMaybe<WebUserIdRequest>;
}

export interface UpdateWebUserGeographies {
  /** A list of client geography ids to add to the user. */
  clientGeographiesToAdd?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of client geography ids to delete from the user. */
  clientGeographiesToDelete?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The user being updated, either the id, or login id. */
  webUserId?: InputMaybe<WebUserIdRequest>;
}

export interface UpdateWebUserRequest {
  /**
   * If true, the user is treated as if they have all permissions. This field is only editable by Admin accounts, and a user cannot edit this field on their own account.
   * 
   * 
   *  - Admin accounts only
   *
   */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restricts the level that WebUsers can access candidates. Restricted, Filtered, or Unrestricted.
   * 
   * 
   *  - Admin accounts only
   *
   */
  candRestrictType?: InputMaybe<WuserCandRestrictType>;
  /** When a (non-internal) user account is not for an employee of our client, this is used by the client to designate their employer. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, the user will no longer be able to login. This field is only editable by Admin accounts, and a user cannot edit this field on their own account.
   * 
   * 
   *  - Admin accounts only
   *
   */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The email address associated with the user account. When this is changed, it sends an email to the new and old addresses to ensure it isn't fraudulent. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, the user is internal to Alpine. This field is only editable by Internal Admin accounts.
   * 
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When set, this is a comma-delimited list of IP-addresses (simple wild-cards supported) that the user is restricted to logging-in from. This is ignored for an administrator. This field is only editable by Admin accounts.
   * 
   * 
   *  - Admin accounts only
   *
   */
  loginLocation?: InputMaybe<Scalars['String']['input']>;
  /** The name of the user, usually the first and last names. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** What the new WebUser's password will be changed to in plain text. */
  newPassword?: InputMaybe<Scalars['String']['input']>;
  /** What the old WebUser's password in plain text. */
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  /**
   * If set, this stores the CmRole value that determines basic permissions the user holds in Qlik. Only the values: null, Creator, Contributor, and Consumer are acceptible. This field is only editable by Internal Admin accounts.
   * 
   * 
   *  - Requires All Features: ReportsAdvanced
   * 
   *  - Internal accounts only
   * 
   *  - Admin accounts only
   *
   */
  qlik?: InputMaybe<QlikCmRole>;
  /** The user being updated, either the id, or login id. */
  webUserId?: InputMaybe<WebUserIdRequest>;
}

export interface UpdateWebUserRoles {
  /** A list of client role ids to add to the user. */
  clientRolesToAdd?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of client role ids to delete from the user. */
  clientRolesToDelete?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The user being updated, either the id, or login id. */
  webUserId?: InputMaybe<WebUserIdRequest>;
}

export interface UploadExamRequest {
  clientId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  examCode: Scalars['String']['input'];
  examDate?: InputMaybe<Scalars['CmDate']['input']>;
  examDpExternalId: Scalars['String']['input'];
  examGrade: Scalars['String']['input'];
  examRegistrationId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}

export interface UploadExamResponse {
  clientID: Scalars['String']['output'];
  email: Scalars['String']['output'];
  examCode: Scalars['String']['output'];
  examGrade: Scalars['String']['output'];
  examRegistrationID: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  updateStatus: Array<Maybe<Scalars['String']['output']>>;
}

export interface UpsertAffiliationRequest {
  /** Makes the affiliation unable to be selected by a candidate. Does not remove the record from the database. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This pipe delimited list field, if not null, will require a candidate to enter something into the affiliation email field. The items in this field are the domains that are allowed in the email address. if this field is a blank stirng, anything can be entered. If sub-domains should match, start the pattern with the '@' character. To only include sub-domains, start the pattern with the '.' character. To turn this field into an exclusion list, start the pattern with the '!' character. */
  emailFormat?: InputMaybe<Scalars['String']['input']>;
  /** Determines if an email is required or not. If this field is left null, then an email can't be added at all. False means it can be added, but is not required. True means required. */
  emailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier used by any system outside certmetrics to identify the affiliation. If provided without the Id field, the mutation will attempt to update by this externalId. If no match is found, it will create a new affiliation with an externalId with the provided value. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The certmetrics id for the affiliation. This field is optional to update an existing affiliation. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** This RegEx field, if not null, will require a candidate to enter something into the affiliation id field. This field determines how the information in the affiliation id field can look. If this field is a blank string, anything can be entered in affiliation id. */
  idFormat?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the affiliation. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** This RegEx field, if not null, will require a candidate to enter something into the company name field. This field determines how the information in the company name field can look. If this field is a blank string, anything can be entered in company name. */
  otherFormat?: InputMaybe<Scalars['String']['input']>;
  /** The group that this affiliation belongs to according to reports. If one affiliation belongs to a web group, they're all expected to. */
  reportGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines the type of affiliation. */
  type?: InputMaybe<AffType>;
  /** The group that this affiliation belongs to according to the website. This field is required to create a new affiliation. */
  webGroup?: InputMaybe<Scalars['String']['input']>;
}

export interface UpsertExamAuthorizationResponse {
  /** The date on which the auth is active. */
  activeDate: Scalars['DateTime']['output'];
  /** External id of the candidate that this auth is for. */
  candidateExternalId: Scalars['String']['output'];
  /** Exam catalog external id. */
  examCode: Scalars['String']['output'];
  /** The date on which the auth expires. */
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  /** A message indicating the result of the upsert operation. */
  message?: Maybe<Scalars['String']['output']>;
  /** The date after which the auth may be sent to the testing data provider. */
  sendOkDate: Scalars['DateTime']['output'];
}

export interface UpsertExamItemCatalogRequest {
  comment?: InputMaybe<Scalars['String']['input']>;
  itemCorrectAnswer?: InputMaybe<Scalars['String']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  itemScoreMax?: InputMaybe<Scalars['Decimal']['input']>;
  itemScoreWeight?: InputMaybe<Scalars['Decimal']['input']>;
  languageId?: InputMaybe<Scalars['String']['input']>;
  unscoredForms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface UpsertExamSectionCatalogRequest {
  coverage?: InputMaybe<Scalars['String']['input']>;
  cutScore?: InputMaybe<Scalars['Decimal']['input']>;
  examForm?: InputMaybe<Scalars['String']['input']>;
  high?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  low?: InputMaybe<Scalars['Decimal']['input']>;
  maxScore?: InputMaybe<Scalars['Decimal']['input']>;
  mid?: InputMaybe<Scalars['Decimal']['input']>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
}

export interface ValidationCode {
  activeDate?: Maybe<Scalars['String']['output']>;
  candidateEmail?: Maybe<Scalars['String']['output']>;
  certification?: Maybe<Scalars['String']['output']>;
  certificationStatus?: Maybe<Scalars['String']['output']>;
  inactiveDate?: Maybe<Scalars['String']['output']>;
  validationCode?: Maybe<Scalars['String']['output']>;
}

export interface ValidationCodeRequest {
  validationCodeList: Array<InputMaybe<Scalars['String']['input']>>;
}

export interface VerifyCandidateSelfMergeRequest {
  jwt: Scalars['String']['input'];
}

export interface VerifyVoucherCode {
  candidate?: Maybe<Candidate>;
  dataProvider?: Maybe<DataProvider>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  eventStatus?: Maybe<ExevtType>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  examCode?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  examDeliveredDate?: Maybe<Scalars['CmDate']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  examGrade?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  examName?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  examStatus?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  result?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  testCenterId?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  voucherCode?: Maybe<Scalars['String']['output']>;
}

export interface VerifyVoucherCodeRequest {
  voucherCodeList: Array<Scalars['String']['input']>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: VmwareExamVoucherVerification
 *
 */
export interface VmwareTools {
  /**
   * 
   * 
   * 
   * 
   * 
   *  - Requires All Features: VmwareExamVoucherVerification
   * 
   *  - Admin accounts only
   *
   */
  verifyVoucherCodes?: Maybe<Array<Maybe<VerifyVoucherCode>>>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: ApiAccount, Candidate
 *  - Requires All Features: VmwareExamVoucherVerification
 *
 */
export interface VmwareToolsVerifyVoucherCodesArgs {
  request?: InputMaybe<VerifyVoucherCodeRequest>;
}

/**
 * Defines a request for voiding an eTransaction.
 * 
 * 
 *  - Requires All Permissions: Ecommerce.Transactions.Modify
 * 
 *  - Must have candidate access
 *
 */
export interface VoidEtransactionRequest {
  candidateId: CandidateIdRequest;
  transactionId: Scalars['Int']['input'];
}

/**
 * Shows voucher information.
 * 
 * 
 *  - Requires All Features: Benefit
 * 
 *  - Must have candidate access
 *
 */
export interface Voucher {
  /** Used to group a set of vouchers together. */
  batchId?: Maybe<Scalars['String']['output']>;
  /** This indicates the benefit the voucher has been assigned to. */
  benefitId?: Maybe<Scalars['Int']['output']>;
  catalog?: Maybe<BenefitCatalog>;
  /** When this voucher was created */
  created?: Maybe<Scalars['CmDateTimeOffset']['output']>;
  /** The unique ID of the voucher data. */
  externalId?: Maybe<Scalars['String']['output']>;
  /**
   * 
   * 
   * Searchable.
   * 
   * Sortable.
   */
  id: Scalars['Int']['output'];
  /** The last date the voucher is usable (it is still active on this date). Null means it never goes inactive. */
  inactiveDate?: Maybe<Scalars['CmDate']['output']>;
  /** Indicates whether the voucher is available to be assigned to a candidate. */
  invalid?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * 
 * 
 * 
 *  - Requires All Features: Benefit
 *
 */
export interface VoucherCount {
  benefitCatalog?: Maybe<BenefitCatalog>;
  benefitCatalogId: Scalars['Int']['output'];
  remainingCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalUsed: Scalars['Int']['output'];
}

export interface VoucherCountByBatch {
  batchId?: Maybe<Scalars['String']['output']>;
  expiredCount: Scalars['Int']['output'];
  invalidatedCount: Scalars['Int']['output'];
  remainingCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  usedCount: Scalars['Int']['output'];
}

export interface VoucherCountByBatchRequest {
  batchId?: InputMaybe<Scalars['String']['input']>;
}

export interface VoucherUploadRequest {
  inactiveDate?: InputMaybe<Scalars['CmDate']['input']>;
  tokenId: Scalars['String']['input'];
}

/**
 * Returns a list of candidates who have been watched.
 * 
 *  - Disallowed Account Types: Candidate
 *  - Requires All Permissions: WatchedCandidateList.View
 * 
 *  - Must have candidate access
 *
 */
export interface WatchedCandidatesReport {
  candidate?: Maybe<Candidate>;
  cmcId: Scalars['Int']['output'];
  lastExamDate?: Maybe<Scalars['CmDate']['output']>;
  watchUntil: Scalars['CmDate']['output'];
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface WebUser {
  admin: Scalars['Boolean']['output'];
  candRestrictType: WuserCandRestrictType;
  companyName?: Maybe<Scalars['String']['output']>;
  created: Scalars['CmDateTimeOffset']['output'];
  disabled: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internal: Scalars['Boolean']['output'];
  isDuplicateEmail?: Maybe<Scalars['Boolean']['output']>;
  lastPwdUpdate?: Maybe<Scalars['DateTime']['output']>;
  login: Scalars['String']['output'];
  loginLocation?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: ReportsAdvanced
   *
   */
  qlik?: Maybe<QlikCmRole>;
  updated?: Maybe<Scalars['CmDateTimeOffset']['output']>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface WebUserAccount {
  candidateSettingFilters?: Maybe<Array<Maybe<CandidateSettingFilter>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: OtherRequirementUploadCandidateAccess
   * 
   *  - Requires All Permissions: OtherRequirements.ReviewList.View
   *
   */
  certRequirementsPendingReviewCount?: Maybe<Scalars['Int']['output']>;
  emailRequestList?: Maybe<Array<Maybe<EmailRequest>>>;
  /**
   * 
   * 
   * 
   *  - Requires All Features: ExamSecurity
   * 
   *  - Requires All Permissions: Exam.ReviewList.View
   *
   */
  examsPendingReviewCount?: Maybe<Scalars['Int']['output']>;
  geographies?: Maybe<Array<Maybe<ClientGeography>>>;
  historyList?: Maybe<Array<Maybe<WebUserHistory>>>;
  id: Scalars['Int']['output'];
  login: Scalars['String']['output'];
  /**
   * 
   * 
   * 
   *  - Requires All Features: MergeCandidates
   * 
   *  - Requires All Permissions: MergeList.View
   *
   */
  pendingMergesCount?: Maybe<Scalars['Int']['output']>;
  permissionList?: Maybe<Array<Maybe<Permission>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  webUser?: Maybe<WebUser>;
}


/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface WebUserAccountPermissionListArgs {
  request?: InputMaybe<WebUserPermissionListRequest>;
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface WebUserHistory {
  created: Scalars['CmDateTimeOffset']['output'];
  /** This indicates the user responsible. */
  creator?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** The message that was logged */
  message?: Maybe<Scalars['String']['output']>;
  /** If the activity affected something else in the database, this points to the record as appropriate. */
  targetId?: Maybe<Scalars['Int']['output']>;
  /** The type of the history entry. */
  type: WuhType;
  /** Indicates the user this pertains to. */
  webUserId: Scalars['Int']['output'];
}

/**
 * 
 * 
 *  - Disallowed Account Types: Candidate
 */
export interface WebUserIdRequest {
  /** The CertMetrics WebUser Id. When this is set, all other fields are ignored. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The unique login id for the WebUser account. This is used to find a WebUser when WebUser Id is not supplied. */
  login?: InputMaybe<Scalars['String']['input']>;
}

export interface WebUserPermissionListRequest {
  includeAvailable?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum WuhType {
  /** CookieAgrSigned */
  CookieAgrSigned = 'CookieAgrSigned',
  /** EditBcat */
  EditBcat = 'EditBcat',
  /** EditCcat */
  EditCcat = 'EditCcat',
  /** EditClientFeature */
  EditClientFeature = 'EditClientFeature',
  /** EditCocat */
  EditCocat = 'EditCocat',
  /** EditCog */
  EditCog = 'EditCog',
  /** EditCrcat */
  EditCrcat = 'EditCrcat',
  /** EditEmcat */
  EditEmcat = 'EditEmcat',
  /** EditExcat */
  EditExcat = 'EditExcat',
  /** EditIcat */
  EditIcat = 'EditIcat',
  /** EditLocalization */
  EditLocalization = 'EditLocalization',
  /** EditNewsArticle */
  EditNewsArticle = 'EditNewsArticle',
  /** EditStandingTemplate */
  EditStandingTemplate = 'EditStandingTemplate',
  /** EditUser */
  EditUser = 'EditUser',
  /** EditWebUserClientRole */
  EditWebUserClientRole = 'EditWebUserClientRole',
  /** ImpersonateCandidate */
  ImpersonateCandidate = 'ImpersonateCandidate',
  /** ImpersonateUser */
  ImpersonateUser = 'ImpersonateUser',
  /** Login */
  Login = 'Login',
  /** Logout */
  Logout = 'Logout',
  /** PermissionChange */
  PermissionChange = 'PermissionChange',
  /** WebToolActivity */
  WebToolActivity = 'WebToolActivity'
}

export enum WuserCandRestrictType {
  /** Filtered */
  Filtered = 'Filtered',
  /** Restricted */
  Restricted = 'Restricted',
  /** Unrestricted */
  Unrestricted = 'Unrestricted'
}

/** Contains a variety of helper links for Xvoucher candidate egress sso. */
export interface XvoucherSsoEgress {
  dashboard?: Maybe<Scalars['String']['output']>;
}

export interface ZendeskEnabledHistoryListRequest {
  /** Determines whether to sync Zendesk ticket history. */
  sync: Scalars['Boolean']['input'];
}


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    